/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * AgencyOS API
 * API AgencyOS (/api/v1). Le client des apps est généré depuis ce schéma.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AcademyAccount,
  AcademyAccountConsentsCreate200,
  AcademyAccountExportRetrieve200,
  AcademyActivityReportsListParams,
  AcademyAttemptsListParams,
  AcademyCalibrationRetrieveParams,
  AcademyChallengeRetrieveParams,
  AcademyCheckout,
  AcademyCheckoutFallback,
  AcademyCheckoutState,
  AcademyCountries,
  AcademyCourseExercisesRecordingCreateParams,
  AcademyCourseLessonsAnswerCreateParams,
  AcademyCourseLessonsListenCreateParams,
  AcademyCourseLessonsListenRetrieveParams,
  AcademyCourseLessonsPitfallsCreateParams,
  AcademyCourseLessonsPitfallsRetrieveParams,
  AcademyCourseLessonsRestartCreateParams,
  AcademyCourseLessonsRetrieveParams,
  AcademyCourseLessonsTranslationCreateParams,
  AcademyCourseLessonsTranslationRetrieveParams,
  AcademyCourseMethodLinkRetrieveParams,
  AcademyCourseMethodRetrieveParams,
  AcademyCourseProductionsListParams,
  AcademyCourseRetrieveParams,
  AcademyCourseReviewCreateParams,
  AcademyCourseReviewRetrieveParams,
  AcademyCoursesListParams,
  AcademyExamReportsListParams,
  AcademyFormatRetrieveParams,
  AcademyFreeMockRetrieveParams,
  AcademyHistoryLessonsRetakeCreateParams,
  AcademyHistoryLessonsRetrieveParams,
  AcademyHistoryRetrieveParams,
  AcademyLearnerProgressListParams,
  AcademyLearnerProgressReportCreateParams,
  AcademyLearnerProgressRetrieveParams,
  AcademyLearnersListParams,
  AcademyLegalPage,
  AcademyLegalRetrieveParams,
  AcademyLessonPitfallsListParams,
  AcademyLessonTranslationsListParams,
  AcademyLessonsListParams,
  AcademyMockExamsListParams,
  AcademyMocksListParams,
  AcademyMonthlyPacksAnalysisRetrieveParams,
  AcademyMonthlyPacksListParams,
  AcademyOffer,
  AcademyOralAvailabilityCreateParams,
  AcademyOralAvailabilityDestroyParams,
  AcademyOralAvailabilityListParams,
  AcademyOralAvailabilityPartialUpdateParams,
  AcademyOralAvailabilityRetrieveParams,
  AcademyOralCreditsListParams,
  AcademyOralOutlineRetrieveParams,
  AcademyOralSessionsAbsentCreateParams,
  AcademyOralSessionsGradeCreateParams,
  AcademyOralSessionsListParams,
  AcademyOralSessionsRefundCreateParams,
  AcademyOralSessionsRetrieveParams,
  AcademyOralSessionsStartCreateParams,
  AcademyOralSessionsStatsRetrieve200,
  AcademyOralSessionsStatsRetrieveParams,
  AcademyOralSlotsRetrieveParams,
  AcademyPassagesAudioStatusRetrieveParams,
  AcademyPassagesGenerateMissingAudioParams,
  AcademyPassagesListParams,
  AcademyPlansListParams,
  AcademyProductionsListParams,
  AcademyProductionsOverviewRetrieveParams,
  AcademyProgressRetrieveParams,
  AcademyQuestionsListParams,
  AcademyQuote,
  AcademyReportCreateParams,
  AcademyReportRetrieveParams,
  AcademyReviewRequestsListParams,
  AcademyReviewRequestsStatsRetrieveParams,
  AcademySalesOfferRetrieveParams,
  AcademySalesPromoCodesListParams,
  AcademySalesReviewsRetrieveParams,
  AcademySalesStatsRetrieve200,
  AcademySalesStatsRetrieveParams,
  AcademySalesSubscriptionsExtendCreateParams,
  AcademySalesSubscriptionsListParams,
  AcademySalesSubscriptionsRefundCreateParams,
  AcademySalesSubscriptionsRetrieveParams,
  AcademySettings,
  AcademySettingsListParams,
  AcademySimulated,
  AcademySourcesListParams,
  AcademyStudentsListParams,
  AcademyTasksListParams,
  AcademyTestimonialsListParams,
  AcademyTestimonialsModerateCreateParams,
  AcademyTestimonialsRetrieveParams,
  AcademyTrendsListParams,
  AcademyTutorRetrieveParams,
  AcademyUrgentListParams,
  ActivityReportDetail,
  ActivityReportPreview,
  ActivityReportQueued,
  ActivityReportRequestRequest,
  AnswerRequest,
  Attempt,
  AttemptReview,
  AttemptReviewRequests,
  AttemptState,
  AudioLink,
  AudioUploadRequest,
  BuildMonthRequest,
  Calibration,
  ChallengeActionRequest,
  ChallengeCorrection,
  ChallengeView,
  CheckoutRequest,
  CheckoutSimulateRequest,
  CoAudioQueued,
  CoAudioStatus,
  CompleteReviewRequest,
  ConsentRequest,
  Course,
  CourseGradeRequest,
  CoursePath,
  CourseProduction,
  DeleteRequest,
  ExamFormat,
  ExamProfile,
  ExamProfileRequest,
  ExamReport,
  ExaminerReply,
  ExaminerTurnRequest,
  ExamsChangeRequest,
  ExerciseAnswerRequest,
  ExerciseRecordingRequest,
  ExerciseResult,
  ExtendRequest,
  ExtendStudentRequest,
  FalseFriendsRequestRequest,
  FalseFriendsResult,
  Feedback,
  FeedbackRequest,
  FreeMockStartRequest,
  FreeMockState,
  GeneratedDocument,
  GoetheProfileRequest,
  GoetheState,
  GradingOverview,
  History,
  HistoryItem,
  HistoryPage,
  KnownSource,
  KnownSourceRequest,
  Learner,
  LearnerAdmin,
  LearnerProgress,
  LearnerReport,
  Lesson,
  LessonCorrection,
  LessonDetail,
  LessonPitfallsTeam,
  LessonRetake,
  LessonTranslation,
  LessonTranslationView,
  Listen,
  Method,
  MethodLink,
  MockExam,
  MockExamLearner,
  MonthAnalysis,
  MonthlyPack,
  MyReviews,
  MyTestimonial,
  NoteRequest,
  OralAbsentRequest,
  OralBookRequest,
  OralBooking,
  OralBookingAdmin,
  OralCancelRequest,
  OralCheckout,
  OralChoiceRequest,
  OralCreditEntry,
  OralCreditEntryRequest,
  OralCredits,
  OralGradeRequest,
  OralOffer,
  OralOutline,
  OralPayRequest,
  OralRefundRequest,
  OralRescheduleRequest,
  OralSlots,
  PaginatedAcademySettingsList,
  PaginatedActivityReportList,
  PaginatedCourseList,
  PaginatedCourseProductionList,
  PaginatedExamReportList,
  PaginatedKnownSourceList,
  PaginatedLearnerAdminList,
  PaginatedLessonList,
  PaginatedLessonPitfallsTeamList,
  PaginatedLessonTranslationList,
  PaginatedMockExamList,
  PaginatedMonthlyPackList,
  PaginatedOralBookingAdminList,
  PaginatedOralCreditEntryList,
  PaginatedPassageList,
  PaginatedProductionList,
  PaginatedPromoCodeList,
  PaginatedQuestionList,
  PaginatedStudentList,
  PaginatedSubscriptionAdminList,
  PaginatedTaskList,
  PaginatedTestimonialAdminList,
  PaginatedTrainerAvailabilityList,
  PaginatedTrainerReviewRequestList,
  Passage,
  PassageAudioLink,
  PatchedAcademySettingsRequest,
  PatchedKnownSourceRequest,
  PatchedLearnerRequest,
  PatchedLessonPitfallsTeamRequest,
  PatchedLessonRequest,
  PatchedMockExamRequest,
  PatchedPassageRequest,
  PatchedPromoCodeRequest,
  PatchedQuestionRequest,
  PatchedTaskRequest,
  PatchedTrainerAvailabilityRequest,
  PaymentRestoreAlertCreated,
  PaymentUnavailable,
  Pitfalls,
  Plan,
  Production,
  PromoCode,
  PromoCodeRequest,
  PublicReviews,
  Question,
  QuestionRequest,
  QuoteRequest,
  Recorded,
  RecordingRequest,
  RedoRecordingRequest,
  RedoRequest,
  RedoTask,
  RedoTurnReply,
  RedoTurnRequest,
  Redone,
  RefundRequest,
  RegisterRequest,
  Registered,
  RestoreAlertRequest,
  RetakeResult,
  ReviewModerateRequest,
  ReviewRequestCreateRequest,
  ReviewStats,
  ReviewSubmitRequest,
  ReviewToday,
  Saved,
  SpeakingReply,
  SpeakingTurnRequest,
  SpokenLanguage,
  StartMockRequest,
  StartRequest,
  StudentCreateRequest,
  StudentDetail,
  StudentImportRequest,
  StudentImportRow,
  StudentOptions,
  SubscribeRequest,
  Subscribed,
  SubscriptionAdmin,
  SwitchModuleRequest,
  Task,
  TaskRequest,
  TestimonialAdmin,
  TextListenRequestRequest,
  TextRequest,
  Texts,
  TextsRequestRequest,
  TrainerAvailability,
  TrainerAvailabilityRequest,
  TrainerGradeRequest,
  TrainerReviewRequest,
  TranslationRequestRequest,
  Trend,
  TutorMessageRequest,
  TutorReply,
  TutorState,
  UrgentMock
} from '.././model';

import { apiFetch } from '../../http';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * « My plan »: the offer of the learner's country, trial, subscriptions and invoices,
one-click renewal, referral, consents.
 */
export type academyAccountRetrieveResponse200 = {
  data: AcademyAccount
  status: 200
}
    
export type academyAccountRetrieveResponseSuccess = (academyAccountRetrieveResponse200) & {
  headers: Headers;
};
;

export type academyAccountRetrieveResponse = (academyAccountRetrieveResponseSuccess)

export const getAcademyAccountRetrieveUrl = () => {


  

  return `/api/v1/academy/account/`
}

export const academyAccountRetrieve = async ( options?: RequestInit): Promise<academyAccountRetrieveResponse> => {
  
  return apiFetch<academyAccountRetrieveResponse>(getAcademyAccountRetrieveUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyAccountRetrieveQueryKey = () => {
    return [
    `/api/v1/academy/account/`
    ] as const;
    }

    
export const getAcademyAccountRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academyAccountRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyAccountRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyAccountRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyAccountRetrieve>>> = ({ signal }) => academyAccountRetrieve({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyAccountRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyAccountRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academyAccountRetrieve>>>
export type AcademyAccountRetrieveQueryError = unknown


export function useAcademyAccountRetrieve<TData = Awaited<ReturnType<typeof academyAccountRetrieve>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyAccountRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyAccountRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyAccountRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyAccountRetrieve<TData = Awaited<ReturnType<typeof academyAccountRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyAccountRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyAccountRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyAccountRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyAccountRetrieve<TData = Awaited<ReturnType<typeof academyAccountRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyAccountRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyAccountRetrieve<TData = Awaited<ReturnType<typeof academyAccountRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyAccountRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyAccountRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Audience measurement and tips by e-mail: consent given or withdrawn at any time.
 */
export type academyAccountConsentsCreateResponse200 = {
  data: AcademyAccountConsentsCreate200
  status: 200
}
    
export type academyAccountConsentsCreateResponseSuccess = (academyAccountConsentsCreateResponse200) & {
  headers: Headers;
};
;

export type academyAccountConsentsCreateResponse = (academyAccountConsentsCreateResponseSuccess)

export const getAcademyAccountConsentsCreateUrl = () => {


  

  return `/api/v1/academy/account/consents/`
}

export const academyAccountConsentsCreate = async (consentRequest: ConsentRequest, options?: RequestInit): Promise<academyAccountConsentsCreateResponse> => {
  
  return apiFetch<academyAccountConsentsCreateResponse>(getAcademyAccountConsentsCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      consentRequest,)
  }
);}




export const getAcademyAccountConsentsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyAccountConsentsCreate>>, TError,{data: ConsentRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyAccountConsentsCreate>>, TError,{data: ConsentRequest}, TContext> => {

const mutationKey = ['academyAccountConsentsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyAccountConsentsCreate>>, {data: ConsentRequest}> = (props) => {
          const {data} = props ?? {};

          return  academyAccountConsentsCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyAccountConsentsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyAccountConsentsCreate>>>
    export type AcademyAccountConsentsCreateMutationBody = ConsentRequest
    export type AcademyAccountConsentsCreateMutationError = unknown

    export const useAcademyAccountConsentsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyAccountConsentsCreate>>, TError,{data: ConsentRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyAccountConsentsCreate>>,
        TError,
        {data: ConsentRequest},
        TContext
      > => {

      const mutationOptions = getAcademyAccountConsentsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Right to erasure, in self-service (confirmed by typing the account's e-mail).
 */
export type academyAccountDeleteCreateResponse204 = {
  data: void
  status: 204
}
    
export type academyAccountDeleteCreateResponseSuccess = (academyAccountDeleteCreateResponse204) & {
  headers: Headers;
};
;

export type academyAccountDeleteCreateResponse = (academyAccountDeleteCreateResponseSuccess)

export const getAcademyAccountDeleteCreateUrl = () => {


  

  return `/api/v1/academy/account/delete/`
}

export const academyAccountDeleteCreate = async (deleteRequest: DeleteRequest, options?: RequestInit): Promise<academyAccountDeleteCreateResponse> => {
  
  return apiFetch<academyAccountDeleteCreateResponse>(getAcademyAccountDeleteCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      deleteRequest,)
  }
);}




export const getAcademyAccountDeleteCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyAccountDeleteCreate>>, TError,{data: DeleteRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyAccountDeleteCreate>>, TError,{data: DeleteRequest}, TContext> => {

const mutationKey = ['academyAccountDeleteCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyAccountDeleteCreate>>, {data: DeleteRequest}> = (props) => {
          const {data} = props ?? {};

          return  academyAccountDeleteCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyAccountDeleteCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyAccountDeleteCreate>>>
    export type AcademyAccountDeleteCreateMutationBody = DeleteRequest
    export type AcademyAccountDeleteCreateMutationError = unknown

    export const useAcademyAccountDeleteCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyAccountDeleteCreate>>, TError,{data: DeleteRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyAccountDeleteCreate>>,
        TError,
        {data: DeleteRequest},
        TContext
      > => {

      const mutationOptions = getAcademyAccountDeleteCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Right of access and portability: every piece of data, as a JSON file.
 */
export type academyAccountExportRetrieveResponse200 = {
  data: AcademyAccountExportRetrieve200
  status: 200
}
    
export type academyAccountExportRetrieveResponseSuccess = (academyAccountExportRetrieveResponse200) & {
  headers: Headers;
};
;

export type academyAccountExportRetrieveResponse = (academyAccountExportRetrieveResponseSuccess)

export const getAcademyAccountExportRetrieveUrl = () => {


  

  return `/api/v1/academy/account/export/`
}

export const academyAccountExportRetrieve = async ( options?: RequestInit): Promise<academyAccountExportRetrieveResponse> => {
  
  return apiFetch<academyAccountExportRetrieveResponse>(getAcademyAccountExportRetrieveUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyAccountExportRetrieveQueryKey = () => {
    return [
    `/api/v1/academy/account/export/`
    ] as const;
    }

    
export const getAcademyAccountExportRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academyAccountExportRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyAccountExportRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyAccountExportRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyAccountExportRetrieve>>> = ({ signal }) => academyAccountExportRetrieve({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyAccountExportRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyAccountExportRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academyAccountExportRetrieve>>>
export type AcademyAccountExportRetrieveQueryError = unknown


export function useAcademyAccountExportRetrieve<TData = Awaited<ReturnType<typeof academyAccountExportRetrieve>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyAccountExportRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyAccountExportRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyAccountExportRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyAccountExportRetrieve<TData = Awaited<ReturnType<typeof academyAccountExportRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyAccountExportRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyAccountExportRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyAccountExportRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyAccountExportRetrieve<TData = Awaited<ReturnType<typeof academyAccountExportRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyAccountExportRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyAccountExportRetrieve<TData = Awaited<ReturnType<typeof academyAccountExportRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyAccountExportRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyAccountExportRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Reports sent (archive, newest first), preview and « send me now ».
 */
export type academyActivityReportsListResponse200 = {
  data: PaginatedActivityReportList
  status: 200
}
    
export type academyActivityReportsListResponseSuccess = (academyActivityReportsListResponse200) & {
  headers: Headers;
};
;

export type academyActivityReportsListResponse = (academyActivityReportsListResponseSuccess)

export const getAcademyActivityReportsListUrl = (params?: AcademyActivityReportsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/activity-reports/?${stringifiedParams}` : `/api/v1/academy/activity-reports/`
}

export const academyActivityReportsList = async (params?: AcademyActivityReportsListParams, options?: RequestInit): Promise<academyActivityReportsListResponse> => {
  
  return apiFetch<academyActivityReportsListResponse>(getAcademyActivityReportsListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyActivityReportsListQueryKey = (params?: AcademyActivityReportsListParams,) => {
    return [
    `/api/v1/academy/activity-reports/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAcademyActivityReportsListQueryOptions = <TData = Awaited<ReturnType<typeof academyActivityReportsList>>, TError = unknown>(params?: AcademyActivityReportsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyActivityReportsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyActivityReportsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyActivityReportsList>>> = ({ signal }) => academyActivityReportsList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyActivityReportsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyActivityReportsListQueryResult = NonNullable<Awaited<ReturnType<typeof academyActivityReportsList>>>
export type AcademyActivityReportsListQueryError = unknown


export function useAcademyActivityReportsList<TData = Awaited<ReturnType<typeof academyActivityReportsList>>, TError = unknown>(
 params: undefined |  AcademyActivityReportsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyActivityReportsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyActivityReportsList>>,
          TError,
          Awaited<ReturnType<typeof academyActivityReportsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyActivityReportsList<TData = Awaited<ReturnType<typeof academyActivityReportsList>>, TError = unknown>(
 params?: AcademyActivityReportsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyActivityReportsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyActivityReportsList>>,
          TError,
          Awaited<ReturnType<typeof academyActivityReportsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyActivityReportsList<TData = Awaited<ReturnType<typeof academyActivityReportsList>>, TError = unknown>(
 params?: AcademyActivityReportsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyActivityReportsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyActivityReportsList<TData = Awaited<ReturnType<typeof academyActivityReportsList>>, TError = unknown>(
 params?: AcademyActivityReportsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyActivityReportsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyActivityReportsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Reports sent (archive, newest first), preview and « send me now ».
 */
export type academyActivityReportsRetrieveResponse200 = {
  data: ActivityReportDetail
  status: 200
}
    
export type academyActivityReportsRetrieveResponseSuccess = (academyActivityReportsRetrieveResponse200) & {
  headers: Headers;
};
;

export type academyActivityReportsRetrieveResponse = (academyActivityReportsRetrieveResponseSuccess)

export const getAcademyActivityReportsRetrieveUrl = (id: string,) => {


  

  return `/api/v1/academy/activity-reports/${id}/`
}

export const academyActivityReportsRetrieve = async (id: string, options?: RequestInit): Promise<academyActivityReportsRetrieveResponse> => {
  
  return apiFetch<academyActivityReportsRetrieveResponse>(getAcademyActivityReportsRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyActivityReportsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/academy/activity-reports/${id}/`
    ] as const;
    }

    
export const getAcademyActivityReportsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academyActivityReportsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyActivityReportsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyActivityReportsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyActivityReportsRetrieve>>> = ({ signal }) => academyActivityReportsRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyActivityReportsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyActivityReportsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academyActivityReportsRetrieve>>>
export type AcademyActivityReportsRetrieveQueryError = unknown


export function useAcademyActivityReportsRetrieve<TData = Awaited<ReturnType<typeof academyActivityReportsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyActivityReportsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyActivityReportsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyActivityReportsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyActivityReportsRetrieve<TData = Awaited<ReturnType<typeof academyActivityReportsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyActivityReportsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyActivityReportsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyActivityReportsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyActivityReportsRetrieve<TData = Awaited<ReturnType<typeof academyActivityReportsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyActivityReportsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyActivityReportsRetrieve<TData = Awaited<ReturnType<typeof academyActivityReportsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyActivityReportsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyActivityReportsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * The report of a day as it would be sent now (nothing is sent nor recorded).
 */
export type academyActivityReportsPreviewCreateResponse200 = {
  data: ActivityReportPreview
  status: 200
}
    
export type academyActivityReportsPreviewCreateResponseSuccess = (academyActivityReportsPreviewCreateResponse200) & {
  headers: Headers;
};
;

export type academyActivityReportsPreviewCreateResponse = (academyActivityReportsPreviewCreateResponseSuccess)

export const getAcademyActivityReportsPreviewCreateUrl = () => {


  

  return `/api/v1/academy/activity-reports/preview/`
}

export const academyActivityReportsPreviewCreate = async (activityReportRequestRequest: ActivityReportRequestRequest, options?: RequestInit): Promise<academyActivityReportsPreviewCreateResponse> => {
  
  return apiFetch<academyActivityReportsPreviewCreateResponse>(getAcademyActivityReportsPreviewCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      activityReportRequestRequest,)
  }
);}




export const getAcademyActivityReportsPreviewCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyActivityReportsPreviewCreate>>, TError,{data: ActivityReportRequestRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyActivityReportsPreviewCreate>>, TError,{data: ActivityReportRequestRequest}, TContext> => {

const mutationKey = ['academyActivityReportsPreviewCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyActivityReportsPreviewCreate>>, {data: ActivityReportRequestRequest}> = (props) => {
          const {data} = props ?? {};

          return  academyActivityReportsPreviewCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyActivityReportsPreviewCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyActivityReportsPreviewCreate>>>
    export type AcademyActivityReportsPreviewCreateMutationBody = ActivityReportRequestRequest
    export type AcademyActivityReportsPreviewCreateMutationError = unknown

    export const useAcademyActivityReportsPreviewCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyActivityReportsPreviewCreate>>, TError,{data: ActivityReportRequestRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyActivityReportsPreviewCreate>>,
        TError,
        {data: ActivityReportRequestRequest},
        TContext
      > => {

      const mutationOptions = getAcademyActivityReportsPreviewCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * The report of a day sent now to the staff member only (kept in the archive).
 */
export type academyActivityReportsSendMeCreateResponse202 = {
  data: ActivityReportQueued
  status: 202
}
    
export type academyActivityReportsSendMeCreateResponseSuccess = (academyActivityReportsSendMeCreateResponse202) & {
  headers: Headers;
};
;

export type academyActivityReportsSendMeCreateResponse = (academyActivityReportsSendMeCreateResponseSuccess)

export const getAcademyActivityReportsSendMeCreateUrl = () => {


  

  return `/api/v1/academy/activity-reports/send-me/`
}

export const academyActivityReportsSendMeCreate = async (activityReportRequestRequest: ActivityReportRequestRequest, options?: RequestInit): Promise<academyActivityReportsSendMeCreateResponse> => {
  
  return apiFetch<academyActivityReportsSendMeCreateResponse>(getAcademyActivityReportsSendMeCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      activityReportRequestRequest,)
  }
);}




export const getAcademyActivityReportsSendMeCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyActivityReportsSendMeCreate>>, TError,{data: ActivityReportRequestRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyActivityReportsSendMeCreate>>, TError,{data: ActivityReportRequestRequest}, TContext> => {

const mutationKey = ['academyActivityReportsSendMeCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyActivityReportsSendMeCreate>>, {data: ActivityReportRequestRequest}> = (props) => {
          const {data} = props ?? {};

          return  academyActivityReportsSendMeCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyActivityReportsSendMeCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyActivityReportsSendMeCreate>>>
    export type AcademyActivityReportsSendMeCreateMutationBody = ActivityReportRequestRequest
    export type AcademyActivityReportsSendMeCreateMutationError = unknown

    export const useAcademyActivityReportsSendMeCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyActivityReportsSendMeCreate>>, TError,{data: ActivityReportRequestRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyActivityReportsSendMeCreate>>,
        TError,
        {data: ActivityReportRequestRequest},
        TContext
      > => {

      const mutationOptions = getAcademyActivityReportsSendMeCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * The signed-in learner only: never an agency member's tools.
 */
export type academyAttemptsListResponse200 = {
  data: Attempt[]
  status: 200
}
    
export type academyAttemptsListResponseSuccess = (academyAttemptsListResponse200) & {
  headers: Headers;
};
;

export type academyAttemptsListResponse = (academyAttemptsListResponseSuccess)

export const getAcademyAttemptsListUrl = (params?: AcademyAttemptsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/attempts/?${stringifiedParams}` : `/api/v1/academy/attempts/`
}

export const academyAttemptsList = async (params?: AcademyAttemptsListParams, options?: RequestInit): Promise<academyAttemptsListResponse> => {
  
  return apiFetch<academyAttemptsListResponse>(getAcademyAttemptsListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyAttemptsListQueryKey = (params?: AcademyAttemptsListParams,) => {
    return [
    `/api/v1/academy/attempts/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAcademyAttemptsListQueryOptions = <TData = Awaited<ReturnType<typeof academyAttemptsList>>, TError = unknown>(params?: AcademyAttemptsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyAttemptsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyAttemptsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyAttemptsList>>> = ({ signal }) => academyAttemptsList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyAttemptsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyAttemptsListQueryResult = NonNullable<Awaited<ReturnType<typeof academyAttemptsList>>>
export type AcademyAttemptsListQueryError = unknown


export function useAcademyAttemptsList<TData = Awaited<ReturnType<typeof academyAttemptsList>>, TError = unknown>(
 params: undefined |  AcademyAttemptsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyAttemptsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyAttemptsList>>,
          TError,
          Awaited<ReturnType<typeof academyAttemptsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyAttemptsList<TData = Awaited<ReturnType<typeof academyAttemptsList>>, TError = unknown>(
 params?: AcademyAttemptsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyAttemptsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyAttemptsList>>,
          TError,
          Awaited<ReturnType<typeof academyAttemptsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyAttemptsList<TData = Awaited<ReturnType<typeof academyAttemptsList>>, TError = unknown>(
 params?: AcademyAttemptsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyAttemptsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyAttemptsList<TData = Awaited<ReturnType<typeof academyAttemptsList>>, TError = unknown>(
 params?: AcademyAttemptsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyAttemptsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyAttemptsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * The signed-in learner only: never an agency member's tools.
 */
export type academyAttemptsCreateResponse201 = {
  data: Attempt
  status: 201
}
    
export type academyAttemptsCreateResponseSuccess = (academyAttemptsCreateResponse201) & {
  headers: Headers;
};
;

export type academyAttemptsCreateResponse = (academyAttemptsCreateResponseSuccess)

export const getAcademyAttemptsCreateUrl = () => {


  

  return `/api/v1/academy/attempts/`
}

export const academyAttemptsCreate = async (startRequest: StartRequest, options?: RequestInit): Promise<academyAttemptsCreateResponse> => {
  
  return apiFetch<academyAttemptsCreateResponse>(getAcademyAttemptsCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      startRequest,)
  }
);}




export const getAcademyAttemptsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyAttemptsCreate>>, TError,{data: StartRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyAttemptsCreate>>, TError,{data: StartRequest}, TContext> => {

const mutationKey = ['academyAttemptsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyAttemptsCreate>>, {data: StartRequest}> = (props) => {
          const {data} = props ?? {};

          return  academyAttemptsCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyAttemptsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyAttemptsCreate>>>
    export type AcademyAttemptsCreateMutationBody = StartRequest
    export type AcademyAttemptsCreateMutationError = unknown

    export const useAcademyAttemptsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyAttemptsCreate>>, TError,{data: StartRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyAttemptsCreate>>,
        TError,
        {data: StartRequest},
        TContext
      > => {

      const mutationOptions = getAcademyAttemptsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * What the player shows now (the server keeps the time: a reload resumes, P3B-03).
 */
export type academyAttemptsRetrieveResponse200 = {
  data: AttemptState
  status: 200
}
    
export type academyAttemptsRetrieveResponseSuccess = (academyAttemptsRetrieveResponse200) & {
  headers: Headers;
};
;

export type academyAttemptsRetrieveResponse = (academyAttemptsRetrieveResponseSuccess)

export const getAcademyAttemptsRetrieveUrl = (id: string,) => {


  

  return `/api/v1/academy/attempts/${id}/`
}

export const academyAttemptsRetrieve = async (id: string, options?: RequestInit): Promise<academyAttemptsRetrieveResponse> => {
  
  return apiFetch<academyAttemptsRetrieveResponse>(getAcademyAttemptsRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyAttemptsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/academy/attempts/${id}/`
    ] as const;
    }

    
export const getAcademyAttemptsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academyAttemptsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyAttemptsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyAttemptsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyAttemptsRetrieve>>> = ({ signal }) => academyAttemptsRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyAttemptsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyAttemptsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academyAttemptsRetrieve>>>
export type AcademyAttemptsRetrieveQueryError = unknown


export function useAcademyAttemptsRetrieve<TData = Awaited<ReturnType<typeof academyAttemptsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyAttemptsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyAttemptsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyAttemptsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyAttemptsRetrieve<TData = Awaited<ReturnType<typeof academyAttemptsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyAttemptsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyAttemptsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyAttemptsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyAttemptsRetrieve<TData = Awaited<ReturnType<typeof academyAttemptsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyAttemptsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyAttemptsRetrieve<TData = Awaited<ReturnType<typeof academyAttemptsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyAttemptsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyAttemptsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * The signed-in learner only: never an agency member's tools.
 */
export type academyAttemptsAnswerCreateResponse200 = {
  data: AttemptState
  status: 200
}
    
export type academyAttemptsAnswerCreateResponseSuccess = (academyAttemptsAnswerCreateResponse200) & {
  headers: Headers;
};
;

export type academyAttemptsAnswerCreateResponse = (academyAttemptsAnswerCreateResponseSuccess)

export const getAcademyAttemptsAnswerCreateUrl = (id: string,) => {


  

  return `/api/v1/academy/attempts/${id}/answer/`
}

export const academyAttemptsAnswerCreate = async (id: string,
    answerRequest: AnswerRequest, options?: RequestInit): Promise<academyAttemptsAnswerCreateResponse> => {
  
  return apiFetch<academyAttemptsAnswerCreateResponse>(getAcademyAttemptsAnswerCreateUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      answerRequest,)
  }
);}




export const getAcademyAttemptsAnswerCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyAttemptsAnswerCreate>>, TError,{id: string;data: AnswerRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyAttemptsAnswerCreate>>, TError,{id: string;data: AnswerRequest}, TContext> => {

const mutationKey = ['academyAttemptsAnswerCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyAttemptsAnswerCreate>>, {id: string;data: AnswerRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  academyAttemptsAnswerCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyAttemptsAnswerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyAttemptsAnswerCreate>>>
    export type AcademyAttemptsAnswerCreateMutationBody = AnswerRequest
    export type AcademyAttemptsAnswerCreateMutationError = unknown

    export const useAcademyAttemptsAnswerCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyAttemptsAnswerCreate>>, TError,{id: string;data: AnswerRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyAttemptsAnswerCreate>>,
        TError,
        {id: string;data: AnswerRequest},
        TContext
      > => {

      const mutationOptions = getAcademyAttemptsAnswerCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Signed link to a CO audio of the current sitting: played once in exam mode, as at the test
centre; paused and heard again at will in training mode (D-144).
 */
export type academyAttemptsAudioRetrieveResponse200 = {
  data: AudioLink
  status: 200
}
    
export type academyAttemptsAudioRetrieveResponseSuccess = (academyAttemptsAudioRetrieveResponse200) & {
  headers: Headers;
};
;

export type academyAttemptsAudioRetrieveResponse = (academyAttemptsAudioRetrieveResponseSuccess)

export const getAcademyAttemptsAudioRetrieveUrl = (id: string,
    questionId: string,) => {


  

  return `/api/v1/academy/attempts/${id}/audio/${questionId}/`
}

export const academyAttemptsAudioRetrieve = async (id: string,
    questionId: string, options?: RequestInit): Promise<academyAttemptsAudioRetrieveResponse> => {
  
  return apiFetch<academyAttemptsAudioRetrieveResponse>(getAcademyAttemptsAudioRetrieveUrl(id,questionId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyAttemptsAudioRetrieveQueryKey = (id?: string,
    questionId?: string,) => {
    return [
    `/api/v1/academy/attempts/${id}/audio/${questionId}/`
    ] as const;
    }

    
export const getAcademyAttemptsAudioRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academyAttemptsAudioRetrieve>>, TError = unknown>(id: string,
    questionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyAttemptsAudioRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyAttemptsAudioRetrieveQueryKey(id,questionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyAttemptsAudioRetrieve>>> = ({ signal }) => academyAttemptsAudioRetrieve(id,questionId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id && questionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyAttemptsAudioRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyAttemptsAudioRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academyAttemptsAudioRetrieve>>>
export type AcademyAttemptsAudioRetrieveQueryError = unknown


export function useAcademyAttemptsAudioRetrieve<TData = Awaited<ReturnType<typeof academyAttemptsAudioRetrieve>>, TError = unknown>(
 id: string,
    questionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyAttemptsAudioRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyAttemptsAudioRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyAttemptsAudioRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyAttemptsAudioRetrieve<TData = Awaited<ReturnType<typeof academyAttemptsAudioRetrieve>>, TError = unknown>(
 id: string,
    questionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyAttemptsAudioRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyAttemptsAudioRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyAttemptsAudioRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyAttemptsAudioRetrieve<TData = Awaited<ReturnType<typeof academyAttemptsAudioRetrieve>>, TError = unknown>(
 id: string,
    questionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyAttemptsAudioRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyAttemptsAudioRetrieve<TData = Awaited<ReturnType<typeof academyAttemptsAudioRetrieve>>, TError = unknown>(
 id: string,
    questionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyAttemptsAudioRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyAttemptsAudioRetrieveQueryOptions(id,questionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * One turn of speech of the learner in EO task 2 → the examiner's live answer (French).
 */
export type academyAttemptsExaminerCreateResponse200 = {
  data: ExaminerReply
  status: 200
}
    
export type academyAttemptsExaminerCreateResponseSuccess = (academyAttemptsExaminerCreateResponse200) & {
  headers: Headers;
};
;

export type academyAttemptsExaminerCreateResponse = (academyAttemptsExaminerCreateResponseSuccess)

export const getAcademyAttemptsExaminerCreateUrl = (id: string,) => {


  

  return `/api/v1/academy/attempts/${id}/examiner/`
}

export const academyAttemptsExaminerCreate = async (id: string,
    examinerTurnRequest: ExaminerTurnRequest, options?: RequestInit): Promise<academyAttemptsExaminerCreateResponse> => {
    const formData = new FormData();
formData.append(`task`, examinerTurnRequest.task)
formData.append(`audio`, examinerTurnRequest.audio)
if(examinerTurnRequest.offset !== undefined) {
 formData.append(`offset`, examinerTurnRequest.offset.toString())
 }
if(examinerTurnRequest.keep !== undefined) {
 formData.append(`keep`, examinerTurnRequest.keep.toString())
 }

  return apiFetch<academyAttemptsExaminerCreateResponse>(getAcademyAttemptsExaminerCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    ,
    body: 
      formData,
  }
);}




export const getAcademyAttemptsExaminerCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyAttemptsExaminerCreate>>, TError,{id: string;data: ExaminerTurnRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyAttemptsExaminerCreate>>, TError,{id: string;data: ExaminerTurnRequest}, TContext> => {

const mutationKey = ['academyAttemptsExaminerCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyAttemptsExaminerCreate>>, {id: string;data: ExaminerTurnRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  academyAttemptsExaminerCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyAttemptsExaminerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyAttemptsExaminerCreate>>>
    export type AcademyAttemptsExaminerCreateMutationBody = ExaminerTurnRequest
    export type AcademyAttemptsExaminerCreateMutationError = unknown

    export const useAcademyAttemptsExaminerCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyAttemptsExaminerCreate>>, TError,{id: string;data: ExaminerTurnRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyAttemptsExaminerCreate>>,
        TError,
        {id: string;data: ExaminerTurnRequest},
        TContext
      > => {

      const mutationOptions = getAcademyAttemptsExaminerCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Goethe A1 (D-163): Lesen and Schreiben are one 45-minute block; the learner goes from one
to the other in the order they choose, the time of the block keeps running.
 */
export type academyAttemptsModuleCreateResponse200 = {
  data: AttemptState
  status: 200
}
    
export type academyAttemptsModuleCreateResponseSuccess = (academyAttemptsModuleCreateResponse200) & {
  headers: Headers;
};
;

export type academyAttemptsModuleCreateResponse = (academyAttemptsModuleCreateResponseSuccess)

export const getAcademyAttemptsModuleCreateUrl = (id: string,) => {


  

  return `/api/v1/academy/attempts/${id}/module/`
}

export const academyAttemptsModuleCreate = async (id: string,
    switchModuleRequest: SwitchModuleRequest, options?: RequestInit): Promise<academyAttemptsModuleCreateResponse> => {
  
  return apiFetch<academyAttemptsModuleCreateResponse>(getAcademyAttemptsModuleCreateUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      switchModuleRequest,)
  }
);}




export const getAcademyAttemptsModuleCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyAttemptsModuleCreate>>, TError,{id: string;data: SwitchModuleRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyAttemptsModuleCreate>>, TError,{id: string;data: SwitchModuleRequest}, TContext> => {

const mutationKey = ['academyAttemptsModuleCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyAttemptsModuleCreate>>, {id: string;data: SwitchModuleRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  academyAttemptsModuleCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyAttemptsModuleCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyAttemptsModuleCreate>>>
    export type AcademyAttemptsModuleCreateMutationBody = SwitchModuleRequest
    export type AcademyAttemptsModuleCreateMutationError = unknown

    export const useAcademyAttemptsModuleCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyAttemptsModuleCreate>>, TError,{id: string;data: SwitchModuleRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyAttemptsModuleCreate>>,
        TError,
        {id: string;data: SwitchModuleRequest},
        TContext
      > => {

      const mutationOptions = getAcademyAttemptsModuleCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * The learner ends the current section before the time (e.g. EE finished early).
 */
export type academyAttemptsNextCreateResponse200 = {
  data: AttemptState
  status: 200
}
    
export type academyAttemptsNextCreateResponseSuccess = (academyAttemptsNextCreateResponse200) & {
  headers: Headers;
};
;

export type academyAttemptsNextCreateResponse = (academyAttemptsNextCreateResponseSuccess)

export const getAcademyAttemptsNextCreateUrl = (id: string,) => {


  

  return `/api/v1/academy/attempts/${id}/next/`
}

export const academyAttemptsNextCreate = async (id: string, options?: RequestInit): Promise<academyAttemptsNextCreateResponse> => {
  
  return apiFetch<academyAttemptsNextCreateResponse>(getAcademyAttemptsNextCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getAcademyAttemptsNextCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyAttemptsNextCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyAttemptsNextCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['academyAttemptsNextCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyAttemptsNextCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  academyAttemptsNextCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyAttemptsNextCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyAttemptsNextCreate>>>
    
    export type AcademyAttemptsNextCreateMutationError = unknown

    export const useAcademyAttemptsNextCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyAttemptsNextCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyAttemptsNextCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getAcademyAttemptsNextCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * IELTS Listening: close the current part (end of its audio, or the learner's choice); the
previous parts can never be changed; the last part closes the section.
 */
export type academyAttemptsPartCreateResponse200 = {
  data: AttemptState
  status: 200
}
    
export type academyAttemptsPartCreateResponseSuccess = (academyAttemptsPartCreateResponse200) & {
  headers: Headers;
};
;

export type academyAttemptsPartCreateResponse = (academyAttemptsPartCreateResponseSuccess)

export const getAcademyAttemptsPartCreateUrl = (id: string,) => {


  

  return `/api/v1/academy/attempts/${id}/part/`
}

export const academyAttemptsPartCreate = async (id: string, options?: RequestInit): Promise<academyAttemptsPartCreateResponse> => {
  
  return apiFetch<academyAttemptsPartCreateResponse>(getAcademyAttemptsPartCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getAcademyAttemptsPartCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyAttemptsPartCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyAttemptsPartCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['academyAttemptsPartCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyAttemptsPartCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  academyAttemptsPartCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyAttemptsPartCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyAttemptsPartCreate>>>
    
    export type AcademyAttemptsPartCreateMutationError = unknown

    export const useAcademyAttemptsPartCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyAttemptsPartCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyAttemptsPartCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getAcademyAttemptsPartCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Signed link to the audio of the Listening part being played (played once).
 */
export type academyAttemptsPassageAudioRetrieveResponse200 = {
  data: PassageAudioLink
  status: 200
}
    
export type academyAttemptsPassageAudioRetrieveResponseSuccess = (academyAttemptsPassageAudioRetrieveResponse200) & {
  headers: Headers;
};
;

export type academyAttemptsPassageAudioRetrieveResponse = (academyAttemptsPassageAudioRetrieveResponseSuccess)

export const getAcademyAttemptsPassageAudioRetrieveUrl = (id: string,
    passageId: string,) => {


  

  return `/api/v1/academy/attempts/${id}/passage-audio/${passageId}/`
}

export const academyAttemptsPassageAudioRetrieve = async (id: string,
    passageId: string, options?: RequestInit): Promise<academyAttemptsPassageAudioRetrieveResponse> => {
  
  return apiFetch<academyAttemptsPassageAudioRetrieveResponse>(getAcademyAttemptsPassageAudioRetrieveUrl(id,passageId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyAttemptsPassageAudioRetrieveQueryKey = (id?: string,
    passageId?: string,) => {
    return [
    `/api/v1/academy/attempts/${id}/passage-audio/${passageId}/`
    ] as const;
    }

    
export const getAcademyAttemptsPassageAudioRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academyAttemptsPassageAudioRetrieve>>, TError = unknown>(id: string,
    passageId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyAttemptsPassageAudioRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyAttemptsPassageAudioRetrieveQueryKey(id,passageId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyAttemptsPassageAudioRetrieve>>> = ({ signal }) => academyAttemptsPassageAudioRetrieve(id,passageId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id && passageId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyAttemptsPassageAudioRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyAttemptsPassageAudioRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academyAttemptsPassageAudioRetrieve>>>
export type AcademyAttemptsPassageAudioRetrieveQueryError = unknown


export function useAcademyAttemptsPassageAudioRetrieve<TData = Awaited<ReturnType<typeof academyAttemptsPassageAudioRetrieve>>, TError = unknown>(
 id: string,
    passageId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyAttemptsPassageAudioRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyAttemptsPassageAudioRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyAttemptsPassageAudioRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyAttemptsPassageAudioRetrieve<TData = Awaited<ReturnType<typeof academyAttemptsPassageAudioRetrieve>>, TError = unknown>(
 id: string,
    passageId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyAttemptsPassageAudioRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyAttemptsPassageAudioRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyAttemptsPassageAudioRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyAttemptsPassageAudioRetrieve<TData = Awaited<ReturnType<typeof academyAttemptsPassageAudioRetrieve>>, TError = unknown>(
 id: string,
    passageId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyAttemptsPassageAudioRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyAttemptsPassageAudioRetrieve<TData = Awaited<ReturnType<typeof academyAttemptsPassageAudioRetrieve>>, TError = unknown>(
 id: string,
    passageId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyAttemptsPassageAudioRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyAttemptsPassageAudioRetrieveQueryOptions(id,passageId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * The signed-in learner only: never an agency member's tools.
 */
export type academyAttemptsRecordingCreateResponse200 = {
  data: Recorded
  status: 200
}
    
export type academyAttemptsRecordingCreateResponseSuccess = (academyAttemptsRecordingCreateResponse200) & {
  headers: Headers;
};
;

export type academyAttemptsRecordingCreateResponse = (academyAttemptsRecordingCreateResponseSuccess)

export const getAcademyAttemptsRecordingCreateUrl = (id: string,) => {


  

  return `/api/v1/academy/attempts/${id}/recording/`
}

export const academyAttemptsRecordingCreate = async (id: string,
    recordingRequest: RecordingRequest, options?: RequestInit): Promise<academyAttemptsRecordingCreateResponse> => {
    const formData = new FormData();
formData.append(`task`, recordingRequest.task)
formData.append(`audio`, recordingRequest.audio)

  return apiFetch<academyAttemptsRecordingCreateResponse>(getAcademyAttemptsRecordingCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    ,
    body: 
      formData,
  }
);}




export const getAcademyAttemptsRecordingCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyAttemptsRecordingCreate>>, TError,{id: string;data: RecordingRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyAttemptsRecordingCreate>>, TError,{id: string;data: RecordingRequest}, TContext> => {

const mutationKey = ['academyAttemptsRecordingCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyAttemptsRecordingCreate>>, {id: string;data: RecordingRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  academyAttemptsRecordingCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyAttemptsRecordingCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyAttemptsRecordingCreate>>>
    export type AcademyAttemptsRecordingCreateMutationBody = RecordingRequest
    export type AcademyAttemptsRecordingCreateMutationError = unknown

    export const useAcademyAttemptsRecordingCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyAttemptsRecordingCreate>>, TError,{id: string;data: RecordingRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyAttemptsRecordingCreate>>,
        TError,
        {id: string;data: RecordingRequest},
        TContext
      > => {

      const mutationOptions = getAcademyAttemptsRecordingCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * D-175: opens the one redo of an inaudible recording: the task and its official time.
 */
export type academyAttemptsRedoCreateResponse200 = {
  data: RedoTask
  status: 200
}
    
export type academyAttemptsRedoCreateResponseSuccess = (academyAttemptsRedoCreateResponse200) & {
  headers: Headers;
};
;

export type academyAttemptsRedoCreateResponse = (academyAttemptsRedoCreateResponseSuccess)

export const getAcademyAttemptsRedoCreateUrl = (id: string,) => {


  

  return `/api/v1/academy/attempts/${id}/redo/`
}

export const academyAttemptsRedoCreate = async (id: string,
    redoRequest: RedoRequest, options?: RequestInit): Promise<academyAttemptsRedoCreateResponse> => {
  
  return apiFetch<academyAttemptsRedoCreateResponse>(getAcademyAttemptsRedoCreateUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      redoRequest,)
  }
);}




export const getAcademyAttemptsRedoCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyAttemptsRedoCreate>>, TError,{id: string;data: RedoRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyAttemptsRedoCreate>>, TError,{id: string;data: RedoRequest}, TContext> => {

const mutationKey = ['academyAttemptsRedoCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyAttemptsRedoCreate>>, {id: string;data: RedoRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  academyAttemptsRedoCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyAttemptsRedoCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyAttemptsRedoCreate>>>
    export type AcademyAttemptsRedoCreateMutationBody = RedoRequest
    export type AcademyAttemptsRedoCreateMutationError = unknown

    export const useAcademyAttemptsRedoCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyAttemptsRedoCreate>>, TError,{id: string;data: RedoRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyAttemptsRedoCreate>>,
        TError,
        {id: string;data: RedoRequest},
        TContext
      > => {

      const mutationOptions = getAcademyAttemptsRedoCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * D-175: the new recording; the correction runs and the results are computed again.
 */
export type academyAttemptsRedoRecordingCreateResponse200 = {
  data: Redone
  status: 200
}
    
export type academyAttemptsRedoRecordingCreateResponseSuccess = (academyAttemptsRedoRecordingCreateResponse200) & {
  headers: Headers;
};
;

export type academyAttemptsRedoRecordingCreateResponse = (academyAttemptsRedoRecordingCreateResponseSuccess)

export const getAcademyAttemptsRedoRecordingCreateUrl = (id: string,) => {


  

  return `/api/v1/academy/attempts/${id}/redo/recording/`
}

export const academyAttemptsRedoRecordingCreate = async (id: string,
    redoRecordingRequest: RedoRecordingRequest, options?: RequestInit): Promise<academyAttemptsRedoRecordingCreateResponse> => {
    const formData = new FormData();
formData.append(`production`, redoRecordingRequest.production)
if(redoRecordingRequest.audio !== undefined) {
 formData.append(`audio`, redoRecordingRequest.audio)
 }

  return apiFetch<academyAttemptsRedoRecordingCreateResponse>(getAcademyAttemptsRedoRecordingCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    ,
    body: 
      formData,
  }
);}




export const getAcademyAttemptsRedoRecordingCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyAttemptsRedoRecordingCreate>>, TError,{id: string;data: RedoRecordingRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyAttemptsRedoRecordingCreate>>, TError,{id: string;data: RedoRecordingRequest}, TContext> => {

const mutationKey = ['academyAttemptsRedoRecordingCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyAttemptsRedoRecordingCreate>>, {id: string;data: RedoRecordingRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  academyAttemptsRedoRecordingCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyAttemptsRedoRecordingCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyAttemptsRedoRecordingCreate>>>
    export type AcademyAttemptsRedoRecordingCreateMutationBody = RedoRecordingRequest
    export type AcademyAttemptsRedoRecordingCreateMutationError = unknown

    export const useAcademyAttemptsRedoRecordingCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyAttemptsRedoRecordingCreate>>, TError,{id: string;data: RedoRecordingRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyAttemptsRedoRecordingCreate>>,
        TError,
        {id: string;data: RedoRecordingRequest},
        TContext
      > => {

      const mutationOptions = getAcademyAttemptsRedoRecordingCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * D-179: the live examiner of a redo, under the limits of the exam, without an oral credit.
 */
export type academyAttemptsRedoTurnCreateResponse200 = {
  data: RedoTurnReply
  status: 200
}
    
export type academyAttemptsRedoTurnCreateResponseSuccess = (academyAttemptsRedoTurnCreateResponse200) & {
  headers: Headers;
};
;

export type academyAttemptsRedoTurnCreateResponse = (academyAttemptsRedoTurnCreateResponseSuccess)

export const getAcademyAttemptsRedoTurnCreateUrl = (id: string,) => {


  

  return `/api/v1/academy/attempts/${id}/redo/turn/`
}

export const academyAttemptsRedoTurnCreate = async (id: string,
    redoTurnRequest: RedoTurnRequest, options?: RequestInit): Promise<academyAttemptsRedoTurnCreateResponse> => {
    const formData = new FormData();
formData.append(`production`, redoTurnRequest.production)
if(redoTurnRequest.audio !== undefined) {
 formData.append(`audio`, redoTurnRequest.audio)
 }
if(redoTurnRequest.offset !== undefined) {
 formData.append(`offset`, redoTurnRequest.offset.toString())
 }
if(redoTurnRequest.keep !== undefined) {
 formData.append(`keep`, redoTurnRequest.keep.toString())
 }

  return apiFetch<academyAttemptsRedoTurnCreateResponse>(getAcademyAttemptsRedoTurnCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    ,
    body: 
      formData,
  }
);}




export const getAcademyAttemptsRedoTurnCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyAttemptsRedoTurnCreate>>, TError,{id: string;data: RedoTurnRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyAttemptsRedoTurnCreate>>, TError,{id: string;data: RedoTurnRequest}, TContext> => {

const mutationKey = ['academyAttemptsRedoTurnCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyAttemptsRedoTurnCreate>>, {id: string;data: RedoTurnRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  academyAttemptsRedoTurnCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyAttemptsRedoTurnCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyAttemptsRedoTurnCreate>>>
    export type AcademyAttemptsRedoTurnCreateMutationBody = RedoTurnRequest
    export type AcademyAttemptsRedoTurnCreateMutationError = unknown

    export const useAcademyAttemptsRedoTurnCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyAttemptsRedoTurnCreate>>, TError,{id: string;data: RedoTurnRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyAttemptsRedoTurnCreate>>,
        TError,
        {id: string;data: RedoTurnRequest},
        TContext
      > => {

      const mutationOptions = getAcademyAttemptsRedoTurnCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * After the end: every question with the right answer and its explanation (P3B-09).
 */
export type academyAttemptsReviewRetrieveResponse200 = {
  data: AttemptReview
  status: 200
}
    
export type academyAttemptsReviewRetrieveResponseSuccess = (academyAttemptsReviewRetrieveResponse200) & {
  headers: Headers;
};
;

export type academyAttemptsReviewRetrieveResponse = (academyAttemptsReviewRetrieveResponseSuccess)

export const getAcademyAttemptsReviewRetrieveUrl = (id: string,) => {


  

  return `/api/v1/academy/attempts/${id}/review/`
}

export const academyAttemptsReviewRetrieve = async (id: string, options?: RequestInit): Promise<academyAttemptsReviewRetrieveResponse> => {
  
  return apiFetch<academyAttemptsReviewRetrieveResponse>(getAcademyAttemptsReviewRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyAttemptsReviewRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/academy/attempts/${id}/review/`
    ] as const;
    }

    
export const getAcademyAttemptsReviewRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academyAttemptsReviewRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyAttemptsReviewRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyAttemptsReviewRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyAttemptsReviewRetrieve>>> = ({ signal }) => academyAttemptsReviewRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyAttemptsReviewRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyAttemptsReviewRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academyAttemptsReviewRetrieve>>>
export type AcademyAttemptsReviewRetrieveQueryError = unknown


export function useAcademyAttemptsReviewRetrieve<TData = Awaited<ReturnType<typeof academyAttemptsReviewRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyAttemptsReviewRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyAttemptsReviewRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyAttemptsReviewRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyAttemptsReviewRetrieve<TData = Awaited<ReturnType<typeof academyAttemptsReviewRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyAttemptsReviewRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyAttemptsReviewRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyAttemptsReviewRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyAttemptsReviewRetrieve<TData = Awaited<ReturnType<typeof academyAttemptsReviewRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyAttemptsReviewRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyAttemptsReviewRetrieve<TData = Awaited<ReturnType<typeof academyAttemptsReviewRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyAttemptsReviewRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyAttemptsReviewRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * IELTS Speaking or TEF Canada oral expression with the live examiner: without audio, the
examiner opens the part (IELTS Part 1 question, Part 2 cue card and minute of preparation,
Part 3 discussion; TEF section A phone call, section B friend who never agrees); with the
audio of a turn, the examiner answers (English for the IELTS, French for the TEF).
 */
export type academyAttemptsSpeakingCreateResponse200 = {
  data: SpeakingReply
  status: 200
}
    
export type academyAttemptsSpeakingCreateResponseSuccess = (academyAttemptsSpeakingCreateResponse200) & {
  headers: Headers;
};
;

export type academyAttemptsSpeakingCreateResponse = (academyAttemptsSpeakingCreateResponseSuccess)

export const getAcademyAttemptsSpeakingCreateUrl = (id: string,) => {


  

  return `/api/v1/academy/attempts/${id}/speaking/`
}

export const academyAttemptsSpeakingCreate = async (id: string,
    speakingTurnRequest: SpeakingTurnRequest, options?: RequestInit): Promise<academyAttemptsSpeakingCreateResponse> => {
    const formData = new FormData();
formData.append(`task`, speakingTurnRequest.task)
if(speakingTurnRequest.audio !== undefined) {
 formData.append(`audio`, speakingTurnRequest.audio)
 }
if(speakingTurnRequest.offset !== undefined) {
 formData.append(`offset`, speakingTurnRequest.offset.toString())
 }
if(speakingTurnRequest.keep !== undefined) {
 formData.append(`keep`, speakingTurnRequest.keep.toString())
 }
if(speakingTurnRequest.topic !== undefined) {
 formData.append(`topic`, speakingTurnRequest.topic.toString())
 }
if(speakingTurnRequest.side !== undefined) {
 formData.append(`side`, speakingTurnRequest.side)
 }

  return apiFetch<academyAttemptsSpeakingCreateResponse>(getAcademyAttemptsSpeakingCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    ,
    body: 
      formData,
  }
);}




export const getAcademyAttemptsSpeakingCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyAttemptsSpeakingCreate>>, TError,{id: string;data: SpeakingTurnRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyAttemptsSpeakingCreate>>, TError,{id: string;data: SpeakingTurnRequest}, TContext> => {

const mutationKey = ['academyAttemptsSpeakingCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyAttemptsSpeakingCreate>>, {id: string;data: SpeakingTurnRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  academyAttemptsSpeakingCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyAttemptsSpeakingCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyAttemptsSpeakingCreate>>>
    export type AcademyAttemptsSpeakingCreateMutationBody = SpeakingTurnRequest
    export type AcademyAttemptsSpeakingCreateMutationError = unknown

    export const useAcademyAttemptsSpeakingCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyAttemptsSpeakingCreate>>, TError,{id: string;data: SpeakingTurnRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyAttemptsSpeakingCreate>>,
        TError,
        {id: string;data: SpeakingTurnRequest},
        TContext
      > => {

      const mutationOptions = getAcademyAttemptsSpeakingCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * EE: saved as the learner types (draft), then submitted.
 */
export type academyAttemptsTextCreateResponse200 = {
  data: Saved
  status: 200
}
    
export type academyAttemptsTextCreateResponseSuccess = (academyAttemptsTextCreateResponse200) & {
  headers: Headers;
};
;

export type academyAttemptsTextCreateResponse = (academyAttemptsTextCreateResponseSuccess)

export const getAcademyAttemptsTextCreateUrl = (id: string,) => {


  

  return `/api/v1/academy/attempts/${id}/text/`
}

export const academyAttemptsTextCreate = async (id: string,
    textRequest: TextRequest, options?: RequestInit): Promise<academyAttemptsTextCreateResponse> => {
  
  return apiFetch<academyAttemptsTextCreateResponse>(getAcademyAttemptsTextCreateUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      textRequest,)
  }
);}




export const getAcademyAttemptsTextCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyAttemptsTextCreate>>, TError,{id: string;data: TextRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyAttemptsTextCreate>>, TError,{id: string;data: TextRequest}, TContext> => {

const mutationKey = ['academyAttemptsTextCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyAttemptsTextCreate>>, {id: string;data: TextRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  academyAttemptsTextCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyAttemptsTextCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyAttemptsTextCreate>>>
    export type AcademyAttemptsTextCreateMutationBody = TextRequest
    export type AcademyAttemptsTextCreateMutationError = unknown

    export const useAcademyAttemptsTextCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyAttemptsTextCreate>>, TError,{id: string;data: TextRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyAttemptsTextCreate>>,
        TError,
        {id: string;data: TextRequest},
        TContext
      > => {

      const mutationOptions = getAcademyAttemptsTextCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * « Demander la revue d'un formateur » on the written or spoken work of a finished sitting
(D-124): included requests left, each production's mark and its request, if any.
 */
export type academyAttemptsTrainerReviewRetrieveResponse200 = {
  data: AttemptReviewRequests
  status: 200
}
    
export type academyAttemptsTrainerReviewRetrieveResponseSuccess = (academyAttemptsTrainerReviewRetrieveResponse200) & {
  headers: Headers;
};
;

export type academyAttemptsTrainerReviewRetrieveResponse = (academyAttemptsTrainerReviewRetrieveResponseSuccess)

export const getAcademyAttemptsTrainerReviewRetrieveUrl = (id: string,) => {


  

  return `/api/v1/academy/attempts/${id}/trainer-review/`
}

export const academyAttemptsTrainerReviewRetrieve = async (id: string, options?: RequestInit): Promise<academyAttemptsTrainerReviewRetrieveResponse> => {
  
  return apiFetch<academyAttemptsTrainerReviewRetrieveResponse>(getAcademyAttemptsTrainerReviewRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyAttemptsTrainerReviewRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/academy/attempts/${id}/trainer-review/`
    ] as const;
    }

    
export const getAcademyAttemptsTrainerReviewRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academyAttemptsTrainerReviewRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyAttemptsTrainerReviewRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyAttemptsTrainerReviewRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyAttemptsTrainerReviewRetrieve>>> = ({ signal }) => academyAttemptsTrainerReviewRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyAttemptsTrainerReviewRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyAttemptsTrainerReviewRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academyAttemptsTrainerReviewRetrieve>>>
export type AcademyAttemptsTrainerReviewRetrieveQueryError = unknown


export function useAcademyAttemptsTrainerReviewRetrieve<TData = Awaited<ReturnType<typeof academyAttemptsTrainerReviewRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyAttemptsTrainerReviewRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyAttemptsTrainerReviewRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyAttemptsTrainerReviewRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyAttemptsTrainerReviewRetrieve<TData = Awaited<ReturnType<typeof academyAttemptsTrainerReviewRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyAttemptsTrainerReviewRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyAttemptsTrainerReviewRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyAttemptsTrainerReviewRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyAttemptsTrainerReviewRetrieve<TData = Awaited<ReturnType<typeof academyAttemptsTrainerReviewRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyAttemptsTrainerReviewRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyAttemptsTrainerReviewRetrieve<TData = Awaited<ReturnType<typeof academyAttemptsTrainerReviewRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyAttemptsTrainerReviewRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyAttemptsTrainerReviewRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * « Demander la revue d'un formateur » on the written or spoken work of a finished sitting
(D-124): included requests left, each production's mark and its request, if any.
 */
export type academyAttemptsTrainerReviewCreateResponse201 = {
  data: AttemptReviewRequests
  status: 201
}
    
export type academyAttemptsTrainerReviewCreateResponseSuccess = (academyAttemptsTrainerReviewCreateResponse201) & {
  headers: Headers;
};
;

export type academyAttemptsTrainerReviewCreateResponse = (academyAttemptsTrainerReviewCreateResponseSuccess)

export const getAcademyAttemptsTrainerReviewCreateUrl = (id: string,) => {


  

  return `/api/v1/academy/attempts/${id}/trainer-review/`
}

export const academyAttemptsTrainerReviewCreate = async (id: string,
    reviewRequestCreateRequest: ReviewRequestCreateRequest, options?: RequestInit): Promise<academyAttemptsTrainerReviewCreateResponse> => {
  
  return apiFetch<academyAttemptsTrainerReviewCreateResponse>(getAcademyAttemptsTrainerReviewCreateUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      reviewRequestCreateRequest,)
  }
);}




export const getAcademyAttemptsTrainerReviewCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyAttemptsTrainerReviewCreate>>, TError,{id: string;data: ReviewRequestCreateRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyAttemptsTrainerReviewCreate>>, TError,{id: string;data: ReviewRequestCreateRequest}, TContext> => {

const mutationKey = ['academyAttemptsTrainerReviewCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyAttemptsTrainerReviewCreate>>, {id: string;data: ReviewRequestCreateRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  academyAttemptsTrainerReviewCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyAttemptsTrainerReviewCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyAttemptsTrainerReviewCreate>>>
    export type AcademyAttemptsTrainerReviewCreateMutationBody = ReviewRequestCreateRequest
    export type AcademyAttemptsTrainerReviewCreateMutationError = unknown

    export const useAcademyAttemptsTrainerReviewCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyAttemptsTrainerReviewCreate>>, TError,{id: string;data: ReviewRequestCreateRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyAttemptsTrainerReviewCreate>>,
        TError,
        {id: string;data: ReviewRequestCreateRequest},
        TContext
      > => {

      const mutationOptions = getAcademyAttemptsTrainerReviewCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * AI marks against the trainers' re-grading, for EE and EO (the agency's copies only).
 */
export type academyCalibrationRetrieveResponse200 = {
  data: Calibration
  status: 200
}
    
export type academyCalibrationRetrieveResponseSuccess = (academyCalibrationRetrieveResponse200) & {
  headers: Headers;
};
;

export type academyCalibrationRetrieveResponse = (academyCalibrationRetrieveResponseSuccess)

export const getAcademyCalibrationRetrieveUrl = (params?: AcademyCalibrationRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/calibration/?${stringifiedParams}` : `/api/v1/academy/calibration/`
}

export const academyCalibrationRetrieve = async (params?: AcademyCalibrationRetrieveParams, options?: RequestInit): Promise<academyCalibrationRetrieveResponse> => {
  
  return apiFetch<academyCalibrationRetrieveResponse>(getAcademyCalibrationRetrieveUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyCalibrationRetrieveQueryKey = (params?: AcademyCalibrationRetrieveParams,) => {
    return [
    `/api/v1/academy/calibration/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAcademyCalibrationRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academyCalibrationRetrieve>>, TError = unknown>(params?: AcademyCalibrationRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyCalibrationRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyCalibrationRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyCalibrationRetrieve>>> = ({ signal }) => academyCalibrationRetrieve(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyCalibrationRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyCalibrationRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academyCalibrationRetrieve>>>
export type AcademyCalibrationRetrieveQueryError = unknown


export function useAcademyCalibrationRetrieve<TData = Awaited<ReturnType<typeof academyCalibrationRetrieve>>, TError = unknown>(
 params: undefined |  AcademyCalibrationRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyCalibrationRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyCalibrationRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyCalibrationRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyCalibrationRetrieve<TData = Awaited<ReturnType<typeof academyCalibrationRetrieve>>, TError = unknown>(
 params?: AcademyCalibrationRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyCalibrationRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyCalibrationRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyCalibrationRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyCalibrationRetrieve<TData = Awaited<ReturnType<typeof academyCalibrationRetrieve>>, TError = unknown>(
 params?: AcademyCalibrationRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyCalibrationRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyCalibrationRetrieve<TData = Awaited<ReturnType<typeof academyCalibrationRetrieve>>, TError = unknown>(
 params?: AcademyCalibrationRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyCalibrationRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyCalibrationRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Today's challenge: start (questions appear), submit, leaderboard.
 */
export type academyChallengeRetrieveResponse200 = {
  data: ChallengeView
  status: 200
}
    
export type academyChallengeRetrieveResponseSuccess = (academyChallengeRetrieveResponse200) & {
  headers: Headers;
};
;

export type academyChallengeRetrieveResponse = (academyChallengeRetrieveResponseSuccess)

export const getAcademyChallengeRetrieveUrl = (params?: AcademyChallengeRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/challenge/?${stringifiedParams}` : `/api/v1/academy/challenge/`
}

export const academyChallengeRetrieve = async (params?: AcademyChallengeRetrieveParams, options?: RequestInit): Promise<academyChallengeRetrieveResponse> => {
  
  return apiFetch<academyChallengeRetrieveResponse>(getAcademyChallengeRetrieveUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyChallengeRetrieveQueryKey = (params?: AcademyChallengeRetrieveParams,) => {
    return [
    `/api/v1/academy/challenge/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAcademyChallengeRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academyChallengeRetrieve>>, TError = unknown>(params?: AcademyChallengeRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyChallengeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyChallengeRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyChallengeRetrieve>>> = ({ signal }) => academyChallengeRetrieve(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyChallengeRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyChallengeRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academyChallengeRetrieve>>>
export type AcademyChallengeRetrieveQueryError = unknown


export function useAcademyChallengeRetrieve<TData = Awaited<ReturnType<typeof academyChallengeRetrieve>>, TError = unknown>(
 params: undefined |  AcademyChallengeRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyChallengeRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyChallengeRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyChallengeRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyChallengeRetrieve<TData = Awaited<ReturnType<typeof academyChallengeRetrieve>>, TError = unknown>(
 params?: AcademyChallengeRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyChallengeRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyChallengeRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyChallengeRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyChallengeRetrieve<TData = Awaited<ReturnType<typeof academyChallengeRetrieve>>, TError = unknown>(
 params?: AcademyChallengeRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyChallengeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyChallengeRetrieve<TData = Awaited<ReturnType<typeof academyChallengeRetrieve>>, TError = unknown>(
 params?: AcademyChallengeRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyChallengeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyChallengeRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Today's challenge: start (questions appear), submit, leaderboard.
 */
export type academyChallengeCreateResponse200 = {
  data: ChallengeView
  status: 200
}
    
export type academyChallengeCreateResponseSuccess = (academyChallengeCreateResponse200) & {
  headers: Headers;
};
;

export type academyChallengeCreateResponse = (academyChallengeCreateResponseSuccess)

export const getAcademyChallengeCreateUrl = () => {


  

  return `/api/v1/academy/challenge/`
}

export const academyChallengeCreate = async (challengeActionRequest: ChallengeActionRequest, options?: RequestInit): Promise<academyChallengeCreateResponse> => {
  
  return apiFetch<academyChallengeCreateResponse>(getAcademyChallengeCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      challengeActionRequest,)
  }
);}




export const getAcademyChallengeCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyChallengeCreate>>, TError,{data: ChallengeActionRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyChallengeCreate>>, TError,{data: ChallengeActionRequest}, TContext> => {

const mutationKey = ['academyChallengeCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyChallengeCreate>>, {data: ChallengeActionRequest}> = (props) => {
          const {data} = props ?? {};

          return  academyChallengeCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyChallengeCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyChallengeCreate>>>
    export type AcademyChallengeCreateMutationBody = ChallengeActionRequest
    export type AcademyChallengeCreateMutationError = unknown

    export const useAcademyChallengeCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyChallengeCreate>>, TError,{data: ChallengeActionRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyChallengeCreate>>,
        TError,
        {data: ChallengeActionRequest},
        TContext
      > => {

      const mutationOptions = getAcademyChallengeCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Invoice + payment request; the answer tells where to send the learner.
 */
export type academyCheckoutCreateResponse201 = {
  data: AcademyCheckout
  status: 201
}

export type academyCheckoutCreateResponse409 = {
  data: AcademyCheckoutFallback
  status: 409
}

export type academyCheckoutCreateResponse503 = {
  data: PaymentUnavailable
  status: 503
}
    
export type academyCheckoutCreateResponseSuccess = (academyCheckoutCreateResponse201) & {
  headers: Headers;
};
export type academyCheckoutCreateResponseError = (academyCheckoutCreateResponse409 | academyCheckoutCreateResponse503) & {
  headers: Headers;
};

export type academyCheckoutCreateResponse = (academyCheckoutCreateResponseSuccess | academyCheckoutCreateResponseError)

export const getAcademyCheckoutCreateUrl = () => {


  

  return `/api/v1/academy/checkout/`
}

export const academyCheckoutCreate = async (checkoutRequest: CheckoutRequest, options?: RequestInit): Promise<academyCheckoutCreateResponse> => {
  
  return apiFetch<academyCheckoutCreateResponse>(getAcademyCheckoutCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      checkoutRequest,)
  }
);}




export const getAcademyCheckoutCreateMutationOptions = <TError = AcademyCheckoutFallback | PaymentUnavailable,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyCheckoutCreate>>, TError,{data: CheckoutRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyCheckoutCreate>>, TError,{data: CheckoutRequest}, TContext> => {

const mutationKey = ['academyCheckoutCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyCheckoutCreate>>, {data: CheckoutRequest}> = (props) => {
          const {data} = props ?? {};

          return  academyCheckoutCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyCheckoutCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyCheckoutCreate>>>
    export type AcademyCheckoutCreateMutationBody = CheckoutRequest
    export type AcademyCheckoutCreateMutationError = AcademyCheckoutFallback | PaymentUnavailable

    export const useAcademyCheckoutCreate = <TError = AcademyCheckoutFallback | PaymentUnavailable,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyCheckoutCreate>>, TError,{data: CheckoutRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyCheckoutCreate>>,
        TError,
        {data: CheckoutRequest},
        TContext
      > => {

      const mutationOptions = getAcademyCheckoutCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type academyCheckoutRetrieveResponse200 = {
  data: AcademyCheckoutState
  status: 200
}
    
export type academyCheckoutRetrieveResponseSuccess = (academyCheckoutRetrieveResponse200) & {
  headers: Headers;
};
;

export type academyCheckoutRetrieveResponse = (academyCheckoutRetrieveResponseSuccess)

export const getAcademyCheckoutRetrieveUrl = (id: string,) => {


  

  return `/api/v1/academy/checkout/${id}/`
}

export const academyCheckoutRetrieve = async (id: string, options?: RequestInit): Promise<academyCheckoutRetrieveResponse> => {
  
  return apiFetch<academyCheckoutRetrieveResponse>(getAcademyCheckoutRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyCheckoutRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/academy/checkout/${id}/`
    ] as const;
    }

    
export const getAcademyCheckoutRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academyCheckoutRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyCheckoutRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyCheckoutRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyCheckoutRetrieve>>> = ({ signal }) => academyCheckoutRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyCheckoutRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyCheckoutRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academyCheckoutRetrieve>>>
export type AcademyCheckoutRetrieveQueryError = unknown


export function useAcademyCheckoutRetrieve<TData = Awaited<ReturnType<typeof academyCheckoutRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyCheckoutRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyCheckoutRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyCheckoutRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyCheckoutRetrieve<TData = Awaited<ReturnType<typeof academyCheckoutRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyCheckoutRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyCheckoutRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyCheckoutRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyCheckoutRetrieve<TData = Awaited<ReturnType<typeof academyCheckoutRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyCheckoutRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyCheckoutRetrieve<TData = Awaited<ReturnType<typeof academyCheckoutRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyCheckoutRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyCheckoutRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Sandbox without keys only: plays the provider's answer (no network, no money).
 */
export type academyCheckoutSimulateCreateResponse202 = {
  data: AcademySimulated
  status: 202
}
    
export type academyCheckoutSimulateCreateResponseSuccess = (academyCheckoutSimulateCreateResponse202) & {
  headers: Headers;
};
;

export type academyCheckoutSimulateCreateResponse = (academyCheckoutSimulateCreateResponseSuccess)

export const getAcademyCheckoutSimulateCreateUrl = (id: string,) => {


  

  return `/api/v1/academy/checkout/${id}/simulate/`
}

export const academyCheckoutSimulateCreate = async (id: string,
    checkoutSimulateRequest: CheckoutSimulateRequest, options?: RequestInit): Promise<academyCheckoutSimulateCreateResponse> => {
  
  return apiFetch<academyCheckoutSimulateCreateResponse>(getAcademyCheckoutSimulateCreateUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      checkoutSimulateRequest,)
  }
);}




export const getAcademyCheckoutSimulateCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyCheckoutSimulateCreate>>, TError,{id: string;data: CheckoutSimulateRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyCheckoutSimulateCreate>>, TError,{id: string;data: CheckoutSimulateRequest}, TContext> => {

const mutationKey = ['academyCheckoutSimulateCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyCheckoutSimulateCreate>>, {id: string;data: CheckoutSimulateRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  academyCheckoutSimulateCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyCheckoutSimulateCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyCheckoutSimulateCreate>>>
    export type AcademyCheckoutSimulateCreateMutationBody = CheckoutSimulateRequest
    export type AcademyCheckoutSimulateCreateMutationError = unknown

    export const useAcademyCheckoutSimulateCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyCheckoutSimulateCreate>>, TError,{id: string;data: CheckoutSimulateRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyCheckoutSimulateCreate>>,
        TError,
        {id: string;data: CheckoutSimulateRequest},
        TContext
      > => {

      const mutationOptions = getAcademyCheckoutSimulateCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * D-132: « tell me by e-mail when online payment works again » (usual provider in
maintenance and no fallback for the learner's country).
 */
export type academyCheckoutNotifyRestoredCreateResponse201 = {
  data: PaymentRestoreAlertCreated
  status: 201
}
    
export type academyCheckoutNotifyRestoredCreateResponseSuccess = (academyCheckoutNotifyRestoredCreateResponse201) & {
  headers: Headers;
};
;

export type academyCheckoutNotifyRestoredCreateResponse = (academyCheckoutNotifyRestoredCreateResponseSuccess)

export const getAcademyCheckoutNotifyRestoredCreateUrl = () => {


  

  return `/api/v1/academy/checkout/notify-restored/`
}

export const academyCheckoutNotifyRestoredCreate = async (restoreAlertRequest: RestoreAlertRequest, options?: RequestInit): Promise<academyCheckoutNotifyRestoredCreateResponse> => {
  
  return apiFetch<academyCheckoutNotifyRestoredCreateResponse>(getAcademyCheckoutNotifyRestoredCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      restoreAlertRequest,)
  }
);}




export const getAcademyCheckoutNotifyRestoredCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyCheckoutNotifyRestoredCreate>>, TError,{data: RestoreAlertRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyCheckoutNotifyRestoredCreate>>, TError,{data: RestoreAlertRequest}, TContext> => {

const mutationKey = ['academyCheckoutNotifyRestoredCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyCheckoutNotifyRestoredCreate>>, {data: RestoreAlertRequest}> = (props) => {
          const {data} = props ?? {};

          return  academyCheckoutNotifyRestoredCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyCheckoutNotifyRestoredCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyCheckoutNotifyRestoredCreate>>>
    export type AcademyCheckoutNotifyRestoredCreateMutationBody = RestoreAlertRequest
    export type AcademyCheckoutNotifyRestoredCreateMutationError = unknown

    export const useAcademyCheckoutNotifyRestoredCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyCheckoutNotifyRestoredCreate>>, TError,{data: RestoreAlertRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyCheckoutNotifyRestoredCreate>>,
        TError,
        {data: RestoreAlertRequest},
        TContext
      > => {

      const mutationOptions = getAcademyCheckoutNotifyRestoredCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type academyCheckoutQuoteCreateResponse200 = {
  data: AcademyQuote
  status: 200
}
    
export type academyCheckoutQuoteCreateResponseSuccess = (academyCheckoutQuoteCreateResponse200) & {
  headers: Headers;
};
;

export type academyCheckoutQuoteCreateResponse = (academyCheckoutQuoteCreateResponseSuccess)

export const getAcademyCheckoutQuoteCreateUrl = () => {


  

  return `/api/v1/academy/checkout/quote/`
}

export const academyCheckoutQuoteCreate = async (quoteRequest: QuoteRequest, options?: RequestInit): Promise<academyCheckoutQuoteCreateResponse> => {
  
  return apiFetch<academyCheckoutQuoteCreateResponse>(getAcademyCheckoutQuoteCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      quoteRequest,)
  }
);}




export const getAcademyCheckoutQuoteCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyCheckoutQuoteCreate>>, TError,{data: QuoteRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyCheckoutQuoteCreate>>, TError,{data: QuoteRequest}, TContext> => {

const mutationKey = ['academyCheckoutQuoteCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyCheckoutQuoteCreate>>, {data: QuoteRequest}> = (props) => {
          const {data} = props ?? {};

          return  academyCheckoutQuoteCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyCheckoutQuoteCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyCheckoutQuoteCreate>>>
    export type AcademyCheckoutQuoteCreateMutationBody = QuoteRequest
    export type AcademyCheckoutQuoteCreateMutationError = unknown

    export const useAcademyCheckoutQuoteCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyCheckoutQuoteCreate>>, TError,{data: QuoteRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyCheckoutQuoteCreate>>,
        TError,
        {data: QuoteRequest},
        TContext
      > => {

      const mutationOptions = getAcademyCheckoutQuoteCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * The learner's course (levels, units, lessons locked / unlocked / completed).
 */
export type academyCourseRetrieveResponse200 = {
  data: CoursePath
  status: 200
}
    
export type academyCourseRetrieveResponseSuccess = (academyCourseRetrieveResponse200) & {
  headers: Headers;
};
;

export type academyCourseRetrieveResponse = (academyCourseRetrieveResponseSuccess)

export const getAcademyCourseRetrieveUrl = (params?: AcademyCourseRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/course/?${stringifiedParams}` : `/api/v1/academy/course/`
}

export const academyCourseRetrieve = async (params?: AcademyCourseRetrieveParams, options?: RequestInit): Promise<academyCourseRetrieveResponse> => {
  
  return apiFetch<academyCourseRetrieveResponse>(getAcademyCourseRetrieveUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyCourseRetrieveQueryKey = (params?: AcademyCourseRetrieveParams,) => {
    return [
    `/api/v1/academy/course/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAcademyCourseRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academyCourseRetrieve>>, TError = unknown>(params?: AcademyCourseRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyCourseRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyCourseRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyCourseRetrieve>>> = ({ signal }) => academyCourseRetrieve(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyCourseRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyCourseRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academyCourseRetrieve>>>
export type AcademyCourseRetrieveQueryError = unknown


export function useAcademyCourseRetrieve<TData = Awaited<ReturnType<typeof academyCourseRetrieve>>, TError = unknown>(
 params: undefined |  AcademyCourseRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyCourseRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyCourseRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyCourseRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyCourseRetrieve<TData = Awaited<ReturnType<typeof academyCourseRetrieve>>, TError = unknown>(
 params?: AcademyCourseRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyCourseRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyCourseRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyCourseRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyCourseRetrieve<TData = Awaited<ReturnType<typeof academyCourseRetrieve>>, TError = unknown>(
 params?: AcademyCourseRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyCourseRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyCourseRetrieve<TData = Awaited<ReturnType<typeof academyCourseRetrieve>>, TError = unknown>(
 params?: AcademyCourseRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyCourseRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyCourseRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * « write » and « speak » answers of the course; a trainer marks those the AI could not.
 */
export type academyCourseProductionsListResponse200 = {
  data: PaginatedCourseProductionList
  status: 200
}
    
export type academyCourseProductionsListResponseSuccess = (academyCourseProductionsListResponse200) & {
  headers: Headers;
};
;

export type academyCourseProductionsListResponse = (academyCourseProductionsListResponseSuccess)

export const getAcademyCourseProductionsListUrl = (params?: AcademyCourseProductionsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/course-productions/?${stringifiedParams}` : `/api/v1/academy/course-productions/`
}

export const academyCourseProductionsList = async (params?: AcademyCourseProductionsListParams, options?: RequestInit): Promise<academyCourseProductionsListResponse> => {
  
  return apiFetch<academyCourseProductionsListResponse>(getAcademyCourseProductionsListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyCourseProductionsListQueryKey = (params?: AcademyCourseProductionsListParams,) => {
    return [
    `/api/v1/academy/course-productions/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAcademyCourseProductionsListQueryOptions = <TData = Awaited<ReturnType<typeof academyCourseProductionsList>>, TError = unknown>(params?: AcademyCourseProductionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyCourseProductionsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyCourseProductionsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyCourseProductionsList>>> = ({ signal }) => academyCourseProductionsList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyCourseProductionsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyCourseProductionsListQueryResult = NonNullable<Awaited<ReturnType<typeof academyCourseProductionsList>>>
export type AcademyCourseProductionsListQueryError = unknown


export function useAcademyCourseProductionsList<TData = Awaited<ReturnType<typeof academyCourseProductionsList>>, TError = unknown>(
 params: undefined |  AcademyCourseProductionsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyCourseProductionsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyCourseProductionsList>>,
          TError,
          Awaited<ReturnType<typeof academyCourseProductionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyCourseProductionsList<TData = Awaited<ReturnType<typeof academyCourseProductionsList>>, TError = unknown>(
 params?: AcademyCourseProductionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyCourseProductionsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyCourseProductionsList>>,
          TError,
          Awaited<ReturnType<typeof academyCourseProductionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyCourseProductionsList<TData = Awaited<ReturnType<typeof academyCourseProductionsList>>, TError = unknown>(
 params?: AcademyCourseProductionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyCourseProductionsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyCourseProductionsList<TData = Awaited<ReturnType<typeof academyCourseProductionsList>>, TError = unknown>(
 params?: AcademyCourseProductionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyCourseProductionsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyCourseProductionsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * « write » and « speak » answers of the course; a trainer marks those the AI could not.
 */
export type academyCourseProductionsRetrieveResponse200 = {
  data: CourseProduction
  status: 200
}
    
export type academyCourseProductionsRetrieveResponseSuccess = (academyCourseProductionsRetrieveResponse200) & {
  headers: Headers;
};
;

export type academyCourseProductionsRetrieveResponse = (academyCourseProductionsRetrieveResponseSuccess)

export const getAcademyCourseProductionsRetrieveUrl = (id: string,) => {


  

  return `/api/v1/academy/course-productions/${id}/`
}

export const academyCourseProductionsRetrieve = async (id: string, options?: RequestInit): Promise<academyCourseProductionsRetrieveResponse> => {
  
  return apiFetch<academyCourseProductionsRetrieveResponse>(getAcademyCourseProductionsRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyCourseProductionsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/academy/course-productions/${id}/`
    ] as const;
    }

    
export const getAcademyCourseProductionsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academyCourseProductionsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyCourseProductionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyCourseProductionsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyCourseProductionsRetrieve>>> = ({ signal }) => academyCourseProductionsRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyCourseProductionsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyCourseProductionsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academyCourseProductionsRetrieve>>>
export type AcademyCourseProductionsRetrieveQueryError = unknown


export function useAcademyCourseProductionsRetrieve<TData = Awaited<ReturnType<typeof academyCourseProductionsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyCourseProductionsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyCourseProductionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyCourseProductionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyCourseProductionsRetrieve<TData = Awaited<ReturnType<typeof academyCourseProductionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyCourseProductionsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyCourseProductionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyCourseProductionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyCourseProductionsRetrieve<TData = Awaited<ReturnType<typeof academyCourseProductionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyCourseProductionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyCourseProductionsRetrieve<TData = Awaited<ReturnType<typeof academyCourseProductionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyCourseProductionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyCourseProductionsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * « write » and « speak » answers of the course; a trainer marks those the AI could not.
 */
export type academyCourseProductionsGradeCreateResponse200 = {
  data: CourseProduction
  status: 200
}
    
export type academyCourseProductionsGradeCreateResponseSuccess = (academyCourseProductionsGradeCreateResponse200) & {
  headers: Headers;
};
;

export type academyCourseProductionsGradeCreateResponse = (academyCourseProductionsGradeCreateResponseSuccess)

export const getAcademyCourseProductionsGradeCreateUrl = (id: string,) => {


  

  return `/api/v1/academy/course-productions/${id}/grade/`
}

export const academyCourseProductionsGradeCreate = async (id: string,
    courseGradeRequest: CourseGradeRequest, options?: RequestInit): Promise<academyCourseProductionsGradeCreateResponse> => {
  
  return apiFetch<academyCourseProductionsGradeCreateResponse>(getAcademyCourseProductionsGradeCreateUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      courseGradeRequest,)
  }
);}




export const getAcademyCourseProductionsGradeCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyCourseProductionsGradeCreate>>, TError,{id: string;data: CourseGradeRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyCourseProductionsGradeCreate>>, TError,{id: string;data: CourseGradeRequest}, TContext> => {

const mutationKey = ['academyCourseProductionsGradeCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyCourseProductionsGradeCreate>>, {id: string;data: CourseGradeRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  academyCourseProductionsGradeCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyCourseProductionsGradeCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyCourseProductionsGradeCreate>>>
    export type AcademyCourseProductionsGradeCreateMutationBody = CourseGradeRequest
    export type AcademyCourseProductionsGradeCreateMutationError = unknown

    export const useAcademyCourseProductionsGradeCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyCourseProductionsGradeCreate>>, TError,{id: string;data: CourseGradeRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyCourseProductionsGradeCreate>>,
        TError,
        {id: string;data: CourseGradeRequest},
        TContext
      > => {

      const mutationOptions = getAcademyCourseProductionsGradeCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * D-175: the AI tries again now on work still « en correction ».
 */
export type academyCourseProductionsRetryCreateResponse200 = {
  data: CourseProduction
  status: 200
}
    
export type academyCourseProductionsRetryCreateResponseSuccess = (academyCourseProductionsRetryCreateResponse200) & {
  headers: Headers;
};
;

export type academyCourseProductionsRetryCreateResponse = (academyCourseProductionsRetryCreateResponseSuccess)

export const getAcademyCourseProductionsRetryCreateUrl = (id: string,) => {


  

  return `/api/v1/academy/course-productions/${id}/retry/`
}

export const academyCourseProductionsRetryCreate = async (id: string, options?: RequestInit): Promise<academyCourseProductionsRetryCreateResponse> => {
  
  return apiFetch<academyCourseProductionsRetryCreateResponse>(getAcademyCourseProductionsRetryCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getAcademyCourseProductionsRetryCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyCourseProductionsRetryCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyCourseProductionsRetryCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['academyCourseProductionsRetryCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyCourseProductionsRetryCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  academyCourseProductionsRetryCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyCourseProductionsRetryCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyCourseProductionsRetryCreate>>>
    
    export type AcademyCourseProductionsRetryCreateMutationError = unknown

    export const useAcademyCourseProductionsRetryCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyCourseProductionsRetryCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyCourseProductionsRetryCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getAcademyCourseProductionsRetryCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * A « speak » exercise: the recording is transcribed and marked by the AI (background).
 */
export type academyCourseExercisesRecordingCreateResponse200 = {
  data: ExerciseResult
  status: 200
}
    
export type academyCourseExercisesRecordingCreateResponseSuccess = (academyCourseExercisesRecordingCreateResponse200) & {
  headers: Headers;
};
;

export type academyCourseExercisesRecordingCreateResponse = (academyCourseExercisesRecordingCreateResponseSuccess)

export const getAcademyCourseExercisesRecordingCreateUrl = (id: string,
    params?: AcademyCourseExercisesRecordingCreateParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/course/exercises/${id}/recording/?${stringifiedParams}` : `/api/v1/academy/course/exercises/${id}/recording/`
}

export const academyCourseExercisesRecordingCreate = async (id: string,
    exerciseRecordingRequest: ExerciseRecordingRequest,
    params?: AcademyCourseExercisesRecordingCreateParams, options?: RequestInit): Promise<academyCourseExercisesRecordingCreateResponse> => {
    const formData = new FormData();
formData.append(`audio`, exerciseRecordingRequest.audio)

  return apiFetch<academyCourseExercisesRecordingCreateResponse>(getAcademyCourseExercisesRecordingCreateUrl(id,params),
  {      
    ...options,
    method: 'POST'
    ,
    body: 
      formData,
  }
);}




export const getAcademyCourseExercisesRecordingCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyCourseExercisesRecordingCreate>>, TError,{id: string;data: ExerciseRecordingRequest;params?: AcademyCourseExercisesRecordingCreateParams}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyCourseExercisesRecordingCreate>>, TError,{id: string;data: ExerciseRecordingRequest;params?: AcademyCourseExercisesRecordingCreateParams}, TContext> => {

const mutationKey = ['academyCourseExercisesRecordingCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyCourseExercisesRecordingCreate>>, {id: string;data: ExerciseRecordingRequest;params?: AcademyCourseExercisesRecordingCreateParams}> = (props) => {
          const {id,data,params} = props ?? {};

          return  academyCourseExercisesRecordingCreate(id,data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyCourseExercisesRecordingCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyCourseExercisesRecordingCreate>>>
    export type AcademyCourseExercisesRecordingCreateMutationBody = ExerciseRecordingRequest
    export type AcademyCourseExercisesRecordingCreateMutationError = unknown

    export const useAcademyCourseExercisesRecordingCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyCourseExercisesRecordingCreate>>, TError,{id: string;data: ExerciseRecordingRequest;params?: AcademyCourseExercisesRecordingCreateParams}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyCourseExercisesRecordingCreate>>,
        TError,
        {id: string;data: ExerciseRecordingRequest;params?: AcademyCourseExercisesRecordingCreateParams},
        TContext
      > => {

      const mutationOptions = getAcademyCourseExercisesRecordingCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * The signed-in learner only: never an agency member's tools.
 */
export type academyCourseLessonsRetrieveResponse200 = {
  data: LessonDetail
  status: 200
}
    
export type academyCourseLessonsRetrieveResponseSuccess = (academyCourseLessonsRetrieveResponse200) & {
  headers: Headers;
};
;

export type academyCourseLessonsRetrieveResponse = (academyCourseLessonsRetrieveResponseSuccess)

export const getAcademyCourseLessonsRetrieveUrl = (id: string,
    params?: AcademyCourseLessonsRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/course/lessons/${id}/?${stringifiedParams}` : `/api/v1/academy/course/lessons/${id}/`
}

export const academyCourseLessonsRetrieve = async (id: string,
    params?: AcademyCourseLessonsRetrieveParams, options?: RequestInit): Promise<academyCourseLessonsRetrieveResponse> => {
  
  return apiFetch<academyCourseLessonsRetrieveResponse>(getAcademyCourseLessonsRetrieveUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyCourseLessonsRetrieveQueryKey = (id?: string,
    params?: AcademyCourseLessonsRetrieveParams,) => {
    return [
    `/api/v1/academy/course/lessons/${id}/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAcademyCourseLessonsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academyCourseLessonsRetrieve>>, TError = unknown>(id: string,
    params?: AcademyCourseLessonsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyCourseLessonsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyCourseLessonsRetrieveQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyCourseLessonsRetrieve>>> = ({ signal }) => academyCourseLessonsRetrieve(id,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyCourseLessonsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyCourseLessonsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academyCourseLessonsRetrieve>>>
export type AcademyCourseLessonsRetrieveQueryError = unknown


export function useAcademyCourseLessonsRetrieve<TData = Awaited<ReturnType<typeof academyCourseLessonsRetrieve>>, TError = unknown>(
 id: string,
    params: undefined |  AcademyCourseLessonsRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyCourseLessonsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyCourseLessonsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyCourseLessonsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyCourseLessonsRetrieve<TData = Awaited<ReturnType<typeof academyCourseLessonsRetrieve>>, TError = unknown>(
 id: string,
    params?: AcademyCourseLessonsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyCourseLessonsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyCourseLessonsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyCourseLessonsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyCourseLessonsRetrieve<TData = Awaited<ReturnType<typeof academyCourseLessonsRetrieve>>, TError = unknown>(
 id: string,
    params?: AcademyCourseLessonsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyCourseLessonsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyCourseLessonsRetrieve<TData = Awaited<ReturnType<typeof academyCourseLessonsRetrieve>>, TError = unknown>(
 id: string,
    params?: AcademyCourseLessonsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyCourseLessonsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyCourseLessonsRetrieveQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * One answer: auto-marked at once; a « write » text is marked by the AI in the background.
 */
export type academyCourseLessonsAnswerCreateResponse200 = {
  data: ExerciseResult
  status: 200
}
    
export type academyCourseLessonsAnswerCreateResponseSuccess = (academyCourseLessonsAnswerCreateResponse200) & {
  headers: Headers;
};
;

export type academyCourseLessonsAnswerCreateResponse = (academyCourseLessonsAnswerCreateResponseSuccess)

export const getAcademyCourseLessonsAnswerCreateUrl = (id: string,
    params?: AcademyCourseLessonsAnswerCreateParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/course/lessons/${id}/answer/?${stringifiedParams}` : `/api/v1/academy/course/lessons/${id}/answer/`
}

export const academyCourseLessonsAnswerCreate = async (id: string,
    exerciseAnswerRequest: ExerciseAnswerRequest,
    params?: AcademyCourseLessonsAnswerCreateParams, options?: RequestInit): Promise<academyCourseLessonsAnswerCreateResponse> => {
  
  return apiFetch<academyCourseLessonsAnswerCreateResponse>(getAcademyCourseLessonsAnswerCreateUrl(id,params),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      exerciseAnswerRequest,)
  }
);}




export const getAcademyCourseLessonsAnswerCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyCourseLessonsAnswerCreate>>, TError,{id: string;data: ExerciseAnswerRequest;params?: AcademyCourseLessonsAnswerCreateParams}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyCourseLessonsAnswerCreate>>, TError,{id: string;data: ExerciseAnswerRequest;params?: AcademyCourseLessonsAnswerCreateParams}, TContext> => {

const mutationKey = ['academyCourseLessonsAnswerCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyCourseLessonsAnswerCreate>>, {id: string;data: ExerciseAnswerRequest;params?: AcademyCourseLessonsAnswerCreateParams}> = (props) => {
          const {id,data,params} = props ?? {};

          return  academyCourseLessonsAnswerCreate(id,data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyCourseLessonsAnswerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyCourseLessonsAnswerCreate>>>
    export type AcademyCourseLessonsAnswerCreateMutationBody = ExerciseAnswerRequest
    export type AcademyCourseLessonsAnswerCreateMutationError = unknown

    export const useAcademyCourseLessonsAnswerCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyCourseLessonsAnswerCreate>>, TError,{id: string;data: ExerciseAnswerRequest;params?: AcademyCourseLessonsAnswerCreateParams}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyCourseLessonsAnswerCreate>>,
        TError,
        {id: string;data: ExerciseAnswerRequest;params?: AcademyCourseLessonsAnswerCreateParams},
        TContext
      > => {

      const mutationOptions = getAcademyCourseLessonsAnswerCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * « Listen to the explanation »: the voice (server, device, French/English) and the text;
POST prepares the server's audio when it is not made yet.
 */
export type academyCourseLessonsListenRetrieveResponse200 = {
  data: Listen
  status: 200
}
    
export type academyCourseLessonsListenRetrieveResponseSuccess = (academyCourseLessonsListenRetrieveResponse200) & {
  headers: Headers;
};
;

export type academyCourseLessonsListenRetrieveResponse = (academyCourseLessonsListenRetrieveResponseSuccess)

export const getAcademyCourseLessonsListenRetrieveUrl = (id: string,
    params?: AcademyCourseLessonsListenRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/course/lessons/${id}/listen/?${stringifiedParams}` : `/api/v1/academy/course/lessons/${id}/listen/`
}

export const academyCourseLessonsListenRetrieve = async (id: string,
    params?: AcademyCourseLessonsListenRetrieveParams, options?: RequestInit): Promise<academyCourseLessonsListenRetrieveResponse> => {
  
  return apiFetch<academyCourseLessonsListenRetrieveResponse>(getAcademyCourseLessonsListenRetrieveUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyCourseLessonsListenRetrieveQueryKey = (id?: string,
    params?: AcademyCourseLessonsListenRetrieveParams,) => {
    return [
    `/api/v1/academy/course/lessons/${id}/listen/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAcademyCourseLessonsListenRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academyCourseLessonsListenRetrieve>>, TError = unknown>(id: string,
    params?: AcademyCourseLessonsListenRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyCourseLessonsListenRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyCourseLessonsListenRetrieveQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyCourseLessonsListenRetrieve>>> = ({ signal }) => academyCourseLessonsListenRetrieve(id,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyCourseLessonsListenRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyCourseLessonsListenRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academyCourseLessonsListenRetrieve>>>
export type AcademyCourseLessonsListenRetrieveQueryError = unknown


export function useAcademyCourseLessonsListenRetrieve<TData = Awaited<ReturnType<typeof academyCourseLessonsListenRetrieve>>, TError = unknown>(
 id: string,
    params: undefined |  AcademyCourseLessonsListenRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyCourseLessonsListenRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyCourseLessonsListenRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyCourseLessonsListenRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyCourseLessonsListenRetrieve<TData = Awaited<ReturnType<typeof academyCourseLessonsListenRetrieve>>, TError = unknown>(
 id: string,
    params?: AcademyCourseLessonsListenRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyCourseLessonsListenRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyCourseLessonsListenRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyCourseLessonsListenRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyCourseLessonsListenRetrieve<TData = Awaited<ReturnType<typeof academyCourseLessonsListenRetrieve>>, TError = unknown>(
 id: string,
    params?: AcademyCourseLessonsListenRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyCourseLessonsListenRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyCourseLessonsListenRetrieve<TData = Awaited<ReturnType<typeof academyCourseLessonsListenRetrieve>>, TError = unknown>(
 id: string,
    params?: AcademyCourseLessonsListenRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyCourseLessonsListenRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyCourseLessonsListenRetrieveQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * « Listen to the explanation »: the voice (server, device, French/English) and the text;
POST prepares the server's audio when it is not made yet.
 */
export type academyCourseLessonsListenCreateResponse200 = {
  data: Listen
  status: 200
}
    
export type academyCourseLessonsListenCreateResponseSuccess = (academyCourseLessonsListenCreateResponse200) & {
  headers: Headers;
};
;

export type academyCourseLessonsListenCreateResponse = (academyCourseLessonsListenCreateResponseSuccess)

export const getAcademyCourseLessonsListenCreateUrl = (id: string,
    params?: AcademyCourseLessonsListenCreateParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/course/lessons/${id}/listen/?${stringifiedParams}` : `/api/v1/academy/course/lessons/${id}/listen/`
}

export const academyCourseLessonsListenCreate = async (id: string,
    translationRequestRequest: TranslationRequestRequest,
    params?: AcademyCourseLessonsListenCreateParams, options?: RequestInit): Promise<academyCourseLessonsListenCreateResponse> => {
  
  return apiFetch<academyCourseLessonsListenCreateResponse>(getAcademyCourseLessonsListenCreateUrl(id,params),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      translationRequestRequest,)
  }
);}




export const getAcademyCourseLessonsListenCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyCourseLessonsListenCreate>>, TError,{id: string;data: TranslationRequestRequest;params?: AcademyCourseLessonsListenCreateParams}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyCourseLessonsListenCreate>>, TError,{id: string;data: TranslationRequestRequest;params?: AcademyCourseLessonsListenCreateParams}, TContext> => {

const mutationKey = ['academyCourseLessonsListenCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyCourseLessonsListenCreate>>, {id: string;data: TranslationRequestRequest;params?: AcademyCourseLessonsListenCreateParams}> = (props) => {
          const {id,data,params} = props ?? {};

          return  academyCourseLessonsListenCreate(id,data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyCourseLessonsListenCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyCourseLessonsListenCreate>>>
    export type AcademyCourseLessonsListenCreateMutationBody = TranslationRequestRequest
    export type AcademyCourseLessonsListenCreateMutationError = unknown

    export const useAcademyCourseLessonsListenCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyCourseLessonsListenCreate>>, TError,{id: string;data: TranslationRequestRequest;params?: AcademyCourseLessonsListenCreateParams}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyCourseLessonsListenCreate>>,
        TError,
        {id: string;data: TranslationRequestRequest;params?: AcademyCourseLessonsListenCreateParams},
        TContext
      > => {

      const mutationOptions = getAcademyCourseLessonsListenCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * « Pour vous qui parlez <langue> »: GET reads what is kept, POST asks for it (made once).
 */
export type academyCourseLessonsPitfallsRetrieveResponse200 = {
  data: Pitfalls
  status: 200
}
    
export type academyCourseLessonsPitfallsRetrieveResponseSuccess = (academyCourseLessonsPitfallsRetrieveResponse200) & {
  headers: Headers;
};
;

export type academyCourseLessonsPitfallsRetrieveResponse = (academyCourseLessonsPitfallsRetrieveResponseSuccess)

export const getAcademyCourseLessonsPitfallsRetrieveUrl = (id: string,
    params?: AcademyCourseLessonsPitfallsRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/course/lessons/${id}/pitfalls/?${stringifiedParams}` : `/api/v1/academy/course/lessons/${id}/pitfalls/`
}

export const academyCourseLessonsPitfallsRetrieve = async (id: string,
    params?: AcademyCourseLessonsPitfallsRetrieveParams, options?: RequestInit): Promise<academyCourseLessonsPitfallsRetrieveResponse> => {
  
  return apiFetch<academyCourseLessonsPitfallsRetrieveResponse>(getAcademyCourseLessonsPitfallsRetrieveUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyCourseLessonsPitfallsRetrieveQueryKey = (id?: string,
    params?: AcademyCourseLessonsPitfallsRetrieveParams,) => {
    return [
    `/api/v1/academy/course/lessons/${id}/pitfalls/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAcademyCourseLessonsPitfallsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academyCourseLessonsPitfallsRetrieve>>, TError = unknown>(id: string,
    params?: AcademyCourseLessonsPitfallsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyCourseLessonsPitfallsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyCourseLessonsPitfallsRetrieveQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyCourseLessonsPitfallsRetrieve>>> = ({ signal }) => academyCourseLessonsPitfallsRetrieve(id,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyCourseLessonsPitfallsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyCourseLessonsPitfallsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academyCourseLessonsPitfallsRetrieve>>>
export type AcademyCourseLessonsPitfallsRetrieveQueryError = unknown


export function useAcademyCourseLessonsPitfallsRetrieve<TData = Awaited<ReturnType<typeof academyCourseLessonsPitfallsRetrieve>>, TError = unknown>(
 id: string,
    params: undefined |  AcademyCourseLessonsPitfallsRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyCourseLessonsPitfallsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyCourseLessonsPitfallsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyCourseLessonsPitfallsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyCourseLessonsPitfallsRetrieve<TData = Awaited<ReturnType<typeof academyCourseLessonsPitfallsRetrieve>>, TError = unknown>(
 id: string,
    params?: AcademyCourseLessonsPitfallsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyCourseLessonsPitfallsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyCourseLessonsPitfallsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyCourseLessonsPitfallsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyCourseLessonsPitfallsRetrieve<TData = Awaited<ReturnType<typeof academyCourseLessonsPitfallsRetrieve>>, TError = unknown>(
 id: string,
    params?: AcademyCourseLessonsPitfallsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyCourseLessonsPitfallsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyCourseLessonsPitfallsRetrieve<TData = Awaited<ReturnType<typeof academyCourseLessonsPitfallsRetrieve>>, TError = unknown>(
 id: string,
    params?: AcademyCourseLessonsPitfallsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyCourseLessonsPitfallsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyCourseLessonsPitfallsRetrieveQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * « Pour vous qui parlez <langue> »: GET reads what is kept, POST asks for it (made once).
 */
export type academyCourseLessonsPitfallsCreateResponse200 = {
  data: Pitfalls
  status: 200
}
    
export type academyCourseLessonsPitfallsCreateResponseSuccess = (academyCourseLessonsPitfallsCreateResponse200) & {
  headers: Headers;
};
;

export type academyCourseLessonsPitfallsCreateResponse = (academyCourseLessonsPitfallsCreateResponseSuccess)

export const getAcademyCourseLessonsPitfallsCreateUrl = (id: string,
    params?: AcademyCourseLessonsPitfallsCreateParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/course/lessons/${id}/pitfalls/?${stringifiedParams}` : `/api/v1/academy/course/lessons/${id}/pitfalls/`
}

export const academyCourseLessonsPitfallsCreate = async (id: string,
    translationRequestRequest: TranslationRequestRequest,
    params?: AcademyCourseLessonsPitfallsCreateParams, options?: RequestInit): Promise<academyCourseLessonsPitfallsCreateResponse> => {
  
  return apiFetch<academyCourseLessonsPitfallsCreateResponse>(getAcademyCourseLessonsPitfallsCreateUrl(id,params),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      translationRequestRequest,)
  }
);}




export const getAcademyCourseLessonsPitfallsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyCourseLessonsPitfallsCreate>>, TError,{id: string;data: TranslationRequestRequest;params?: AcademyCourseLessonsPitfallsCreateParams}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyCourseLessonsPitfallsCreate>>, TError,{id: string;data: TranslationRequestRequest;params?: AcademyCourseLessonsPitfallsCreateParams}, TContext> => {

const mutationKey = ['academyCourseLessonsPitfallsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyCourseLessonsPitfallsCreate>>, {id: string;data: TranslationRequestRequest;params?: AcademyCourseLessonsPitfallsCreateParams}> = (props) => {
          const {id,data,params} = props ?? {};

          return  academyCourseLessonsPitfallsCreate(id,data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyCourseLessonsPitfallsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyCourseLessonsPitfallsCreate>>>
    export type AcademyCourseLessonsPitfallsCreateMutationBody = TranslationRequestRequest
    export type AcademyCourseLessonsPitfallsCreateMutationError = unknown

    export const useAcademyCourseLessonsPitfallsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyCourseLessonsPitfallsCreate>>, TError,{id: string;data: TranslationRequestRequest;params?: AcademyCourseLessonsPitfallsCreateParams}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyCourseLessonsPitfallsCreate>>,
        TError,
        {id: string;data: TranslationRequestRequest;params?: AcademyCourseLessonsPitfallsCreateParams},
        TContext
      > => {

      const mutationOptions = getAcademyCourseLessonsPitfallsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * The signed-in learner only: never an agency member's tools.
 */
export type academyCourseLessonsRestartCreateResponse200 = {
  data: LessonDetail
  status: 200
}
    
export type academyCourseLessonsRestartCreateResponseSuccess = (academyCourseLessonsRestartCreateResponse200) & {
  headers: Headers;
};
;

export type academyCourseLessonsRestartCreateResponse = (academyCourseLessonsRestartCreateResponseSuccess)

export const getAcademyCourseLessonsRestartCreateUrl = (id: string,
    params?: AcademyCourseLessonsRestartCreateParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/course/lessons/${id}/restart/?${stringifiedParams}` : `/api/v1/academy/course/lessons/${id}/restart/`
}

export const academyCourseLessonsRestartCreate = async (id: string,
    params?: AcademyCourseLessonsRestartCreateParams, options?: RequestInit): Promise<academyCourseLessonsRestartCreateResponse> => {
  
  return apiFetch<academyCourseLessonsRestartCreateResponse>(getAcademyCourseLessonsRestartCreateUrl(id,params),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getAcademyCourseLessonsRestartCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyCourseLessonsRestartCreate>>, TError,{id: string;params?: AcademyCourseLessonsRestartCreateParams}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyCourseLessonsRestartCreate>>, TError,{id: string;params?: AcademyCourseLessonsRestartCreateParams}, TContext> => {

const mutationKey = ['academyCourseLessonsRestartCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyCourseLessonsRestartCreate>>, {id: string;params?: AcademyCourseLessonsRestartCreateParams}> = (props) => {
          const {id,params} = props ?? {};

          return  academyCourseLessonsRestartCreate(id,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyCourseLessonsRestartCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyCourseLessonsRestartCreate>>>
    
    export type AcademyCourseLessonsRestartCreateMutationError = unknown

    export const useAcademyCourseLessonsRestartCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyCourseLessonsRestartCreate>>, TError,{id: string;params?: AcademyCourseLessonsRestartCreateParams}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyCourseLessonsRestartCreate>>,
        TError,
        {id: string;params?: AcademyCourseLessonsRestartCreateParams},
        TContext
      > => {

      const mutationOptions = getAcademyCourseLessonsRestartCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * « Translate into my language »: GET reads what is kept, POST asks for it.
 */
export type academyCourseLessonsTranslationRetrieveResponse200 = {
  data: LessonTranslationView
  status: 200
}
    
export type academyCourseLessonsTranslationRetrieveResponseSuccess = (academyCourseLessonsTranslationRetrieveResponse200) & {
  headers: Headers;
};
;

export type academyCourseLessonsTranslationRetrieveResponse = (academyCourseLessonsTranslationRetrieveResponseSuccess)

export const getAcademyCourseLessonsTranslationRetrieveUrl = (id: string,
    params?: AcademyCourseLessonsTranslationRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/course/lessons/${id}/translation/?${stringifiedParams}` : `/api/v1/academy/course/lessons/${id}/translation/`
}

export const academyCourseLessonsTranslationRetrieve = async (id: string,
    params?: AcademyCourseLessonsTranslationRetrieveParams, options?: RequestInit): Promise<academyCourseLessonsTranslationRetrieveResponse> => {
  
  return apiFetch<academyCourseLessonsTranslationRetrieveResponse>(getAcademyCourseLessonsTranslationRetrieveUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyCourseLessonsTranslationRetrieveQueryKey = (id?: string,
    params?: AcademyCourseLessonsTranslationRetrieveParams,) => {
    return [
    `/api/v1/academy/course/lessons/${id}/translation/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAcademyCourseLessonsTranslationRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academyCourseLessonsTranslationRetrieve>>, TError = unknown>(id: string,
    params?: AcademyCourseLessonsTranslationRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyCourseLessonsTranslationRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyCourseLessonsTranslationRetrieveQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyCourseLessonsTranslationRetrieve>>> = ({ signal }) => academyCourseLessonsTranslationRetrieve(id,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyCourseLessonsTranslationRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyCourseLessonsTranslationRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academyCourseLessonsTranslationRetrieve>>>
export type AcademyCourseLessonsTranslationRetrieveQueryError = unknown


export function useAcademyCourseLessonsTranslationRetrieve<TData = Awaited<ReturnType<typeof academyCourseLessonsTranslationRetrieve>>, TError = unknown>(
 id: string,
    params: undefined |  AcademyCourseLessonsTranslationRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyCourseLessonsTranslationRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyCourseLessonsTranslationRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyCourseLessonsTranslationRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyCourseLessonsTranslationRetrieve<TData = Awaited<ReturnType<typeof academyCourseLessonsTranslationRetrieve>>, TError = unknown>(
 id: string,
    params?: AcademyCourseLessonsTranslationRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyCourseLessonsTranslationRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyCourseLessonsTranslationRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyCourseLessonsTranslationRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyCourseLessonsTranslationRetrieve<TData = Awaited<ReturnType<typeof academyCourseLessonsTranslationRetrieve>>, TError = unknown>(
 id: string,
    params?: AcademyCourseLessonsTranslationRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyCourseLessonsTranslationRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyCourseLessonsTranslationRetrieve<TData = Awaited<ReturnType<typeof academyCourseLessonsTranslationRetrieve>>, TError = unknown>(
 id: string,
    params?: AcademyCourseLessonsTranslationRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyCourseLessonsTranslationRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyCourseLessonsTranslationRetrieveQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * « Translate into my language »: GET reads what is kept, POST asks for it.
 */
export type academyCourseLessonsTranslationCreateResponse200 = {
  data: LessonTranslationView
  status: 200
}
    
export type academyCourseLessonsTranslationCreateResponseSuccess = (academyCourseLessonsTranslationCreateResponse200) & {
  headers: Headers;
};
;

export type academyCourseLessonsTranslationCreateResponse = (academyCourseLessonsTranslationCreateResponseSuccess)

export const getAcademyCourseLessonsTranslationCreateUrl = (id: string,
    params?: AcademyCourseLessonsTranslationCreateParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/course/lessons/${id}/translation/?${stringifiedParams}` : `/api/v1/academy/course/lessons/${id}/translation/`
}

export const academyCourseLessonsTranslationCreate = async (id: string,
    translationRequestRequest: TranslationRequestRequest,
    params?: AcademyCourseLessonsTranslationCreateParams, options?: RequestInit): Promise<academyCourseLessonsTranslationCreateResponse> => {
  
  return apiFetch<academyCourseLessonsTranslationCreateResponse>(getAcademyCourseLessonsTranslationCreateUrl(id,params),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      translationRequestRequest,)
  }
);}




export const getAcademyCourseLessonsTranslationCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyCourseLessonsTranslationCreate>>, TError,{id: string;data: TranslationRequestRequest;params?: AcademyCourseLessonsTranslationCreateParams}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyCourseLessonsTranslationCreate>>, TError,{id: string;data: TranslationRequestRequest;params?: AcademyCourseLessonsTranslationCreateParams}, TContext> => {

const mutationKey = ['academyCourseLessonsTranslationCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyCourseLessonsTranslationCreate>>, {id: string;data: TranslationRequestRequest;params?: AcademyCourseLessonsTranslationCreateParams}> = (props) => {
          const {id,data,params} = props ?? {};

          return  academyCourseLessonsTranslationCreate(id,data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyCourseLessonsTranslationCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyCourseLessonsTranslationCreate>>>
    export type AcademyCourseLessonsTranslationCreateMutationBody = TranslationRequestRequest
    export type AcademyCourseLessonsTranslationCreateMutationError = unknown

    export const useAcademyCourseLessonsTranslationCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyCourseLessonsTranslationCreate>>, TError,{id: string;data: TranslationRequestRequest;params?: AcademyCourseLessonsTranslationCreateParams}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyCourseLessonsTranslationCreate>>,
        TError,
        {id: string;data: TranslationRequestRequest;params?: AcademyCourseLessonsTranslationCreateParams},
        TContext
      > => {

      const mutationOptions = getAcademyCourseLessonsTranslationCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * « Méthode et astuces » of an exam: always open with a plan, and without one when the
agency offers it (setting « method_free », on by default).
 */
export type academyCourseMethodRetrieveResponse200 = {
  data: Method
  status: 200
}
    
export type academyCourseMethodRetrieveResponseSuccess = (academyCourseMethodRetrieveResponse200) & {
  headers: Headers;
};
;

export type academyCourseMethodRetrieveResponse = (academyCourseMethodRetrieveResponseSuccess)

export const getAcademyCourseMethodRetrieveUrl = (params?: AcademyCourseMethodRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/course/method/?${stringifiedParams}` : `/api/v1/academy/course/method/`
}

export const academyCourseMethodRetrieve = async (params?: AcademyCourseMethodRetrieveParams, options?: RequestInit): Promise<academyCourseMethodRetrieveResponse> => {
  
  return apiFetch<academyCourseMethodRetrieveResponse>(getAcademyCourseMethodRetrieveUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyCourseMethodRetrieveQueryKey = (params?: AcademyCourseMethodRetrieveParams,) => {
    return [
    `/api/v1/academy/course/method/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAcademyCourseMethodRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academyCourseMethodRetrieve>>, TError = unknown>(params?: AcademyCourseMethodRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyCourseMethodRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyCourseMethodRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyCourseMethodRetrieve>>> = ({ signal }) => academyCourseMethodRetrieve(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyCourseMethodRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyCourseMethodRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academyCourseMethodRetrieve>>>
export type AcademyCourseMethodRetrieveQueryError = unknown


export function useAcademyCourseMethodRetrieve<TData = Awaited<ReturnType<typeof academyCourseMethodRetrieve>>, TError = unknown>(
 params: undefined |  AcademyCourseMethodRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyCourseMethodRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyCourseMethodRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyCourseMethodRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyCourseMethodRetrieve<TData = Awaited<ReturnType<typeof academyCourseMethodRetrieve>>, TError = unknown>(
 params?: AcademyCourseMethodRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyCourseMethodRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyCourseMethodRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyCourseMethodRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyCourseMethodRetrieve<TData = Awaited<ReturnType<typeof academyCourseMethodRetrieve>>, TError = unknown>(
 params?: AcademyCourseMethodRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyCourseMethodRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyCourseMethodRetrieve<TData = Awaited<ReturnType<typeof academyCourseMethodRetrieve>>, TError = unknown>(
 params?: AcademyCourseMethodRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyCourseMethodRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyCourseMethodRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * « How to succeed in this type of question? »: the method lesson of a section and a task
(TCF) or a question type (IELTS); `lesson` is null when there is none yet.
 */
export type academyCourseMethodLinkRetrieveResponse200 = {
  data: MethodLink
  status: 200
}
    
export type academyCourseMethodLinkRetrieveResponseSuccess = (academyCourseMethodLinkRetrieveResponse200) & {
  headers: Headers;
};
;

export type academyCourseMethodLinkRetrieveResponse = (academyCourseMethodLinkRetrieveResponseSuccess)

export const getAcademyCourseMethodLinkRetrieveUrl = (params: AcademyCourseMethodLinkRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/course/method-link/?${stringifiedParams}` : `/api/v1/academy/course/method-link/`
}

export const academyCourseMethodLinkRetrieve = async (params: AcademyCourseMethodLinkRetrieveParams, options?: RequestInit): Promise<academyCourseMethodLinkRetrieveResponse> => {
  
  return apiFetch<academyCourseMethodLinkRetrieveResponse>(getAcademyCourseMethodLinkRetrieveUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyCourseMethodLinkRetrieveQueryKey = (params?: AcademyCourseMethodLinkRetrieveParams,) => {
    return [
    `/api/v1/academy/course/method-link/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAcademyCourseMethodLinkRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academyCourseMethodLinkRetrieve>>, TError = unknown>(params: AcademyCourseMethodLinkRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyCourseMethodLinkRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyCourseMethodLinkRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyCourseMethodLinkRetrieve>>> = ({ signal }) => academyCourseMethodLinkRetrieve(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyCourseMethodLinkRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyCourseMethodLinkRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academyCourseMethodLinkRetrieve>>>
export type AcademyCourseMethodLinkRetrieveQueryError = unknown


export function useAcademyCourseMethodLinkRetrieve<TData = Awaited<ReturnType<typeof academyCourseMethodLinkRetrieve>>, TError = unknown>(
 params: AcademyCourseMethodLinkRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyCourseMethodLinkRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyCourseMethodLinkRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyCourseMethodLinkRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyCourseMethodLinkRetrieve<TData = Awaited<ReturnType<typeof academyCourseMethodLinkRetrieve>>, TError = unknown>(
 params: AcademyCourseMethodLinkRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyCourseMethodLinkRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyCourseMethodLinkRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyCourseMethodLinkRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyCourseMethodLinkRetrieve<TData = Awaited<ReturnType<typeof academyCourseMethodLinkRetrieve>>, TError = unknown>(
 params: AcademyCourseMethodLinkRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyCourseMethodLinkRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyCourseMethodLinkRetrieve<TData = Awaited<ReturnType<typeof academyCourseMethodLinkRetrieve>>, TError = unknown>(
 params: AcademyCourseMethodLinkRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyCourseMethodLinkRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyCourseMethodLinkRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Spaced review: the missed exercises due today, and one answer.
 */
export type academyCourseReviewRetrieveResponse200 = {
  data: ReviewToday
  status: 200
}
    
export type academyCourseReviewRetrieveResponseSuccess = (academyCourseReviewRetrieveResponse200) & {
  headers: Headers;
};
;

export type academyCourseReviewRetrieveResponse = (academyCourseReviewRetrieveResponseSuccess)

export const getAcademyCourseReviewRetrieveUrl = (params?: AcademyCourseReviewRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/course/review/?${stringifiedParams}` : `/api/v1/academy/course/review/`
}

export const academyCourseReviewRetrieve = async (params?: AcademyCourseReviewRetrieveParams, options?: RequestInit): Promise<academyCourseReviewRetrieveResponse> => {
  
  return apiFetch<academyCourseReviewRetrieveResponse>(getAcademyCourseReviewRetrieveUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyCourseReviewRetrieveQueryKey = (params?: AcademyCourseReviewRetrieveParams,) => {
    return [
    `/api/v1/academy/course/review/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAcademyCourseReviewRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academyCourseReviewRetrieve>>, TError = unknown>(params?: AcademyCourseReviewRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyCourseReviewRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyCourseReviewRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyCourseReviewRetrieve>>> = ({ signal }) => academyCourseReviewRetrieve(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyCourseReviewRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyCourseReviewRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academyCourseReviewRetrieve>>>
export type AcademyCourseReviewRetrieveQueryError = unknown


export function useAcademyCourseReviewRetrieve<TData = Awaited<ReturnType<typeof academyCourseReviewRetrieve>>, TError = unknown>(
 params: undefined |  AcademyCourseReviewRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyCourseReviewRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyCourseReviewRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyCourseReviewRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyCourseReviewRetrieve<TData = Awaited<ReturnType<typeof academyCourseReviewRetrieve>>, TError = unknown>(
 params?: AcademyCourseReviewRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyCourseReviewRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyCourseReviewRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyCourseReviewRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyCourseReviewRetrieve<TData = Awaited<ReturnType<typeof academyCourseReviewRetrieve>>, TError = unknown>(
 params?: AcademyCourseReviewRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyCourseReviewRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyCourseReviewRetrieve<TData = Awaited<ReturnType<typeof academyCourseReviewRetrieve>>, TError = unknown>(
 params?: AcademyCourseReviewRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyCourseReviewRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyCourseReviewRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Spaced review: the missed exercises due today, and one answer.
 */
export type academyCourseReviewCreateResponse200 = {
  data: ExerciseResult
  status: 200
}
    
export type academyCourseReviewCreateResponseSuccess = (academyCourseReviewCreateResponse200) & {
  headers: Headers;
};
;

export type academyCourseReviewCreateResponse = (academyCourseReviewCreateResponseSuccess)

export const getAcademyCourseReviewCreateUrl = (params?: AcademyCourseReviewCreateParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/course/review/?${stringifiedParams}` : `/api/v1/academy/course/review/`
}

export const academyCourseReviewCreate = async (exerciseAnswerRequest: ExerciseAnswerRequest,
    params?: AcademyCourseReviewCreateParams, options?: RequestInit): Promise<academyCourseReviewCreateResponse> => {
  
  return apiFetch<academyCourseReviewCreateResponse>(getAcademyCourseReviewCreateUrl(params),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      exerciseAnswerRequest,)
  }
);}




export const getAcademyCourseReviewCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyCourseReviewCreate>>, TError,{data: ExerciseAnswerRequest;params?: AcademyCourseReviewCreateParams}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyCourseReviewCreate>>, TError,{data: ExerciseAnswerRequest;params?: AcademyCourseReviewCreateParams}, TContext> => {

const mutationKey = ['academyCourseReviewCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyCourseReviewCreate>>, {data: ExerciseAnswerRequest;params?: AcademyCourseReviewCreateParams}> = (props) => {
          const {data,params} = props ?? {};

          return  academyCourseReviewCreate(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyCourseReviewCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyCourseReviewCreate>>>
    export type AcademyCourseReviewCreateMutationBody = ExerciseAnswerRequest
    export type AcademyCourseReviewCreateMutationError = unknown

    export const useAcademyCourseReviewCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyCourseReviewCreate>>, TError,{data: ExerciseAnswerRequest;params?: AcademyCourseReviewCreateParams}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyCourseReviewCreate>>,
        TError,
        {data: ExerciseAnswerRequest;params?: AcademyCourseReviewCreateParams},
        TContext
      > => {

      const mutationOptions = getAcademyCourseReviewCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type academyCoursesListResponse200 = {
  data: PaginatedCourseList
  status: 200
}
    
export type academyCoursesListResponseSuccess = (academyCoursesListResponse200) & {
  headers: Headers;
};
;

export type academyCoursesListResponse = (academyCoursesListResponseSuccess)

export const getAcademyCoursesListUrl = (params?: AcademyCoursesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/courses/?${stringifiedParams}` : `/api/v1/academy/courses/`
}

export const academyCoursesList = async (params?: AcademyCoursesListParams, options?: RequestInit): Promise<academyCoursesListResponse> => {
  
  return apiFetch<academyCoursesListResponse>(getAcademyCoursesListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyCoursesListQueryKey = (params?: AcademyCoursesListParams,) => {
    return [
    `/api/v1/academy/courses/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAcademyCoursesListQueryOptions = <TData = Awaited<ReturnType<typeof academyCoursesList>>, TError = unknown>(params?: AcademyCoursesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyCoursesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyCoursesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyCoursesList>>> = ({ signal }) => academyCoursesList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyCoursesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyCoursesListQueryResult = NonNullable<Awaited<ReturnType<typeof academyCoursesList>>>
export type AcademyCoursesListQueryError = unknown


export function useAcademyCoursesList<TData = Awaited<ReturnType<typeof academyCoursesList>>, TError = unknown>(
 params: undefined |  AcademyCoursesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyCoursesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyCoursesList>>,
          TError,
          Awaited<ReturnType<typeof academyCoursesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyCoursesList<TData = Awaited<ReturnType<typeof academyCoursesList>>, TError = unknown>(
 params?: AcademyCoursesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyCoursesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyCoursesList>>,
          TError,
          Awaited<ReturnType<typeof academyCoursesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyCoursesList<TData = Awaited<ReturnType<typeof academyCoursesList>>, TError = unknown>(
 params?: AcademyCoursesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyCoursesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyCoursesList<TData = Awaited<ReturnType<typeof academyCoursesList>>, TError = unknown>(
 params?: AcademyCoursesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyCoursesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyCoursesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type academyCoursesRetrieveResponse200 = {
  data: Course
  status: 200
}
    
export type academyCoursesRetrieveResponseSuccess = (academyCoursesRetrieveResponse200) & {
  headers: Headers;
};
;

export type academyCoursesRetrieveResponse = (academyCoursesRetrieveResponseSuccess)

export const getAcademyCoursesRetrieveUrl = (id: string,) => {


  

  return `/api/v1/academy/courses/${id}/`
}

export const academyCoursesRetrieve = async (id: string, options?: RequestInit): Promise<academyCoursesRetrieveResponse> => {
  
  return apiFetch<academyCoursesRetrieveResponse>(getAcademyCoursesRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyCoursesRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/academy/courses/${id}/`
    ] as const;
    }

    
export const getAcademyCoursesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academyCoursesRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyCoursesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyCoursesRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyCoursesRetrieve>>> = ({ signal }) => academyCoursesRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyCoursesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyCoursesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academyCoursesRetrieve>>>
export type AcademyCoursesRetrieveQueryError = unknown


export function useAcademyCoursesRetrieve<TData = Awaited<ReturnType<typeof academyCoursesRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyCoursesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyCoursesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyCoursesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyCoursesRetrieve<TData = Awaited<ReturnType<typeof academyCoursesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyCoursesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyCoursesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyCoursesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyCoursesRetrieve<TData = Awaited<ReturnType<typeof academyCoursesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyCoursesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyCoursesRetrieve<TData = Awaited<ReturnType<typeof academyCoursesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyCoursesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyCoursesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Back office, read only: the sessions reported by the learners, by centre (the AI
analyses them).
 */
export type academyExamReportsListResponse200 = {
  data: PaginatedExamReportList
  status: 200
}
    
export type academyExamReportsListResponseSuccess = (academyExamReportsListResponse200) & {
  headers: Headers;
};
;

export type academyExamReportsListResponse = (academyExamReportsListResponseSuccess)

export const getAcademyExamReportsListUrl = (params?: AcademyExamReportsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/exam-reports/?${stringifiedParams}` : `/api/v1/academy/exam-reports/`
}

export const academyExamReportsList = async (params?: AcademyExamReportsListParams, options?: RequestInit): Promise<academyExamReportsListResponse> => {
  
  return apiFetch<academyExamReportsListResponse>(getAcademyExamReportsListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyExamReportsListQueryKey = (params?: AcademyExamReportsListParams,) => {
    return [
    `/api/v1/academy/exam-reports/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAcademyExamReportsListQueryOptions = <TData = Awaited<ReturnType<typeof academyExamReportsList>>, TError = unknown>(params?: AcademyExamReportsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyExamReportsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyExamReportsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyExamReportsList>>> = ({ signal }) => academyExamReportsList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyExamReportsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyExamReportsListQueryResult = NonNullable<Awaited<ReturnType<typeof academyExamReportsList>>>
export type AcademyExamReportsListQueryError = unknown


export function useAcademyExamReportsList<TData = Awaited<ReturnType<typeof academyExamReportsList>>, TError = unknown>(
 params: undefined |  AcademyExamReportsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyExamReportsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyExamReportsList>>,
          TError,
          Awaited<ReturnType<typeof academyExamReportsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyExamReportsList<TData = Awaited<ReturnType<typeof academyExamReportsList>>, TError = unknown>(
 params?: AcademyExamReportsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyExamReportsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyExamReportsList>>,
          TError,
          Awaited<ReturnType<typeof academyExamReportsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyExamReportsList<TData = Awaited<ReturnType<typeof academyExamReportsList>>, TError = unknown>(
 params?: AcademyExamReportsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyExamReportsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyExamReportsList<TData = Awaited<ReturnType<typeof academyExamReportsList>>, TError = unknown>(
 params?: AcademyExamReportsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyExamReportsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyExamReportsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Back office, read only: the sessions reported by the learners, by centre (the AI
analyses them).
 */
export type academyExamReportsRetrieveResponse200 = {
  data: ExamReport
  status: 200
}
    
export type academyExamReportsRetrieveResponseSuccess = (academyExamReportsRetrieveResponse200) & {
  headers: Headers;
};
;

export type academyExamReportsRetrieveResponse = (academyExamReportsRetrieveResponseSuccess)

export const getAcademyExamReportsRetrieveUrl = (id: string,) => {


  

  return `/api/v1/academy/exam-reports/${id}/`
}

export const academyExamReportsRetrieve = async (id: string, options?: RequestInit): Promise<academyExamReportsRetrieveResponse> => {
  
  return apiFetch<academyExamReportsRetrieveResponse>(getAcademyExamReportsRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyExamReportsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/academy/exam-reports/${id}/`
    ] as const;
    }

    
export const getAcademyExamReportsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academyExamReportsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyExamReportsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyExamReportsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyExamReportsRetrieve>>> = ({ signal }) => academyExamReportsRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyExamReportsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyExamReportsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academyExamReportsRetrieve>>>
export type AcademyExamReportsRetrieveQueryError = unknown


export function useAcademyExamReportsRetrieve<TData = Awaited<ReturnType<typeof academyExamReportsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyExamReportsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyExamReportsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyExamReportsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyExamReportsRetrieve<TData = Awaited<ReturnType<typeof academyExamReportsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyExamReportsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyExamReportsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyExamReportsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyExamReportsRetrieve<TData = Awaited<ReturnType<typeof academyExamReportsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyExamReportsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyExamReportsRetrieve<TData = Awaited<ReturnType<typeof academyExamReportsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyExamReportsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyExamReportsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * The signed-in learner only: never an agency member's tools.
 */
export type academyFeedbackCreateResponse201 = {
  data: Feedback
  status: 201
}
    
export type academyFeedbackCreateResponseSuccess = (academyFeedbackCreateResponse201) & {
  headers: Headers;
};
;

export type academyFeedbackCreateResponse = (academyFeedbackCreateResponseSuccess)

export const getAcademyFeedbackCreateUrl = () => {


  

  return `/api/v1/academy/feedback/`
}

export const academyFeedbackCreate = async (feedbackRequest: FeedbackRequest, options?: RequestInit): Promise<academyFeedbackCreateResponse> => {
  
  return apiFetch<academyFeedbackCreateResponse>(getAcademyFeedbackCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      feedbackRequest,)
  }
);}




export const getAcademyFeedbackCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyFeedbackCreate>>, TError,{data: FeedbackRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyFeedbackCreate>>, TError,{data: FeedbackRequest}, TContext> => {

const mutationKey = ['academyFeedbackCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyFeedbackCreate>>, {data: FeedbackRequest}> = (props) => {
          const {data} = props ?? {};

          return  academyFeedbackCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyFeedbackCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyFeedbackCreate>>>
    export type AcademyFeedbackCreateMutationBody = FeedbackRequest
    export type AcademyFeedbackCreateMutationError = unknown

    export const useAcademyFeedbackCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyFeedbackCreate>>, TError,{data: FeedbackRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyFeedbackCreate>>,
        TError,
        {data: FeedbackRequest},
        TContext
      > => {

      const mutationOptions = getAcademyFeedbackCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * The exam format table (sections, word limits, EO timings, rubrics): learners and staff.
 */
export type academyFormatRetrieveResponse200 = {
  data: ExamFormat
  status: 200
}
    
export type academyFormatRetrieveResponseSuccess = (academyFormatRetrieveResponse200) & {
  headers: Headers;
};
;

export type academyFormatRetrieveResponse = (academyFormatRetrieveResponseSuccess)

export const getAcademyFormatRetrieveUrl = (params?: AcademyFormatRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/format/?${stringifiedParams}` : `/api/v1/academy/format/`
}

export const academyFormatRetrieve = async (params?: AcademyFormatRetrieveParams, options?: RequestInit): Promise<academyFormatRetrieveResponse> => {
  
  return apiFetch<academyFormatRetrieveResponse>(getAcademyFormatRetrieveUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyFormatRetrieveQueryKey = (params?: AcademyFormatRetrieveParams,) => {
    return [
    `/api/v1/academy/format/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAcademyFormatRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academyFormatRetrieve>>, TError = unknown>(params?: AcademyFormatRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyFormatRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyFormatRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyFormatRetrieve>>> = ({ signal }) => academyFormatRetrieve(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyFormatRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyFormatRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academyFormatRetrieve>>>
export type AcademyFormatRetrieveQueryError = unknown


export function useAcademyFormatRetrieve<TData = Awaited<ReturnType<typeof academyFormatRetrieve>>, TError = unknown>(
 params: undefined |  AcademyFormatRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyFormatRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyFormatRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyFormatRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyFormatRetrieve<TData = Awaited<ReturnType<typeof academyFormatRetrieve>>, TError = unknown>(
 params?: AcademyFormatRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyFormatRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyFormatRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyFormatRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyFormatRetrieve<TData = Awaited<ReturnType<typeof academyFormatRetrieve>>, TError = unknown>(
 params?: AcademyFormatRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyFormatRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyFormatRetrieve<TData = Awaited<ReturnType<typeof academyFormatRetrieve>>, TError = unknown>(
 params?: AcademyFormatRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyFormatRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyFormatRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * The signed-in learner only: never an agency member's tools.
 */
export type academyFreeMockRetrieveResponse200 = {
  data: FreeMockState
  status: 200
}
    
export type academyFreeMockRetrieveResponseSuccess = (academyFreeMockRetrieveResponse200) & {
  headers: Headers;
};
;

export type academyFreeMockRetrieveResponse = (academyFreeMockRetrieveResponseSuccess)

export const getAcademyFreeMockRetrieveUrl = (params?: AcademyFreeMockRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/free-mock/?${stringifiedParams}` : `/api/v1/academy/free-mock/`
}

export const academyFreeMockRetrieve = async (params?: AcademyFreeMockRetrieveParams, options?: RequestInit): Promise<academyFreeMockRetrieveResponse> => {
  
  return apiFetch<academyFreeMockRetrieveResponse>(getAcademyFreeMockRetrieveUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyFreeMockRetrieveQueryKey = (params?: AcademyFreeMockRetrieveParams,) => {
    return [
    `/api/v1/academy/free-mock/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAcademyFreeMockRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academyFreeMockRetrieve>>, TError = unknown>(params?: AcademyFreeMockRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyFreeMockRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyFreeMockRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyFreeMockRetrieve>>> = ({ signal }) => academyFreeMockRetrieve(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyFreeMockRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyFreeMockRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academyFreeMockRetrieve>>>
export type AcademyFreeMockRetrieveQueryError = unknown


export function useAcademyFreeMockRetrieve<TData = Awaited<ReturnType<typeof academyFreeMockRetrieve>>, TError = unknown>(
 params: undefined |  AcademyFreeMockRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyFreeMockRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyFreeMockRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyFreeMockRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyFreeMockRetrieve<TData = Awaited<ReturnType<typeof academyFreeMockRetrieve>>, TError = unknown>(
 params?: AcademyFreeMockRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyFreeMockRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyFreeMockRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyFreeMockRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyFreeMockRetrieve<TData = Awaited<ReturnType<typeof academyFreeMockRetrieve>>, TError = unknown>(
 params?: AcademyFreeMockRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyFreeMockRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyFreeMockRetrieve<TData = Awaited<ReturnType<typeof academyFreeMockRetrieve>>, TError = unknown>(
 params?: AcademyFreeMockRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyFreeMockRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyFreeMockRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * The signed-in learner only: never an agency member's tools.
 */
export type academyFreeMockCreateResponse201 = {
  data: Attempt
  status: 201
}
    
export type academyFreeMockCreateResponseSuccess = (academyFreeMockCreateResponse201) & {
  headers: Headers;
};
;

export type academyFreeMockCreateResponse = (academyFreeMockCreateResponseSuccess)

export const getAcademyFreeMockCreateUrl = () => {


  

  return `/api/v1/academy/free-mock/`
}

export const academyFreeMockCreate = async (freeMockStartRequest: FreeMockStartRequest, options?: RequestInit): Promise<academyFreeMockCreateResponse> => {
  
  return apiFetch<academyFreeMockCreateResponse>(getAcademyFreeMockCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      freeMockStartRequest,)
  }
);}




export const getAcademyFreeMockCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyFreeMockCreate>>, TError,{data: FreeMockStartRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyFreeMockCreate>>, TError,{data: FreeMockStartRequest}, TContext> => {

const mutationKey = ['academyFreeMockCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyFreeMockCreate>>, {data: FreeMockStartRequest}> = (props) => {
          const {data} = props ?? {};

          return  academyFreeMockCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyFreeMockCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyFreeMockCreate>>>
    export type AcademyFreeMockCreateMutationBody = FreeMockStartRequest
    export type AcademyFreeMockCreateMutationError = unknown

    export const useAcademyFreeMockCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyFreeMockCreate>>, TError,{data: FreeMockStartRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyFreeMockCreate>>,
        TError,
        {data: FreeMockStartRequest},
        TContext
      > => {

      const mutationOptions = getAcademyFreeMockCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * The German levels of the learner (Goethe-Zertifikat A1 to C2).
 */
export type academyGoetheRetrieveResponse200 = {
  data: GoetheState
  status: 200
}
    
export type academyGoetheRetrieveResponseSuccess = (academyGoetheRetrieveResponse200) & {
  headers: Headers;
};
;

export type academyGoetheRetrieveResponse = (academyGoetheRetrieveResponseSuccess)

export const getAcademyGoetheRetrieveUrl = () => {


  

  return `/api/v1/academy/goethe/`
}

export const academyGoetheRetrieve = async ( options?: RequestInit): Promise<academyGoetheRetrieveResponse> => {
  
  return apiFetch<academyGoetheRetrieveResponse>(getAcademyGoetheRetrieveUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyGoetheRetrieveQueryKey = () => {
    return [
    `/api/v1/academy/goethe/`
    ] as const;
    }

    
export const getAcademyGoetheRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academyGoetheRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyGoetheRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyGoetheRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyGoetheRetrieve>>> = ({ signal }) => academyGoetheRetrieve({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyGoetheRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyGoetheRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academyGoetheRetrieve>>>
export type AcademyGoetheRetrieveQueryError = unknown


export function useAcademyGoetheRetrieve<TData = Awaited<ReturnType<typeof academyGoetheRetrieve>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyGoetheRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyGoetheRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyGoetheRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyGoetheRetrieve<TData = Awaited<ReturnType<typeof academyGoetheRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyGoetheRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyGoetheRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyGoetheRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyGoetheRetrieve<TData = Awaited<ReturnType<typeof academyGoetheRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyGoetheRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyGoetheRetrieve<TData = Awaited<ReturnType<typeof academyGoetheRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyGoetheRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyGoetheRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * The German levels of the learner (Goethe-Zertifikat A1 to C2).
 */
export type academyGoetheCreateResponse200 = {
  data: GoetheState
  status: 200
}
    
export type academyGoetheCreateResponseSuccess = (academyGoetheCreateResponse200) & {
  headers: Headers;
};
;

export type academyGoetheCreateResponse = (academyGoetheCreateResponseSuccess)

export const getAcademyGoetheCreateUrl = () => {


  

  return `/api/v1/academy/goethe/`
}

export const academyGoetheCreate = async (goetheProfileRequest: GoetheProfileRequest, options?: RequestInit): Promise<academyGoetheCreateResponse> => {
  
  return apiFetch<academyGoetheCreateResponse>(getAcademyGoetheCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      goetheProfileRequest,)
  }
);}




export const getAcademyGoetheCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyGoetheCreate>>, TError,{data: GoetheProfileRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyGoetheCreate>>, TError,{data: GoetheProfileRequest}, TContext> => {

const mutationKey = ['academyGoetheCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyGoetheCreate>>, {data: GoetheProfileRequest}> = (props) => {
          const {data} = props ?? {};

          return  academyGoetheCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyGoetheCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyGoetheCreate>>>
    export type AcademyGoetheCreateMutationBody = GoetheProfileRequest
    export type AcademyGoetheCreateMutationError = unknown

    export const useAcademyGoetheCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyGoetheCreate>>, TError,{data: GoetheProfileRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyGoetheCreate>>,
        TError,
        {data: GoetheProfileRequest},
        TContext
      > => {

      const mutationOptions = getAcademyGoetheCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Everything the learner did in one exam (one German level), newest first.
 */
export type academyHistoryRetrieveResponse200 = {
  data: HistoryPage
  status: 200
}
    
export type academyHistoryRetrieveResponseSuccess = (academyHistoryRetrieveResponse200) & {
  headers: Headers;
};
;

export type academyHistoryRetrieveResponse = (academyHistoryRetrieveResponseSuccess)

export const getAcademyHistoryRetrieveUrl = (params?: AcademyHistoryRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/history/?${stringifiedParams}` : `/api/v1/academy/history/`
}

export const academyHistoryRetrieve = async (params?: AcademyHistoryRetrieveParams, options?: RequestInit): Promise<academyHistoryRetrieveResponse> => {
  
  return apiFetch<academyHistoryRetrieveResponse>(getAcademyHistoryRetrieveUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyHistoryRetrieveQueryKey = (params?: AcademyHistoryRetrieveParams,) => {
    return [
    `/api/v1/academy/history/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAcademyHistoryRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academyHistoryRetrieve>>, TError = unknown>(params?: AcademyHistoryRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyHistoryRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyHistoryRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyHistoryRetrieve>>> = ({ signal }) => academyHistoryRetrieve(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyHistoryRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyHistoryRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academyHistoryRetrieve>>>
export type AcademyHistoryRetrieveQueryError = unknown


export function useAcademyHistoryRetrieve<TData = Awaited<ReturnType<typeof academyHistoryRetrieve>>, TError = unknown>(
 params: undefined |  AcademyHistoryRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyHistoryRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyHistoryRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyHistoryRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyHistoryRetrieve<TData = Awaited<ReturnType<typeof academyHistoryRetrieve>>, TError = unknown>(
 params?: AcademyHistoryRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyHistoryRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyHistoryRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyHistoryRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyHistoryRetrieve<TData = Awaited<ReturnType<typeof academyHistoryRetrieve>>, TError = unknown>(
 params?: AcademyHistoryRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyHistoryRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyHistoryRetrieve<TData = Awaited<ReturnType<typeof academyHistoryRetrieve>>, TError = unknown>(
 params?: AcademyHistoryRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyHistoryRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyHistoryRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * What the correction's screen of a sitting adds: its status, « Refaire », the report.
 */
export type academyHistoryAttemptsRetrieveResponse200 = {
  data: HistoryItem
  status: 200
}
    
export type academyHistoryAttemptsRetrieveResponseSuccess = (academyHistoryAttemptsRetrieveResponse200) & {
  headers: Headers;
};
;

export type academyHistoryAttemptsRetrieveResponse = (academyHistoryAttemptsRetrieveResponseSuccess)

export const getAcademyHistoryAttemptsRetrieveUrl = (id: string,) => {


  

  return `/api/v1/academy/history/attempts/${id}/`
}

export const academyHistoryAttemptsRetrieve = async (id: string, options?: RequestInit): Promise<academyHistoryAttemptsRetrieveResponse> => {
  
  return apiFetch<academyHistoryAttemptsRetrieveResponse>(getAcademyHistoryAttemptsRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyHistoryAttemptsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/academy/history/attempts/${id}/`
    ] as const;
    }

    
export const getAcademyHistoryAttemptsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academyHistoryAttemptsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyHistoryAttemptsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyHistoryAttemptsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyHistoryAttemptsRetrieve>>> = ({ signal }) => academyHistoryAttemptsRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyHistoryAttemptsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyHistoryAttemptsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academyHistoryAttemptsRetrieve>>>
export type AcademyHistoryAttemptsRetrieveQueryError = unknown


export function useAcademyHistoryAttemptsRetrieve<TData = Awaited<ReturnType<typeof academyHistoryAttemptsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyHistoryAttemptsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyHistoryAttemptsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyHistoryAttemptsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyHistoryAttemptsRetrieve<TData = Awaited<ReturnType<typeof academyHistoryAttemptsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyHistoryAttemptsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyHistoryAttemptsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyHistoryAttemptsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyHistoryAttemptsRetrieve<TData = Awaited<ReturnType<typeof academyHistoryAttemptsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyHistoryAttemptsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyHistoryAttemptsRetrieve<TData = Awaited<ReturnType<typeof academyHistoryAttemptsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyHistoryAttemptsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyHistoryAttemptsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * « Refaire »: a new sitting of the same activity; the old correction stays intact.
 */
export type academyHistoryAttemptsRetakeCreateResponse200 = {
  data: RetakeResult
  status: 200
}
    
export type academyHistoryAttemptsRetakeCreateResponseSuccess = (academyHistoryAttemptsRetakeCreateResponse200) & {
  headers: Headers;
};
;

export type academyHistoryAttemptsRetakeCreateResponse = (academyHistoryAttemptsRetakeCreateResponseSuccess)

export const getAcademyHistoryAttemptsRetakeCreateUrl = (id: string,) => {


  

  return `/api/v1/academy/history/attempts/${id}/retake/`
}

export const academyHistoryAttemptsRetakeCreate = async (id: string, options?: RequestInit): Promise<academyHistoryAttemptsRetakeCreateResponse> => {
  
  return apiFetch<academyHistoryAttemptsRetakeCreateResponse>(getAcademyHistoryAttemptsRetakeCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getAcademyHistoryAttemptsRetakeCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyHistoryAttemptsRetakeCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyHistoryAttemptsRetakeCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['academyHistoryAttemptsRetakeCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyHistoryAttemptsRetakeCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  academyHistoryAttemptsRetakeCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyHistoryAttemptsRetakeCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyHistoryAttemptsRetakeCreate>>>
    
    export type AcademyHistoryAttemptsRetakeCreateMutationError = unknown

    export const useAcademyHistoryAttemptsRetakeCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyHistoryAttemptsRetakeCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyHistoryAttemptsRetakeCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getAcademyHistoryAttemptsRetakeCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * The correction of a past challenge (it was readable only on its own day).
 */
export type academyHistoryChallengesRetrieveResponse200 = {
  data: ChallengeCorrection
  status: 200
}
    
export type academyHistoryChallengesRetrieveResponseSuccess = (academyHistoryChallengesRetrieveResponse200) & {
  headers: Headers;
};
;

export type academyHistoryChallengesRetrieveResponse = (academyHistoryChallengesRetrieveResponseSuccess)

export const getAcademyHistoryChallengesRetrieveUrl = (id: string,) => {


  

  return `/api/v1/academy/history/challenges/${id}/`
}

export const academyHistoryChallengesRetrieve = async (id: string, options?: RequestInit): Promise<academyHistoryChallengesRetrieveResponse> => {
  
  return apiFetch<academyHistoryChallengesRetrieveResponse>(getAcademyHistoryChallengesRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyHistoryChallengesRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/academy/history/challenges/${id}/`
    ] as const;
    }

    
export const getAcademyHistoryChallengesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academyHistoryChallengesRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyHistoryChallengesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyHistoryChallengesRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyHistoryChallengesRetrieve>>> = ({ signal }) => academyHistoryChallengesRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyHistoryChallengesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyHistoryChallengesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academyHistoryChallengesRetrieve>>>
export type AcademyHistoryChallengesRetrieveQueryError = unknown


export function useAcademyHistoryChallengesRetrieve<TData = Awaited<ReturnType<typeof academyHistoryChallengesRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyHistoryChallengesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyHistoryChallengesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyHistoryChallengesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyHistoryChallengesRetrieve<TData = Awaited<ReturnType<typeof academyHistoryChallengesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyHistoryChallengesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyHistoryChallengesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyHistoryChallengesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyHistoryChallengesRetrieve<TData = Awaited<ReturnType<typeof academyHistoryChallengesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyHistoryChallengesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyHistoryChallengesRetrieve<TData = Awaited<ReturnType<typeof academyHistoryChallengesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyHistoryChallengesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyHistoryChallengesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * The saved correction of one try at a lesson.
 */
export type academyHistoryLessonsRetrieveResponse200 = {
  data: LessonCorrection
  status: 200
}
    
export type academyHistoryLessonsRetrieveResponseSuccess = (academyHistoryLessonsRetrieveResponse200) & {
  headers: Headers;
};
;

export type academyHistoryLessonsRetrieveResponse = (academyHistoryLessonsRetrieveResponseSuccess)

export const getAcademyHistoryLessonsRetrieveUrl = (id: string,
    params?: AcademyHistoryLessonsRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/history/lessons/${id}/?${stringifiedParams}` : `/api/v1/academy/history/lessons/${id}/`
}

export const academyHistoryLessonsRetrieve = async (id: string,
    params?: AcademyHistoryLessonsRetrieveParams, options?: RequestInit): Promise<academyHistoryLessonsRetrieveResponse> => {
  
  return apiFetch<academyHistoryLessonsRetrieveResponse>(getAcademyHistoryLessonsRetrieveUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyHistoryLessonsRetrieveQueryKey = (id?: string,
    params?: AcademyHistoryLessonsRetrieveParams,) => {
    return [
    `/api/v1/academy/history/lessons/${id}/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAcademyHistoryLessonsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academyHistoryLessonsRetrieve>>, TError = unknown>(id: string,
    params?: AcademyHistoryLessonsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyHistoryLessonsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyHistoryLessonsRetrieveQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyHistoryLessonsRetrieve>>> = ({ signal }) => academyHistoryLessonsRetrieve(id,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyHistoryLessonsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyHistoryLessonsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academyHistoryLessonsRetrieve>>>
export type AcademyHistoryLessonsRetrieveQueryError = unknown


export function useAcademyHistoryLessonsRetrieve<TData = Awaited<ReturnType<typeof academyHistoryLessonsRetrieve>>, TError = unknown>(
 id: string,
    params: undefined |  AcademyHistoryLessonsRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyHistoryLessonsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyHistoryLessonsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyHistoryLessonsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyHistoryLessonsRetrieve<TData = Awaited<ReturnType<typeof academyHistoryLessonsRetrieve>>, TError = unknown>(
 id: string,
    params?: AcademyHistoryLessonsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyHistoryLessonsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyHistoryLessonsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyHistoryLessonsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyHistoryLessonsRetrieve<TData = Awaited<ReturnType<typeof academyHistoryLessonsRetrieve>>, TError = unknown>(
 id: string,
    params?: AcademyHistoryLessonsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyHistoryLessonsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyHistoryLessonsRetrieve<TData = Awaited<ReturnType<typeof academyHistoryLessonsRetrieve>>, TError = unknown>(
 id: string,
    params?: AcademyHistoryLessonsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyHistoryLessonsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyHistoryLessonsRetrieveQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Start the exercises of the lesson again; the try under way is kept in the history.
 */
export type academyHistoryLessonsRetakeCreateResponse200 = {
  data: LessonRetake
  status: 200
}
    
export type academyHistoryLessonsRetakeCreateResponseSuccess = (academyHistoryLessonsRetakeCreateResponse200) & {
  headers: Headers;
};
;

export type academyHistoryLessonsRetakeCreateResponse = (academyHistoryLessonsRetakeCreateResponseSuccess)

export const getAcademyHistoryLessonsRetakeCreateUrl = (id: string,
    params?: AcademyHistoryLessonsRetakeCreateParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/history/lessons/${id}/retake/?${stringifiedParams}` : `/api/v1/academy/history/lessons/${id}/retake/`
}

export const academyHistoryLessonsRetakeCreate = async (id: string,
    params?: AcademyHistoryLessonsRetakeCreateParams, options?: RequestInit): Promise<academyHistoryLessonsRetakeCreateResponse> => {
  
  return apiFetch<academyHistoryLessonsRetakeCreateResponse>(getAcademyHistoryLessonsRetakeCreateUrl(id,params),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getAcademyHistoryLessonsRetakeCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyHistoryLessonsRetakeCreate>>, TError,{id: string;params?: AcademyHistoryLessonsRetakeCreateParams}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyHistoryLessonsRetakeCreate>>, TError,{id: string;params?: AcademyHistoryLessonsRetakeCreateParams}, TContext> => {

const mutationKey = ['academyHistoryLessonsRetakeCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyHistoryLessonsRetakeCreate>>, {id: string;params?: AcademyHistoryLessonsRetakeCreateParams}> = (props) => {
          const {id,params} = props ?? {};

          return  academyHistoryLessonsRetakeCreate(id,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyHistoryLessonsRetakeCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyHistoryLessonsRetakeCreate>>>
    
    export type AcademyHistoryLessonsRetakeCreateMutationError = unknown

    export const useAcademyHistoryLessonsRetakeCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyHistoryLessonsRetakeCreate>>, TError,{id: string;params?: AcademyHistoryLessonsRetakeCreateParams}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyHistoryLessonsRetakeCreate>>,
        TError,
        {id: string;params?: AcademyHistoryLessonsRetakeCreateParams},
        TContext
      > => {

      const mutationOptions = getAcademyHistoryLessonsRetakeCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * The mother tongues a learner can choose (versioned list).
 */
export type academyLanguagesListResponse200 = {
  data: SpokenLanguage[]
  status: 200
}
    
export type academyLanguagesListResponseSuccess = (academyLanguagesListResponse200) & {
  headers: Headers;
};
;

export type academyLanguagesListResponse = (academyLanguagesListResponseSuccess)

export const getAcademyLanguagesListUrl = () => {


  

  return `/api/v1/academy/languages/`
}

export const academyLanguagesList = async ( options?: RequestInit): Promise<academyLanguagesListResponse> => {
  
  return apiFetch<academyLanguagesListResponse>(getAcademyLanguagesListUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyLanguagesListQueryKey = () => {
    return [
    `/api/v1/academy/languages/`
    ] as const;
    }

    
export const getAcademyLanguagesListQueryOptions = <TData = Awaited<ReturnType<typeof academyLanguagesList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLanguagesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyLanguagesListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyLanguagesList>>> = ({ signal }) => academyLanguagesList({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyLanguagesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyLanguagesListQueryResult = NonNullable<Awaited<ReturnType<typeof academyLanguagesList>>>
export type AcademyLanguagesListQueryError = unknown


export function useAcademyLanguagesList<TData = Awaited<ReturnType<typeof academyLanguagesList>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLanguagesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyLanguagesList>>,
          TError,
          Awaited<ReturnType<typeof academyLanguagesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyLanguagesList<TData = Awaited<ReturnType<typeof academyLanguagesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLanguagesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyLanguagesList>>,
          TError,
          Awaited<ReturnType<typeof academyLanguagesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyLanguagesList<TData = Awaited<ReturnType<typeof academyLanguagesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLanguagesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyLanguagesList<TData = Awaited<ReturnType<typeof academyLanguagesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLanguagesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyLanguagesListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * A trainer or advisor looks at a learner's progress and prints the complete report.
 */
export type academyLearnerProgressListResponse200 = {
  data: PaginatedLearnerAdminList
  status: 200
}
    
export type academyLearnerProgressListResponseSuccess = (academyLearnerProgressListResponse200) & {
  headers: Headers;
};
;

export type academyLearnerProgressListResponse = (academyLearnerProgressListResponseSuccess)

export const getAcademyLearnerProgressListUrl = (params?: AcademyLearnerProgressListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/learner-progress/?${stringifiedParams}` : `/api/v1/academy/learner-progress/`
}

export const academyLearnerProgressList = async (params?: AcademyLearnerProgressListParams, options?: RequestInit): Promise<academyLearnerProgressListResponse> => {
  
  return apiFetch<academyLearnerProgressListResponse>(getAcademyLearnerProgressListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyLearnerProgressListQueryKey = (params?: AcademyLearnerProgressListParams,) => {
    return [
    `/api/v1/academy/learner-progress/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAcademyLearnerProgressListQueryOptions = <TData = Awaited<ReturnType<typeof academyLearnerProgressList>>, TError = unknown>(params?: AcademyLearnerProgressListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLearnerProgressList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyLearnerProgressListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyLearnerProgressList>>> = ({ signal }) => academyLearnerProgressList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyLearnerProgressList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyLearnerProgressListQueryResult = NonNullable<Awaited<ReturnType<typeof academyLearnerProgressList>>>
export type AcademyLearnerProgressListQueryError = unknown


export function useAcademyLearnerProgressList<TData = Awaited<ReturnType<typeof academyLearnerProgressList>>, TError = unknown>(
 params: undefined |  AcademyLearnerProgressListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLearnerProgressList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyLearnerProgressList>>,
          TError,
          Awaited<ReturnType<typeof academyLearnerProgressList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyLearnerProgressList<TData = Awaited<ReturnType<typeof academyLearnerProgressList>>, TError = unknown>(
 params?: AcademyLearnerProgressListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLearnerProgressList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyLearnerProgressList>>,
          TError,
          Awaited<ReturnType<typeof academyLearnerProgressList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyLearnerProgressList<TData = Awaited<ReturnType<typeof academyLearnerProgressList>>, TError = unknown>(
 params?: AcademyLearnerProgressListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLearnerProgressList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyLearnerProgressList<TData = Awaited<ReturnType<typeof academyLearnerProgressList>>, TError = unknown>(
 params?: AcademyLearnerProgressListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLearnerProgressList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyLearnerProgressListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * A trainer or advisor looks at a learner's progress and prints the complete report.
 */
export type academyLearnerProgressRetrieveResponse200 = {
  data: LearnerProgress
  status: 200
}
    
export type academyLearnerProgressRetrieveResponseSuccess = (academyLearnerProgressRetrieveResponse200) & {
  headers: Headers;
};
;

export type academyLearnerProgressRetrieveResponse = (academyLearnerProgressRetrieveResponseSuccess)

export const getAcademyLearnerProgressRetrieveUrl = (id: string,
    params?: AcademyLearnerProgressRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/learner-progress/${id}/?${stringifiedParams}` : `/api/v1/academy/learner-progress/${id}/`
}

export const academyLearnerProgressRetrieve = async (id: string,
    params?: AcademyLearnerProgressRetrieveParams, options?: RequestInit): Promise<academyLearnerProgressRetrieveResponse> => {
  
  return apiFetch<academyLearnerProgressRetrieveResponse>(getAcademyLearnerProgressRetrieveUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyLearnerProgressRetrieveQueryKey = (id?: string,
    params?: AcademyLearnerProgressRetrieveParams,) => {
    return [
    `/api/v1/academy/learner-progress/${id}/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAcademyLearnerProgressRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academyLearnerProgressRetrieve>>, TError = unknown>(id: string,
    params?: AcademyLearnerProgressRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLearnerProgressRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyLearnerProgressRetrieveQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyLearnerProgressRetrieve>>> = ({ signal }) => academyLearnerProgressRetrieve(id,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyLearnerProgressRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyLearnerProgressRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academyLearnerProgressRetrieve>>>
export type AcademyLearnerProgressRetrieveQueryError = unknown


export function useAcademyLearnerProgressRetrieve<TData = Awaited<ReturnType<typeof academyLearnerProgressRetrieve>>, TError = unknown>(
 id: string,
    params: undefined |  AcademyLearnerProgressRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLearnerProgressRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyLearnerProgressRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyLearnerProgressRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyLearnerProgressRetrieve<TData = Awaited<ReturnType<typeof academyLearnerProgressRetrieve>>, TError = unknown>(
 id: string,
    params?: AcademyLearnerProgressRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLearnerProgressRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyLearnerProgressRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyLearnerProgressRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyLearnerProgressRetrieve<TData = Awaited<ReturnType<typeof academyLearnerProgressRetrieve>>, TError = unknown>(
 id: string,
    params?: AcademyLearnerProgressRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLearnerProgressRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyLearnerProgressRetrieve<TData = Awaited<ReturnType<typeof academyLearnerProgressRetrieve>>, TError = unknown>(
 id: string,
    params?: AcademyLearnerProgressRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLearnerProgressRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyLearnerProgressRetrieveQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * A trainer or advisor looks at a learner's progress and prints the complete report.
 */
export type academyLearnerProgressReportCreateResponse201 = {
  data: GeneratedDocument
  status: 201
}
    
export type academyLearnerProgressReportCreateResponseSuccess = (academyLearnerProgressReportCreateResponse201) & {
  headers: Headers;
};
;

export type academyLearnerProgressReportCreateResponse = (academyLearnerProgressReportCreateResponseSuccess)

export const getAcademyLearnerProgressReportCreateUrl = (id: string,
    params?: AcademyLearnerProgressReportCreateParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/learner-progress/${id}/report/?${stringifiedParams}` : `/api/v1/academy/learner-progress/${id}/report/`
}

export const academyLearnerProgressReportCreate = async (id: string,
    params?: AcademyLearnerProgressReportCreateParams, options?: RequestInit): Promise<academyLearnerProgressReportCreateResponse> => {
  
  return apiFetch<academyLearnerProgressReportCreateResponse>(getAcademyLearnerProgressReportCreateUrl(id,params),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getAcademyLearnerProgressReportCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyLearnerProgressReportCreate>>, TError,{id: string;params?: AcademyLearnerProgressReportCreateParams}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyLearnerProgressReportCreate>>, TError,{id: string;params?: AcademyLearnerProgressReportCreateParams}, TContext> => {

const mutationKey = ['academyLearnerProgressReportCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyLearnerProgressReportCreate>>, {id: string;params?: AcademyLearnerProgressReportCreateParams}> = (props) => {
          const {id,params} = props ?? {};

          return  academyLearnerProgressReportCreate(id,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyLearnerProgressReportCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyLearnerProgressReportCreate>>>
    
    export type AcademyLearnerProgressReportCreateMutationError = unknown

    export const useAcademyLearnerProgressReportCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyLearnerProgressReportCreate>>, TError,{id: string;params?: AcademyLearnerProgressReportCreateParams}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyLearnerProgressReportCreate>>,
        TError,
        {id: string;params?: AcademyLearnerProgressReportCreateParams},
        TContext
      > => {

      const mutationOptions = getAcademyLearnerProgressReportCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type academyLearnersListResponse200 = {
  data: PaginatedLearnerAdminList
  status: 200
}
    
export type academyLearnersListResponseSuccess = (academyLearnersListResponse200) & {
  headers: Headers;
};
;

export type academyLearnersListResponse = (academyLearnersListResponseSuccess)

export const getAcademyLearnersListUrl = (params?: AcademyLearnersListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/learners/?${stringifiedParams}` : `/api/v1/academy/learners/`
}

export const academyLearnersList = async (params?: AcademyLearnersListParams, options?: RequestInit): Promise<academyLearnersListResponse> => {
  
  return apiFetch<academyLearnersListResponse>(getAcademyLearnersListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyLearnersListQueryKey = (params?: AcademyLearnersListParams,) => {
    return [
    `/api/v1/academy/learners/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAcademyLearnersListQueryOptions = <TData = Awaited<ReturnType<typeof academyLearnersList>>, TError = unknown>(params?: AcademyLearnersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLearnersList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyLearnersListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyLearnersList>>> = ({ signal }) => academyLearnersList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyLearnersList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyLearnersListQueryResult = NonNullable<Awaited<ReturnType<typeof academyLearnersList>>>
export type AcademyLearnersListQueryError = unknown


export function useAcademyLearnersList<TData = Awaited<ReturnType<typeof academyLearnersList>>, TError = unknown>(
 params: undefined |  AcademyLearnersListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLearnersList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyLearnersList>>,
          TError,
          Awaited<ReturnType<typeof academyLearnersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyLearnersList<TData = Awaited<ReturnType<typeof academyLearnersList>>, TError = unknown>(
 params?: AcademyLearnersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLearnersList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyLearnersList>>,
          TError,
          Awaited<ReturnType<typeof academyLearnersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyLearnersList<TData = Awaited<ReturnType<typeof academyLearnersList>>, TError = unknown>(
 params?: AcademyLearnersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLearnersList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyLearnersList<TData = Awaited<ReturnType<typeof academyLearnersList>>, TError = unknown>(
 params?: AcademyLearnersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLearnersList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyLearnersListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type academyLearnersRetrieveResponse200 = {
  data: LearnerAdmin
  status: 200
}
    
export type academyLearnersRetrieveResponseSuccess = (academyLearnersRetrieveResponse200) & {
  headers: Headers;
};
;

export type academyLearnersRetrieveResponse = (academyLearnersRetrieveResponseSuccess)

export const getAcademyLearnersRetrieveUrl = (id: string,) => {


  

  return `/api/v1/academy/learners/${id}/`
}

export const academyLearnersRetrieve = async (id: string, options?: RequestInit): Promise<academyLearnersRetrieveResponse> => {
  
  return apiFetch<academyLearnersRetrieveResponse>(getAcademyLearnersRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyLearnersRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/academy/learners/${id}/`
    ] as const;
    }

    
export const getAcademyLearnersRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academyLearnersRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLearnersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyLearnersRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyLearnersRetrieve>>> = ({ signal }) => academyLearnersRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyLearnersRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyLearnersRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academyLearnersRetrieve>>>
export type AcademyLearnersRetrieveQueryError = unknown


export function useAcademyLearnersRetrieve<TData = Awaited<ReturnType<typeof academyLearnersRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLearnersRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyLearnersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyLearnersRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyLearnersRetrieve<TData = Awaited<ReturnType<typeof academyLearnersRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLearnersRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyLearnersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyLearnersRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyLearnersRetrieve<TData = Awaited<ReturnType<typeof academyLearnersRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLearnersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyLearnersRetrieve<TData = Awaited<ReturnType<typeof academyLearnersRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLearnersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyLearnersRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Terms of sale, privacy, refund and cookies pages of the Academy (data, FR/EN).
 */
export type academyLegalRetrieveResponse200 = {
  data: AcademyLegalPage
  status: 200
}
    
export type academyLegalRetrieveResponseSuccess = (academyLegalRetrieveResponse200) & {
  headers: Headers;
};
;

export type academyLegalRetrieveResponse = (academyLegalRetrieveResponseSuccess)

export const getAcademyLegalRetrieveUrl = (page: string,
    params?: AcademyLegalRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/legal/${page}/?${stringifiedParams}` : `/api/v1/academy/legal/${page}/`
}

export const academyLegalRetrieve = async (page: string,
    params?: AcademyLegalRetrieveParams, options?: RequestInit): Promise<academyLegalRetrieveResponse> => {
  
  return apiFetch<academyLegalRetrieveResponse>(getAcademyLegalRetrieveUrl(page,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyLegalRetrieveQueryKey = (page?: string,
    params?: AcademyLegalRetrieveParams,) => {
    return [
    `/api/v1/academy/legal/${page}/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAcademyLegalRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academyLegalRetrieve>>, TError = unknown>(page: string,
    params?: AcademyLegalRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLegalRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyLegalRetrieveQueryKey(page,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyLegalRetrieve>>> = ({ signal }) => academyLegalRetrieve(page,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(page), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyLegalRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyLegalRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academyLegalRetrieve>>>
export type AcademyLegalRetrieveQueryError = unknown


export function useAcademyLegalRetrieve<TData = Awaited<ReturnType<typeof academyLegalRetrieve>>, TError = unknown>(
 page: string,
    params: undefined |  AcademyLegalRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLegalRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyLegalRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyLegalRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyLegalRetrieve<TData = Awaited<ReturnType<typeof academyLegalRetrieve>>, TError = unknown>(
 page: string,
    params?: AcademyLegalRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLegalRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyLegalRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyLegalRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyLegalRetrieve<TData = Awaited<ReturnType<typeof academyLegalRetrieve>>, TError = unknown>(
 page: string,
    params?: AcademyLegalRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLegalRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyLegalRetrieve<TData = Awaited<ReturnType<typeof academyLegalRetrieve>>, TError = unknown>(
 page: string,
    params?: AcademyLegalRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLegalRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyLegalRetrieveQueryOptions(page,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * The traps prepared by the AI for each mother tongue (D-122): a trainer reads them, corrects
them and marks them « relu » (or withdraws them).
 */
export type academyLessonPitfallsListResponse200 = {
  data: PaginatedLessonPitfallsTeamList
  status: 200
}
    
export type academyLessonPitfallsListResponseSuccess = (academyLessonPitfallsListResponse200) & {
  headers: Headers;
};
;

export type academyLessonPitfallsListResponse = (academyLessonPitfallsListResponseSuccess)

export const getAcademyLessonPitfallsListUrl = (params?: AcademyLessonPitfallsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/lesson-pitfalls/?${stringifiedParams}` : `/api/v1/academy/lesson-pitfalls/`
}

export const academyLessonPitfallsList = async (params?: AcademyLessonPitfallsListParams, options?: RequestInit): Promise<academyLessonPitfallsListResponse> => {
  
  return apiFetch<academyLessonPitfallsListResponse>(getAcademyLessonPitfallsListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyLessonPitfallsListQueryKey = (params?: AcademyLessonPitfallsListParams,) => {
    return [
    `/api/v1/academy/lesson-pitfalls/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAcademyLessonPitfallsListQueryOptions = <TData = Awaited<ReturnType<typeof academyLessonPitfallsList>>, TError = unknown>(params?: AcademyLessonPitfallsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLessonPitfallsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyLessonPitfallsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyLessonPitfallsList>>> = ({ signal }) => academyLessonPitfallsList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyLessonPitfallsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyLessonPitfallsListQueryResult = NonNullable<Awaited<ReturnType<typeof academyLessonPitfallsList>>>
export type AcademyLessonPitfallsListQueryError = unknown


export function useAcademyLessonPitfallsList<TData = Awaited<ReturnType<typeof academyLessonPitfallsList>>, TError = unknown>(
 params: undefined |  AcademyLessonPitfallsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLessonPitfallsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyLessonPitfallsList>>,
          TError,
          Awaited<ReturnType<typeof academyLessonPitfallsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyLessonPitfallsList<TData = Awaited<ReturnType<typeof academyLessonPitfallsList>>, TError = unknown>(
 params?: AcademyLessonPitfallsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLessonPitfallsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyLessonPitfallsList>>,
          TError,
          Awaited<ReturnType<typeof academyLessonPitfallsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyLessonPitfallsList<TData = Awaited<ReturnType<typeof academyLessonPitfallsList>>, TError = unknown>(
 params?: AcademyLessonPitfallsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLessonPitfallsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyLessonPitfallsList<TData = Awaited<ReturnType<typeof academyLessonPitfallsList>>, TError = unknown>(
 params?: AcademyLessonPitfallsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLessonPitfallsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyLessonPitfallsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * The traps prepared by the AI for each mother tongue (D-122): a trainer reads them, corrects
them and marks them « relu » (or withdraws them).
 */
export type academyLessonPitfallsRetrieveResponse200 = {
  data: LessonPitfallsTeam
  status: 200
}
    
export type academyLessonPitfallsRetrieveResponseSuccess = (academyLessonPitfallsRetrieveResponse200) & {
  headers: Headers;
};
;

export type academyLessonPitfallsRetrieveResponse = (academyLessonPitfallsRetrieveResponseSuccess)

export const getAcademyLessonPitfallsRetrieveUrl = (id: string,) => {


  

  return `/api/v1/academy/lesson-pitfalls/${id}/`
}

export const academyLessonPitfallsRetrieve = async (id: string, options?: RequestInit): Promise<academyLessonPitfallsRetrieveResponse> => {
  
  return apiFetch<academyLessonPitfallsRetrieveResponse>(getAcademyLessonPitfallsRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyLessonPitfallsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/academy/lesson-pitfalls/${id}/`
    ] as const;
    }

    
export const getAcademyLessonPitfallsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academyLessonPitfallsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLessonPitfallsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyLessonPitfallsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyLessonPitfallsRetrieve>>> = ({ signal }) => academyLessonPitfallsRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyLessonPitfallsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyLessonPitfallsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academyLessonPitfallsRetrieve>>>
export type AcademyLessonPitfallsRetrieveQueryError = unknown


export function useAcademyLessonPitfallsRetrieve<TData = Awaited<ReturnType<typeof academyLessonPitfallsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLessonPitfallsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyLessonPitfallsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyLessonPitfallsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyLessonPitfallsRetrieve<TData = Awaited<ReturnType<typeof academyLessonPitfallsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLessonPitfallsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyLessonPitfallsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyLessonPitfallsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyLessonPitfallsRetrieve<TData = Awaited<ReturnType<typeof academyLessonPitfallsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLessonPitfallsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyLessonPitfallsRetrieve<TData = Awaited<ReturnType<typeof academyLessonPitfallsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLessonPitfallsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyLessonPitfallsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * The traps prepared by the AI for each mother tongue (D-122): a trainer reads them, corrects
them and marks them « relu » (or withdraws them).
 */
export type academyLessonPitfallsPartialUpdateResponse200 = {
  data: LessonPitfallsTeam
  status: 200
}
    
export type academyLessonPitfallsPartialUpdateResponseSuccess = (academyLessonPitfallsPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type academyLessonPitfallsPartialUpdateResponse = (academyLessonPitfallsPartialUpdateResponseSuccess)

export const getAcademyLessonPitfallsPartialUpdateUrl = (id: string,) => {


  

  return `/api/v1/academy/lesson-pitfalls/${id}/`
}

export const academyLessonPitfallsPartialUpdate = async (id: string,
    patchedLessonPitfallsTeamRequest: PatchedLessonPitfallsTeamRequest, options?: RequestInit): Promise<academyLessonPitfallsPartialUpdateResponse> => {
  
  return apiFetch<academyLessonPitfallsPartialUpdateResponse>(getAcademyLessonPitfallsPartialUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedLessonPitfallsTeamRequest,)
  }
);}




export const getAcademyLessonPitfallsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyLessonPitfallsPartialUpdate>>, TError,{id: string;data: PatchedLessonPitfallsTeamRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyLessonPitfallsPartialUpdate>>, TError,{id: string;data: PatchedLessonPitfallsTeamRequest}, TContext> => {

const mutationKey = ['academyLessonPitfallsPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyLessonPitfallsPartialUpdate>>, {id: string;data: PatchedLessonPitfallsTeamRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  academyLessonPitfallsPartialUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyLessonPitfallsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof academyLessonPitfallsPartialUpdate>>>
    export type AcademyLessonPitfallsPartialUpdateMutationBody = PatchedLessonPitfallsTeamRequest
    export type AcademyLessonPitfallsPartialUpdateMutationError = unknown

    export const useAcademyLessonPitfallsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyLessonPitfallsPartialUpdate>>, TError,{id: string;data: PatchedLessonPitfallsTeamRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyLessonPitfallsPartialUpdate>>,
        TError,
        {id: string;data: PatchedLessonPitfallsTeamRequest},
        TContext
      > => {

      const mutationOptions = getAcademyLessonPitfallsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * The AI translations kept (read only): trainers can check what the learners read.
 */
export type academyLessonTranslationsListResponse200 = {
  data: PaginatedLessonTranslationList
  status: 200
}
    
export type academyLessonTranslationsListResponseSuccess = (academyLessonTranslationsListResponse200) & {
  headers: Headers;
};
;

export type academyLessonTranslationsListResponse = (academyLessonTranslationsListResponseSuccess)

export const getAcademyLessonTranslationsListUrl = (params?: AcademyLessonTranslationsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/lesson-translations/?${stringifiedParams}` : `/api/v1/academy/lesson-translations/`
}

export const academyLessonTranslationsList = async (params?: AcademyLessonTranslationsListParams, options?: RequestInit): Promise<academyLessonTranslationsListResponse> => {
  
  return apiFetch<academyLessonTranslationsListResponse>(getAcademyLessonTranslationsListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyLessonTranslationsListQueryKey = (params?: AcademyLessonTranslationsListParams,) => {
    return [
    `/api/v1/academy/lesson-translations/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAcademyLessonTranslationsListQueryOptions = <TData = Awaited<ReturnType<typeof academyLessonTranslationsList>>, TError = unknown>(params?: AcademyLessonTranslationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLessonTranslationsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyLessonTranslationsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyLessonTranslationsList>>> = ({ signal }) => academyLessonTranslationsList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyLessonTranslationsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyLessonTranslationsListQueryResult = NonNullable<Awaited<ReturnType<typeof academyLessonTranslationsList>>>
export type AcademyLessonTranslationsListQueryError = unknown


export function useAcademyLessonTranslationsList<TData = Awaited<ReturnType<typeof academyLessonTranslationsList>>, TError = unknown>(
 params: undefined |  AcademyLessonTranslationsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLessonTranslationsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyLessonTranslationsList>>,
          TError,
          Awaited<ReturnType<typeof academyLessonTranslationsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyLessonTranslationsList<TData = Awaited<ReturnType<typeof academyLessonTranslationsList>>, TError = unknown>(
 params?: AcademyLessonTranslationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLessonTranslationsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyLessonTranslationsList>>,
          TError,
          Awaited<ReturnType<typeof academyLessonTranslationsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyLessonTranslationsList<TData = Awaited<ReturnType<typeof academyLessonTranslationsList>>, TError = unknown>(
 params?: AcademyLessonTranslationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLessonTranslationsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyLessonTranslationsList<TData = Awaited<ReturnType<typeof academyLessonTranslationsList>>, TError = unknown>(
 params?: AcademyLessonTranslationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLessonTranslationsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyLessonTranslationsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * The AI translations kept (read only): trainers can check what the learners read.
 */
export type academyLessonTranslationsRetrieveResponse200 = {
  data: LessonTranslation
  status: 200
}
    
export type academyLessonTranslationsRetrieveResponseSuccess = (academyLessonTranslationsRetrieveResponse200) & {
  headers: Headers;
};
;

export type academyLessonTranslationsRetrieveResponse = (academyLessonTranslationsRetrieveResponseSuccess)

export const getAcademyLessonTranslationsRetrieveUrl = (id: string,) => {


  

  return `/api/v1/academy/lesson-translations/${id}/`
}

export const academyLessonTranslationsRetrieve = async (id: string, options?: RequestInit): Promise<academyLessonTranslationsRetrieveResponse> => {
  
  return apiFetch<academyLessonTranslationsRetrieveResponse>(getAcademyLessonTranslationsRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyLessonTranslationsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/academy/lesson-translations/${id}/`
    ] as const;
    }

    
export const getAcademyLessonTranslationsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academyLessonTranslationsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLessonTranslationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyLessonTranslationsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyLessonTranslationsRetrieve>>> = ({ signal }) => academyLessonTranslationsRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyLessonTranslationsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyLessonTranslationsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academyLessonTranslationsRetrieve>>>
export type AcademyLessonTranslationsRetrieveQueryError = unknown


export function useAcademyLessonTranslationsRetrieve<TData = Awaited<ReturnType<typeof academyLessonTranslationsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLessonTranslationsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyLessonTranslationsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyLessonTranslationsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyLessonTranslationsRetrieve<TData = Awaited<ReturnType<typeof academyLessonTranslationsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLessonTranslationsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyLessonTranslationsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyLessonTranslationsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyLessonTranslationsRetrieve<TData = Awaited<ReturnType<typeof academyLessonTranslationsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLessonTranslationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyLessonTranslationsRetrieve<TData = Awaited<ReturnType<typeof academyLessonTranslationsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLessonTranslationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyLessonTranslationsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Trainers read, correct, review and publish the lessons (anti-plagiarism filter).
 */
export type academyLessonsListResponse200 = {
  data: PaginatedLessonList
  status: 200
}
    
export type academyLessonsListResponseSuccess = (academyLessonsListResponse200) & {
  headers: Headers;
};
;

export type academyLessonsListResponse = (academyLessonsListResponseSuccess)

export const getAcademyLessonsListUrl = (params?: AcademyLessonsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/lessons/?${stringifiedParams}` : `/api/v1/academy/lessons/`
}

export const academyLessonsList = async (params?: AcademyLessonsListParams, options?: RequestInit): Promise<academyLessonsListResponse> => {
  
  return apiFetch<academyLessonsListResponse>(getAcademyLessonsListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyLessonsListQueryKey = (params?: AcademyLessonsListParams,) => {
    return [
    `/api/v1/academy/lessons/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAcademyLessonsListQueryOptions = <TData = Awaited<ReturnType<typeof academyLessonsList>>, TError = unknown>(params?: AcademyLessonsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLessonsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyLessonsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyLessonsList>>> = ({ signal }) => academyLessonsList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyLessonsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyLessonsListQueryResult = NonNullable<Awaited<ReturnType<typeof academyLessonsList>>>
export type AcademyLessonsListQueryError = unknown


export function useAcademyLessonsList<TData = Awaited<ReturnType<typeof academyLessonsList>>, TError = unknown>(
 params: undefined |  AcademyLessonsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLessonsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyLessonsList>>,
          TError,
          Awaited<ReturnType<typeof academyLessonsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyLessonsList<TData = Awaited<ReturnType<typeof academyLessonsList>>, TError = unknown>(
 params?: AcademyLessonsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLessonsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyLessonsList>>,
          TError,
          Awaited<ReturnType<typeof academyLessonsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyLessonsList<TData = Awaited<ReturnType<typeof academyLessonsList>>, TError = unknown>(
 params?: AcademyLessonsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLessonsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyLessonsList<TData = Awaited<ReturnType<typeof academyLessonsList>>, TError = unknown>(
 params?: AcademyLessonsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLessonsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyLessonsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Trainers read, correct, review and publish the lessons (anti-plagiarism filter).
 */
export type academyLessonsRetrieveResponse200 = {
  data: Lesson
  status: 200
}
    
export type academyLessonsRetrieveResponseSuccess = (academyLessonsRetrieveResponse200) & {
  headers: Headers;
};
;

export type academyLessonsRetrieveResponse = (academyLessonsRetrieveResponseSuccess)

export const getAcademyLessonsRetrieveUrl = (id: string,) => {


  

  return `/api/v1/academy/lessons/${id}/`
}

export const academyLessonsRetrieve = async (id: string, options?: RequestInit): Promise<academyLessonsRetrieveResponse> => {
  
  return apiFetch<academyLessonsRetrieveResponse>(getAcademyLessonsRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyLessonsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/academy/lessons/${id}/`
    ] as const;
    }

    
export const getAcademyLessonsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academyLessonsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLessonsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyLessonsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyLessonsRetrieve>>> = ({ signal }) => academyLessonsRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyLessonsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyLessonsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academyLessonsRetrieve>>>
export type AcademyLessonsRetrieveQueryError = unknown


export function useAcademyLessonsRetrieve<TData = Awaited<ReturnType<typeof academyLessonsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLessonsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyLessonsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyLessonsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyLessonsRetrieve<TData = Awaited<ReturnType<typeof academyLessonsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLessonsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyLessonsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyLessonsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyLessonsRetrieve<TData = Awaited<ReturnType<typeof academyLessonsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLessonsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyLessonsRetrieve<TData = Awaited<ReturnType<typeof academyLessonsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyLessonsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyLessonsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Trainers read, correct, review and publish the lessons (anti-plagiarism filter).
 */
export type academyLessonsPartialUpdateResponse200 = {
  data: Lesson
  status: 200
}
    
export type academyLessonsPartialUpdateResponseSuccess = (academyLessonsPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type academyLessonsPartialUpdateResponse = (academyLessonsPartialUpdateResponseSuccess)

export const getAcademyLessonsPartialUpdateUrl = (id: string,) => {


  

  return `/api/v1/academy/lessons/${id}/`
}

export const academyLessonsPartialUpdate = async (id: string,
    patchedLessonRequest: PatchedLessonRequest, options?: RequestInit): Promise<academyLessonsPartialUpdateResponse> => {
  
  return apiFetch<academyLessonsPartialUpdateResponse>(getAcademyLessonsPartialUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedLessonRequest,)
  }
);}




export const getAcademyLessonsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyLessonsPartialUpdate>>, TError,{id: string;data: PatchedLessonRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyLessonsPartialUpdate>>, TError,{id: string;data: PatchedLessonRequest}, TContext> => {

const mutationKey = ['academyLessonsPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyLessonsPartialUpdate>>, {id: string;data: PatchedLessonRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  academyLessonsPartialUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyLessonsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof academyLessonsPartialUpdate>>>
    export type AcademyLessonsPartialUpdateMutationBody = PatchedLessonRequest
    export type AcademyLessonsPartialUpdateMutationError = unknown

    export const useAcademyLessonsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyLessonsPartialUpdate>>, TError,{id: string;data: PatchedLessonRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyLessonsPartialUpdate>>,
        TError,
        {id: string;data: PatchedLessonRequest},
        TContext
      > => {

      const mutationOptions = getAcademyLessonsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Trainers read, correct, review and publish the lessons (anti-plagiarism filter).
 */
export type academyLessonsPublishCreateResponse200 = {
  data: Lesson
  status: 200
}
    
export type academyLessonsPublishCreateResponseSuccess = (academyLessonsPublishCreateResponse200) & {
  headers: Headers;
};
;

export type academyLessonsPublishCreateResponse = (academyLessonsPublishCreateResponseSuccess)

export const getAcademyLessonsPublishCreateUrl = (id: string,) => {


  

  return `/api/v1/academy/lessons/${id}/publish/`
}

export const academyLessonsPublishCreate = async (id: string, options?: RequestInit): Promise<academyLessonsPublishCreateResponse> => {
  
  return apiFetch<academyLessonsPublishCreateResponse>(getAcademyLessonsPublishCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getAcademyLessonsPublishCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyLessonsPublishCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyLessonsPublishCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['academyLessonsPublishCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyLessonsPublishCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  academyLessonsPublishCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyLessonsPublishCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyLessonsPublishCreate>>>
    
    export type AcademyLessonsPublishCreateMutationError = unknown

    export const useAcademyLessonsPublishCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyLessonsPublishCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyLessonsPublishCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getAcademyLessonsPublishCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Trainers read, correct, review and publish the lessons (anti-plagiarism filter).
 */
export type academyLessonsReviewCreateResponse200 = {
  data: Lesson
  status: 200
}
    
export type academyLessonsReviewCreateResponseSuccess = (academyLessonsReviewCreateResponse200) & {
  headers: Headers;
};
;

export type academyLessonsReviewCreateResponse = (academyLessonsReviewCreateResponseSuccess)

export const getAcademyLessonsReviewCreateUrl = (id: string,) => {


  

  return `/api/v1/academy/lessons/${id}/review/`
}

export const academyLessonsReviewCreate = async (id: string, options?: RequestInit): Promise<academyLessonsReviewCreateResponse> => {
  
  return apiFetch<academyLessonsReviewCreateResponse>(getAcademyLessonsReviewCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getAcademyLessonsReviewCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyLessonsReviewCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyLessonsReviewCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['academyLessonsReviewCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyLessonsReviewCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  academyLessonsReviewCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyLessonsReviewCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyLessonsReviewCreate>>>
    
    export type AcademyLessonsReviewCreateMutationError = unknown

    export const useAcademyLessonsReviewCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyLessonsReviewCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyLessonsReviewCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getAcademyLessonsReviewCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * The signed-in learner only: never an agency member's tools.
 */
export type academyMeRetrieveResponse200 = {
  data: Learner
  status: 200
}
    
export type academyMeRetrieveResponseSuccess = (academyMeRetrieveResponse200) & {
  headers: Headers;
};
;

export type academyMeRetrieveResponse = (academyMeRetrieveResponseSuccess)

export const getAcademyMeRetrieveUrl = () => {


  

  return `/api/v1/academy/me/`
}

export const academyMeRetrieve = async ( options?: RequestInit): Promise<academyMeRetrieveResponse> => {
  
  return apiFetch<academyMeRetrieveResponse>(getAcademyMeRetrieveUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyMeRetrieveQueryKey = () => {
    return [
    `/api/v1/academy/me/`
    ] as const;
    }

    
export const getAcademyMeRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academyMeRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyMeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyMeRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyMeRetrieve>>> = ({ signal }) => academyMeRetrieve({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyMeRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyMeRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academyMeRetrieve>>>
export type AcademyMeRetrieveQueryError = unknown


export function useAcademyMeRetrieve<TData = Awaited<ReturnType<typeof academyMeRetrieve>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyMeRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyMeRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyMeRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyMeRetrieve<TData = Awaited<ReturnType<typeof academyMeRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyMeRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyMeRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyMeRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyMeRetrieve<TData = Awaited<ReturnType<typeof academyMeRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyMeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyMeRetrieve<TData = Awaited<ReturnType<typeof academyMeRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyMeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyMeRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * The signed-in learner only: never an agency member's tools.
 */
export type academyMePartialUpdateResponse200 = {
  data: Learner
  status: 200
}
    
export type academyMePartialUpdateResponseSuccess = (academyMePartialUpdateResponse200) & {
  headers: Headers;
};
;

export type academyMePartialUpdateResponse = (academyMePartialUpdateResponseSuccess)

export const getAcademyMePartialUpdateUrl = () => {


  

  return `/api/v1/academy/me/`
}

export const academyMePartialUpdate = async (patchedLearnerRequest: PatchedLearnerRequest, options?: RequestInit): Promise<academyMePartialUpdateResponse> => {
  
  return apiFetch<academyMePartialUpdateResponse>(getAcademyMePartialUpdateUrl(),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedLearnerRequest,)
  }
);}




export const getAcademyMePartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyMePartialUpdate>>, TError,{data: PatchedLearnerRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyMePartialUpdate>>, TError,{data: PatchedLearnerRequest}, TContext> => {

const mutationKey = ['academyMePartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyMePartialUpdate>>, {data: PatchedLearnerRequest}> = (props) => {
          const {data} = props ?? {};

          return  academyMePartialUpdate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyMePartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof academyMePartialUpdate>>>
    export type AcademyMePartialUpdateMutationBody = PatchedLearnerRequest
    export type AcademyMePartialUpdateMutationError = unknown

    export const useAcademyMePartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyMePartialUpdate>>, TError,{data: PatchedLearnerRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyMePartialUpdate>>,
        TError,
        {data: PatchedLearnerRequest},
        TContext
      > => {

      const mutationOptions = getAcademyMePartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * The exams the learner prepares, with the goal of each (TCF: NCLC, IELTS: band).
 */
export type academyMeExamsListResponse200 = {
  data: ExamProfile[]
  status: 200
}
    
export type academyMeExamsListResponseSuccess = (academyMeExamsListResponse200) & {
  headers: Headers;
};
;

export type academyMeExamsListResponse = (academyMeExamsListResponseSuccess)

export const getAcademyMeExamsListUrl = () => {


  

  return `/api/v1/academy/me/exams/`
}

export const academyMeExamsList = async ( options?: RequestInit): Promise<academyMeExamsListResponse> => {
  
  return apiFetch<academyMeExamsListResponse>(getAcademyMeExamsListUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyMeExamsListQueryKey = () => {
    return [
    `/api/v1/academy/me/exams/`
    ] as const;
    }

    
export const getAcademyMeExamsListQueryOptions = <TData = Awaited<ReturnType<typeof academyMeExamsList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyMeExamsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyMeExamsListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyMeExamsList>>> = ({ signal }) => academyMeExamsList({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyMeExamsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyMeExamsListQueryResult = NonNullable<Awaited<ReturnType<typeof academyMeExamsList>>>
export type AcademyMeExamsListQueryError = unknown


export function useAcademyMeExamsList<TData = Awaited<ReturnType<typeof academyMeExamsList>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyMeExamsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyMeExamsList>>,
          TError,
          Awaited<ReturnType<typeof academyMeExamsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyMeExamsList<TData = Awaited<ReturnType<typeof academyMeExamsList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyMeExamsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyMeExamsList>>,
          TError,
          Awaited<ReturnType<typeof academyMeExamsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyMeExamsList<TData = Awaited<ReturnType<typeof academyMeExamsList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyMeExamsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyMeExamsList<TData = Awaited<ReturnType<typeof academyMeExamsList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyMeExamsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyMeExamsListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Follow an exam and set its goal (target, date, centre).
 */
export type academyMeExamsCreateResponse200 = {
  data: ExamProfile[]
  status: 200
}
    
export type academyMeExamsCreateResponseSuccess = (academyMeExamsCreateResponse200) & {
  headers: Headers;
};
;

export type academyMeExamsCreateResponse = (academyMeExamsCreateResponseSuccess)

export const getAcademyMeExamsCreateUrl = () => {


  

  return `/api/v1/academy/me/exams/`
}

export const academyMeExamsCreate = async (examProfileRequest: ExamProfileRequest, options?: RequestInit): Promise<academyMeExamsCreateResponse> => {
  
  return apiFetch<academyMeExamsCreateResponse>(getAcademyMeExamsCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      examProfileRequest,)
  }
);}




export const getAcademyMeExamsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyMeExamsCreate>>, TError,{data: ExamProfileRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyMeExamsCreate>>, TError,{data: ExamProfileRequest}, TContext> => {

const mutationKey = ['academyMeExamsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyMeExamsCreate>>, {data: ExamProfileRequest}> = (props) => {
          const {data} = props ?? {};

          return  academyMeExamsCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyMeExamsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyMeExamsCreate>>>
    export type AcademyMeExamsCreateMutationBody = ExamProfileRequest
    export type AcademyMeExamsCreateMutationError = unknown

    export const useAcademyMeExamsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyMeExamsCreate>>, TError,{data: ExamProfileRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyMeExamsCreate>>,
        TError,
        {data: ExamProfileRequest},
        TContext
      > => {

      const mutationOptions = getAcademyMeExamsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Oral credits left (1 per examiner session) and the date they come back (D-124).
 */
export type academyMeOralCreditsRetrieveResponse200 = {
  data: OralCredits
  status: 200
}
    
export type academyMeOralCreditsRetrieveResponseSuccess = (academyMeOralCreditsRetrieveResponse200) & {
  headers: Headers;
};
;

export type academyMeOralCreditsRetrieveResponse = (academyMeOralCreditsRetrieveResponseSuccess)

export const getAcademyMeOralCreditsRetrieveUrl = () => {


  

  return `/api/v1/academy/me/oral-credits/`
}

export const academyMeOralCreditsRetrieve = async ( options?: RequestInit): Promise<academyMeOralCreditsRetrieveResponse> => {
  
  return apiFetch<academyMeOralCreditsRetrieveResponse>(getAcademyMeOralCreditsRetrieveUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyMeOralCreditsRetrieveQueryKey = () => {
    return [
    `/api/v1/academy/me/oral-credits/`
    ] as const;
    }

    
export const getAcademyMeOralCreditsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academyMeOralCreditsRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyMeOralCreditsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyMeOralCreditsRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyMeOralCreditsRetrieve>>> = ({ signal }) => academyMeOralCreditsRetrieve({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyMeOralCreditsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyMeOralCreditsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academyMeOralCreditsRetrieve>>>
export type AcademyMeOralCreditsRetrieveQueryError = unknown


export function useAcademyMeOralCreditsRetrieve<TData = Awaited<ReturnType<typeof academyMeOralCreditsRetrieve>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyMeOralCreditsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyMeOralCreditsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyMeOralCreditsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyMeOralCreditsRetrieve<TData = Awaited<ReturnType<typeof academyMeOralCreditsRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyMeOralCreditsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyMeOralCreditsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyMeOralCreditsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyMeOralCreditsRetrieve<TData = Awaited<ReturnType<typeof academyMeOralCreditsRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyMeOralCreditsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyMeOralCreditsRetrieve<TData = Awaited<ReturnType<typeof academyMeOralCreditsRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyMeOralCreditsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyMeOralCreditsRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * What the learner may review, and their reviews (with their status).
 */
export type academyMeReviewsRetrieveResponse200 = {
  data: MyReviews
  status: 200
}
    
export type academyMeReviewsRetrieveResponseSuccess = (academyMeReviewsRetrieveResponse200) & {
  headers: Headers;
};
;

export type academyMeReviewsRetrieveResponse = (academyMeReviewsRetrieveResponseSuccess)

export const getAcademyMeReviewsRetrieveUrl = () => {


  

  return `/api/v1/academy/me/reviews/`
}

export const academyMeReviewsRetrieve = async ( options?: RequestInit): Promise<academyMeReviewsRetrieveResponse> => {
  
  return apiFetch<academyMeReviewsRetrieveResponse>(getAcademyMeReviewsRetrieveUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyMeReviewsRetrieveQueryKey = () => {
    return [
    `/api/v1/academy/me/reviews/`
    ] as const;
    }

    
export const getAcademyMeReviewsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academyMeReviewsRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyMeReviewsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyMeReviewsRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyMeReviewsRetrieve>>> = ({ signal }) => academyMeReviewsRetrieve({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyMeReviewsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyMeReviewsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academyMeReviewsRetrieve>>>
export type AcademyMeReviewsRetrieveQueryError = unknown


export function useAcademyMeReviewsRetrieve<TData = Awaited<ReturnType<typeof academyMeReviewsRetrieve>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyMeReviewsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyMeReviewsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyMeReviewsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyMeReviewsRetrieve<TData = Awaited<ReturnType<typeof academyMeReviewsRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyMeReviewsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyMeReviewsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyMeReviewsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyMeReviewsRetrieve<TData = Awaited<ReturnType<typeof academyMeReviewsRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyMeReviewsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyMeReviewsRetrieve<TData = Awaited<ReturnType<typeof academyMeReviewsRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyMeReviewsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyMeReviewsRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * What the learner may review, and their reviews (with their status).
 */
export type academyMeReviewsCreateResponse201 = {
  data: MyTestimonial
  status: 201
}
    
export type academyMeReviewsCreateResponseSuccess = (academyMeReviewsCreateResponse201) & {
  headers: Headers;
};
;

export type academyMeReviewsCreateResponse = (academyMeReviewsCreateResponseSuccess)

export const getAcademyMeReviewsCreateUrl = () => {


  

  return `/api/v1/academy/me/reviews/`
}

export const academyMeReviewsCreate = async (reviewSubmitRequest: ReviewSubmitRequest, options?: RequestInit): Promise<academyMeReviewsCreateResponse> => {
  
  return apiFetch<academyMeReviewsCreateResponse>(getAcademyMeReviewsCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      reviewSubmitRequest,)
  }
);}




export const getAcademyMeReviewsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyMeReviewsCreate>>, TError,{data: ReviewSubmitRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyMeReviewsCreate>>, TError,{data: ReviewSubmitRequest}, TContext> => {

const mutationKey = ['academyMeReviewsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyMeReviewsCreate>>, {data: ReviewSubmitRequest}> = (props) => {
          const {data} = props ?? {};

          return  academyMeReviewsCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyMeReviewsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyMeReviewsCreate>>>
    export type AcademyMeReviewsCreateMutationBody = ReviewSubmitRequest
    export type AcademyMeReviewsCreateMutationError = unknown

    export const useAcademyMeReviewsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyMeReviewsCreate>>, TError,{data: ReviewSubmitRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyMeReviewsCreate>>,
        TError,
        {data: ReviewSubmitRequest},
        TContext
      > => {

      const mutationOptions = getAcademyMeReviewsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * The learner withdraws their review (it disappears from the site at once).
 */
export type academyMeReviewsWithdrawCreateResponse200 = {
  data: MyTestimonial
  status: 200
}
    
export type academyMeReviewsWithdrawCreateResponseSuccess = (academyMeReviewsWithdrawCreateResponse200) & {
  headers: Headers;
};
;

export type academyMeReviewsWithdrawCreateResponse = (academyMeReviewsWithdrawCreateResponseSuccess)

export const getAcademyMeReviewsWithdrawCreateUrl = (id: string,) => {


  

  return `/api/v1/academy/me/reviews/${id}/withdraw/`
}

export const academyMeReviewsWithdrawCreate = async (id: string, options?: RequestInit): Promise<academyMeReviewsWithdrawCreateResponse> => {
  
  return apiFetch<academyMeReviewsWithdrawCreateResponse>(getAcademyMeReviewsWithdrawCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getAcademyMeReviewsWithdrawCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyMeReviewsWithdrawCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyMeReviewsWithdrawCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['academyMeReviewsWithdrawCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyMeReviewsWithdrawCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  academyMeReviewsWithdrawCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyMeReviewsWithdrawCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyMeReviewsWithdrawCreate>>>
    
    export type AcademyMeReviewsWithdrawCreateMutationError = unknown

    export const useAcademyMeReviewsWithdrawCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyMeReviewsWithdrawCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyMeReviewsWithdrawCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getAcademyMeReviewsWithdrawCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type academyMockExamsListResponse200 = {
  data: PaginatedMockExamList
  status: 200
}
    
export type academyMockExamsListResponseSuccess = (academyMockExamsListResponse200) & {
  headers: Headers;
};
;

export type academyMockExamsListResponse = (academyMockExamsListResponseSuccess)

export const getAcademyMockExamsListUrl = (params?: AcademyMockExamsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/mock-exams/?${stringifiedParams}` : `/api/v1/academy/mock-exams/`
}

export const academyMockExamsList = async (params?: AcademyMockExamsListParams, options?: RequestInit): Promise<academyMockExamsListResponse> => {
  
  return apiFetch<academyMockExamsListResponse>(getAcademyMockExamsListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyMockExamsListQueryKey = (params?: AcademyMockExamsListParams,) => {
    return [
    `/api/v1/academy/mock-exams/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAcademyMockExamsListQueryOptions = <TData = Awaited<ReturnType<typeof academyMockExamsList>>, TError = unknown>(params?: AcademyMockExamsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyMockExamsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyMockExamsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyMockExamsList>>> = ({ signal }) => academyMockExamsList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyMockExamsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyMockExamsListQueryResult = NonNullable<Awaited<ReturnType<typeof academyMockExamsList>>>
export type AcademyMockExamsListQueryError = unknown


export function useAcademyMockExamsList<TData = Awaited<ReturnType<typeof academyMockExamsList>>, TError = unknown>(
 params: undefined |  AcademyMockExamsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyMockExamsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyMockExamsList>>,
          TError,
          Awaited<ReturnType<typeof academyMockExamsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyMockExamsList<TData = Awaited<ReturnType<typeof academyMockExamsList>>, TError = unknown>(
 params?: AcademyMockExamsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyMockExamsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyMockExamsList>>,
          TError,
          Awaited<ReturnType<typeof academyMockExamsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyMockExamsList<TData = Awaited<ReturnType<typeof academyMockExamsList>>, TError = unknown>(
 params?: AcademyMockExamsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyMockExamsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyMockExamsList<TData = Awaited<ReturnType<typeof academyMockExamsList>>, TError = unknown>(
 params?: AcademyMockExamsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyMockExamsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyMockExamsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type academyMockExamsRetrieveResponse200 = {
  data: MockExam
  status: 200
}
    
export type academyMockExamsRetrieveResponseSuccess = (academyMockExamsRetrieveResponse200) & {
  headers: Headers;
};
;

export type academyMockExamsRetrieveResponse = (academyMockExamsRetrieveResponseSuccess)

export const getAcademyMockExamsRetrieveUrl = (id: string,) => {


  

  return `/api/v1/academy/mock-exams/${id}/`
}

export const academyMockExamsRetrieve = async (id: string, options?: RequestInit): Promise<academyMockExamsRetrieveResponse> => {
  
  return apiFetch<academyMockExamsRetrieveResponse>(getAcademyMockExamsRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyMockExamsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/academy/mock-exams/${id}/`
    ] as const;
    }

    
export const getAcademyMockExamsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academyMockExamsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyMockExamsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyMockExamsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyMockExamsRetrieve>>> = ({ signal }) => academyMockExamsRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyMockExamsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyMockExamsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academyMockExamsRetrieve>>>
export type AcademyMockExamsRetrieveQueryError = unknown


export function useAcademyMockExamsRetrieve<TData = Awaited<ReturnType<typeof academyMockExamsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyMockExamsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyMockExamsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyMockExamsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyMockExamsRetrieve<TData = Awaited<ReturnType<typeof academyMockExamsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyMockExamsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyMockExamsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyMockExamsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyMockExamsRetrieve<TData = Awaited<ReturnType<typeof academyMockExamsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyMockExamsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyMockExamsRetrieve<TData = Awaited<ReturnType<typeof academyMockExamsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyMockExamsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyMockExamsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type academyMockExamsPartialUpdateResponse200 = {
  data: MockExam
  status: 200
}
    
export type academyMockExamsPartialUpdateResponseSuccess = (academyMockExamsPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type academyMockExamsPartialUpdateResponse = (academyMockExamsPartialUpdateResponseSuccess)

export const getAcademyMockExamsPartialUpdateUrl = (id: string,) => {


  

  return `/api/v1/academy/mock-exams/${id}/`
}

export const academyMockExamsPartialUpdate = async (id: string,
    patchedMockExamRequest: PatchedMockExamRequest, options?: RequestInit): Promise<academyMockExamsPartialUpdateResponse> => {
  
  return apiFetch<academyMockExamsPartialUpdateResponse>(getAcademyMockExamsPartialUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedMockExamRequest,)
  }
);}




export const getAcademyMockExamsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyMockExamsPartialUpdate>>, TError,{id: string;data: PatchedMockExamRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyMockExamsPartialUpdate>>, TError,{id: string;data: PatchedMockExamRequest}, TContext> => {

const mutationKey = ['academyMockExamsPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyMockExamsPartialUpdate>>, {id: string;data: PatchedMockExamRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  academyMockExamsPartialUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyMockExamsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof academyMockExamsPartialUpdate>>>
    export type AcademyMockExamsPartialUpdateMutationBody = PatchedMockExamRequest
    export type AcademyMockExamsPartialUpdateMutationError = unknown

    export const useAcademyMockExamsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyMockExamsPartialUpdate>>, TError,{id: string;data: PatchedMockExamRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyMockExamsPartialUpdate>>,
        TError,
        {id: string;data: PatchedMockExamRequest},
        TContext
      > => {

      const mutationOptions = getAcademyMockExamsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * The numbered mock exams with the official structure; start one.
 */
export type academyMocksListResponse200 = {
  data: MockExamLearner[]
  status: 200
}
    
export type academyMocksListResponseSuccess = (academyMocksListResponse200) & {
  headers: Headers;
};
;

export type academyMocksListResponse = (academyMocksListResponseSuccess)

export const getAcademyMocksListUrl = (params?: AcademyMocksListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/mocks/?${stringifiedParams}` : `/api/v1/academy/mocks/`
}

export const academyMocksList = async (params?: AcademyMocksListParams, options?: RequestInit): Promise<academyMocksListResponse> => {
  
  return apiFetch<academyMocksListResponse>(getAcademyMocksListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyMocksListQueryKey = (params?: AcademyMocksListParams,) => {
    return [
    `/api/v1/academy/mocks/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAcademyMocksListQueryOptions = <TData = Awaited<ReturnType<typeof academyMocksList>>, TError = unknown>(params?: AcademyMocksListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyMocksList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyMocksListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyMocksList>>> = ({ signal }) => academyMocksList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyMocksList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyMocksListQueryResult = NonNullable<Awaited<ReturnType<typeof academyMocksList>>>
export type AcademyMocksListQueryError = unknown


export function useAcademyMocksList<TData = Awaited<ReturnType<typeof academyMocksList>>, TError = unknown>(
 params: undefined |  AcademyMocksListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyMocksList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyMocksList>>,
          TError,
          Awaited<ReturnType<typeof academyMocksList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyMocksList<TData = Awaited<ReturnType<typeof academyMocksList>>, TError = unknown>(
 params?: AcademyMocksListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyMocksList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyMocksList>>,
          TError,
          Awaited<ReturnType<typeof academyMocksList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyMocksList<TData = Awaited<ReturnType<typeof academyMocksList>>, TError = unknown>(
 params?: AcademyMocksListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyMocksList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyMocksList<TData = Awaited<ReturnType<typeof academyMocksList>>, TError = unknown>(
 params?: AcademyMocksListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyMocksList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyMocksListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * The numbered mock exams with the official structure; start one.
 */
export type academyMocksCreateResponse201 = {
  data: Attempt
  status: 201
}
    
export type academyMocksCreateResponseSuccess = (academyMocksCreateResponse201) & {
  headers: Headers;
};
;

export type academyMocksCreateResponse = (academyMocksCreateResponseSuccess)

export const getAcademyMocksCreateUrl = () => {


  

  return `/api/v1/academy/mocks/`
}

export const academyMocksCreate = async (startMockRequest: StartMockRequest, options?: RequestInit): Promise<academyMocksCreateResponse> => {
  
  return apiFetch<academyMocksCreateResponse>(getAcademyMocksCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      startMockRequest,)
  }
);}




export const getAcademyMocksCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyMocksCreate>>, TError,{data: StartMockRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyMocksCreate>>, TError,{data: StartMockRequest}, TContext> => {

const mutationKey = ['academyMocksCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyMocksCreate>>, {data: StartMockRequest}> = (props) => {
          const {data} = props ?? {};

          return  academyMocksCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyMocksCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyMocksCreate>>>
    export type AcademyMocksCreateMutationBody = StartMockRequest
    export type AcademyMocksCreateMutationError = unknown

    export const useAcademyMocksCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyMocksCreate>>, TError,{data: StartMockRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyMocksCreate>>,
        TError,
        {data: StartMockRequest},
        TContext
      > => {

      const mutationOptions = getAcademyMocksCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Session analyses: the AI analyses the reported sessions of a centre and prepares the
urgent session mock exam (every night, or on demand); an admin sends it by hand.
 */
export type academyMonthlyPacksListResponse200 = {
  data: PaginatedMonthlyPackList
  status: 200
}
    
export type academyMonthlyPacksListResponseSuccess = (academyMonthlyPacksListResponse200) & {
  headers: Headers;
};
;

export type academyMonthlyPacksListResponse = (academyMonthlyPacksListResponseSuccess)

export const getAcademyMonthlyPacksListUrl = (params?: AcademyMonthlyPacksListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/monthly-packs/?${stringifiedParams}` : `/api/v1/academy/monthly-packs/`
}

export const academyMonthlyPacksList = async (params?: AcademyMonthlyPacksListParams, options?: RequestInit): Promise<academyMonthlyPacksListResponse> => {
  
  return apiFetch<academyMonthlyPacksListResponse>(getAcademyMonthlyPacksListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyMonthlyPacksListQueryKey = (params?: AcademyMonthlyPacksListParams,) => {
    return [
    `/api/v1/academy/monthly-packs/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAcademyMonthlyPacksListQueryOptions = <TData = Awaited<ReturnType<typeof academyMonthlyPacksList>>, TError = unknown>(params?: AcademyMonthlyPacksListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyMonthlyPacksList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyMonthlyPacksListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyMonthlyPacksList>>> = ({ signal }) => academyMonthlyPacksList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyMonthlyPacksList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyMonthlyPacksListQueryResult = NonNullable<Awaited<ReturnType<typeof academyMonthlyPacksList>>>
export type AcademyMonthlyPacksListQueryError = unknown


export function useAcademyMonthlyPacksList<TData = Awaited<ReturnType<typeof academyMonthlyPacksList>>, TError = unknown>(
 params: undefined |  AcademyMonthlyPacksListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyMonthlyPacksList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyMonthlyPacksList>>,
          TError,
          Awaited<ReturnType<typeof academyMonthlyPacksList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyMonthlyPacksList<TData = Awaited<ReturnType<typeof academyMonthlyPacksList>>, TError = unknown>(
 params?: AcademyMonthlyPacksListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyMonthlyPacksList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyMonthlyPacksList>>,
          TError,
          Awaited<ReturnType<typeof academyMonthlyPacksList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyMonthlyPacksList<TData = Awaited<ReturnType<typeof academyMonthlyPacksList>>, TError = unknown>(
 params?: AcademyMonthlyPacksListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyMonthlyPacksList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyMonthlyPacksList<TData = Awaited<ReturnType<typeof academyMonthlyPacksList>>, TError = unknown>(
 params?: AcademyMonthlyPacksListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyMonthlyPacksList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyMonthlyPacksListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Session analyses: the AI analyses the reported sessions of a centre and prepares the
urgent session mock exam (every night, or on demand); an admin sends it by hand.
 */
export type academyMonthlyPacksRetrieveResponse200 = {
  data: MonthlyPack
  status: 200
}
    
export type academyMonthlyPacksRetrieveResponseSuccess = (academyMonthlyPacksRetrieveResponse200) & {
  headers: Headers;
};
;

export type academyMonthlyPacksRetrieveResponse = (academyMonthlyPacksRetrieveResponseSuccess)

export const getAcademyMonthlyPacksRetrieveUrl = (id: string,) => {


  

  return `/api/v1/academy/monthly-packs/${id}/`
}

export const academyMonthlyPacksRetrieve = async (id: string, options?: RequestInit): Promise<academyMonthlyPacksRetrieveResponse> => {
  
  return apiFetch<academyMonthlyPacksRetrieveResponse>(getAcademyMonthlyPacksRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyMonthlyPacksRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/academy/monthly-packs/${id}/`
    ] as const;
    }

    
export const getAcademyMonthlyPacksRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academyMonthlyPacksRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyMonthlyPacksRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyMonthlyPacksRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyMonthlyPacksRetrieve>>> = ({ signal }) => academyMonthlyPacksRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyMonthlyPacksRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyMonthlyPacksRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academyMonthlyPacksRetrieve>>>
export type AcademyMonthlyPacksRetrieveQueryError = unknown


export function useAcademyMonthlyPacksRetrieve<TData = Awaited<ReturnType<typeof academyMonthlyPacksRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyMonthlyPacksRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyMonthlyPacksRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyMonthlyPacksRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyMonthlyPacksRetrieve<TData = Awaited<ReturnType<typeof academyMonthlyPacksRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyMonthlyPacksRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyMonthlyPacksRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyMonthlyPacksRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyMonthlyPacksRetrieve<TData = Awaited<ReturnType<typeof academyMonthlyPacksRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyMonthlyPacksRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyMonthlyPacksRetrieve<TData = Awaited<ReturnType<typeof academyMonthlyPacksRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyMonthlyPacksRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyMonthlyPacksRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Session analyses: the AI analyses the reported sessions of a centre and prepares the
urgent session mock exam (every night, or on demand); an admin sends it by hand.
 */
export type academyMonthlyPacksSendCreateResponse200 = {
  data: MonthlyPack
  status: 200
}
    
export type academyMonthlyPacksSendCreateResponseSuccess = (academyMonthlyPacksSendCreateResponse200) & {
  headers: Headers;
};
;

export type academyMonthlyPacksSendCreateResponse = (academyMonthlyPacksSendCreateResponseSuccess)

export const getAcademyMonthlyPacksSendCreateUrl = (id: string,) => {


  

  return `/api/v1/academy/monthly-packs/${id}/send/`
}

export const academyMonthlyPacksSendCreate = async (id: string, options?: RequestInit): Promise<academyMonthlyPacksSendCreateResponse> => {
  
  return apiFetch<academyMonthlyPacksSendCreateResponse>(getAcademyMonthlyPacksSendCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getAcademyMonthlyPacksSendCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyMonthlyPacksSendCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyMonthlyPacksSendCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['academyMonthlyPacksSendCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyMonthlyPacksSendCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  academyMonthlyPacksSendCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyMonthlyPacksSendCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyMonthlyPacksSendCreate>>>
    
    export type AcademyMonthlyPacksSendCreateMutationError = unknown

    export const useAcademyMonthlyPacksSendCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyMonthlyPacksSendCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyMonthlyPacksSendCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getAcademyMonthlyPacksSendCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Session analyses: the AI analyses the reported sessions of a centre and prepares the
urgent session mock exam (every night, or on demand); an admin sends it by hand.
 */
export type academyMonthlyPacksAnalysisRetrieveResponse200 = {
  data: MonthAnalysis
  status: 200
}
    
export type academyMonthlyPacksAnalysisRetrieveResponseSuccess = (academyMonthlyPacksAnalysisRetrieveResponse200) & {
  headers: Headers;
};
;

export type academyMonthlyPacksAnalysisRetrieveResponse = (academyMonthlyPacksAnalysisRetrieveResponseSuccess)

export const getAcademyMonthlyPacksAnalysisRetrieveUrl = (params?: AcademyMonthlyPacksAnalysisRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/monthly-packs/analysis/?${stringifiedParams}` : `/api/v1/academy/monthly-packs/analysis/`
}

export const academyMonthlyPacksAnalysisRetrieve = async (params?: AcademyMonthlyPacksAnalysisRetrieveParams, options?: RequestInit): Promise<academyMonthlyPacksAnalysisRetrieveResponse> => {
  
  return apiFetch<academyMonthlyPacksAnalysisRetrieveResponse>(getAcademyMonthlyPacksAnalysisRetrieveUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyMonthlyPacksAnalysisRetrieveQueryKey = (params?: AcademyMonthlyPacksAnalysisRetrieveParams,) => {
    return [
    `/api/v1/academy/monthly-packs/analysis/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAcademyMonthlyPacksAnalysisRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academyMonthlyPacksAnalysisRetrieve>>, TError = unknown>(params?: AcademyMonthlyPacksAnalysisRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyMonthlyPacksAnalysisRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyMonthlyPacksAnalysisRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyMonthlyPacksAnalysisRetrieve>>> = ({ signal }) => academyMonthlyPacksAnalysisRetrieve(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyMonthlyPacksAnalysisRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyMonthlyPacksAnalysisRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academyMonthlyPacksAnalysisRetrieve>>>
export type AcademyMonthlyPacksAnalysisRetrieveQueryError = unknown


export function useAcademyMonthlyPacksAnalysisRetrieve<TData = Awaited<ReturnType<typeof academyMonthlyPacksAnalysisRetrieve>>, TError = unknown>(
 params: undefined |  AcademyMonthlyPacksAnalysisRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyMonthlyPacksAnalysisRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyMonthlyPacksAnalysisRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyMonthlyPacksAnalysisRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyMonthlyPacksAnalysisRetrieve<TData = Awaited<ReturnType<typeof academyMonthlyPacksAnalysisRetrieve>>, TError = unknown>(
 params?: AcademyMonthlyPacksAnalysisRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyMonthlyPacksAnalysisRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyMonthlyPacksAnalysisRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyMonthlyPacksAnalysisRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyMonthlyPacksAnalysisRetrieve<TData = Awaited<ReturnType<typeof academyMonthlyPacksAnalysisRetrieve>>, TError = unknown>(
 params?: AcademyMonthlyPacksAnalysisRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyMonthlyPacksAnalysisRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyMonthlyPacksAnalysisRetrieve<TData = Awaited<ReturnType<typeof academyMonthlyPacksAnalysisRetrieve>>, TError = unknown>(
 params?: AcademyMonthlyPacksAnalysisRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyMonthlyPacksAnalysisRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyMonthlyPacksAnalysisRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Session analyses: the AI analyses the reported sessions of a centre and prepares the
urgent session mock exam (every night, or on demand); an admin sends it by hand.
 */
export type academyMonthlyPacksBuildCreateResponse201 = {
  data: MonthlyPack
  status: 201
}
    
export type academyMonthlyPacksBuildCreateResponseSuccess = (academyMonthlyPacksBuildCreateResponse201) & {
  headers: Headers;
};
;

export type academyMonthlyPacksBuildCreateResponse = (academyMonthlyPacksBuildCreateResponseSuccess)

export const getAcademyMonthlyPacksBuildCreateUrl = () => {


  

  return `/api/v1/academy/monthly-packs/build/`
}

export const academyMonthlyPacksBuildCreate = async (buildMonthRequest: BuildMonthRequest, options?: RequestInit): Promise<academyMonthlyPacksBuildCreateResponse> => {
  
  return apiFetch<academyMonthlyPacksBuildCreateResponse>(getAcademyMonthlyPacksBuildCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      buildMonthRequest,)
  }
);}




export const getAcademyMonthlyPacksBuildCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyMonthlyPacksBuildCreate>>, TError,{data: BuildMonthRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyMonthlyPacksBuildCreate>>, TError,{data: BuildMonthRequest}, TContext> => {

const mutationKey = ['academyMonthlyPacksBuildCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyMonthlyPacksBuildCreate>>, {data: BuildMonthRequest}> = (props) => {
          const {data} = props ?? {};

          return  academyMonthlyPacksBuildCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyMonthlyPacksBuildCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyMonthlyPacksBuildCreate>>>
    export type AcademyMonthlyPacksBuildCreateMutationBody = BuildMonthRequest
    export type AcademyMonthlyPacksBuildCreateMutationError = unknown

    export const useAcademyMonthlyPacksBuildCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyMonthlyPacksBuildCreate>>, TError,{data: BuildMonthRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyMonthlyPacksBuildCreate>>,
        TError,
        {data: BuildMonthRequest},
        TContext
      > => {

      const mutationOptions = getAcademyMonthlyPacksBuildCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * « Écouter » a translated help text: server voice, else the device, else French/English.
 */
export type academyMotherTongueListenCreateResponse200 = {
  data: Listen
  status: 200
}
    
export type academyMotherTongueListenCreateResponseSuccess = (academyMotherTongueListenCreateResponse200) & {
  headers: Headers;
};
;

export type academyMotherTongueListenCreateResponse = (academyMotherTongueListenCreateResponseSuccess)

export const getAcademyMotherTongueListenCreateUrl = () => {


  

  return `/api/v1/academy/mother-tongue/listen/`
}

export const academyMotherTongueListenCreate = async (textListenRequestRequest: TextListenRequestRequest, options?: RequestInit): Promise<academyMotherTongueListenCreateResponse> => {
  
  return apiFetch<academyMotherTongueListenCreateResponse>(getAcademyMotherTongueListenCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      textListenRequestRequest,)
  }
);}




export const getAcademyMotherTongueListenCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyMotherTongueListenCreate>>, TError,{data: TextListenRequestRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyMotherTongueListenCreate>>, TError,{data: TextListenRequestRequest}, TContext> => {

const mutationKey = ['academyMotherTongueListenCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyMotherTongueListenCreate>>, {data: TextListenRequestRequest}> = (props) => {
          const {data} = props ?? {};

          return  academyMotherTongueListenCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyMotherTongueListenCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyMotherTongueListenCreate>>>
    export type AcademyMotherTongueListenCreateMutationBody = TextListenRequestRequest
    export type AcademyMotherTongueListenCreateMutationError = unknown

    export const useAcademyMotherTongueListenCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyMotherTongueListenCreate>>, TError,{data: TextListenRequestRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyMotherTongueListenCreate>>,
        TError,
        {data: TextListenRequestRequest},
        TContext
      > => {

      const mutationOptions = getAcademyMotherTongueListenCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * « Traduire dans ma langue » of any help text (D-122): the kept translations at once, the
new ones made in the background (ask again to read them). Refused (409) while a timed exam
section is running: the exam content is never translated.
 */
export type academyMotherTongueTextsCreateResponse200 = {
  data: Texts
  status: 200
}
    
export type academyMotherTongueTextsCreateResponseSuccess = (academyMotherTongueTextsCreateResponse200) & {
  headers: Headers;
};
;

export type academyMotherTongueTextsCreateResponse = (academyMotherTongueTextsCreateResponseSuccess)

export const getAcademyMotherTongueTextsCreateUrl = () => {


  

  return `/api/v1/academy/mother-tongue/texts/`
}

export const academyMotherTongueTextsCreate = async (textsRequestRequest: TextsRequestRequest, options?: RequestInit): Promise<academyMotherTongueTextsCreateResponse> => {
  
  return apiFetch<academyMotherTongueTextsCreateResponse>(getAcademyMotherTongueTextsCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      textsRequestRequest,)
  }
);}




export const getAcademyMotherTongueTextsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyMotherTongueTextsCreate>>, TError,{data: TextsRequestRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyMotherTongueTextsCreate>>, TError,{data: TextsRequestRequest}, TContext> => {

const mutationKey = ['academyMotherTongueTextsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyMotherTongueTextsCreate>>, {data: TextsRequestRequest}> = (props) => {
          const {data} = props ?? {};

          return  academyMotherTongueTextsCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyMotherTongueTextsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyMotherTongueTextsCreate>>>
    export type AcademyMotherTongueTextsCreateMutationBody = TextsRequestRequest
    export type AcademyMotherTongueTextsCreateMutationError = unknown

    export const useAcademyMotherTongueTextsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyMotherTongueTextsCreate>>, TError,{data: TextsRequestRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyMotherTongueTextsCreate>>,
        TError,
        {data: TextsRequestRequest},
        TContext
      > => {

      const mutationOptions = getAcademyMotherTongueTextsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * The trainers' windows for mock orals. A trainer manages their own; the owner and the
manager everyone's (only for members whose languages fit the exams chosen).
 */
export type academyOralAvailabilityListResponse200 = {
  data: PaginatedTrainerAvailabilityList
  status: 200
}
    
export type academyOralAvailabilityListResponseSuccess = (academyOralAvailabilityListResponse200) & {
  headers: Headers;
};
;

export type academyOralAvailabilityListResponse = (academyOralAvailabilityListResponseSuccess)

export const getAcademyOralAvailabilityListUrl = (params?: AcademyOralAvailabilityListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/oral-availability/?${stringifiedParams}` : `/api/v1/academy/oral-availability/`
}

export const academyOralAvailabilityList = async (params?: AcademyOralAvailabilityListParams, options?: RequestInit): Promise<academyOralAvailabilityListResponse> => {
  
  return apiFetch<academyOralAvailabilityListResponse>(getAcademyOralAvailabilityListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyOralAvailabilityListQueryKey = (params?: AcademyOralAvailabilityListParams,) => {
    return [
    `/api/v1/academy/oral-availability/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAcademyOralAvailabilityListQueryOptions = <TData = Awaited<ReturnType<typeof academyOralAvailabilityList>>, TError = unknown>(params?: AcademyOralAvailabilityListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyOralAvailabilityList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyOralAvailabilityListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyOralAvailabilityList>>> = ({ signal }) => academyOralAvailabilityList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyOralAvailabilityList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyOralAvailabilityListQueryResult = NonNullable<Awaited<ReturnType<typeof academyOralAvailabilityList>>>
export type AcademyOralAvailabilityListQueryError = unknown


export function useAcademyOralAvailabilityList<TData = Awaited<ReturnType<typeof academyOralAvailabilityList>>, TError = unknown>(
 params: undefined |  AcademyOralAvailabilityListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyOralAvailabilityList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyOralAvailabilityList>>,
          TError,
          Awaited<ReturnType<typeof academyOralAvailabilityList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyOralAvailabilityList<TData = Awaited<ReturnType<typeof academyOralAvailabilityList>>, TError = unknown>(
 params?: AcademyOralAvailabilityListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyOralAvailabilityList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyOralAvailabilityList>>,
          TError,
          Awaited<ReturnType<typeof academyOralAvailabilityList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyOralAvailabilityList<TData = Awaited<ReturnType<typeof academyOralAvailabilityList>>, TError = unknown>(
 params?: AcademyOralAvailabilityListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyOralAvailabilityList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyOralAvailabilityList<TData = Awaited<ReturnType<typeof academyOralAvailabilityList>>, TError = unknown>(
 params?: AcademyOralAvailabilityListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyOralAvailabilityList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyOralAvailabilityListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * The trainers' windows for mock orals. A trainer manages their own; the owner and the
manager everyone's (only for members whose languages fit the exams chosen).
 */
export type academyOralAvailabilityCreateResponse201 = {
  data: TrainerAvailability
  status: 201
}
    
export type academyOralAvailabilityCreateResponseSuccess = (academyOralAvailabilityCreateResponse201) & {
  headers: Headers;
};
;

export type academyOralAvailabilityCreateResponse = (academyOralAvailabilityCreateResponseSuccess)

export const getAcademyOralAvailabilityCreateUrl = (params?: AcademyOralAvailabilityCreateParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/oral-availability/?${stringifiedParams}` : `/api/v1/academy/oral-availability/`
}

export const academyOralAvailabilityCreate = async (trainerAvailabilityRequest: TrainerAvailabilityRequest,
    params?: AcademyOralAvailabilityCreateParams, options?: RequestInit): Promise<academyOralAvailabilityCreateResponse> => {
  
  return apiFetch<academyOralAvailabilityCreateResponse>(getAcademyOralAvailabilityCreateUrl(params),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      trainerAvailabilityRequest,)
  }
);}




export const getAcademyOralAvailabilityCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyOralAvailabilityCreate>>, TError,{data: TrainerAvailabilityRequest;params?: AcademyOralAvailabilityCreateParams}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyOralAvailabilityCreate>>, TError,{data: TrainerAvailabilityRequest;params?: AcademyOralAvailabilityCreateParams}, TContext> => {

const mutationKey = ['academyOralAvailabilityCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyOralAvailabilityCreate>>, {data: TrainerAvailabilityRequest;params?: AcademyOralAvailabilityCreateParams}> = (props) => {
          const {data,params} = props ?? {};

          return  academyOralAvailabilityCreate(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyOralAvailabilityCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyOralAvailabilityCreate>>>
    export type AcademyOralAvailabilityCreateMutationBody = TrainerAvailabilityRequest
    export type AcademyOralAvailabilityCreateMutationError = unknown

    export const useAcademyOralAvailabilityCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyOralAvailabilityCreate>>, TError,{data: TrainerAvailabilityRequest;params?: AcademyOralAvailabilityCreateParams}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyOralAvailabilityCreate>>,
        TError,
        {data: TrainerAvailabilityRequest;params?: AcademyOralAvailabilityCreateParams},
        TContext
      > => {

      const mutationOptions = getAcademyOralAvailabilityCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * The trainers' windows for mock orals. A trainer manages their own; the owner and the
manager everyone's (only for members whose languages fit the exams chosen).
 */
export type academyOralAvailabilityRetrieveResponse200 = {
  data: TrainerAvailability
  status: 200
}
    
export type academyOralAvailabilityRetrieveResponseSuccess = (academyOralAvailabilityRetrieveResponse200) & {
  headers: Headers;
};
;

export type academyOralAvailabilityRetrieveResponse = (academyOralAvailabilityRetrieveResponseSuccess)

export const getAcademyOralAvailabilityRetrieveUrl = (id: string,
    params?: AcademyOralAvailabilityRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/oral-availability/${id}/?${stringifiedParams}` : `/api/v1/academy/oral-availability/${id}/`
}

export const academyOralAvailabilityRetrieve = async (id: string,
    params?: AcademyOralAvailabilityRetrieveParams, options?: RequestInit): Promise<academyOralAvailabilityRetrieveResponse> => {
  
  return apiFetch<academyOralAvailabilityRetrieveResponse>(getAcademyOralAvailabilityRetrieveUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyOralAvailabilityRetrieveQueryKey = (id?: string,
    params?: AcademyOralAvailabilityRetrieveParams,) => {
    return [
    `/api/v1/academy/oral-availability/${id}/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAcademyOralAvailabilityRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academyOralAvailabilityRetrieve>>, TError = unknown>(id: string,
    params?: AcademyOralAvailabilityRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyOralAvailabilityRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyOralAvailabilityRetrieveQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyOralAvailabilityRetrieve>>> = ({ signal }) => academyOralAvailabilityRetrieve(id,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyOralAvailabilityRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyOralAvailabilityRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academyOralAvailabilityRetrieve>>>
export type AcademyOralAvailabilityRetrieveQueryError = unknown


export function useAcademyOralAvailabilityRetrieve<TData = Awaited<ReturnType<typeof academyOralAvailabilityRetrieve>>, TError = unknown>(
 id: string,
    params: undefined |  AcademyOralAvailabilityRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyOralAvailabilityRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyOralAvailabilityRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyOralAvailabilityRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyOralAvailabilityRetrieve<TData = Awaited<ReturnType<typeof academyOralAvailabilityRetrieve>>, TError = unknown>(
 id: string,
    params?: AcademyOralAvailabilityRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyOralAvailabilityRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyOralAvailabilityRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyOralAvailabilityRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyOralAvailabilityRetrieve<TData = Awaited<ReturnType<typeof academyOralAvailabilityRetrieve>>, TError = unknown>(
 id: string,
    params?: AcademyOralAvailabilityRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyOralAvailabilityRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyOralAvailabilityRetrieve<TData = Awaited<ReturnType<typeof academyOralAvailabilityRetrieve>>, TError = unknown>(
 id: string,
    params?: AcademyOralAvailabilityRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyOralAvailabilityRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyOralAvailabilityRetrieveQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * The trainers' windows for mock orals. A trainer manages their own; the owner and the
manager everyone's (only for members whose languages fit the exams chosen).
 */
export type academyOralAvailabilityPartialUpdateResponse200 = {
  data: TrainerAvailability
  status: 200
}
    
export type academyOralAvailabilityPartialUpdateResponseSuccess = (academyOralAvailabilityPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type academyOralAvailabilityPartialUpdateResponse = (academyOralAvailabilityPartialUpdateResponseSuccess)

export const getAcademyOralAvailabilityPartialUpdateUrl = (id: string,
    params?: AcademyOralAvailabilityPartialUpdateParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/oral-availability/${id}/?${stringifiedParams}` : `/api/v1/academy/oral-availability/${id}/`
}

export const academyOralAvailabilityPartialUpdate = async (id: string,
    patchedTrainerAvailabilityRequest: PatchedTrainerAvailabilityRequest,
    params?: AcademyOralAvailabilityPartialUpdateParams, options?: RequestInit): Promise<academyOralAvailabilityPartialUpdateResponse> => {
  
  return apiFetch<academyOralAvailabilityPartialUpdateResponse>(getAcademyOralAvailabilityPartialUpdateUrl(id,params),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedTrainerAvailabilityRequest,)
  }
);}




export const getAcademyOralAvailabilityPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyOralAvailabilityPartialUpdate>>, TError,{id: string;data: PatchedTrainerAvailabilityRequest;params?: AcademyOralAvailabilityPartialUpdateParams}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyOralAvailabilityPartialUpdate>>, TError,{id: string;data: PatchedTrainerAvailabilityRequest;params?: AcademyOralAvailabilityPartialUpdateParams}, TContext> => {

const mutationKey = ['academyOralAvailabilityPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyOralAvailabilityPartialUpdate>>, {id: string;data: PatchedTrainerAvailabilityRequest;params?: AcademyOralAvailabilityPartialUpdateParams}> = (props) => {
          const {id,data,params} = props ?? {};

          return  academyOralAvailabilityPartialUpdate(id,data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyOralAvailabilityPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof academyOralAvailabilityPartialUpdate>>>
    export type AcademyOralAvailabilityPartialUpdateMutationBody = PatchedTrainerAvailabilityRequest
    export type AcademyOralAvailabilityPartialUpdateMutationError = unknown

    export const useAcademyOralAvailabilityPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyOralAvailabilityPartialUpdate>>, TError,{id: string;data: PatchedTrainerAvailabilityRequest;params?: AcademyOralAvailabilityPartialUpdateParams}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyOralAvailabilityPartialUpdate>>,
        TError,
        {id: string;data: PatchedTrainerAvailabilityRequest;params?: AcademyOralAvailabilityPartialUpdateParams},
        TContext
      > => {

      const mutationOptions = getAcademyOralAvailabilityPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * The trainers' windows for mock orals. A trainer manages their own; the owner and the
manager everyone's (only for members whose languages fit the exams chosen).
 */
export type academyOralAvailabilityDestroyResponse204 = {
  data: void
  status: 204
}
    
export type academyOralAvailabilityDestroyResponseSuccess = (academyOralAvailabilityDestroyResponse204) & {
  headers: Headers;
};
;

export type academyOralAvailabilityDestroyResponse = (academyOralAvailabilityDestroyResponseSuccess)

export const getAcademyOralAvailabilityDestroyUrl = (id: string,
    params?: AcademyOralAvailabilityDestroyParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/oral-availability/${id}/?${stringifiedParams}` : `/api/v1/academy/oral-availability/${id}/`
}

export const academyOralAvailabilityDestroy = async (id: string,
    params?: AcademyOralAvailabilityDestroyParams, options?: RequestInit): Promise<academyOralAvailabilityDestroyResponse> => {
  
  return apiFetch<academyOralAvailabilityDestroyResponse>(getAcademyOralAvailabilityDestroyUrl(id,params),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}




export const getAcademyOralAvailabilityDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyOralAvailabilityDestroy>>, TError,{id: string;params?: AcademyOralAvailabilityDestroyParams}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyOralAvailabilityDestroy>>, TError,{id: string;params?: AcademyOralAvailabilityDestroyParams}, TContext> => {

const mutationKey = ['academyOralAvailabilityDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyOralAvailabilityDestroy>>, {id: string;params?: AcademyOralAvailabilityDestroyParams}> = (props) => {
          const {id,params} = props ?? {};

          return  academyOralAvailabilityDestroy(id,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyOralAvailabilityDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof academyOralAvailabilityDestroy>>>
    
    export type AcademyOralAvailabilityDestroyMutationError = unknown

    export const useAcademyOralAvailabilityDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyOralAvailabilityDestroy>>, TError,{id: string;params?: AcademyOralAvailabilityDestroyParams}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyOralAvailabilityDestroy>>,
        TError,
        {id: string;params?: AcademyOralAvailabilityDestroyParams},
        TContext
      > => {

      const mutationOptions = getAcademyOralAvailabilityDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Journal of a learner's oral credits; the team adds credits (commercial gesture, reason
required, audit log) (D-124).
 */
export type academyOralCreditsListResponse200 = {
  data: PaginatedOralCreditEntryList
  status: 200
}
    
export type academyOralCreditsListResponseSuccess = (academyOralCreditsListResponse200) & {
  headers: Headers;
};
;

export type academyOralCreditsListResponse = (academyOralCreditsListResponseSuccess)

export const getAcademyOralCreditsListUrl = (params?: AcademyOralCreditsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/oral-credits/?${stringifiedParams}` : `/api/v1/academy/oral-credits/`
}

export const academyOralCreditsList = async (params?: AcademyOralCreditsListParams, options?: RequestInit): Promise<academyOralCreditsListResponse> => {
  
  return apiFetch<academyOralCreditsListResponse>(getAcademyOralCreditsListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyOralCreditsListQueryKey = (params?: AcademyOralCreditsListParams,) => {
    return [
    `/api/v1/academy/oral-credits/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAcademyOralCreditsListQueryOptions = <TData = Awaited<ReturnType<typeof academyOralCreditsList>>, TError = unknown>(params?: AcademyOralCreditsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyOralCreditsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyOralCreditsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyOralCreditsList>>> = ({ signal }) => academyOralCreditsList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyOralCreditsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyOralCreditsListQueryResult = NonNullable<Awaited<ReturnType<typeof academyOralCreditsList>>>
export type AcademyOralCreditsListQueryError = unknown


export function useAcademyOralCreditsList<TData = Awaited<ReturnType<typeof academyOralCreditsList>>, TError = unknown>(
 params: undefined |  AcademyOralCreditsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyOralCreditsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyOralCreditsList>>,
          TError,
          Awaited<ReturnType<typeof academyOralCreditsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyOralCreditsList<TData = Awaited<ReturnType<typeof academyOralCreditsList>>, TError = unknown>(
 params?: AcademyOralCreditsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyOralCreditsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyOralCreditsList>>,
          TError,
          Awaited<ReturnType<typeof academyOralCreditsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyOralCreditsList<TData = Awaited<ReturnType<typeof academyOralCreditsList>>, TError = unknown>(
 params?: AcademyOralCreditsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyOralCreditsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyOralCreditsList<TData = Awaited<ReturnType<typeof academyOralCreditsList>>, TError = unknown>(
 params?: AcademyOralCreditsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyOralCreditsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyOralCreditsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Journal of a learner's oral credits; the team adds credits (commercial gesture, reason
required, audit log) (D-124).
 */
export type academyOralCreditsCreateResponse201 = {
  data: OralCreditEntry
  status: 201
}
    
export type academyOralCreditsCreateResponseSuccess = (academyOralCreditsCreateResponse201) & {
  headers: Headers;
};
;

export type academyOralCreditsCreateResponse = (academyOralCreditsCreateResponseSuccess)

export const getAcademyOralCreditsCreateUrl = () => {


  

  return `/api/v1/academy/oral-credits/`
}

export const academyOralCreditsCreate = async (oralCreditEntryRequest: OralCreditEntryRequest, options?: RequestInit): Promise<academyOralCreditsCreateResponse> => {
  
  return apiFetch<academyOralCreditsCreateResponse>(getAcademyOralCreditsCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      oralCreditEntryRequest,)
  }
);}




export const getAcademyOralCreditsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyOralCreditsCreate>>, TError,{data: OralCreditEntryRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyOralCreditsCreate>>, TError,{data: OralCreditEntryRequest}, TContext> => {

const mutationKey = ['academyOralCreditsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyOralCreditsCreate>>, {data: OralCreditEntryRequest}> = (props) => {
          const {data} = props ?? {};

          return  academyOralCreditsCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyOralCreditsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyOralCreditsCreate>>>
    export type AcademyOralCreditsCreateMutationBody = OralCreditEntryRequest
    export type AcademyOralCreditsCreateMutationError = unknown

    export const useAcademyOralCreditsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyOralCreditsCreate>>, TError,{data: OralCreditEntryRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyOralCreditsCreate>>,
        TError,
        {data: OralCreditEntryRequest},
        TContext
      > => {

      const mutationOptions = getAcademyOralCreditsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Journal of a learner's oral credits; the team adds credits (commercial gesture, reason
required, audit log) (D-124).
 */
export type academyOralCreditsRetrieveResponse200 = {
  data: OralCreditEntry
  status: 200
}
    
export type academyOralCreditsRetrieveResponseSuccess = (academyOralCreditsRetrieveResponse200) & {
  headers: Headers;
};
;

export type academyOralCreditsRetrieveResponse = (academyOralCreditsRetrieveResponseSuccess)

export const getAcademyOralCreditsRetrieveUrl = (id: string,) => {


  

  return `/api/v1/academy/oral-credits/${id}/`
}

export const academyOralCreditsRetrieve = async (id: string, options?: RequestInit): Promise<academyOralCreditsRetrieveResponse> => {
  
  return apiFetch<academyOralCreditsRetrieveResponse>(getAcademyOralCreditsRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyOralCreditsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/academy/oral-credits/${id}/`
    ] as const;
    }

    
export const getAcademyOralCreditsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academyOralCreditsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyOralCreditsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyOralCreditsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyOralCreditsRetrieve>>> = ({ signal }) => academyOralCreditsRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyOralCreditsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyOralCreditsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academyOralCreditsRetrieve>>>
export type AcademyOralCreditsRetrieveQueryError = unknown


export function useAcademyOralCreditsRetrieve<TData = Awaited<ReturnType<typeof academyOralCreditsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyOralCreditsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyOralCreditsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyOralCreditsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyOralCreditsRetrieve<TData = Awaited<ReturnType<typeof academyOralCreditsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyOralCreditsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyOralCreditsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyOralCreditsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyOralCreditsRetrieve<TData = Awaited<ReturnType<typeof academyOralCreditsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyOralCreditsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyOralCreditsRetrieve<TData = Awaited<ReturnType<typeof academyOralCreditsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyOralCreditsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyOralCreditsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * The planning of the mock orals: a trainer sees their own sessions in their language(s)
(D-120), without the payments; the owner and the manager see everything and record refunds.
 */
export type academyOralSessionsListResponse200 = {
  data: PaginatedOralBookingAdminList
  status: 200
}
    
export type academyOralSessionsListResponseSuccess = (academyOralSessionsListResponse200) & {
  headers: Headers;
};
;

export type academyOralSessionsListResponse = (academyOralSessionsListResponseSuccess)

export const getAcademyOralSessionsListUrl = (params?: AcademyOralSessionsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/oral-sessions/?${stringifiedParams}` : `/api/v1/academy/oral-sessions/`
}

export const academyOralSessionsList = async (params?: AcademyOralSessionsListParams, options?: RequestInit): Promise<academyOralSessionsListResponse> => {
  
  return apiFetch<academyOralSessionsListResponse>(getAcademyOralSessionsListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyOralSessionsListQueryKey = (params?: AcademyOralSessionsListParams,) => {
    return [
    `/api/v1/academy/oral-sessions/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAcademyOralSessionsListQueryOptions = <TData = Awaited<ReturnType<typeof academyOralSessionsList>>, TError = unknown>(params?: AcademyOralSessionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyOralSessionsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyOralSessionsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyOralSessionsList>>> = ({ signal }) => academyOralSessionsList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyOralSessionsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyOralSessionsListQueryResult = NonNullable<Awaited<ReturnType<typeof academyOralSessionsList>>>
export type AcademyOralSessionsListQueryError = unknown


export function useAcademyOralSessionsList<TData = Awaited<ReturnType<typeof academyOralSessionsList>>, TError = unknown>(
 params: undefined |  AcademyOralSessionsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyOralSessionsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyOralSessionsList>>,
          TError,
          Awaited<ReturnType<typeof academyOralSessionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyOralSessionsList<TData = Awaited<ReturnType<typeof academyOralSessionsList>>, TError = unknown>(
 params?: AcademyOralSessionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyOralSessionsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyOralSessionsList>>,
          TError,
          Awaited<ReturnType<typeof academyOralSessionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyOralSessionsList<TData = Awaited<ReturnType<typeof academyOralSessionsList>>, TError = unknown>(
 params?: AcademyOralSessionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyOralSessionsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyOralSessionsList<TData = Awaited<ReturnType<typeof academyOralSessionsList>>, TError = unknown>(
 params?: AcademyOralSessionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyOralSessionsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyOralSessionsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * The planning of the mock orals: a trainer sees their own sessions in their language(s)
(D-120), without the payments; the owner and the manager see everything and record refunds.
 */
export type academyOralSessionsRetrieveResponse200 = {
  data: OralBookingAdmin
  status: 200
}
    
export type academyOralSessionsRetrieveResponseSuccess = (academyOralSessionsRetrieveResponse200) & {
  headers: Headers;
};
;

export type academyOralSessionsRetrieveResponse = (academyOralSessionsRetrieveResponseSuccess)

export const getAcademyOralSessionsRetrieveUrl = (id: string,
    params?: AcademyOralSessionsRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/oral-sessions/${id}/?${stringifiedParams}` : `/api/v1/academy/oral-sessions/${id}/`
}

export const academyOralSessionsRetrieve = async (id: string,
    params?: AcademyOralSessionsRetrieveParams, options?: RequestInit): Promise<academyOralSessionsRetrieveResponse> => {
  
  return apiFetch<academyOralSessionsRetrieveResponse>(getAcademyOralSessionsRetrieveUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyOralSessionsRetrieveQueryKey = (id?: string,
    params?: AcademyOralSessionsRetrieveParams,) => {
    return [
    `/api/v1/academy/oral-sessions/${id}/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAcademyOralSessionsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academyOralSessionsRetrieve>>, TError = unknown>(id: string,
    params?: AcademyOralSessionsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyOralSessionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyOralSessionsRetrieveQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyOralSessionsRetrieve>>> = ({ signal }) => academyOralSessionsRetrieve(id,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyOralSessionsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyOralSessionsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academyOralSessionsRetrieve>>>
export type AcademyOralSessionsRetrieveQueryError = unknown


export function useAcademyOralSessionsRetrieve<TData = Awaited<ReturnType<typeof academyOralSessionsRetrieve>>, TError = unknown>(
 id: string,
    params: undefined |  AcademyOralSessionsRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyOralSessionsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyOralSessionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyOralSessionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyOralSessionsRetrieve<TData = Awaited<ReturnType<typeof academyOralSessionsRetrieve>>, TError = unknown>(
 id: string,
    params?: AcademyOralSessionsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyOralSessionsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyOralSessionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyOralSessionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyOralSessionsRetrieve<TData = Awaited<ReturnType<typeof academyOralSessionsRetrieve>>, TError = unknown>(
 id: string,
    params?: AcademyOralSessionsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyOralSessionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyOralSessionsRetrieve<TData = Awaited<ReturnType<typeof academyOralSessionsRetrieve>>, TError = unknown>(
 id: string,
    params?: AcademyOralSessionsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyOralSessionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyOralSessionsRetrieveQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * The planning of the mock orals: a trainer sees their own sessions in their language(s)
(D-120), without the payments; the owner and the manager see everything and record refunds.
 */
export type academyOralSessionsAbsentCreateResponse200 = {
  data: OralBookingAdmin
  status: 200
}
    
export type academyOralSessionsAbsentCreateResponseSuccess = (academyOralSessionsAbsentCreateResponse200) & {
  headers: Headers;
};
;

export type academyOralSessionsAbsentCreateResponse = (academyOralSessionsAbsentCreateResponseSuccess)

export const getAcademyOralSessionsAbsentCreateUrl = (id: string,
    params?: AcademyOralSessionsAbsentCreateParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/oral-sessions/${id}/absent/?${stringifiedParams}` : `/api/v1/academy/oral-sessions/${id}/absent/`
}

export const academyOralSessionsAbsentCreate = async (id: string,
    oralAbsentRequest: OralAbsentRequest,
    params?: AcademyOralSessionsAbsentCreateParams, options?: RequestInit): Promise<academyOralSessionsAbsentCreateResponse> => {
  
  return apiFetch<academyOralSessionsAbsentCreateResponse>(getAcademyOralSessionsAbsentCreateUrl(id,params),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      oralAbsentRequest,)
  }
);}




export const getAcademyOralSessionsAbsentCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyOralSessionsAbsentCreate>>, TError,{id: string;data: OralAbsentRequest;params?: AcademyOralSessionsAbsentCreateParams}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyOralSessionsAbsentCreate>>, TError,{id: string;data: OralAbsentRequest;params?: AcademyOralSessionsAbsentCreateParams}, TContext> => {

const mutationKey = ['academyOralSessionsAbsentCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyOralSessionsAbsentCreate>>, {id: string;data: OralAbsentRequest;params?: AcademyOralSessionsAbsentCreateParams}> = (props) => {
          const {id,data,params} = props ?? {};

          return  academyOralSessionsAbsentCreate(id,data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyOralSessionsAbsentCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyOralSessionsAbsentCreate>>>
    export type AcademyOralSessionsAbsentCreateMutationBody = OralAbsentRequest
    export type AcademyOralSessionsAbsentCreateMutationError = unknown

    export const useAcademyOralSessionsAbsentCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyOralSessionsAbsentCreate>>, TError,{id: string;data: OralAbsentRequest;params?: AcademyOralSessionsAbsentCreateParams}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyOralSessionsAbsentCreate>>,
        TError,
        {id: string;data: OralAbsentRequest;params?: AcademyOralSessionsAbsentCreateParams},
        TContext
      > => {

      const mutationOptions = getAcademyOralSessionsAbsentCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * The planning of the mock orals: a trainer sees their own sessions in their language(s)
(D-120), without the payments; the owner and the manager see everything and record refunds.
 */
export type academyOralSessionsGradeCreateResponse200 = {
  data: OralBookingAdmin
  status: 200
}
    
export type academyOralSessionsGradeCreateResponseSuccess = (academyOralSessionsGradeCreateResponse200) & {
  headers: Headers;
};
;

export type academyOralSessionsGradeCreateResponse = (academyOralSessionsGradeCreateResponseSuccess)

export const getAcademyOralSessionsGradeCreateUrl = (id: string,
    params?: AcademyOralSessionsGradeCreateParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/oral-sessions/${id}/grade/?${stringifiedParams}` : `/api/v1/academy/oral-sessions/${id}/grade/`
}

export const academyOralSessionsGradeCreate = async (id: string,
    oralGradeRequest: OralGradeRequest,
    params?: AcademyOralSessionsGradeCreateParams, options?: RequestInit): Promise<academyOralSessionsGradeCreateResponse> => {
  
  return apiFetch<academyOralSessionsGradeCreateResponse>(getAcademyOralSessionsGradeCreateUrl(id,params),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      oralGradeRequest,)
  }
);}




export const getAcademyOralSessionsGradeCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyOralSessionsGradeCreate>>, TError,{id: string;data: OralGradeRequest;params?: AcademyOralSessionsGradeCreateParams}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyOralSessionsGradeCreate>>, TError,{id: string;data: OralGradeRequest;params?: AcademyOralSessionsGradeCreateParams}, TContext> => {

const mutationKey = ['academyOralSessionsGradeCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyOralSessionsGradeCreate>>, {id: string;data: OralGradeRequest;params?: AcademyOralSessionsGradeCreateParams}> = (props) => {
          const {id,data,params} = props ?? {};

          return  academyOralSessionsGradeCreate(id,data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyOralSessionsGradeCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyOralSessionsGradeCreate>>>
    export type AcademyOralSessionsGradeCreateMutationBody = OralGradeRequest
    export type AcademyOralSessionsGradeCreateMutationError = unknown

    export const useAcademyOralSessionsGradeCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyOralSessionsGradeCreate>>, TError,{id: string;data: OralGradeRequest;params?: AcademyOralSessionsGradeCreateParams}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyOralSessionsGradeCreate>>,
        TError,
        {id: string;data: OralGradeRequest;params?: AcademyOralSessionsGradeCreateParams},
        TContext
      > => {

      const mutationOptions = getAcademyOralSessionsGradeCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * The planning of the mock orals: a trainer sees their own sessions in their language(s)
(D-120), without the payments; the owner and the manager see everything and record refunds.
 */
export type academyOralSessionsRefundCreateResponse200 = {
  data: OralBookingAdmin
  status: 200
}
    
export type academyOralSessionsRefundCreateResponseSuccess = (academyOralSessionsRefundCreateResponse200) & {
  headers: Headers;
};
;

export type academyOralSessionsRefundCreateResponse = (academyOralSessionsRefundCreateResponseSuccess)

export const getAcademyOralSessionsRefundCreateUrl = (id: string,
    params?: AcademyOralSessionsRefundCreateParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/oral-sessions/${id}/refund/?${stringifiedParams}` : `/api/v1/academy/oral-sessions/${id}/refund/`
}

export const academyOralSessionsRefundCreate = async (id: string,
    oralRefundRequest: OralRefundRequest,
    params?: AcademyOralSessionsRefundCreateParams, options?: RequestInit): Promise<academyOralSessionsRefundCreateResponse> => {
  
  return apiFetch<academyOralSessionsRefundCreateResponse>(getAcademyOralSessionsRefundCreateUrl(id,params),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      oralRefundRequest,)
  }
);}




export const getAcademyOralSessionsRefundCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyOralSessionsRefundCreate>>, TError,{id: string;data: OralRefundRequest;params?: AcademyOralSessionsRefundCreateParams}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyOralSessionsRefundCreate>>, TError,{id: string;data: OralRefundRequest;params?: AcademyOralSessionsRefundCreateParams}, TContext> => {

const mutationKey = ['academyOralSessionsRefundCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyOralSessionsRefundCreate>>, {id: string;data: OralRefundRequest;params?: AcademyOralSessionsRefundCreateParams}> = (props) => {
          const {id,data,params} = props ?? {};

          return  academyOralSessionsRefundCreate(id,data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyOralSessionsRefundCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyOralSessionsRefundCreate>>>
    export type AcademyOralSessionsRefundCreateMutationBody = OralRefundRequest
    export type AcademyOralSessionsRefundCreateMutationError = unknown

    export const useAcademyOralSessionsRefundCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyOralSessionsRefundCreate>>, TError,{id: string;data: OralRefundRequest;params?: AcademyOralSessionsRefundCreateParams}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyOralSessionsRefundCreate>>,
        TError,
        {id: string;data: OralRefundRequest;params?: AcademyOralSessionsRefundCreateParams},
        TContext
      > => {

      const mutationOptions = getAcademyOralSessionsRefundCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * The planning of the mock orals: a trainer sees their own sessions in their language(s)
(D-120), without the payments; the owner and the manager see everything and record refunds.
 */
export type academyOralSessionsStartCreateResponse200 = {
  data: OralBookingAdmin
  status: 200
}
    
export type academyOralSessionsStartCreateResponseSuccess = (academyOralSessionsStartCreateResponse200) & {
  headers: Headers;
};
;

export type academyOralSessionsStartCreateResponse = (academyOralSessionsStartCreateResponseSuccess)

export const getAcademyOralSessionsStartCreateUrl = (id: string,
    params?: AcademyOralSessionsStartCreateParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/oral-sessions/${id}/start/?${stringifiedParams}` : `/api/v1/academy/oral-sessions/${id}/start/`
}

export const academyOralSessionsStartCreate = async (id: string,
    params?: AcademyOralSessionsStartCreateParams, options?: RequestInit): Promise<academyOralSessionsStartCreateResponse> => {
  
  return apiFetch<academyOralSessionsStartCreateResponse>(getAcademyOralSessionsStartCreateUrl(id,params),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getAcademyOralSessionsStartCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyOralSessionsStartCreate>>, TError,{id: string;params?: AcademyOralSessionsStartCreateParams}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyOralSessionsStartCreate>>, TError,{id: string;params?: AcademyOralSessionsStartCreateParams}, TContext> => {

const mutationKey = ['academyOralSessionsStartCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyOralSessionsStartCreate>>, {id: string;params?: AcademyOralSessionsStartCreateParams}> = (props) => {
          const {id,params} = props ?? {};

          return  academyOralSessionsStartCreate(id,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyOralSessionsStartCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyOralSessionsStartCreate>>>
    
    export type AcademyOralSessionsStartCreateMutationError = unknown

    export const useAcademyOralSessionsStartCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyOralSessionsStartCreate>>, TError,{id: string;params?: AcademyOralSessionsStartCreateParams}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyOralSessionsStartCreate>>,
        TError,
        {id: string;params?: AcademyOralSessionsStartCreateParams},
        TContext
      > => {

      const mutationOptions = getAcademyOralSessionsStartCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * The planning of the mock orals: a trainer sees their own sessions in their language(s)
(D-120), without the payments; the owner and the manager see everything and record refunds.
 */
export type academyOralSessionsStatsRetrieveResponse200 = {
  data: AcademyOralSessionsStatsRetrieve200
  status: 200
}
    
export type academyOralSessionsStatsRetrieveResponseSuccess = (academyOralSessionsStatsRetrieveResponse200) & {
  headers: Headers;
};
;

export type academyOralSessionsStatsRetrieveResponse = (academyOralSessionsStatsRetrieveResponseSuccess)

export const getAcademyOralSessionsStatsRetrieveUrl = (params?: AcademyOralSessionsStatsRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/oral-sessions/stats/?${stringifiedParams}` : `/api/v1/academy/oral-sessions/stats/`
}

export const academyOralSessionsStatsRetrieve = async (params?: AcademyOralSessionsStatsRetrieveParams, options?: RequestInit): Promise<academyOralSessionsStatsRetrieveResponse> => {
  
  return apiFetch<academyOralSessionsStatsRetrieveResponse>(getAcademyOralSessionsStatsRetrieveUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyOralSessionsStatsRetrieveQueryKey = (params?: AcademyOralSessionsStatsRetrieveParams,) => {
    return [
    `/api/v1/academy/oral-sessions/stats/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAcademyOralSessionsStatsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academyOralSessionsStatsRetrieve>>, TError = unknown>(params?: AcademyOralSessionsStatsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyOralSessionsStatsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyOralSessionsStatsRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyOralSessionsStatsRetrieve>>> = ({ signal }) => academyOralSessionsStatsRetrieve(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyOralSessionsStatsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyOralSessionsStatsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academyOralSessionsStatsRetrieve>>>
export type AcademyOralSessionsStatsRetrieveQueryError = unknown


export function useAcademyOralSessionsStatsRetrieve<TData = Awaited<ReturnType<typeof academyOralSessionsStatsRetrieve>>, TError = unknown>(
 params: undefined |  AcademyOralSessionsStatsRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyOralSessionsStatsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyOralSessionsStatsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyOralSessionsStatsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyOralSessionsStatsRetrieve<TData = Awaited<ReturnType<typeof academyOralSessionsStatsRetrieve>>, TError = unknown>(
 params?: AcademyOralSessionsStatsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyOralSessionsStatsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyOralSessionsStatsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyOralSessionsStatsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyOralSessionsStatsRetrieve<TData = Awaited<ReturnType<typeof academyOralSessionsStatsRetrieve>>, TError = unknown>(
 params?: AcademyOralSessionsStatsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyOralSessionsStatsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyOralSessionsStatsRetrieve<TData = Awaited<ReturnType<typeof academyOralSessionsStatsRetrieve>>, TError = unknown>(
 params?: AcademyOralSessionsStatsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyOralSessionsStatsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyOralSessionsStatsRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * The signed-in learner only: never an agency member's tools.
 */
export type academyOralBookingsListResponse200 = {
  data: OralBooking[]
  status: 200
}
    
export type academyOralBookingsListResponseSuccess = (academyOralBookingsListResponse200) & {
  headers: Headers;
};
;

export type academyOralBookingsListResponse = (academyOralBookingsListResponseSuccess)

export const getAcademyOralBookingsListUrl = () => {


  

  return `/api/v1/academy/oral/bookings/`
}

export const academyOralBookingsList = async ( options?: RequestInit): Promise<academyOralBookingsListResponse> => {
  
  return apiFetch<academyOralBookingsListResponse>(getAcademyOralBookingsListUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyOralBookingsListQueryKey = () => {
    return [
    `/api/v1/academy/oral/bookings/`
    ] as const;
    }

    
export const getAcademyOralBookingsListQueryOptions = <TData = Awaited<ReturnType<typeof academyOralBookingsList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyOralBookingsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyOralBookingsListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyOralBookingsList>>> = ({ signal }) => academyOralBookingsList({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyOralBookingsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyOralBookingsListQueryResult = NonNullable<Awaited<ReturnType<typeof academyOralBookingsList>>>
export type AcademyOralBookingsListQueryError = unknown


export function useAcademyOralBookingsList<TData = Awaited<ReturnType<typeof academyOralBookingsList>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyOralBookingsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyOralBookingsList>>,
          TError,
          Awaited<ReturnType<typeof academyOralBookingsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyOralBookingsList<TData = Awaited<ReturnType<typeof academyOralBookingsList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyOralBookingsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyOralBookingsList>>,
          TError,
          Awaited<ReturnType<typeof academyOralBookingsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyOralBookingsList<TData = Awaited<ReturnType<typeof academyOralBookingsList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyOralBookingsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyOralBookingsList<TData = Awaited<ReturnType<typeof academyOralBookingsList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyOralBookingsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyOralBookingsListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * The signed-in learner only: never an agency member's tools.
 */
export type academyOralBookingsCreateResponse201 = {
  data: OralBooking
  status: 201
}
    
export type academyOralBookingsCreateResponseSuccess = (academyOralBookingsCreateResponse201) & {
  headers: Headers;
};
;

export type academyOralBookingsCreateResponse = (academyOralBookingsCreateResponseSuccess)

export const getAcademyOralBookingsCreateUrl = () => {


  

  return `/api/v1/academy/oral/bookings/`
}

export const academyOralBookingsCreate = async (oralBookRequest: OralBookRequest, options?: RequestInit): Promise<academyOralBookingsCreateResponse> => {
  
  return apiFetch<academyOralBookingsCreateResponse>(getAcademyOralBookingsCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      oralBookRequest,)
  }
);}




export const getAcademyOralBookingsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyOralBookingsCreate>>, TError,{data: OralBookRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyOralBookingsCreate>>, TError,{data: OralBookRequest}, TContext> => {

const mutationKey = ['academyOralBookingsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyOralBookingsCreate>>, {data: OralBookRequest}> = (props) => {
          const {data} = props ?? {};

          return  academyOralBookingsCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyOralBookingsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyOralBookingsCreate>>>
    export type AcademyOralBookingsCreateMutationBody = OralBookRequest
    export type AcademyOralBookingsCreateMutationError = unknown

    export const useAcademyOralBookingsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyOralBookingsCreate>>, TError,{data: OralBookRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyOralBookingsCreate>>,
        TError,
        {data: OralBookRequest},
        TContext
      > => {

      const mutationOptions = getAcademyOralBookingsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * The signed-in learner only: never an agency member's tools.
 */
export type academyOralBookingsRetrieveResponse200 = {
  data: OralBooking
  status: 200
}
    
export type academyOralBookingsRetrieveResponseSuccess = (academyOralBookingsRetrieveResponse200) & {
  headers: Headers;
};
;

export type academyOralBookingsRetrieveResponse = (academyOralBookingsRetrieveResponseSuccess)

export const getAcademyOralBookingsRetrieveUrl = (id: string,) => {


  

  return `/api/v1/academy/oral/bookings/${id}/`
}

export const academyOralBookingsRetrieve = async (id: string, options?: RequestInit): Promise<academyOralBookingsRetrieveResponse> => {
  
  return apiFetch<academyOralBookingsRetrieveResponse>(getAcademyOralBookingsRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyOralBookingsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/academy/oral/bookings/${id}/`
    ] as const;
    }

    
export const getAcademyOralBookingsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academyOralBookingsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyOralBookingsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyOralBookingsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyOralBookingsRetrieve>>> = ({ signal }) => academyOralBookingsRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyOralBookingsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyOralBookingsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academyOralBookingsRetrieve>>>
export type AcademyOralBookingsRetrieveQueryError = unknown


export function useAcademyOralBookingsRetrieve<TData = Awaited<ReturnType<typeof academyOralBookingsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyOralBookingsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyOralBookingsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyOralBookingsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyOralBookingsRetrieve<TData = Awaited<ReturnType<typeof academyOralBookingsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyOralBookingsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyOralBookingsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyOralBookingsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyOralBookingsRetrieve<TData = Awaited<ReturnType<typeof academyOralBookingsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyOralBookingsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyOralBookingsRetrieve<TData = Awaited<ReturnType<typeof academyOralBookingsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyOralBookingsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyOralBookingsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * The signed-in learner only: never an agency member's tools.
 */
export type academyOralBookingsCancelCreateResponse200 = {
  data: OralBooking
  status: 200
}
    
export type academyOralBookingsCancelCreateResponseSuccess = (academyOralBookingsCancelCreateResponse200) & {
  headers: Headers;
};
;

export type academyOralBookingsCancelCreateResponse = (academyOralBookingsCancelCreateResponseSuccess)

export const getAcademyOralBookingsCancelCreateUrl = (id: string,) => {


  

  return `/api/v1/academy/oral/bookings/${id}/cancel/`
}

export const academyOralBookingsCancelCreate = async (id: string,
    oralCancelRequest: OralCancelRequest, options?: RequestInit): Promise<academyOralBookingsCancelCreateResponse> => {
  
  return apiFetch<academyOralBookingsCancelCreateResponse>(getAcademyOralBookingsCancelCreateUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      oralCancelRequest,)
  }
);}




export const getAcademyOralBookingsCancelCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyOralBookingsCancelCreate>>, TError,{id: string;data: OralCancelRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyOralBookingsCancelCreate>>, TError,{id: string;data: OralCancelRequest}, TContext> => {

const mutationKey = ['academyOralBookingsCancelCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyOralBookingsCancelCreate>>, {id: string;data: OralCancelRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  academyOralBookingsCancelCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyOralBookingsCancelCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyOralBookingsCancelCreate>>>
    export type AcademyOralBookingsCancelCreateMutationBody = OralCancelRequest
    export type AcademyOralBookingsCancelCreateMutationError = unknown

    export const useAcademyOralBookingsCancelCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyOralBookingsCancelCreate>>, TError,{id: string;data: OralCancelRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyOralBookingsCancelCreate>>,
        TError,
        {id: string;data: OralCancelRequest},
        TContext
      > => {

      const mutationOptions = getAcademyOralBookingsCancelCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * The calendar invitation of the session (.ics).
 */
export type academyOralBookingsIcsRetrieveResponse200 = {
  data: string
  status: 200
}
    
export type academyOralBookingsIcsRetrieveResponseSuccess = (academyOralBookingsIcsRetrieveResponse200) & {
  headers: Headers;
};
;

export type academyOralBookingsIcsRetrieveResponse = (academyOralBookingsIcsRetrieveResponseSuccess)

export const getAcademyOralBookingsIcsRetrieveUrl = (id: string,) => {


  

  return `/api/v1/academy/oral/bookings/${id}/ics/`
}

export const academyOralBookingsIcsRetrieve = async (id: string, options?: RequestInit): Promise<academyOralBookingsIcsRetrieveResponse> => {
  
  return apiFetch<academyOralBookingsIcsRetrieveResponse>(getAcademyOralBookingsIcsRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyOralBookingsIcsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/academy/oral/bookings/${id}/ics/`
    ] as const;
    }

    
export const getAcademyOralBookingsIcsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academyOralBookingsIcsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyOralBookingsIcsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyOralBookingsIcsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyOralBookingsIcsRetrieve>>> = ({ signal }) => academyOralBookingsIcsRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyOralBookingsIcsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyOralBookingsIcsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academyOralBookingsIcsRetrieve>>>
export type AcademyOralBookingsIcsRetrieveQueryError = unknown


export function useAcademyOralBookingsIcsRetrieve<TData = Awaited<ReturnType<typeof academyOralBookingsIcsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyOralBookingsIcsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyOralBookingsIcsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyOralBookingsIcsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyOralBookingsIcsRetrieve<TData = Awaited<ReturnType<typeof academyOralBookingsIcsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyOralBookingsIcsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyOralBookingsIcsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyOralBookingsIcsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyOralBookingsIcsRetrieve<TData = Awaited<ReturnType<typeof academyOralBookingsIcsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyOralBookingsIcsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyOralBookingsIcsRetrieve<TData = Awaited<ReturnType<typeof academyOralBookingsIcsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyOralBookingsIcsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyOralBookingsIcsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * The invoice and the payment request of a held slot (common engine D-133).
 */
export type academyOralBookingsPayCreateResponse201 = {
  data: OralCheckout
  status: 201
}

export type academyOralBookingsPayCreateResponse409 = {
  data: AcademyCheckoutFallback
  status: 409
}

export type academyOralBookingsPayCreateResponse503 = {
  data: PaymentUnavailable
  status: 503
}
    
export type academyOralBookingsPayCreateResponseSuccess = (academyOralBookingsPayCreateResponse201) & {
  headers: Headers;
};
export type academyOralBookingsPayCreateResponseError = (academyOralBookingsPayCreateResponse409 | academyOralBookingsPayCreateResponse503) & {
  headers: Headers;
};

export type academyOralBookingsPayCreateResponse = (academyOralBookingsPayCreateResponseSuccess | academyOralBookingsPayCreateResponseError)

export const getAcademyOralBookingsPayCreateUrl = (id: string,) => {


  

  return `/api/v1/academy/oral/bookings/${id}/pay/`
}

export const academyOralBookingsPayCreate = async (id: string,
    oralPayRequest: OralPayRequest, options?: RequestInit): Promise<academyOralBookingsPayCreateResponse> => {
  
  return apiFetch<academyOralBookingsPayCreateResponse>(getAcademyOralBookingsPayCreateUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      oralPayRequest,)
  }
);}




export const getAcademyOralBookingsPayCreateMutationOptions = <TError = AcademyCheckoutFallback | PaymentUnavailable,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyOralBookingsPayCreate>>, TError,{id: string;data: OralPayRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyOralBookingsPayCreate>>, TError,{id: string;data: OralPayRequest}, TContext> => {

const mutationKey = ['academyOralBookingsPayCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyOralBookingsPayCreate>>, {id: string;data: OralPayRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  academyOralBookingsPayCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyOralBookingsPayCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyOralBookingsPayCreate>>>
    export type AcademyOralBookingsPayCreateMutationBody = OralPayRequest
    export type AcademyOralBookingsPayCreateMutationError = AcademyCheckoutFallback | PaymentUnavailable

    export const useAcademyOralBookingsPayCreate = <TError = AcademyCheckoutFallback | PaymentUnavailable,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyOralBookingsPayCreate>>, TError,{id: string;data: OralPayRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyOralBookingsPayCreate>>,
        TError,
        {id: string;data: OralPayRequest},
        TContext
      > => {

      const mutationOptions = getAcademyOralBookingsPayCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * The signed-in learner only: never an agency member's tools.
 */
export type academyOralBookingsRescheduleCreateResponse200 = {
  data: OralBooking
  status: 200
}
    
export type academyOralBookingsRescheduleCreateResponseSuccess = (academyOralBookingsRescheduleCreateResponse200) & {
  headers: Headers;
};
;

export type academyOralBookingsRescheduleCreateResponse = (academyOralBookingsRescheduleCreateResponseSuccess)

export const getAcademyOralBookingsRescheduleCreateUrl = (id: string,) => {


  

  return `/api/v1/academy/oral/bookings/${id}/reschedule/`
}

export const academyOralBookingsRescheduleCreate = async (id: string,
    oralRescheduleRequest: OralRescheduleRequest, options?: RequestInit): Promise<academyOralBookingsRescheduleCreateResponse> => {
  
  return apiFetch<academyOralBookingsRescheduleCreateResponse>(getAcademyOralBookingsRescheduleCreateUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      oralRescheduleRequest,)
  }
);}




export const getAcademyOralBookingsRescheduleCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyOralBookingsRescheduleCreate>>, TError,{id: string;data: OralRescheduleRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyOralBookingsRescheduleCreate>>, TError,{id: string;data: OralRescheduleRequest}, TContext> => {

const mutationKey = ['academyOralBookingsRescheduleCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyOralBookingsRescheduleCreate>>, {id: string;data: OralRescheduleRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  academyOralBookingsRescheduleCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyOralBookingsRescheduleCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyOralBookingsRescheduleCreate>>>
    export type AcademyOralBookingsRescheduleCreateMutationBody = OralRescheduleRequest
    export type AcademyOralBookingsRescheduleCreateMutationError = unknown

    export const useAcademyOralBookingsRescheduleCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyOralBookingsRescheduleCreate>>, TError,{id: string;data: OralRescheduleRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyOralBookingsRescheduleCreate>>,
        TError,
        {id: string;data: OralRescheduleRequest},
        TContext
      > => {

      const mutationOptions = getAcademyOralBookingsRescheduleCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * A credited session becomes a refund request (within the refund period).
 */
export type academyOralBookingsSettleCreateResponse200 = {
  data: OralBooking
  status: 200
}
    
export type academyOralBookingsSettleCreateResponseSuccess = (academyOralBookingsSettleCreateResponse200) & {
  headers: Headers;
};
;

export type academyOralBookingsSettleCreateResponse = (academyOralBookingsSettleCreateResponseSuccess)

export const getAcademyOralBookingsSettleCreateUrl = (id: string,) => {


  

  return `/api/v1/academy/oral/bookings/${id}/settle/`
}

export const academyOralBookingsSettleCreate = async (id: string,
    oralChoiceRequest: OralChoiceRequest, options?: RequestInit): Promise<academyOralBookingsSettleCreateResponse> => {
  
  return apiFetch<academyOralBookingsSettleCreateResponse>(getAcademyOralBookingsSettleCreateUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      oralChoiceRequest,)
  }
);}




export const getAcademyOralBookingsSettleCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyOralBookingsSettleCreate>>, TError,{id: string;data: OralChoiceRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyOralBookingsSettleCreate>>, TError,{id: string;data: OralChoiceRequest}, TContext> => {

const mutationKey = ['academyOralBookingsSettleCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyOralBookingsSettleCreate>>, {id: string;data: OralChoiceRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  academyOralBookingsSettleCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyOralBookingsSettleCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyOralBookingsSettleCreate>>>
    export type AcademyOralBookingsSettleCreateMutationBody = OralChoiceRequest
    export type AcademyOralBookingsSettleCreateMutationError = unknown

    export const useAcademyOralBookingsSettleCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyOralBookingsSettleCreate>>, TError,{id: string;data: OralChoiceRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyOralBookingsSettleCreate>>,
        TError,
        {id: string;data: OralChoiceRequest},
        TContext
      > => {

      const mutationOptions = getAcademyOralBookingsSettleCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * « The trainer did not come »: the session credited or refunded, as the learner chooses.
 */
export type academyOralBookingsTrainerAbsentCreateResponse200 = {
  data: OralBooking
  status: 200
}
    
export type academyOralBookingsTrainerAbsentCreateResponseSuccess = (academyOralBookingsTrainerAbsentCreateResponse200) & {
  headers: Headers;
};
;

export type academyOralBookingsTrainerAbsentCreateResponse = (academyOralBookingsTrainerAbsentCreateResponseSuccess)

export const getAcademyOralBookingsTrainerAbsentCreateUrl = (id: string,) => {


  

  return `/api/v1/academy/oral/bookings/${id}/trainer-absent/`
}

export const academyOralBookingsTrainerAbsentCreate = async (id: string,
    oralChoiceRequest: OralChoiceRequest, options?: RequestInit): Promise<academyOralBookingsTrainerAbsentCreateResponse> => {
  
  return apiFetch<academyOralBookingsTrainerAbsentCreateResponse>(getAcademyOralBookingsTrainerAbsentCreateUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      oralChoiceRequest,)
  }
);}




export const getAcademyOralBookingsTrainerAbsentCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyOralBookingsTrainerAbsentCreate>>, TError,{id: string;data: OralChoiceRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyOralBookingsTrainerAbsentCreate>>, TError,{id: string;data: OralChoiceRequest}, TContext> => {

const mutationKey = ['academyOralBookingsTrainerAbsentCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyOralBookingsTrainerAbsentCreate>>, {id: string;data: OralChoiceRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  academyOralBookingsTrainerAbsentCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyOralBookingsTrainerAbsentCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyOralBookingsTrainerAbsentCreate>>>
    export type AcademyOralBookingsTrainerAbsentCreateMutationBody = OralChoiceRequest
    export type AcademyOralBookingsTrainerAbsentCreateMutationError = unknown

    export const useAcademyOralBookingsTrainerAbsentCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyOralBookingsTrainerAbsentCreate>>, TError,{id: string;data: OralChoiceRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyOralBookingsTrainerAbsentCreate>>,
        TError,
        {id: string;data: OralChoiceRequest},
        TContext
      > => {

      const mutationOptions = getAcademyOralBookingsTrainerAbsentCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Price (catalogue), length, rules shown before payment, exams with trainers, the payment
methods of the learner's country and a session credited earlier (if any).
 */
export type academyOralOfferRetrieveResponse200 = {
  data: OralOffer
  status: 200
}
    
export type academyOralOfferRetrieveResponseSuccess = (academyOralOfferRetrieveResponse200) & {
  headers: Headers;
};
;

export type academyOralOfferRetrieveResponse = (academyOralOfferRetrieveResponseSuccess)

export const getAcademyOralOfferRetrieveUrl = () => {


  

  return `/api/v1/academy/oral/offer/`
}

export const academyOralOfferRetrieve = async ( options?: RequestInit): Promise<academyOralOfferRetrieveResponse> => {
  
  return apiFetch<academyOralOfferRetrieveResponse>(getAcademyOralOfferRetrieveUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyOralOfferRetrieveQueryKey = () => {
    return [
    `/api/v1/academy/oral/offer/`
    ] as const;
    }

    
export const getAcademyOralOfferRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academyOralOfferRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyOralOfferRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyOralOfferRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyOralOfferRetrieve>>> = ({ signal }) => academyOralOfferRetrieve({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyOralOfferRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyOralOfferRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academyOralOfferRetrieve>>>
export type AcademyOralOfferRetrieveQueryError = unknown


export function useAcademyOralOfferRetrieve<TData = Awaited<ReturnType<typeof academyOralOfferRetrieve>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyOralOfferRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyOralOfferRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyOralOfferRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyOralOfferRetrieve<TData = Awaited<ReturnType<typeof academyOralOfferRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyOralOfferRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyOralOfferRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyOralOfferRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyOralOfferRetrieve<TData = Awaited<ReturnType<typeof academyOralOfferRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyOralOfferRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyOralOfferRetrieve<TData = Awaited<ReturnType<typeof academyOralOfferRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyOralOfferRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyOralOfferRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * The official outline of the exam's speaking test (tasks, timings, preparation).
 */
export type academyOralOutlineRetrieveResponse200 = {
  data: OralOutline
  status: 200
}
    
export type academyOralOutlineRetrieveResponseSuccess = (academyOralOutlineRetrieveResponse200) & {
  headers: Headers;
};
;

export type academyOralOutlineRetrieveResponse = (academyOralOutlineRetrieveResponseSuccess)

export const getAcademyOralOutlineRetrieveUrl = (params?: AcademyOralOutlineRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/oral/outline/?${stringifiedParams}` : `/api/v1/academy/oral/outline/`
}

export const academyOralOutlineRetrieve = async (params?: AcademyOralOutlineRetrieveParams, options?: RequestInit): Promise<academyOralOutlineRetrieveResponse> => {
  
  return apiFetch<academyOralOutlineRetrieveResponse>(getAcademyOralOutlineRetrieveUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyOralOutlineRetrieveQueryKey = (params?: AcademyOralOutlineRetrieveParams,) => {
    return [
    `/api/v1/academy/oral/outline/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAcademyOralOutlineRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academyOralOutlineRetrieve>>, TError = unknown>(params?: AcademyOralOutlineRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyOralOutlineRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyOralOutlineRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyOralOutlineRetrieve>>> = ({ signal }) => academyOralOutlineRetrieve(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyOralOutlineRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyOralOutlineRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academyOralOutlineRetrieve>>>
export type AcademyOralOutlineRetrieveQueryError = unknown


export function useAcademyOralOutlineRetrieve<TData = Awaited<ReturnType<typeof academyOralOutlineRetrieve>>, TError = unknown>(
 params: undefined |  AcademyOralOutlineRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyOralOutlineRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyOralOutlineRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyOralOutlineRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyOralOutlineRetrieve<TData = Awaited<ReturnType<typeof academyOralOutlineRetrieve>>, TError = unknown>(
 params?: AcademyOralOutlineRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyOralOutlineRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyOralOutlineRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyOralOutlineRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyOralOutlineRetrieve<TData = Awaited<ReturnType<typeof academyOralOutlineRetrieve>>, TError = unknown>(
 params?: AcademyOralOutlineRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyOralOutlineRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyOralOutlineRetrieve<TData = Awaited<ReturnType<typeof academyOralOutlineRetrieve>>, TError = unknown>(
 params?: AcademyOralOutlineRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyOralOutlineRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyOralOutlineRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Free slots of the trainers of the exam's language, in the learner's time zone.
 */
export type academyOralSlotsRetrieveResponse200 = {
  data: OralSlots
  status: 200
}
    
export type academyOralSlotsRetrieveResponseSuccess = (academyOralSlotsRetrieveResponse200) & {
  headers: Headers;
};
;

export type academyOralSlotsRetrieveResponse = (academyOralSlotsRetrieveResponseSuccess)

export const getAcademyOralSlotsRetrieveUrl = (params?: AcademyOralSlotsRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/oral/slots/?${stringifiedParams}` : `/api/v1/academy/oral/slots/`
}

export const academyOralSlotsRetrieve = async (params?: AcademyOralSlotsRetrieveParams, options?: RequestInit): Promise<academyOralSlotsRetrieveResponse> => {
  
  return apiFetch<academyOralSlotsRetrieveResponse>(getAcademyOralSlotsRetrieveUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyOralSlotsRetrieveQueryKey = (params?: AcademyOralSlotsRetrieveParams,) => {
    return [
    `/api/v1/academy/oral/slots/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAcademyOralSlotsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academyOralSlotsRetrieve>>, TError = unknown>(params?: AcademyOralSlotsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyOralSlotsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyOralSlotsRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyOralSlotsRetrieve>>> = ({ signal }) => academyOralSlotsRetrieve(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyOralSlotsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyOralSlotsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academyOralSlotsRetrieve>>>
export type AcademyOralSlotsRetrieveQueryError = unknown


export function useAcademyOralSlotsRetrieve<TData = Awaited<ReturnType<typeof academyOralSlotsRetrieve>>, TError = unknown>(
 params: undefined |  AcademyOralSlotsRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyOralSlotsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyOralSlotsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyOralSlotsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyOralSlotsRetrieve<TData = Awaited<ReturnType<typeof academyOralSlotsRetrieve>>, TError = unknown>(
 params?: AcademyOralSlotsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyOralSlotsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyOralSlotsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyOralSlotsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyOralSlotsRetrieve<TData = Awaited<ReturnType<typeof academyOralSlotsRetrieve>>, TError = unknown>(
 params?: AcademyOralSlotsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyOralSlotsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyOralSlotsRetrieve<TData = Awaited<ReturnType<typeof academyOralSlotsRetrieve>>, TError = unknown>(
 params?: AcademyOralSlotsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyOralSlotsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyOralSlotsRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type academyPassagesListResponse200 = {
  data: PaginatedPassageList
  status: 200
}
    
export type academyPassagesListResponseSuccess = (academyPassagesListResponse200) & {
  headers: Headers;
};
;

export type academyPassagesListResponse = (academyPassagesListResponseSuccess)

export const getAcademyPassagesListUrl = (params?: AcademyPassagesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/passages/?${stringifiedParams}` : `/api/v1/academy/passages/`
}

export const academyPassagesList = async (params?: AcademyPassagesListParams, options?: RequestInit): Promise<academyPassagesListResponse> => {
  
  return apiFetch<academyPassagesListResponse>(getAcademyPassagesListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyPassagesListQueryKey = (params?: AcademyPassagesListParams,) => {
    return [
    `/api/v1/academy/passages/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAcademyPassagesListQueryOptions = <TData = Awaited<ReturnType<typeof academyPassagesList>>, TError = unknown>(params?: AcademyPassagesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyPassagesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyPassagesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyPassagesList>>> = ({ signal }) => academyPassagesList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyPassagesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyPassagesListQueryResult = NonNullable<Awaited<ReturnType<typeof academyPassagesList>>>
export type AcademyPassagesListQueryError = unknown


export function useAcademyPassagesList<TData = Awaited<ReturnType<typeof academyPassagesList>>, TError = unknown>(
 params: undefined |  AcademyPassagesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyPassagesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyPassagesList>>,
          TError,
          Awaited<ReturnType<typeof academyPassagesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyPassagesList<TData = Awaited<ReturnType<typeof academyPassagesList>>, TError = unknown>(
 params?: AcademyPassagesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyPassagesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyPassagesList>>,
          TError,
          Awaited<ReturnType<typeof academyPassagesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyPassagesList<TData = Awaited<ReturnType<typeof academyPassagesList>>, TError = unknown>(
 params?: AcademyPassagesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyPassagesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyPassagesList<TData = Awaited<ReturnType<typeof academyPassagesList>>, TError = unknown>(
 params?: AcademyPassagesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyPassagesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyPassagesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type academyPassagesRetrieveResponse200 = {
  data: Passage
  status: 200
}
    
export type academyPassagesRetrieveResponseSuccess = (academyPassagesRetrieveResponse200) & {
  headers: Headers;
};
;

export type academyPassagesRetrieveResponse = (academyPassagesRetrieveResponseSuccess)

export const getAcademyPassagesRetrieveUrl = (id: string,) => {


  

  return `/api/v1/academy/passages/${id}/`
}

export const academyPassagesRetrieve = async (id: string, options?: RequestInit): Promise<academyPassagesRetrieveResponse> => {
  
  return apiFetch<academyPassagesRetrieveResponse>(getAcademyPassagesRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyPassagesRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/academy/passages/${id}/`
    ] as const;
    }

    
export const getAcademyPassagesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academyPassagesRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyPassagesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyPassagesRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyPassagesRetrieve>>> = ({ signal }) => academyPassagesRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyPassagesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyPassagesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academyPassagesRetrieve>>>
export type AcademyPassagesRetrieveQueryError = unknown


export function useAcademyPassagesRetrieve<TData = Awaited<ReturnType<typeof academyPassagesRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyPassagesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyPassagesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyPassagesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyPassagesRetrieve<TData = Awaited<ReturnType<typeof academyPassagesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyPassagesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyPassagesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyPassagesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyPassagesRetrieve<TData = Awaited<ReturnType<typeof academyPassagesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyPassagesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyPassagesRetrieve<TData = Awaited<ReturnType<typeof academyPassagesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyPassagesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyPassagesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type academyPassagesPartialUpdateResponse200 = {
  data: Passage
  status: 200
}
    
export type academyPassagesPartialUpdateResponseSuccess = (academyPassagesPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type academyPassagesPartialUpdateResponse = (academyPassagesPartialUpdateResponseSuccess)

export const getAcademyPassagesPartialUpdateUrl = (id: string,) => {


  

  return `/api/v1/academy/passages/${id}/`
}

export const academyPassagesPartialUpdate = async (id: string,
    patchedPassageRequest: PatchedPassageRequest, options?: RequestInit): Promise<academyPassagesPartialUpdateResponse> => {
  
  return apiFetch<academyPassagesPartialUpdateResponse>(getAcademyPassagesPartialUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedPassageRequest,)
  }
);}




export const getAcademyPassagesPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyPassagesPartialUpdate>>, TError,{id: string;data: PatchedPassageRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyPassagesPartialUpdate>>, TError,{id: string;data: PatchedPassageRequest}, TContext> => {

const mutationKey = ['academyPassagesPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyPassagesPartialUpdate>>, {id: string;data: PatchedPassageRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  academyPassagesPartialUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyPassagesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof academyPassagesPartialUpdate>>>
    export type AcademyPassagesPartialUpdateMutationBody = PatchedPassageRequest
    export type AcademyPassagesPartialUpdateMutationError = unknown

    export const useAcademyPassagesPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyPassagesPartialUpdate>>, TError,{id: string;data: PatchedPassageRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyPassagesPartialUpdate>>,
        TError,
        {id: string;data: PatchedPassageRequest},
        TContext
      > => {

      const mutationOptions = getAcademyPassagesPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type academyPassagesGenerateAudioCreateResponse202 = {
  data: CoAudioQueued
  status: 202
}
    
export type academyPassagesGenerateAudioCreateResponseSuccess = (academyPassagesGenerateAudioCreateResponse202) & {
  headers: Headers;
};
;

export type academyPassagesGenerateAudioCreateResponse = (academyPassagesGenerateAudioCreateResponseSuccess)

export const getAcademyPassagesGenerateAudioCreateUrl = (id: string,) => {


  

  return `/api/v1/academy/passages/${id}/generate-audio/`
}

export const academyPassagesGenerateAudioCreate = async (id: string, options?: RequestInit): Promise<academyPassagesGenerateAudioCreateResponse> => {
  
  return apiFetch<academyPassagesGenerateAudioCreateResponse>(getAcademyPassagesGenerateAudioCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getAcademyPassagesGenerateAudioCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyPassagesGenerateAudioCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyPassagesGenerateAudioCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['academyPassagesGenerateAudioCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyPassagesGenerateAudioCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  academyPassagesGenerateAudioCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyPassagesGenerateAudioCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyPassagesGenerateAudioCreate>>>
    
    export type AcademyPassagesGenerateAudioCreateMutationError = unknown

    export const useAcademyPassagesGenerateAudioCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyPassagesGenerateAudioCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyPassagesGenerateAudioCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getAcademyPassagesGenerateAudioCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type academyPassagesPublishCreateResponse200 = {
  data: Passage
  status: 200
}
    
export type academyPassagesPublishCreateResponseSuccess = (academyPassagesPublishCreateResponse200) & {
  headers: Headers;
};
;

export type academyPassagesPublishCreateResponse = (academyPassagesPublishCreateResponseSuccess)

export const getAcademyPassagesPublishCreateUrl = (id: string,) => {


  

  return `/api/v1/academy/passages/${id}/publish/`
}

export const academyPassagesPublishCreate = async (id: string, options?: RequestInit): Promise<academyPassagesPublishCreateResponse> => {
  
  return apiFetch<academyPassagesPublishCreateResponse>(getAcademyPassagesPublishCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getAcademyPassagesPublishCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyPassagesPublishCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyPassagesPublishCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['academyPassagesPublishCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyPassagesPublishCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  academyPassagesPublishCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyPassagesPublishCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyPassagesPublishCreate>>>
    
    export type AcademyPassagesPublishCreateMutationError = unknown

    export const useAcademyPassagesPublishCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyPassagesPublishCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyPassagesPublishCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getAcademyPassagesPublishCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type academyPassagesReviewCreateResponse200 = {
  data: Passage
  status: 200
}
    
export type academyPassagesReviewCreateResponseSuccess = (academyPassagesReviewCreateResponse200) & {
  headers: Headers;
};
;

export type academyPassagesReviewCreateResponse = (academyPassagesReviewCreateResponseSuccess)

export const getAcademyPassagesReviewCreateUrl = (id: string,) => {


  

  return `/api/v1/academy/passages/${id}/review/`
}

export const academyPassagesReviewCreate = async (id: string, options?: RequestInit): Promise<academyPassagesReviewCreateResponse> => {
  
  return apiFetch<academyPassagesReviewCreateResponse>(getAcademyPassagesReviewCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getAcademyPassagesReviewCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyPassagesReviewCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyPassagesReviewCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['academyPassagesReviewCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyPassagesReviewCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  academyPassagesReviewCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyPassagesReviewCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyPassagesReviewCreate>>>
    
    export type AcademyPassagesReviewCreateMutationError = unknown

    export const useAcademyPassagesReviewCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyPassagesReviewCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyPassagesReviewCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getAcademyPassagesReviewCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type academyPassagesAudioStatusRetrieveResponse200 = {
  data: CoAudioStatus
  status: 200
}
    
export type academyPassagesAudioStatusRetrieveResponseSuccess = (academyPassagesAudioStatusRetrieveResponse200) & {
  headers: Headers;
};
;

export type academyPassagesAudioStatusRetrieveResponse = (academyPassagesAudioStatusRetrieveResponseSuccess)

export const getAcademyPassagesAudioStatusRetrieveUrl = (params?: AcademyPassagesAudioStatusRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/passages/audio-status/?${stringifiedParams}` : `/api/v1/academy/passages/audio-status/`
}

export const academyPassagesAudioStatusRetrieve = async (params?: AcademyPassagesAudioStatusRetrieveParams, options?: RequestInit): Promise<academyPassagesAudioStatusRetrieveResponse> => {
  
  return apiFetch<academyPassagesAudioStatusRetrieveResponse>(getAcademyPassagesAudioStatusRetrieveUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyPassagesAudioStatusRetrieveQueryKey = (params?: AcademyPassagesAudioStatusRetrieveParams,) => {
    return [
    `/api/v1/academy/passages/audio-status/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAcademyPassagesAudioStatusRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academyPassagesAudioStatusRetrieve>>, TError = unknown>(params?: AcademyPassagesAudioStatusRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyPassagesAudioStatusRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyPassagesAudioStatusRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyPassagesAudioStatusRetrieve>>> = ({ signal }) => academyPassagesAudioStatusRetrieve(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyPassagesAudioStatusRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyPassagesAudioStatusRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academyPassagesAudioStatusRetrieve>>>
export type AcademyPassagesAudioStatusRetrieveQueryError = unknown


export function useAcademyPassagesAudioStatusRetrieve<TData = Awaited<ReturnType<typeof academyPassagesAudioStatusRetrieve>>, TError = unknown>(
 params: undefined |  AcademyPassagesAudioStatusRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyPassagesAudioStatusRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyPassagesAudioStatusRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyPassagesAudioStatusRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyPassagesAudioStatusRetrieve<TData = Awaited<ReturnType<typeof academyPassagesAudioStatusRetrieve>>, TError = unknown>(
 params?: AcademyPassagesAudioStatusRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyPassagesAudioStatusRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyPassagesAudioStatusRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyPassagesAudioStatusRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyPassagesAudioStatusRetrieve<TData = Awaited<ReturnType<typeof academyPassagesAudioStatusRetrieve>>, TError = unknown>(
 params?: AcademyPassagesAudioStatusRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyPassagesAudioStatusRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyPassagesAudioStatusRetrieve<TData = Awaited<ReturnType<typeof academyPassagesAudioStatusRetrieve>>, TError = unknown>(
 params?: AcademyPassagesAudioStatusRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyPassagesAudioStatusRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyPassagesAudioStatusRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type academyPassagesGenerateMissingAudioResponse202 = {
  data: CoAudioQueued
  status: 202
}
    
export type academyPassagesGenerateMissingAudioResponseSuccess = (academyPassagesGenerateMissingAudioResponse202) & {
  headers: Headers;
};
;

export type academyPassagesGenerateMissingAudioResponse = (academyPassagesGenerateMissingAudioResponseSuccess)

export const getAcademyPassagesGenerateMissingAudioUrl = (params?: AcademyPassagesGenerateMissingAudioParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/passages/generate-audio/?${stringifiedParams}` : `/api/v1/academy/passages/generate-audio/`
}

export const academyPassagesGenerateMissingAudio = async (params?: AcademyPassagesGenerateMissingAudioParams, options?: RequestInit): Promise<academyPassagesGenerateMissingAudioResponse> => {
  
  return apiFetch<academyPassagesGenerateMissingAudioResponse>(getAcademyPassagesGenerateMissingAudioUrl(params),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getAcademyPassagesGenerateMissingAudioMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyPassagesGenerateMissingAudio>>, TError,{params?: AcademyPassagesGenerateMissingAudioParams}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyPassagesGenerateMissingAudio>>, TError,{params?: AcademyPassagesGenerateMissingAudioParams}, TContext> => {

const mutationKey = ['academyPassagesGenerateMissingAudio'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyPassagesGenerateMissingAudio>>, {params?: AcademyPassagesGenerateMissingAudioParams}> = (props) => {
          const {params} = props ?? {};

          return  academyPassagesGenerateMissingAudio(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyPassagesGenerateMissingAudioMutationResult = NonNullable<Awaited<ReturnType<typeof academyPassagesGenerateMissingAudio>>>
    
    export type AcademyPassagesGenerateMissingAudioMutationError = unknown

    export const useAcademyPassagesGenerateMissingAudio = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyPassagesGenerateMissingAudio>>, TError,{params?: AcademyPassagesGenerateMissingAudioParams}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyPassagesGenerateMissingAudio>>,
        TError,
        {params?: AcademyPassagesGenerateMissingAudioParams},
        TContext
      > => {

      const mutationOptions = getAcademyPassagesGenerateMissingAudioMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * The signed-in learner only: never an agency member's tools.
 */
export type academyPlansListResponse200 = {
  data: Plan[]
  status: 200
}
    
export type academyPlansListResponseSuccess = (academyPlansListResponse200) & {
  headers: Headers;
};
;

export type academyPlansListResponse = (academyPlansListResponseSuccess)

export const getAcademyPlansListUrl = (params?: AcademyPlansListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/plans/?${stringifiedParams}` : `/api/v1/academy/plans/`
}

export const academyPlansList = async (params?: AcademyPlansListParams, options?: RequestInit): Promise<academyPlansListResponse> => {
  
  return apiFetch<academyPlansListResponse>(getAcademyPlansListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyPlansListQueryKey = (params?: AcademyPlansListParams,) => {
    return [
    `/api/v1/academy/plans/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAcademyPlansListQueryOptions = <TData = Awaited<ReturnType<typeof academyPlansList>>, TError = unknown>(params?: AcademyPlansListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyPlansList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyPlansListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyPlansList>>> = ({ signal }) => academyPlansList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyPlansList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyPlansListQueryResult = NonNullable<Awaited<ReturnType<typeof academyPlansList>>>
export type AcademyPlansListQueryError = unknown


export function useAcademyPlansList<TData = Awaited<ReturnType<typeof academyPlansList>>, TError = unknown>(
 params: undefined |  AcademyPlansListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyPlansList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyPlansList>>,
          TError,
          Awaited<ReturnType<typeof academyPlansList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyPlansList<TData = Awaited<ReturnType<typeof academyPlansList>>, TError = unknown>(
 params?: AcademyPlansListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyPlansList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyPlansList>>,
          TError,
          Awaited<ReturnType<typeof academyPlansList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyPlansList<TData = Awaited<ReturnType<typeof academyPlansList>>, TError = unknown>(
 params?: AcademyPlansListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyPlansList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyPlansList<TData = Awaited<ReturnType<typeof academyPlansList>>, TError = unknown>(
 params?: AcademyPlansListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyPlansList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyPlansListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * The signed-in learner only: never an agency member's tools.
 */
export type academyPlansCreateResponse201 = {
  data: Subscribed
  status: 201
}
    
export type academyPlansCreateResponseSuccess = (academyPlansCreateResponse201) & {
  headers: Headers;
};
;

export type academyPlansCreateResponse = (academyPlansCreateResponseSuccess)

export const getAcademyPlansCreateUrl = () => {


  

  return `/api/v1/academy/plans/`
}

export const academyPlansCreate = async (subscribeRequest: SubscribeRequest, options?: RequestInit): Promise<academyPlansCreateResponse> => {
  
  return apiFetch<academyPlansCreateResponse>(getAcademyPlansCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      subscribeRequest,)
  }
);}




export const getAcademyPlansCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyPlansCreate>>, TError,{data: SubscribeRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyPlansCreate>>, TError,{data: SubscribeRequest}, TContext> => {

const mutationKey = ['academyPlansCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyPlansCreate>>, {data: SubscribeRequest}> = (props) => {
          const {data} = props ?? {};

          return  academyPlansCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyPlansCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyPlansCreate>>>
    export type AcademyPlansCreateMutationBody = SubscribeRequest
    export type AcademyPlansCreateMutationError = unknown

    export const useAcademyPlansCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyPlansCreate>>, TError,{data: SubscribeRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyPlansCreate>>,
        TError,
        {data: SubscribeRequest},
        TContext
      > => {

      const mutationOptions = getAcademyPlansCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Grading queue: productions for a trainer, and re-grading of AI marks (calibration).
 */
export type academyProductionsListResponse200 = {
  data: PaginatedProductionList
  status: 200
}
    
export type academyProductionsListResponseSuccess = (academyProductionsListResponse200) & {
  headers: Headers;
};
;

export type academyProductionsListResponse = (academyProductionsListResponseSuccess)

export const getAcademyProductionsListUrl = (params?: AcademyProductionsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/productions/?${stringifiedParams}` : `/api/v1/academy/productions/`
}

export const academyProductionsList = async (params?: AcademyProductionsListParams, options?: RequestInit): Promise<academyProductionsListResponse> => {
  
  return apiFetch<academyProductionsListResponse>(getAcademyProductionsListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyProductionsListQueryKey = (params?: AcademyProductionsListParams,) => {
    return [
    `/api/v1/academy/productions/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAcademyProductionsListQueryOptions = <TData = Awaited<ReturnType<typeof academyProductionsList>>, TError = unknown>(params?: AcademyProductionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyProductionsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyProductionsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyProductionsList>>> = ({ signal }) => academyProductionsList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyProductionsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyProductionsListQueryResult = NonNullable<Awaited<ReturnType<typeof academyProductionsList>>>
export type AcademyProductionsListQueryError = unknown


export function useAcademyProductionsList<TData = Awaited<ReturnType<typeof academyProductionsList>>, TError = unknown>(
 params: undefined |  AcademyProductionsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyProductionsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyProductionsList>>,
          TError,
          Awaited<ReturnType<typeof academyProductionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyProductionsList<TData = Awaited<ReturnType<typeof academyProductionsList>>, TError = unknown>(
 params?: AcademyProductionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyProductionsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyProductionsList>>,
          TError,
          Awaited<ReturnType<typeof academyProductionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyProductionsList<TData = Awaited<ReturnType<typeof academyProductionsList>>, TError = unknown>(
 params?: AcademyProductionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyProductionsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyProductionsList<TData = Awaited<ReturnType<typeof academyProductionsList>>, TError = unknown>(
 params?: AcademyProductionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyProductionsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyProductionsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Grading queue: productions for a trainer, and re-grading of AI marks (calibration).
 */
export type academyProductionsRetrieveResponse200 = {
  data: Production
  status: 200
}
    
export type academyProductionsRetrieveResponseSuccess = (academyProductionsRetrieveResponse200) & {
  headers: Headers;
};
;

export type academyProductionsRetrieveResponse = (academyProductionsRetrieveResponseSuccess)

export const getAcademyProductionsRetrieveUrl = (id: string,) => {


  

  return `/api/v1/academy/productions/${id}/`
}

export const academyProductionsRetrieve = async (id: string, options?: RequestInit): Promise<academyProductionsRetrieveResponse> => {
  
  return apiFetch<academyProductionsRetrieveResponse>(getAcademyProductionsRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyProductionsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/academy/productions/${id}/`
    ] as const;
    }

    
export const getAcademyProductionsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academyProductionsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyProductionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyProductionsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyProductionsRetrieve>>> = ({ signal }) => academyProductionsRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyProductionsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyProductionsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academyProductionsRetrieve>>>
export type AcademyProductionsRetrieveQueryError = unknown


export function useAcademyProductionsRetrieve<TData = Awaited<ReturnType<typeof academyProductionsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyProductionsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyProductionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyProductionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyProductionsRetrieve<TData = Awaited<ReturnType<typeof academyProductionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyProductionsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyProductionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyProductionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyProductionsRetrieve<TData = Awaited<ReturnType<typeof academyProductionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyProductionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyProductionsRetrieve<TData = Awaited<ReturnType<typeof academyProductionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyProductionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyProductionsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Grading queue: productions for a trainer, and re-grading of AI marks (calibration).
 */
export type academyProductionsGradeCreateResponse200 = {
  data: Production
  status: 200
}
    
export type academyProductionsGradeCreateResponseSuccess = (academyProductionsGradeCreateResponse200) & {
  headers: Headers;
};
;

export type academyProductionsGradeCreateResponse = (academyProductionsGradeCreateResponseSuccess)

export const getAcademyProductionsGradeCreateUrl = (id: string,) => {


  

  return `/api/v1/academy/productions/${id}/grade/`
}

export const academyProductionsGradeCreate = async (id: string,
    trainerGradeRequest: TrainerGradeRequest, options?: RequestInit): Promise<academyProductionsGradeCreateResponse> => {
  
  return apiFetch<academyProductionsGradeCreateResponse>(getAcademyProductionsGradeCreateUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      trainerGradeRequest,)
  }
);}




export const getAcademyProductionsGradeCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyProductionsGradeCreate>>, TError,{id: string;data: TrainerGradeRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyProductionsGradeCreate>>, TError,{id: string;data: TrainerGradeRequest}, TContext> => {

const mutationKey = ['academyProductionsGradeCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyProductionsGradeCreate>>, {id: string;data: TrainerGradeRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  academyProductionsGradeCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyProductionsGradeCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyProductionsGradeCreate>>>
    export type AcademyProductionsGradeCreateMutationBody = TrainerGradeRequest
    export type AcademyProductionsGradeCreateMutationError = unknown

    export const useAcademyProductionsGradeCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyProductionsGradeCreate>>, TError,{id: string;data: TrainerGradeRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyProductionsGradeCreate>>,
        TError,
        {id: string;data: TrainerGradeRequest},
        TContext
      > => {

      const mutationOptions = getAcademyProductionsGradeCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * D-175: the AI tries again now on work still « en correction ».
 */
export type academyProductionsRetryCreateResponse200 = {
  data: Production
  status: 200
}
    
export type academyProductionsRetryCreateResponseSuccess = (academyProductionsRetryCreateResponse200) & {
  headers: Headers;
};
;

export type academyProductionsRetryCreateResponse = (academyProductionsRetryCreateResponseSuccess)

export const getAcademyProductionsRetryCreateUrl = (id: string,) => {


  

  return `/api/v1/academy/productions/${id}/retry/`
}

export const academyProductionsRetryCreate = async (id: string, options?: RequestInit): Promise<academyProductionsRetryCreateResponse> => {
  
  return apiFetch<academyProductionsRetryCreateResponse>(getAcademyProductionsRetryCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getAcademyProductionsRetryCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyProductionsRetryCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyProductionsRetryCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['academyProductionsRetryCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyProductionsRetryCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  academyProductionsRetryCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyProductionsRetryCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyProductionsRetryCreate>>>
    
    export type AcademyProductionsRetryCreateMutationError = unknown

    export const useAcademyProductionsRetryCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyProductionsRetryCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyProductionsRetryCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getAcademyProductionsRetryCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * D-175: what the back office must warn about (no AI, work waiting, past the bound).
 */
export type academyProductionsOverviewRetrieveResponse200 = {
  data: GradingOverview
  status: 200
}
    
export type academyProductionsOverviewRetrieveResponseSuccess = (academyProductionsOverviewRetrieveResponse200) & {
  headers: Headers;
};
;

export type academyProductionsOverviewRetrieveResponse = (academyProductionsOverviewRetrieveResponseSuccess)

export const getAcademyProductionsOverviewRetrieveUrl = (params?: AcademyProductionsOverviewRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/productions/overview/?${stringifiedParams}` : `/api/v1/academy/productions/overview/`
}

export const academyProductionsOverviewRetrieve = async (params?: AcademyProductionsOverviewRetrieveParams, options?: RequestInit): Promise<academyProductionsOverviewRetrieveResponse> => {
  
  return apiFetch<academyProductionsOverviewRetrieveResponse>(getAcademyProductionsOverviewRetrieveUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyProductionsOverviewRetrieveQueryKey = (params?: AcademyProductionsOverviewRetrieveParams,) => {
    return [
    `/api/v1/academy/productions/overview/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAcademyProductionsOverviewRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academyProductionsOverviewRetrieve>>, TError = unknown>(params?: AcademyProductionsOverviewRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyProductionsOverviewRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyProductionsOverviewRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyProductionsOverviewRetrieve>>> = ({ signal }) => academyProductionsOverviewRetrieve(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyProductionsOverviewRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyProductionsOverviewRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academyProductionsOverviewRetrieve>>>
export type AcademyProductionsOverviewRetrieveQueryError = unknown


export function useAcademyProductionsOverviewRetrieve<TData = Awaited<ReturnType<typeof academyProductionsOverviewRetrieve>>, TError = unknown>(
 params: undefined |  AcademyProductionsOverviewRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyProductionsOverviewRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyProductionsOverviewRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyProductionsOverviewRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyProductionsOverviewRetrieve<TData = Awaited<ReturnType<typeof academyProductionsOverviewRetrieve>>, TError = unknown>(
 params?: AcademyProductionsOverviewRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyProductionsOverviewRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyProductionsOverviewRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyProductionsOverviewRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyProductionsOverviewRetrieve<TData = Awaited<ReturnType<typeof academyProductionsOverviewRetrieve>>, TError = unknown>(
 params?: AcademyProductionsOverviewRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyProductionsOverviewRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyProductionsOverviewRetrieve<TData = Awaited<ReturnType<typeof academyProductionsOverviewRetrieve>>, TError = unknown>(
 params?: AcademyProductionsOverviewRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyProductionsOverviewRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyProductionsOverviewRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Evolution, global rank among all learners, pointed analysis and readiness verdict.
 */
export type academyProgressRetrieveResponse200 = {
  data: LearnerProgress
  status: 200
}
    
export type academyProgressRetrieveResponseSuccess = (academyProgressRetrieveResponse200) & {
  headers: Headers;
};
;

export type academyProgressRetrieveResponse = (academyProgressRetrieveResponseSuccess)

export const getAcademyProgressRetrieveUrl = (params?: AcademyProgressRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/progress/?${stringifiedParams}` : `/api/v1/academy/progress/`
}

export const academyProgressRetrieve = async (params?: AcademyProgressRetrieveParams, options?: RequestInit): Promise<academyProgressRetrieveResponse> => {
  
  return apiFetch<academyProgressRetrieveResponse>(getAcademyProgressRetrieveUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyProgressRetrieveQueryKey = (params?: AcademyProgressRetrieveParams,) => {
    return [
    `/api/v1/academy/progress/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAcademyProgressRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academyProgressRetrieve>>, TError = unknown>(params?: AcademyProgressRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyProgressRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyProgressRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyProgressRetrieve>>> = ({ signal }) => academyProgressRetrieve(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyProgressRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyProgressRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academyProgressRetrieve>>>
export type AcademyProgressRetrieveQueryError = unknown


export function useAcademyProgressRetrieve<TData = Awaited<ReturnType<typeof academyProgressRetrieve>>, TError = unknown>(
 params: undefined |  AcademyProgressRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyProgressRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyProgressRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyProgressRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyProgressRetrieve<TData = Awaited<ReturnType<typeof academyProgressRetrieve>>, TError = unknown>(
 params?: AcademyProgressRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyProgressRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyProgressRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyProgressRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyProgressRetrieve<TData = Awaited<ReturnType<typeof academyProgressRetrieve>>, TError = unknown>(
 params?: AcademyProgressRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyProgressRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyProgressRetrieve<TData = Awaited<ReturnType<typeof academyProgressRetrieve>>, TError = unknown>(
 params?: AcademyProgressRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyProgressRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyProgressRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type academyQuestionsListResponse200 = {
  data: PaginatedQuestionList
  status: 200
}
    
export type academyQuestionsListResponseSuccess = (academyQuestionsListResponse200) & {
  headers: Headers;
};
;

export type academyQuestionsListResponse = (academyQuestionsListResponseSuccess)

export const getAcademyQuestionsListUrl = (params?: AcademyQuestionsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/questions/?${stringifiedParams}` : `/api/v1/academy/questions/`
}

export const academyQuestionsList = async (params?: AcademyQuestionsListParams, options?: RequestInit): Promise<academyQuestionsListResponse> => {
  
  return apiFetch<academyQuestionsListResponse>(getAcademyQuestionsListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyQuestionsListQueryKey = (params?: AcademyQuestionsListParams,) => {
    return [
    `/api/v1/academy/questions/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAcademyQuestionsListQueryOptions = <TData = Awaited<ReturnType<typeof academyQuestionsList>>, TError = unknown>(params?: AcademyQuestionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyQuestionsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyQuestionsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyQuestionsList>>> = ({ signal }) => academyQuestionsList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyQuestionsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyQuestionsListQueryResult = NonNullable<Awaited<ReturnType<typeof academyQuestionsList>>>
export type AcademyQuestionsListQueryError = unknown


export function useAcademyQuestionsList<TData = Awaited<ReturnType<typeof academyQuestionsList>>, TError = unknown>(
 params: undefined |  AcademyQuestionsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyQuestionsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyQuestionsList>>,
          TError,
          Awaited<ReturnType<typeof academyQuestionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyQuestionsList<TData = Awaited<ReturnType<typeof academyQuestionsList>>, TError = unknown>(
 params?: AcademyQuestionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyQuestionsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyQuestionsList>>,
          TError,
          Awaited<ReturnType<typeof academyQuestionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyQuestionsList<TData = Awaited<ReturnType<typeof academyQuestionsList>>, TError = unknown>(
 params?: AcademyQuestionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyQuestionsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyQuestionsList<TData = Awaited<ReturnType<typeof academyQuestionsList>>, TError = unknown>(
 params?: AcademyQuestionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyQuestionsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyQuestionsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type academyQuestionsCreateResponse201 = {
  data: Question
  status: 201
}
    
export type academyQuestionsCreateResponseSuccess = (academyQuestionsCreateResponse201) & {
  headers: Headers;
};
;

export type academyQuestionsCreateResponse = (academyQuestionsCreateResponseSuccess)

export const getAcademyQuestionsCreateUrl = () => {


  

  return `/api/v1/academy/questions/`
}

export const academyQuestionsCreate = async (questionRequest: QuestionRequest, options?: RequestInit): Promise<academyQuestionsCreateResponse> => {
  
  return apiFetch<academyQuestionsCreateResponse>(getAcademyQuestionsCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      questionRequest,)
  }
);}




export const getAcademyQuestionsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyQuestionsCreate>>, TError,{data: QuestionRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyQuestionsCreate>>, TError,{data: QuestionRequest}, TContext> => {

const mutationKey = ['academyQuestionsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyQuestionsCreate>>, {data: QuestionRequest}> = (props) => {
          const {data} = props ?? {};

          return  academyQuestionsCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyQuestionsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyQuestionsCreate>>>
    export type AcademyQuestionsCreateMutationBody = QuestionRequest
    export type AcademyQuestionsCreateMutationError = unknown

    export const useAcademyQuestionsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyQuestionsCreate>>, TError,{data: QuestionRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyQuestionsCreate>>,
        TError,
        {data: QuestionRequest},
        TContext
      > => {

      const mutationOptions = getAcademyQuestionsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type academyQuestionsRetrieveResponse200 = {
  data: Question
  status: 200
}
    
export type academyQuestionsRetrieveResponseSuccess = (academyQuestionsRetrieveResponse200) & {
  headers: Headers;
};
;

export type academyQuestionsRetrieveResponse = (academyQuestionsRetrieveResponseSuccess)

export const getAcademyQuestionsRetrieveUrl = (id: string,) => {


  

  return `/api/v1/academy/questions/${id}/`
}

export const academyQuestionsRetrieve = async (id: string, options?: RequestInit): Promise<academyQuestionsRetrieveResponse> => {
  
  return apiFetch<academyQuestionsRetrieveResponse>(getAcademyQuestionsRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyQuestionsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/academy/questions/${id}/`
    ] as const;
    }

    
export const getAcademyQuestionsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academyQuestionsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyQuestionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyQuestionsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyQuestionsRetrieve>>> = ({ signal }) => academyQuestionsRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyQuestionsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyQuestionsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academyQuestionsRetrieve>>>
export type AcademyQuestionsRetrieveQueryError = unknown


export function useAcademyQuestionsRetrieve<TData = Awaited<ReturnType<typeof academyQuestionsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyQuestionsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyQuestionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyQuestionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyQuestionsRetrieve<TData = Awaited<ReturnType<typeof academyQuestionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyQuestionsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyQuestionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyQuestionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyQuestionsRetrieve<TData = Awaited<ReturnType<typeof academyQuestionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyQuestionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyQuestionsRetrieve<TData = Awaited<ReturnType<typeof academyQuestionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyQuestionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyQuestionsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type academyQuestionsPartialUpdateResponse200 = {
  data: Question
  status: 200
}
    
export type academyQuestionsPartialUpdateResponseSuccess = (academyQuestionsPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type academyQuestionsPartialUpdateResponse = (academyQuestionsPartialUpdateResponseSuccess)

export const getAcademyQuestionsPartialUpdateUrl = (id: string,) => {


  

  return `/api/v1/academy/questions/${id}/`
}

export const academyQuestionsPartialUpdate = async (id: string,
    patchedQuestionRequest: PatchedQuestionRequest, options?: RequestInit): Promise<academyQuestionsPartialUpdateResponse> => {
  
  return apiFetch<academyQuestionsPartialUpdateResponse>(getAcademyQuestionsPartialUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedQuestionRequest,)
  }
);}




export const getAcademyQuestionsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyQuestionsPartialUpdate>>, TError,{id: string;data: PatchedQuestionRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyQuestionsPartialUpdate>>, TError,{id: string;data: PatchedQuestionRequest}, TContext> => {

const mutationKey = ['academyQuestionsPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyQuestionsPartialUpdate>>, {id: string;data: PatchedQuestionRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  academyQuestionsPartialUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyQuestionsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof academyQuestionsPartialUpdate>>>
    export type AcademyQuestionsPartialUpdateMutationBody = PatchedQuestionRequest
    export type AcademyQuestionsPartialUpdateMutationError = unknown

    export const useAcademyQuestionsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyQuestionsPartialUpdate>>, TError,{id: string;data: PatchedQuestionRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyQuestionsPartialUpdate>>,
        TError,
        {id: string;data: PatchedQuestionRequest},
        TContext
      > => {

      const mutationOptions = getAcademyQuestionsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type academyQuestionsAudioCreateResponse200 = {
  data: Question
  status: 200
}
    
export type academyQuestionsAudioCreateResponseSuccess = (academyQuestionsAudioCreateResponse200) & {
  headers: Headers;
};
;

export type academyQuestionsAudioCreateResponse = (academyQuestionsAudioCreateResponseSuccess)

export const getAcademyQuestionsAudioCreateUrl = (id: string,) => {


  

  return `/api/v1/academy/questions/${id}/audio/`
}

export const academyQuestionsAudioCreate = async (id: string,
    audioUploadRequest: AudioUploadRequest, options?: RequestInit): Promise<academyQuestionsAudioCreateResponse> => {
    const formData = new FormData();
formData.append(`audio`, audioUploadRequest.audio)

  return apiFetch<academyQuestionsAudioCreateResponse>(getAcademyQuestionsAudioCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    ,
    body: 
      formData,
  }
);}




export const getAcademyQuestionsAudioCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyQuestionsAudioCreate>>, TError,{id: string;data: AudioUploadRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyQuestionsAudioCreate>>, TError,{id: string;data: AudioUploadRequest}, TContext> => {

const mutationKey = ['academyQuestionsAudioCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyQuestionsAudioCreate>>, {id: string;data: AudioUploadRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  academyQuestionsAudioCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyQuestionsAudioCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyQuestionsAudioCreate>>>
    export type AcademyQuestionsAudioCreateMutationBody = AudioUploadRequest
    export type AcademyQuestionsAudioCreateMutationError = unknown

    export const useAcademyQuestionsAudioCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyQuestionsAudioCreate>>, TError,{id: string;data: AudioUploadRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyQuestionsAudioCreate>>,
        TError,
        {id: string;data: AudioUploadRequest},
        TContext
      > => {

      const mutationOptions = getAcademyQuestionsAudioCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type academyQuestionsGenerateAudioCreateResponse202 = {
  data: CoAudioQueued
  status: 202
}
    
export type academyQuestionsGenerateAudioCreateResponseSuccess = (academyQuestionsGenerateAudioCreateResponse202) & {
  headers: Headers;
};
;

export type academyQuestionsGenerateAudioCreateResponse = (academyQuestionsGenerateAudioCreateResponseSuccess)

export const getAcademyQuestionsGenerateAudioCreateUrl = (id: string,) => {


  

  return `/api/v1/academy/questions/${id}/generate-audio/`
}

export const academyQuestionsGenerateAudioCreate = async (id: string, options?: RequestInit): Promise<academyQuestionsGenerateAudioCreateResponse> => {
  
  return apiFetch<academyQuestionsGenerateAudioCreateResponse>(getAcademyQuestionsGenerateAudioCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getAcademyQuestionsGenerateAudioCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyQuestionsGenerateAudioCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyQuestionsGenerateAudioCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['academyQuestionsGenerateAudioCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyQuestionsGenerateAudioCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  academyQuestionsGenerateAudioCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyQuestionsGenerateAudioCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyQuestionsGenerateAudioCreate>>>
    
    export type AcademyQuestionsGenerateAudioCreateMutationError = unknown

    export const useAcademyQuestionsGenerateAudioCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyQuestionsGenerateAudioCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyQuestionsGenerateAudioCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getAcademyQuestionsGenerateAudioCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type academyQuestionsPublishCreateResponse200 = {
  data: Question
  status: 200
}
    
export type academyQuestionsPublishCreateResponseSuccess = (academyQuestionsPublishCreateResponse200) & {
  headers: Headers;
};
;

export type academyQuestionsPublishCreateResponse = (academyQuestionsPublishCreateResponseSuccess)

export const getAcademyQuestionsPublishCreateUrl = (id: string,) => {


  

  return `/api/v1/academy/questions/${id}/publish/`
}

export const academyQuestionsPublishCreate = async (id: string, options?: RequestInit): Promise<academyQuestionsPublishCreateResponse> => {
  
  return apiFetch<academyQuestionsPublishCreateResponse>(getAcademyQuestionsPublishCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getAcademyQuestionsPublishCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyQuestionsPublishCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyQuestionsPublishCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['academyQuestionsPublishCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyQuestionsPublishCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  academyQuestionsPublishCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyQuestionsPublishCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyQuestionsPublishCreate>>>
    
    export type AcademyQuestionsPublishCreateMutationError = unknown

    export const useAcademyQuestionsPublishCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyQuestionsPublishCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyQuestionsPublishCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getAcademyQuestionsPublishCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type academyQuestionsReviewCreateResponse200 = {
  data: Question
  status: 200
}
    
export type academyQuestionsReviewCreateResponseSuccess = (academyQuestionsReviewCreateResponse200) & {
  headers: Headers;
};
;

export type academyQuestionsReviewCreateResponse = (academyQuestionsReviewCreateResponseSuccess)

export const getAcademyQuestionsReviewCreateUrl = (id: string,) => {


  

  return `/api/v1/academy/questions/${id}/review/`
}

export const academyQuestionsReviewCreate = async (id: string, options?: RequestInit): Promise<academyQuestionsReviewCreateResponse> => {
  
  return apiFetch<academyQuestionsReviewCreateResponse>(getAcademyQuestionsReviewCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getAcademyQuestionsReviewCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyQuestionsReviewCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyQuestionsReviewCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['academyQuestionsReviewCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyQuestionsReviewCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  academyQuestionsReviewCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyQuestionsReviewCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyQuestionsReviewCreate>>>
    
    export type AcademyQuestionsReviewCreateMutationError = unknown

    export const useAcademyQuestionsReviewCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyQuestionsReviewCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyQuestionsReviewCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getAcademyQuestionsReviewCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type academyQuestionsAudioStatusRetrieveResponse200 = {
  data: CoAudioStatus
  status: 200
}
    
export type academyQuestionsAudioStatusRetrieveResponseSuccess = (academyQuestionsAudioStatusRetrieveResponse200) & {
  headers: Headers;
};
;

export type academyQuestionsAudioStatusRetrieveResponse = (academyQuestionsAudioStatusRetrieveResponseSuccess)

export const getAcademyQuestionsAudioStatusRetrieveUrl = () => {


  

  return `/api/v1/academy/questions/audio-status/`
}

export const academyQuestionsAudioStatusRetrieve = async ( options?: RequestInit): Promise<academyQuestionsAudioStatusRetrieveResponse> => {
  
  return apiFetch<academyQuestionsAudioStatusRetrieveResponse>(getAcademyQuestionsAudioStatusRetrieveUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyQuestionsAudioStatusRetrieveQueryKey = () => {
    return [
    `/api/v1/academy/questions/audio-status/`
    ] as const;
    }

    
export const getAcademyQuestionsAudioStatusRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academyQuestionsAudioStatusRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyQuestionsAudioStatusRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyQuestionsAudioStatusRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyQuestionsAudioStatusRetrieve>>> = ({ signal }) => academyQuestionsAudioStatusRetrieve({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyQuestionsAudioStatusRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyQuestionsAudioStatusRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academyQuestionsAudioStatusRetrieve>>>
export type AcademyQuestionsAudioStatusRetrieveQueryError = unknown


export function useAcademyQuestionsAudioStatusRetrieve<TData = Awaited<ReturnType<typeof academyQuestionsAudioStatusRetrieve>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyQuestionsAudioStatusRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyQuestionsAudioStatusRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyQuestionsAudioStatusRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyQuestionsAudioStatusRetrieve<TData = Awaited<ReturnType<typeof academyQuestionsAudioStatusRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyQuestionsAudioStatusRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyQuestionsAudioStatusRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyQuestionsAudioStatusRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyQuestionsAudioStatusRetrieve<TData = Awaited<ReturnType<typeof academyQuestionsAudioStatusRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyQuestionsAudioStatusRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyQuestionsAudioStatusRetrieve<TData = Awaited<ReturnType<typeof academyQuestionsAudioStatusRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyQuestionsAudioStatusRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyQuestionsAudioStatusRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type academyQuestionsGenerateMissingAudioResponse202 = {
  data: CoAudioQueued
  status: 202
}
    
export type academyQuestionsGenerateMissingAudioResponseSuccess = (academyQuestionsGenerateMissingAudioResponse202) & {
  headers: Headers;
};
;

export type academyQuestionsGenerateMissingAudioResponse = (academyQuestionsGenerateMissingAudioResponseSuccess)

export const getAcademyQuestionsGenerateMissingAudioUrl = () => {


  

  return `/api/v1/academy/questions/generate-audio/`
}

export const academyQuestionsGenerateMissingAudio = async ( options?: RequestInit): Promise<academyQuestionsGenerateMissingAudioResponse> => {
  
  return apiFetch<academyQuestionsGenerateMissingAudioResponse>(getAcademyQuestionsGenerateMissingAudioUrl(),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getAcademyQuestionsGenerateMissingAudioMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyQuestionsGenerateMissingAudio>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyQuestionsGenerateMissingAudio>>, TError,void, TContext> => {

const mutationKey = ['academyQuestionsGenerateMissingAudio'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyQuestionsGenerateMissingAudio>>, void> = () => {
          

          return  academyQuestionsGenerateMissingAudio(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyQuestionsGenerateMissingAudioMutationResult = NonNullable<Awaited<ReturnType<typeof academyQuestionsGenerateMissingAudio>>>
    
    export type AcademyQuestionsGenerateMissingAudioMutationError = unknown

    export const useAcademyQuestionsGenerateMissingAudio = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyQuestionsGenerateMissingAudio>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyQuestionsGenerateMissingAudio>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getAcademyQuestionsGenerateMissingAudioMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Public sign-up on the Academy (then sign in with the code received by e-mail).
 */
export type academyRegisterCreateResponse201 = {
  data: Registered
  status: 201
}
    
export type academyRegisterCreateResponseSuccess = (academyRegisterCreateResponse201) & {
  headers: Headers;
};
;

export type academyRegisterCreateResponse = (academyRegisterCreateResponseSuccess)

export const getAcademyRegisterCreateUrl = () => {


  

  return `/api/v1/academy/register/`
}

export const academyRegisterCreate = async (registerRequest: RegisterRequest, options?: RequestInit): Promise<academyRegisterCreateResponse> => {
  
  return apiFetch<academyRegisterCreateResponse>(getAcademyRegisterCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      registerRequest,)
  }
);}




export const getAcademyRegisterCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyRegisterCreate>>, TError,{data: RegisterRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyRegisterCreate>>, TError,{data: RegisterRequest}, TContext> => {

const mutationKey = ['academyRegisterCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyRegisterCreate>>, {data: RegisterRequest}> = (props) => {
          const {data} = props ?? {};

          return  academyRegisterCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyRegisterCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyRegisterCreate>>>
    export type AcademyRegisterCreateMutationBody = RegisterRequest
    export type AcademyRegisterCreateMutationError = unknown

    export const useAcademyRegisterCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyRegisterCreate>>, TError,{data: RegisterRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyRegisterCreate>>,
        TError,
        {data: RegisterRequest},
        TContext
      > => {

      const mutationOptions = getAcademyRegisterCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * The last report asked for, with its signed link once printed (poll until ready).
 */
export type academyReportRetrieveResponse200 = {
  data: LearnerReport
  status: 200
}
    
export type academyReportRetrieveResponseSuccess = (academyReportRetrieveResponse200) & {
  headers: Headers;
};
;

export type academyReportRetrieveResponse = (academyReportRetrieveResponseSuccess)

export const getAcademyReportRetrieveUrl = (params?: AcademyReportRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/report/?${stringifiedParams}` : `/api/v1/academy/report/`
}

export const academyReportRetrieve = async (params?: AcademyReportRetrieveParams, options?: RequestInit): Promise<academyReportRetrieveResponse> => {
  
  return apiFetch<academyReportRetrieveResponse>(getAcademyReportRetrieveUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyReportRetrieveQueryKey = (params?: AcademyReportRetrieveParams,) => {
    return [
    `/api/v1/academy/report/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAcademyReportRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academyReportRetrieve>>, TError = unknown>(params?: AcademyReportRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyReportRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyReportRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyReportRetrieve>>> = ({ signal }) => academyReportRetrieve(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyReportRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyReportRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academyReportRetrieve>>>
export type AcademyReportRetrieveQueryError = unknown


export function useAcademyReportRetrieve<TData = Awaited<ReturnType<typeof academyReportRetrieve>>, TError = unknown>(
 params: undefined |  AcademyReportRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyReportRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyReportRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyReportRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyReportRetrieve<TData = Awaited<ReturnType<typeof academyReportRetrieve>>, TError = unknown>(
 params?: AcademyReportRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyReportRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyReportRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyReportRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyReportRetrieve<TData = Awaited<ReturnType<typeof academyReportRetrieve>>, TError = unknown>(
 params?: AcademyReportRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyReportRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyReportRetrieve<TData = Awaited<ReturnType<typeof academyReportRetrieve>>, TError = unknown>(
 params?: AcademyReportRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyReportRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyReportRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * The learner's complete report (PDF, printed in the background).
 */
export type academyReportCreateResponse201 = {
  data: GeneratedDocument
  status: 201
}
    
export type academyReportCreateResponseSuccess = (academyReportCreateResponse201) & {
  headers: Headers;
};
;

export type academyReportCreateResponse = (academyReportCreateResponseSuccess)

export const getAcademyReportCreateUrl = (params?: AcademyReportCreateParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/report/?${stringifiedParams}` : `/api/v1/academy/report/`
}

export const academyReportCreate = async (params?: AcademyReportCreateParams, options?: RequestInit): Promise<academyReportCreateResponse> => {
  
  return apiFetch<academyReportCreateResponse>(getAcademyReportCreateUrl(params),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getAcademyReportCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyReportCreate>>, TError,{params?: AcademyReportCreateParams}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyReportCreate>>, TError,{params?: AcademyReportCreateParams}, TContext> => {

const mutationKey = ['academyReportCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyReportCreate>>, {params?: AcademyReportCreateParams}> = (props) => {
          const {params} = props ?? {};

          return  academyReportCreate(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyReportCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyReportCreate>>>
    
    export type AcademyReportCreateMutationError = unknown

    export const useAcademyReportCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyReportCreate>>, TError,{params?: AcademyReportCreateParams}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyReportCreate>>,
        TError,
        {params?: AcademyReportCreateParams},
        TContext
      > => {

      const mutationOptions = getAcademyReportCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * En attente d'abord, par échéance (la plus urgente en tête).
 */
export type academyReviewRequestsListResponse200 = {
  data: PaginatedTrainerReviewRequestList
  status: 200
}
    
export type academyReviewRequestsListResponseSuccess = (academyReviewRequestsListResponse200) & {
  headers: Headers;
};
;

export type academyReviewRequestsListResponse = (academyReviewRequestsListResponseSuccess)

export const getAcademyReviewRequestsListUrl = (params?: AcademyReviewRequestsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/review-requests/?${stringifiedParams}` : `/api/v1/academy/review-requests/`
}

export const academyReviewRequestsList = async (params?: AcademyReviewRequestsListParams, options?: RequestInit): Promise<academyReviewRequestsListResponse> => {
  
  return apiFetch<academyReviewRequestsListResponse>(getAcademyReviewRequestsListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyReviewRequestsListQueryKey = (params?: AcademyReviewRequestsListParams,) => {
    return [
    `/api/v1/academy/review-requests/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAcademyReviewRequestsListQueryOptions = <TData = Awaited<ReturnType<typeof academyReviewRequestsList>>, TError = unknown>(params?: AcademyReviewRequestsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyReviewRequestsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyReviewRequestsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyReviewRequestsList>>> = ({ signal }) => academyReviewRequestsList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyReviewRequestsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyReviewRequestsListQueryResult = NonNullable<Awaited<ReturnType<typeof academyReviewRequestsList>>>
export type AcademyReviewRequestsListQueryError = unknown


export function useAcademyReviewRequestsList<TData = Awaited<ReturnType<typeof academyReviewRequestsList>>, TError = unknown>(
 params: undefined |  AcademyReviewRequestsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyReviewRequestsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyReviewRequestsList>>,
          TError,
          Awaited<ReturnType<typeof academyReviewRequestsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyReviewRequestsList<TData = Awaited<ReturnType<typeof academyReviewRequestsList>>, TError = unknown>(
 params?: AcademyReviewRequestsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyReviewRequestsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyReviewRequestsList>>,
          TError,
          Awaited<ReturnType<typeof academyReviewRequestsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyReviewRequestsList<TData = Awaited<ReturnType<typeof academyReviewRequestsList>>, TError = unknown>(
 params?: AcademyReviewRequestsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyReviewRequestsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyReviewRequestsList<TData = Awaited<ReturnType<typeof academyReviewRequestsList>>, TError = unknown>(
 params?: AcademyReviewRequestsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyReviewRequestsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyReviewRequestsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Review requests in the grading queue (D-124): the most urgent first, with the time left
before the promised deadline; a trainer sees only the exams of their language (D-120).
 */
export type academyReviewRequestsRetrieveResponse200 = {
  data: TrainerReviewRequest
  status: 200
}
    
export type academyReviewRequestsRetrieveResponseSuccess = (academyReviewRequestsRetrieveResponse200) & {
  headers: Headers;
};
;

export type academyReviewRequestsRetrieveResponse = (academyReviewRequestsRetrieveResponseSuccess)

export const getAcademyReviewRequestsRetrieveUrl = (id: string,) => {


  

  return `/api/v1/academy/review-requests/${id}/`
}

export const academyReviewRequestsRetrieve = async (id: string, options?: RequestInit): Promise<academyReviewRequestsRetrieveResponse> => {
  
  return apiFetch<academyReviewRequestsRetrieveResponse>(getAcademyReviewRequestsRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyReviewRequestsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/academy/review-requests/${id}/`
    ] as const;
    }

    
export const getAcademyReviewRequestsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academyReviewRequestsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyReviewRequestsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyReviewRequestsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyReviewRequestsRetrieve>>> = ({ signal }) => academyReviewRequestsRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyReviewRequestsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyReviewRequestsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academyReviewRequestsRetrieve>>>
export type AcademyReviewRequestsRetrieveQueryError = unknown


export function useAcademyReviewRequestsRetrieve<TData = Awaited<ReturnType<typeof academyReviewRequestsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyReviewRequestsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyReviewRequestsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyReviewRequestsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyReviewRequestsRetrieve<TData = Awaited<ReturnType<typeof academyReviewRequestsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyReviewRequestsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyReviewRequestsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyReviewRequestsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyReviewRequestsRetrieve<TData = Awaited<ReturnType<typeof academyReviewRequestsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyReviewRequestsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyReviewRequestsRetrieve<TData = Awaited<ReturnType<typeof academyReviewRequestsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyReviewRequestsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyReviewRequestsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Review requests in the grading queue (D-124): the most urgent first, with the time left
before the promised deadline; a trainer sees only the exams of their language (D-120).
 */
export type academyReviewRequestsCompleteCreateResponse200 = {
  data: TrainerReviewRequest
  status: 200
}
    
export type academyReviewRequestsCompleteCreateResponseSuccess = (academyReviewRequestsCompleteCreateResponse200) & {
  headers: Headers;
};
;

export type academyReviewRequestsCompleteCreateResponse = (academyReviewRequestsCompleteCreateResponseSuccess)

export const getAcademyReviewRequestsCompleteCreateUrl = (id: string,) => {


  

  return `/api/v1/academy/review-requests/${id}/complete/`
}

export const academyReviewRequestsCompleteCreate = async (id: string,
    completeReviewRequest: CompleteReviewRequest, options?: RequestInit): Promise<academyReviewRequestsCompleteCreateResponse> => {
  
  return apiFetch<academyReviewRequestsCompleteCreateResponse>(getAcademyReviewRequestsCompleteCreateUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      completeReviewRequest,)
  }
);}




export const getAcademyReviewRequestsCompleteCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyReviewRequestsCompleteCreate>>, TError,{id: string;data: CompleteReviewRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyReviewRequestsCompleteCreate>>, TError,{id: string;data: CompleteReviewRequest}, TContext> => {

const mutationKey = ['academyReviewRequestsCompleteCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyReviewRequestsCompleteCreate>>, {id: string;data: CompleteReviewRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  academyReviewRequestsCompleteCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyReviewRequestsCompleteCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyReviewRequestsCompleteCreate>>>
    export type AcademyReviewRequestsCompleteCreateMutationBody = CompleteReviewRequest
    export type AcademyReviewRequestsCompleteCreateMutationError = unknown

    export const useAcademyReviewRequestsCompleteCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyReviewRequestsCompleteCreate>>, TError,{id: string;data: CompleteReviewRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyReviewRequestsCompleteCreate>>,
        TError,
        {id: string;data: CompleteReviewRequest},
        TContext
      > => {

      const mutationOptions = getAcademyReviewRequestsCompleteCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Review requests in the grading queue (D-124): the most urgent first, with the time left
before the promised deadline; a trainer sees only the exams of their language (D-120).
 */
export type academyReviewRequestsStatsRetrieveResponse200 = {
  data: ReviewStats
  status: 200
}
    
export type academyReviewRequestsStatsRetrieveResponseSuccess = (academyReviewRequestsStatsRetrieveResponse200) & {
  headers: Headers;
};
;

export type academyReviewRequestsStatsRetrieveResponse = (academyReviewRequestsStatsRetrieveResponseSuccess)

export const getAcademyReviewRequestsStatsRetrieveUrl = (params?: AcademyReviewRequestsStatsRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/review-requests/stats/?${stringifiedParams}` : `/api/v1/academy/review-requests/stats/`
}

export const academyReviewRequestsStatsRetrieve = async (params?: AcademyReviewRequestsStatsRetrieveParams, options?: RequestInit): Promise<academyReviewRequestsStatsRetrieveResponse> => {
  
  return apiFetch<academyReviewRequestsStatsRetrieveResponse>(getAcademyReviewRequestsStatsRetrieveUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyReviewRequestsStatsRetrieveQueryKey = (params?: AcademyReviewRequestsStatsRetrieveParams,) => {
    return [
    `/api/v1/academy/review-requests/stats/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAcademyReviewRequestsStatsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academyReviewRequestsStatsRetrieve>>, TError = unknown>(params?: AcademyReviewRequestsStatsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyReviewRequestsStatsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyReviewRequestsStatsRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyReviewRequestsStatsRetrieve>>> = ({ signal }) => academyReviewRequestsStatsRetrieve(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyReviewRequestsStatsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyReviewRequestsStatsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academyReviewRequestsStatsRetrieve>>>
export type AcademyReviewRequestsStatsRetrieveQueryError = unknown


export function useAcademyReviewRequestsStatsRetrieve<TData = Awaited<ReturnType<typeof academyReviewRequestsStatsRetrieve>>, TError = unknown>(
 params: undefined |  AcademyReviewRequestsStatsRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyReviewRequestsStatsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyReviewRequestsStatsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyReviewRequestsStatsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyReviewRequestsStatsRetrieve<TData = Awaited<ReturnType<typeof academyReviewRequestsStatsRetrieve>>, TError = unknown>(
 params?: AcademyReviewRequestsStatsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyReviewRequestsStatsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyReviewRequestsStatsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyReviewRequestsStatsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyReviewRequestsStatsRetrieve<TData = Awaited<ReturnType<typeof academyReviewRequestsStatsRetrieve>>, TError = unknown>(
 params?: AcademyReviewRequestsStatsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyReviewRequestsStatsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyReviewRequestsStatsRetrieve<TData = Awaited<ReturnType<typeof academyReviewRequestsStatsRetrieve>>, TError = unknown>(
 params?: AcademyReviewRequestsStatsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyReviewRequestsStatsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyReviewRequestsStatsRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * ISO 3166-1 codes accepted at sign-up (names are translated by the apps).
 */
export type academySalesCountriesRetrieveResponse200 = {
  data: AcademyCountries
  status: 200
}
    
export type academySalesCountriesRetrieveResponseSuccess = (academySalesCountriesRetrieveResponse200) & {
  headers: Headers;
};
;

export type academySalesCountriesRetrieveResponse = (academySalesCountriesRetrieveResponseSuccess)

export const getAcademySalesCountriesRetrieveUrl = () => {


  

  return `/api/v1/academy/sales/countries/`
}

export const academySalesCountriesRetrieve = async ( options?: RequestInit): Promise<academySalesCountriesRetrieveResponse> => {
  
  return apiFetch<academySalesCountriesRetrieveResponse>(getAcademySalesCountriesRetrieveUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademySalesCountriesRetrieveQueryKey = () => {
    return [
    `/api/v1/academy/sales/countries/`
    ] as const;
    }

    
export const getAcademySalesCountriesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academySalesCountriesRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academySalesCountriesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademySalesCountriesRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academySalesCountriesRetrieve>>> = ({ signal }) => academySalesCountriesRetrieve({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academySalesCountriesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademySalesCountriesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academySalesCountriesRetrieve>>>
export type AcademySalesCountriesRetrieveQueryError = unknown


export function useAcademySalesCountriesRetrieve<TData = Awaited<ReturnType<typeof academySalesCountriesRetrieve>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academySalesCountriesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academySalesCountriesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academySalesCountriesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademySalesCountriesRetrieve<TData = Awaited<ReturnType<typeof academySalesCountriesRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academySalesCountriesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academySalesCountriesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academySalesCountriesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademySalesCountriesRetrieve<TData = Awaited<ReturnType<typeof academySalesCountriesRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academySalesCountriesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademySalesCountriesRetrieve<TData = Awaited<ReturnType<typeof academySalesCountriesRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academySalesCountriesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademySalesCountriesRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * The Academy Pass as sold (public: the price is displayed, D-110), with the payment methods
of `?country=` and the indicative prices.
 */
export type academySalesOfferRetrieveResponse200 = {
  data: AcademyOffer
  status: 200
}
    
export type academySalesOfferRetrieveResponseSuccess = (academySalesOfferRetrieveResponse200) & {
  headers: Headers;
};
;

export type academySalesOfferRetrieveResponse = (academySalesOfferRetrieveResponseSuccess)

export const getAcademySalesOfferRetrieveUrl = (params?: AcademySalesOfferRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/sales/offer/?${stringifiedParams}` : `/api/v1/academy/sales/offer/`
}

export const academySalesOfferRetrieve = async (params?: AcademySalesOfferRetrieveParams, options?: RequestInit): Promise<academySalesOfferRetrieveResponse> => {
  
  return apiFetch<academySalesOfferRetrieveResponse>(getAcademySalesOfferRetrieveUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademySalesOfferRetrieveQueryKey = (params?: AcademySalesOfferRetrieveParams,) => {
    return [
    `/api/v1/academy/sales/offer/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAcademySalesOfferRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academySalesOfferRetrieve>>, TError = unknown>(params?: AcademySalesOfferRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academySalesOfferRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademySalesOfferRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academySalesOfferRetrieve>>> = ({ signal }) => academySalesOfferRetrieve(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academySalesOfferRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademySalesOfferRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academySalesOfferRetrieve>>>
export type AcademySalesOfferRetrieveQueryError = unknown


export function useAcademySalesOfferRetrieve<TData = Awaited<ReturnType<typeof academySalesOfferRetrieve>>, TError = unknown>(
 params: undefined |  AcademySalesOfferRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academySalesOfferRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academySalesOfferRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academySalesOfferRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademySalesOfferRetrieve<TData = Awaited<ReturnType<typeof academySalesOfferRetrieve>>, TError = unknown>(
 params?: AcademySalesOfferRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academySalesOfferRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academySalesOfferRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academySalesOfferRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademySalesOfferRetrieve<TData = Awaited<ReturnType<typeof academySalesOfferRetrieve>>, TError = unknown>(
 params?: AcademySalesOfferRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academySalesOfferRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademySalesOfferRetrieve<TData = Awaited<ReturnType<typeof academySalesOfferRetrieve>>, TError = unknown>(
 params?: AcademySalesOfferRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academySalesOfferRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademySalesOfferRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Promo codes (generic engine, off until the owner turns it on in the settings).
 */
export type academySalesPromoCodesListResponse200 = {
  data: PaginatedPromoCodeList
  status: 200
}
    
export type academySalesPromoCodesListResponseSuccess = (academySalesPromoCodesListResponse200) & {
  headers: Headers;
};
;

export type academySalesPromoCodesListResponse = (academySalesPromoCodesListResponseSuccess)

export const getAcademySalesPromoCodesListUrl = (params?: AcademySalesPromoCodesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/sales/promo-codes/?${stringifiedParams}` : `/api/v1/academy/sales/promo-codes/`
}

export const academySalesPromoCodesList = async (params?: AcademySalesPromoCodesListParams, options?: RequestInit): Promise<academySalesPromoCodesListResponse> => {
  
  return apiFetch<academySalesPromoCodesListResponse>(getAcademySalesPromoCodesListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademySalesPromoCodesListQueryKey = (params?: AcademySalesPromoCodesListParams,) => {
    return [
    `/api/v1/academy/sales/promo-codes/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAcademySalesPromoCodesListQueryOptions = <TData = Awaited<ReturnType<typeof academySalesPromoCodesList>>, TError = unknown>(params?: AcademySalesPromoCodesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academySalesPromoCodesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademySalesPromoCodesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academySalesPromoCodesList>>> = ({ signal }) => academySalesPromoCodesList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academySalesPromoCodesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademySalesPromoCodesListQueryResult = NonNullable<Awaited<ReturnType<typeof academySalesPromoCodesList>>>
export type AcademySalesPromoCodesListQueryError = unknown


export function useAcademySalesPromoCodesList<TData = Awaited<ReturnType<typeof academySalesPromoCodesList>>, TError = unknown>(
 params: undefined |  AcademySalesPromoCodesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academySalesPromoCodesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academySalesPromoCodesList>>,
          TError,
          Awaited<ReturnType<typeof academySalesPromoCodesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademySalesPromoCodesList<TData = Awaited<ReturnType<typeof academySalesPromoCodesList>>, TError = unknown>(
 params?: AcademySalesPromoCodesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academySalesPromoCodesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academySalesPromoCodesList>>,
          TError,
          Awaited<ReturnType<typeof academySalesPromoCodesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademySalesPromoCodesList<TData = Awaited<ReturnType<typeof academySalesPromoCodesList>>, TError = unknown>(
 params?: AcademySalesPromoCodesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academySalesPromoCodesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademySalesPromoCodesList<TData = Awaited<ReturnType<typeof academySalesPromoCodesList>>, TError = unknown>(
 params?: AcademySalesPromoCodesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academySalesPromoCodesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademySalesPromoCodesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Promo codes (generic engine, off until the owner turns it on in the settings).
 */
export type academySalesPromoCodesCreateResponse201 = {
  data: PromoCode
  status: 201
}
    
export type academySalesPromoCodesCreateResponseSuccess = (academySalesPromoCodesCreateResponse201) & {
  headers: Headers;
};
;

export type academySalesPromoCodesCreateResponse = (academySalesPromoCodesCreateResponseSuccess)

export const getAcademySalesPromoCodesCreateUrl = () => {


  

  return `/api/v1/academy/sales/promo-codes/`
}

export const academySalesPromoCodesCreate = async (promoCodeRequest: PromoCodeRequest, options?: RequestInit): Promise<academySalesPromoCodesCreateResponse> => {
  
  return apiFetch<academySalesPromoCodesCreateResponse>(getAcademySalesPromoCodesCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      promoCodeRequest,)
  }
);}




export const getAcademySalesPromoCodesCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academySalesPromoCodesCreate>>, TError,{data: PromoCodeRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academySalesPromoCodesCreate>>, TError,{data: PromoCodeRequest}, TContext> => {

const mutationKey = ['academySalesPromoCodesCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academySalesPromoCodesCreate>>, {data: PromoCodeRequest}> = (props) => {
          const {data} = props ?? {};

          return  academySalesPromoCodesCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademySalesPromoCodesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academySalesPromoCodesCreate>>>
    export type AcademySalesPromoCodesCreateMutationBody = PromoCodeRequest
    export type AcademySalesPromoCodesCreateMutationError = unknown

    export const useAcademySalesPromoCodesCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academySalesPromoCodesCreate>>, TError,{data: PromoCodeRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academySalesPromoCodesCreate>>,
        TError,
        {data: PromoCodeRequest},
        TContext
      > => {

      const mutationOptions = getAcademySalesPromoCodesCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Promo codes (generic engine, off until the owner turns it on in the settings).
 */
export type academySalesPromoCodesRetrieveResponse200 = {
  data: PromoCode
  status: 200
}
    
export type academySalesPromoCodesRetrieveResponseSuccess = (academySalesPromoCodesRetrieveResponse200) & {
  headers: Headers;
};
;

export type academySalesPromoCodesRetrieveResponse = (academySalesPromoCodesRetrieveResponseSuccess)

export const getAcademySalesPromoCodesRetrieveUrl = (id: string,) => {


  

  return `/api/v1/academy/sales/promo-codes/${id}/`
}

export const academySalesPromoCodesRetrieve = async (id: string, options?: RequestInit): Promise<academySalesPromoCodesRetrieveResponse> => {
  
  return apiFetch<academySalesPromoCodesRetrieveResponse>(getAcademySalesPromoCodesRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademySalesPromoCodesRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/academy/sales/promo-codes/${id}/`
    ] as const;
    }

    
export const getAcademySalesPromoCodesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academySalesPromoCodesRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academySalesPromoCodesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademySalesPromoCodesRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academySalesPromoCodesRetrieve>>> = ({ signal }) => academySalesPromoCodesRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academySalesPromoCodesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademySalesPromoCodesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academySalesPromoCodesRetrieve>>>
export type AcademySalesPromoCodesRetrieveQueryError = unknown


export function useAcademySalesPromoCodesRetrieve<TData = Awaited<ReturnType<typeof academySalesPromoCodesRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academySalesPromoCodesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academySalesPromoCodesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academySalesPromoCodesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademySalesPromoCodesRetrieve<TData = Awaited<ReturnType<typeof academySalesPromoCodesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academySalesPromoCodesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academySalesPromoCodesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academySalesPromoCodesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademySalesPromoCodesRetrieve<TData = Awaited<ReturnType<typeof academySalesPromoCodesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academySalesPromoCodesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademySalesPromoCodesRetrieve<TData = Awaited<ReturnType<typeof academySalesPromoCodesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academySalesPromoCodesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademySalesPromoCodesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Promo codes (generic engine, off until the owner turns it on in the settings).
 */
export type academySalesPromoCodesPartialUpdateResponse200 = {
  data: PromoCode
  status: 200
}
    
export type academySalesPromoCodesPartialUpdateResponseSuccess = (academySalesPromoCodesPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type academySalesPromoCodesPartialUpdateResponse = (academySalesPromoCodesPartialUpdateResponseSuccess)

export const getAcademySalesPromoCodesPartialUpdateUrl = (id: string,) => {


  

  return `/api/v1/academy/sales/promo-codes/${id}/`
}

export const academySalesPromoCodesPartialUpdate = async (id: string,
    patchedPromoCodeRequest: PatchedPromoCodeRequest, options?: RequestInit): Promise<academySalesPromoCodesPartialUpdateResponse> => {
  
  return apiFetch<academySalesPromoCodesPartialUpdateResponse>(getAcademySalesPromoCodesPartialUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedPromoCodeRequest,)
  }
);}




export const getAcademySalesPromoCodesPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academySalesPromoCodesPartialUpdate>>, TError,{id: string;data: PatchedPromoCodeRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academySalesPromoCodesPartialUpdate>>, TError,{id: string;data: PatchedPromoCodeRequest}, TContext> => {

const mutationKey = ['academySalesPromoCodesPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academySalesPromoCodesPartialUpdate>>, {id: string;data: PatchedPromoCodeRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  academySalesPromoCodesPartialUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademySalesPromoCodesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof academySalesPromoCodesPartialUpdate>>>
    export type AcademySalesPromoCodesPartialUpdateMutationBody = PatchedPromoCodeRequest
    export type AcademySalesPromoCodesPartialUpdateMutationError = unknown

    export const useAcademySalesPromoCodesPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academySalesPromoCodesPartialUpdate>>, TError,{id: string;data: PatchedPromoCodeRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academySalesPromoCodesPartialUpdate>>,
        TError,
        {id: string;data: PatchedPromoCodeRequest},
        TContext
      > => {

      const mutationOptions = getAcademySalesPromoCodesPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * The published reviews of the agency's Academy (public), with the rating only from the
threshold of real published reviews.
 */
export type academySalesReviewsRetrieveResponse200 = {
  data: PublicReviews
  status: 200
}
    
export type academySalesReviewsRetrieveResponseSuccess = (academySalesReviewsRetrieveResponse200) & {
  headers: Headers;
};
;

export type academySalesReviewsRetrieveResponse = (academySalesReviewsRetrieveResponseSuccess)

export const getAcademySalesReviewsRetrieveUrl = (params?: AcademySalesReviewsRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/sales/reviews/?${stringifiedParams}` : `/api/v1/academy/sales/reviews/`
}

export const academySalesReviewsRetrieve = async (params?: AcademySalesReviewsRetrieveParams, options?: RequestInit): Promise<academySalesReviewsRetrieveResponse> => {
  
  return apiFetch<academySalesReviewsRetrieveResponse>(getAcademySalesReviewsRetrieveUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademySalesReviewsRetrieveQueryKey = (params?: AcademySalesReviewsRetrieveParams,) => {
    return [
    `/api/v1/academy/sales/reviews/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAcademySalesReviewsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academySalesReviewsRetrieve>>, TError = unknown>(params?: AcademySalesReviewsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academySalesReviewsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademySalesReviewsRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academySalesReviewsRetrieve>>> = ({ signal }) => academySalesReviewsRetrieve(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academySalesReviewsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademySalesReviewsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academySalesReviewsRetrieve>>>
export type AcademySalesReviewsRetrieveQueryError = unknown


export function useAcademySalesReviewsRetrieve<TData = Awaited<ReturnType<typeof academySalesReviewsRetrieve>>, TError = unknown>(
 params: undefined |  AcademySalesReviewsRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academySalesReviewsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academySalesReviewsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academySalesReviewsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademySalesReviewsRetrieve<TData = Awaited<ReturnType<typeof academySalesReviewsRetrieve>>, TError = unknown>(
 params?: AcademySalesReviewsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academySalesReviewsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academySalesReviewsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academySalesReviewsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademySalesReviewsRetrieve<TData = Awaited<ReturnType<typeof academySalesReviewsRetrieve>>, TError = unknown>(
 params?: AcademySalesReviewsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academySalesReviewsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademySalesReviewsRetrieve<TData = Awaited<ReturnType<typeof academySalesReviewsRetrieve>>, TError = unknown>(
 params?: AcademySalesReviewsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academySalesReviewsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademySalesReviewsRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Sales dashboard of the month: subscribers, trials, conversions, revenue, renewals, by
country, by payment method and by UTM source.
 */
export type academySalesStatsRetrieveResponse200 = {
  data: AcademySalesStatsRetrieve200
  status: 200
}
    
export type academySalesStatsRetrieveResponseSuccess = (academySalesStatsRetrieveResponse200) & {
  headers: Headers;
};
;

export type academySalesStatsRetrieveResponse = (academySalesStatsRetrieveResponseSuccess)

export const getAcademySalesStatsRetrieveUrl = (params?: AcademySalesStatsRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/sales/stats/?${stringifiedParams}` : `/api/v1/academy/sales/stats/`
}

export const academySalesStatsRetrieve = async (params?: AcademySalesStatsRetrieveParams, options?: RequestInit): Promise<academySalesStatsRetrieveResponse> => {
  
  return apiFetch<academySalesStatsRetrieveResponse>(getAcademySalesStatsRetrieveUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademySalesStatsRetrieveQueryKey = (params?: AcademySalesStatsRetrieveParams,) => {
    return [
    `/api/v1/academy/sales/stats/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAcademySalesStatsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academySalesStatsRetrieve>>, TError = unknown>(params?: AcademySalesStatsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academySalesStatsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademySalesStatsRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academySalesStatsRetrieve>>> = ({ signal }) => academySalesStatsRetrieve(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academySalesStatsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademySalesStatsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academySalesStatsRetrieve>>>
export type AcademySalesStatsRetrieveQueryError = unknown


export function useAcademySalesStatsRetrieve<TData = Awaited<ReturnType<typeof academySalesStatsRetrieve>>, TError = unknown>(
 params: undefined |  AcademySalesStatsRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academySalesStatsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academySalesStatsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academySalesStatsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademySalesStatsRetrieve<TData = Awaited<ReturnType<typeof academySalesStatsRetrieve>>, TError = unknown>(
 params?: AcademySalesStatsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academySalesStatsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academySalesStatsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academySalesStatsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademySalesStatsRetrieve<TData = Awaited<ReturnType<typeof academySalesStatsRetrieve>>, TError = unknown>(
 params?: AcademySalesStatsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academySalesStatsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademySalesStatsRetrieve<TData = Awaited<ReturnType<typeof academySalesStatsRetrieve>>, TError = unknown>(
 params?: AcademySalesStatsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academySalesStatsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademySalesStatsRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Every Academy subscription, with a manual extension and a recorded refund.
 */
export type academySalesSubscriptionsListResponse200 = {
  data: PaginatedSubscriptionAdminList
  status: 200
}
    
export type academySalesSubscriptionsListResponseSuccess = (academySalesSubscriptionsListResponse200) & {
  headers: Headers;
};
;

export type academySalesSubscriptionsListResponse = (academySalesSubscriptionsListResponseSuccess)

export const getAcademySalesSubscriptionsListUrl = (params?: AcademySalesSubscriptionsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/sales/subscriptions/?${stringifiedParams}` : `/api/v1/academy/sales/subscriptions/`
}

export const academySalesSubscriptionsList = async (params?: AcademySalesSubscriptionsListParams, options?: RequestInit): Promise<academySalesSubscriptionsListResponse> => {
  
  return apiFetch<academySalesSubscriptionsListResponse>(getAcademySalesSubscriptionsListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademySalesSubscriptionsListQueryKey = (params?: AcademySalesSubscriptionsListParams,) => {
    return [
    `/api/v1/academy/sales/subscriptions/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAcademySalesSubscriptionsListQueryOptions = <TData = Awaited<ReturnType<typeof academySalesSubscriptionsList>>, TError = unknown>(params?: AcademySalesSubscriptionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academySalesSubscriptionsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademySalesSubscriptionsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academySalesSubscriptionsList>>> = ({ signal }) => academySalesSubscriptionsList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academySalesSubscriptionsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademySalesSubscriptionsListQueryResult = NonNullable<Awaited<ReturnType<typeof academySalesSubscriptionsList>>>
export type AcademySalesSubscriptionsListQueryError = unknown


export function useAcademySalesSubscriptionsList<TData = Awaited<ReturnType<typeof academySalesSubscriptionsList>>, TError = unknown>(
 params: undefined |  AcademySalesSubscriptionsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academySalesSubscriptionsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academySalesSubscriptionsList>>,
          TError,
          Awaited<ReturnType<typeof academySalesSubscriptionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademySalesSubscriptionsList<TData = Awaited<ReturnType<typeof academySalesSubscriptionsList>>, TError = unknown>(
 params?: AcademySalesSubscriptionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academySalesSubscriptionsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academySalesSubscriptionsList>>,
          TError,
          Awaited<ReturnType<typeof academySalesSubscriptionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademySalesSubscriptionsList<TData = Awaited<ReturnType<typeof academySalesSubscriptionsList>>, TError = unknown>(
 params?: AcademySalesSubscriptionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academySalesSubscriptionsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademySalesSubscriptionsList<TData = Awaited<ReturnType<typeof academySalesSubscriptionsList>>, TError = unknown>(
 params?: AcademySalesSubscriptionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academySalesSubscriptionsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademySalesSubscriptionsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Every Academy subscription, with a manual extension and a recorded refund.
 */
export type academySalesSubscriptionsRetrieveResponse200 = {
  data: SubscriptionAdmin
  status: 200
}
    
export type academySalesSubscriptionsRetrieveResponseSuccess = (academySalesSubscriptionsRetrieveResponse200) & {
  headers: Headers;
};
;

export type academySalesSubscriptionsRetrieveResponse = (academySalesSubscriptionsRetrieveResponseSuccess)

export const getAcademySalesSubscriptionsRetrieveUrl = (id: string,
    params?: AcademySalesSubscriptionsRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/sales/subscriptions/${id}/?${stringifiedParams}` : `/api/v1/academy/sales/subscriptions/${id}/`
}

export const academySalesSubscriptionsRetrieve = async (id: string,
    params?: AcademySalesSubscriptionsRetrieveParams, options?: RequestInit): Promise<academySalesSubscriptionsRetrieveResponse> => {
  
  return apiFetch<academySalesSubscriptionsRetrieveResponse>(getAcademySalesSubscriptionsRetrieveUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademySalesSubscriptionsRetrieveQueryKey = (id?: string,
    params?: AcademySalesSubscriptionsRetrieveParams,) => {
    return [
    `/api/v1/academy/sales/subscriptions/${id}/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAcademySalesSubscriptionsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academySalesSubscriptionsRetrieve>>, TError = unknown>(id: string,
    params?: AcademySalesSubscriptionsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academySalesSubscriptionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademySalesSubscriptionsRetrieveQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academySalesSubscriptionsRetrieve>>> = ({ signal }) => academySalesSubscriptionsRetrieve(id,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academySalesSubscriptionsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademySalesSubscriptionsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academySalesSubscriptionsRetrieve>>>
export type AcademySalesSubscriptionsRetrieveQueryError = unknown


export function useAcademySalesSubscriptionsRetrieve<TData = Awaited<ReturnType<typeof academySalesSubscriptionsRetrieve>>, TError = unknown>(
 id: string,
    params: undefined |  AcademySalesSubscriptionsRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academySalesSubscriptionsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academySalesSubscriptionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academySalesSubscriptionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademySalesSubscriptionsRetrieve<TData = Awaited<ReturnType<typeof academySalesSubscriptionsRetrieve>>, TError = unknown>(
 id: string,
    params?: AcademySalesSubscriptionsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academySalesSubscriptionsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academySalesSubscriptionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academySalesSubscriptionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademySalesSubscriptionsRetrieve<TData = Awaited<ReturnType<typeof academySalesSubscriptionsRetrieve>>, TError = unknown>(
 id: string,
    params?: AcademySalesSubscriptionsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academySalesSubscriptionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademySalesSubscriptionsRetrieve<TData = Awaited<ReturnType<typeof academySalesSubscriptionsRetrieve>>, TError = unknown>(
 id: string,
    params?: AcademySalesSubscriptionsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academySalesSubscriptionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademySalesSubscriptionsRetrieveQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Every Academy subscription, with a manual extension and a recorded refund.
 */
export type academySalesSubscriptionsExtendCreateResponse200 = {
  data: SubscriptionAdmin
  status: 200
}
    
export type academySalesSubscriptionsExtendCreateResponseSuccess = (academySalesSubscriptionsExtendCreateResponse200) & {
  headers: Headers;
};
;

export type academySalesSubscriptionsExtendCreateResponse = (academySalesSubscriptionsExtendCreateResponseSuccess)

export const getAcademySalesSubscriptionsExtendCreateUrl = (id: string,
    params?: AcademySalesSubscriptionsExtendCreateParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/sales/subscriptions/${id}/extend/?${stringifiedParams}` : `/api/v1/academy/sales/subscriptions/${id}/extend/`
}

export const academySalesSubscriptionsExtendCreate = async (id: string,
    extendRequest: ExtendRequest,
    params?: AcademySalesSubscriptionsExtendCreateParams, options?: RequestInit): Promise<academySalesSubscriptionsExtendCreateResponse> => {
  
  return apiFetch<academySalesSubscriptionsExtendCreateResponse>(getAcademySalesSubscriptionsExtendCreateUrl(id,params),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      extendRequest,)
  }
);}




export const getAcademySalesSubscriptionsExtendCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academySalesSubscriptionsExtendCreate>>, TError,{id: string;data: ExtendRequest;params?: AcademySalesSubscriptionsExtendCreateParams}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academySalesSubscriptionsExtendCreate>>, TError,{id: string;data: ExtendRequest;params?: AcademySalesSubscriptionsExtendCreateParams}, TContext> => {

const mutationKey = ['academySalesSubscriptionsExtendCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academySalesSubscriptionsExtendCreate>>, {id: string;data: ExtendRequest;params?: AcademySalesSubscriptionsExtendCreateParams}> = (props) => {
          const {id,data,params} = props ?? {};

          return  academySalesSubscriptionsExtendCreate(id,data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademySalesSubscriptionsExtendCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academySalesSubscriptionsExtendCreate>>>
    export type AcademySalesSubscriptionsExtendCreateMutationBody = ExtendRequest
    export type AcademySalesSubscriptionsExtendCreateMutationError = unknown

    export const useAcademySalesSubscriptionsExtendCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academySalesSubscriptionsExtendCreate>>, TError,{id: string;data: ExtendRequest;params?: AcademySalesSubscriptionsExtendCreateParams}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academySalesSubscriptionsExtendCreate>>,
        TError,
        {id: string;data: ExtendRequest;params?: AcademySalesSubscriptionsExtendCreateParams},
        TContext
      > => {

      const mutationOptions = getAcademySalesSubscriptionsExtendCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Every Academy subscription, with a manual extension and a recorded refund.
 */
export type academySalesSubscriptionsRefundCreateResponse200 = {
  data: SubscriptionAdmin
  status: 200
}
    
export type academySalesSubscriptionsRefundCreateResponseSuccess = (academySalesSubscriptionsRefundCreateResponse200) & {
  headers: Headers;
};
;

export type academySalesSubscriptionsRefundCreateResponse = (academySalesSubscriptionsRefundCreateResponseSuccess)

export const getAcademySalesSubscriptionsRefundCreateUrl = (id: string,
    params?: AcademySalesSubscriptionsRefundCreateParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/sales/subscriptions/${id}/refund/?${stringifiedParams}` : `/api/v1/academy/sales/subscriptions/${id}/refund/`
}

export const academySalesSubscriptionsRefundCreate = async (id: string,
    refundRequest: RefundRequest,
    params?: AcademySalesSubscriptionsRefundCreateParams, options?: RequestInit): Promise<academySalesSubscriptionsRefundCreateResponse> => {
  
  return apiFetch<academySalesSubscriptionsRefundCreateResponse>(getAcademySalesSubscriptionsRefundCreateUrl(id,params),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      refundRequest,)
  }
);}




export const getAcademySalesSubscriptionsRefundCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academySalesSubscriptionsRefundCreate>>, TError,{id: string;data: RefundRequest;params?: AcademySalesSubscriptionsRefundCreateParams}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academySalesSubscriptionsRefundCreate>>, TError,{id: string;data: RefundRequest;params?: AcademySalesSubscriptionsRefundCreateParams}, TContext> => {

const mutationKey = ['academySalesSubscriptionsRefundCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academySalesSubscriptionsRefundCreate>>, {id: string;data: RefundRequest;params?: AcademySalesSubscriptionsRefundCreateParams}> = (props) => {
          const {id,data,params} = props ?? {};

          return  academySalesSubscriptionsRefundCreate(id,data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademySalesSubscriptionsRefundCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academySalesSubscriptionsRefundCreate>>>
    export type AcademySalesSubscriptionsRefundCreateMutationBody = RefundRequest
    export type AcademySalesSubscriptionsRefundCreateMutationError = unknown

    export const useAcademySalesSubscriptionsRefundCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academySalesSubscriptionsRefundCreate>>, TError,{id: string;data: RefundRequest;params?: AcademySalesSubscriptionsRefundCreateParams}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academySalesSubscriptionsRefundCreate>>,
        TError,
        {id: string;data: RefundRequest;params?: AcademySalesSubscriptionsRefundCreateParams},
        TContext
      > => {

      const mutationOptions = getAcademySalesSubscriptionsRefundCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type academySettingsListResponse200 = {
  data: PaginatedAcademySettingsList
  status: 200
}
    
export type academySettingsListResponseSuccess = (academySettingsListResponse200) & {
  headers: Headers;
};
;

export type academySettingsListResponse = (academySettingsListResponseSuccess)

export const getAcademySettingsListUrl = (params?: AcademySettingsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/settings/?${stringifiedParams}` : `/api/v1/academy/settings/`
}

export const academySettingsList = async (params?: AcademySettingsListParams, options?: RequestInit): Promise<academySettingsListResponse> => {
  
  return apiFetch<academySettingsListResponse>(getAcademySettingsListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademySettingsListQueryKey = (params?: AcademySettingsListParams,) => {
    return [
    `/api/v1/academy/settings/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAcademySettingsListQueryOptions = <TData = Awaited<ReturnType<typeof academySettingsList>>, TError = unknown>(params?: AcademySettingsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academySettingsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademySettingsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academySettingsList>>> = ({ signal }) => academySettingsList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academySettingsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademySettingsListQueryResult = NonNullable<Awaited<ReturnType<typeof academySettingsList>>>
export type AcademySettingsListQueryError = unknown


export function useAcademySettingsList<TData = Awaited<ReturnType<typeof academySettingsList>>, TError = unknown>(
 params: undefined |  AcademySettingsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academySettingsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academySettingsList>>,
          TError,
          Awaited<ReturnType<typeof academySettingsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademySettingsList<TData = Awaited<ReturnType<typeof academySettingsList>>, TError = unknown>(
 params?: AcademySettingsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academySettingsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academySettingsList>>,
          TError,
          Awaited<ReturnType<typeof academySettingsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademySettingsList<TData = Awaited<ReturnType<typeof academySettingsList>>, TError = unknown>(
 params?: AcademySettingsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academySettingsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademySettingsList<TData = Awaited<ReturnType<typeof academySettingsList>>, TError = unknown>(
 params?: AcademySettingsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academySettingsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademySettingsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type academySettingsRetrieveResponse200 = {
  data: AcademySettings
  status: 200
}
    
export type academySettingsRetrieveResponseSuccess = (academySettingsRetrieveResponse200) & {
  headers: Headers;
};
;

export type academySettingsRetrieveResponse = (academySettingsRetrieveResponseSuccess)

export const getAcademySettingsRetrieveUrl = (id: string,) => {


  

  return `/api/v1/academy/settings/${id}/`
}

export const academySettingsRetrieve = async (id: string, options?: RequestInit): Promise<academySettingsRetrieveResponse> => {
  
  return apiFetch<academySettingsRetrieveResponse>(getAcademySettingsRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademySettingsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/academy/settings/${id}/`
    ] as const;
    }

    
export const getAcademySettingsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academySettingsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academySettingsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademySettingsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academySettingsRetrieve>>> = ({ signal }) => academySettingsRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academySettingsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademySettingsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academySettingsRetrieve>>>
export type AcademySettingsRetrieveQueryError = unknown


export function useAcademySettingsRetrieve<TData = Awaited<ReturnType<typeof academySettingsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academySettingsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academySettingsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academySettingsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademySettingsRetrieve<TData = Awaited<ReturnType<typeof academySettingsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academySettingsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academySettingsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academySettingsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademySettingsRetrieve<TData = Awaited<ReturnType<typeof academySettingsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academySettingsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademySettingsRetrieve<TData = Awaited<ReturnType<typeof academySettingsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academySettingsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademySettingsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type academySettingsPartialUpdateResponse200 = {
  data: AcademySettings
  status: 200
}
    
export type academySettingsPartialUpdateResponseSuccess = (academySettingsPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type academySettingsPartialUpdateResponse = (academySettingsPartialUpdateResponseSuccess)

export const getAcademySettingsPartialUpdateUrl = (id: string,) => {


  

  return `/api/v1/academy/settings/${id}/`
}

export const academySettingsPartialUpdate = async (id: string,
    patchedAcademySettingsRequest: PatchedAcademySettingsRequest, options?: RequestInit): Promise<academySettingsPartialUpdateResponse> => {
  
  return apiFetch<academySettingsPartialUpdateResponse>(getAcademySettingsPartialUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedAcademySettingsRequest,)
  }
);}




export const getAcademySettingsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academySettingsPartialUpdate>>, TError,{id: string;data: PatchedAcademySettingsRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academySettingsPartialUpdate>>, TError,{id: string;data: PatchedAcademySettingsRequest}, TContext> => {

const mutationKey = ['academySettingsPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academySettingsPartialUpdate>>, {id: string;data: PatchedAcademySettingsRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  academySettingsPartialUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademySettingsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof academySettingsPartialUpdate>>>
    export type AcademySettingsPartialUpdateMutationBody = PatchedAcademySettingsRequest
    export type AcademySettingsPartialUpdateMutationError = unknown

    export const useAcademySettingsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academySettingsPartialUpdate>>, TError,{id: string;data: PatchedAcademySettingsRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academySettingsPartialUpdate>>,
        TError,
        {id: string;data: PatchedAcademySettingsRequest},
        TContext
      > => {

      const mutationOptions = getAcademySettingsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type academySourcesListResponse200 = {
  data: PaginatedKnownSourceList
  status: 200
}
    
export type academySourcesListResponseSuccess = (academySourcesListResponse200) & {
  headers: Headers;
};
;

export type academySourcesListResponse = (academySourcesListResponseSuccess)

export const getAcademySourcesListUrl = (params?: AcademySourcesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/sources/?${stringifiedParams}` : `/api/v1/academy/sources/`
}

export const academySourcesList = async (params?: AcademySourcesListParams, options?: RequestInit): Promise<academySourcesListResponse> => {
  
  return apiFetch<academySourcesListResponse>(getAcademySourcesListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademySourcesListQueryKey = (params?: AcademySourcesListParams,) => {
    return [
    `/api/v1/academy/sources/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAcademySourcesListQueryOptions = <TData = Awaited<ReturnType<typeof academySourcesList>>, TError = unknown>(params?: AcademySourcesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academySourcesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademySourcesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academySourcesList>>> = ({ signal }) => academySourcesList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academySourcesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademySourcesListQueryResult = NonNullable<Awaited<ReturnType<typeof academySourcesList>>>
export type AcademySourcesListQueryError = unknown


export function useAcademySourcesList<TData = Awaited<ReturnType<typeof academySourcesList>>, TError = unknown>(
 params: undefined |  AcademySourcesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academySourcesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academySourcesList>>,
          TError,
          Awaited<ReturnType<typeof academySourcesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademySourcesList<TData = Awaited<ReturnType<typeof academySourcesList>>, TError = unknown>(
 params?: AcademySourcesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academySourcesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academySourcesList>>,
          TError,
          Awaited<ReturnType<typeof academySourcesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademySourcesList<TData = Awaited<ReturnType<typeof academySourcesList>>, TError = unknown>(
 params?: AcademySourcesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academySourcesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademySourcesList<TData = Awaited<ReturnType<typeof academySourcesList>>, TError = unknown>(
 params?: AcademySourcesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academySourcesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademySourcesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type academySourcesCreateResponse201 = {
  data: KnownSource
  status: 201
}
    
export type academySourcesCreateResponseSuccess = (academySourcesCreateResponse201) & {
  headers: Headers;
};
;

export type academySourcesCreateResponse = (academySourcesCreateResponseSuccess)

export const getAcademySourcesCreateUrl = () => {


  

  return `/api/v1/academy/sources/`
}

export const academySourcesCreate = async (knownSourceRequest: KnownSourceRequest, options?: RequestInit): Promise<academySourcesCreateResponse> => {
  
  return apiFetch<academySourcesCreateResponse>(getAcademySourcesCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      knownSourceRequest,)
  }
);}




export const getAcademySourcesCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academySourcesCreate>>, TError,{data: KnownSourceRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academySourcesCreate>>, TError,{data: KnownSourceRequest}, TContext> => {

const mutationKey = ['academySourcesCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academySourcesCreate>>, {data: KnownSourceRequest}> = (props) => {
          const {data} = props ?? {};

          return  academySourcesCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademySourcesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academySourcesCreate>>>
    export type AcademySourcesCreateMutationBody = KnownSourceRequest
    export type AcademySourcesCreateMutationError = unknown

    export const useAcademySourcesCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academySourcesCreate>>, TError,{data: KnownSourceRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academySourcesCreate>>,
        TError,
        {data: KnownSourceRequest},
        TContext
      > => {

      const mutationOptions = getAcademySourcesCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type academySourcesRetrieveResponse200 = {
  data: KnownSource
  status: 200
}
    
export type academySourcesRetrieveResponseSuccess = (academySourcesRetrieveResponse200) & {
  headers: Headers;
};
;

export type academySourcesRetrieveResponse = (academySourcesRetrieveResponseSuccess)

export const getAcademySourcesRetrieveUrl = (id: string,) => {


  

  return `/api/v1/academy/sources/${id}/`
}

export const academySourcesRetrieve = async (id: string, options?: RequestInit): Promise<academySourcesRetrieveResponse> => {
  
  return apiFetch<academySourcesRetrieveResponse>(getAcademySourcesRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademySourcesRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/academy/sources/${id}/`
    ] as const;
    }

    
export const getAcademySourcesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academySourcesRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academySourcesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademySourcesRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academySourcesRetrieve>>> = ({ signal }) => academySourcesRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academySourcesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademySourcesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academySourcesRetrieve>>>
export type AcademySourcesRetrieveQueryError = unknown


export function useAcademySourcesRetrieve<TData = Awaited<ReturnType<typeof academySourcesRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academySourcesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academySourcesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academySourcesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademySourcesRetrieve<TData = Awaited<ReturnType<typeof academySourcesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academySourcesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academySourcesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academySourcesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademySourcesRetrieve<TData = Awaited<ReturnType<typeof academySourcesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academySourcesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademySourcesRetrieve<TData = Awaited<ReturnType<typeof academySourcesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academySourcesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademySourcesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type academySourcesPartialUpdateResponse200 = {
  data: KnownSource
  status: 200
}
    
export type academySourcesPartialUpdateResponseSuccess = (academySourcesPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type academySourcesPartialUpdateResponse = (academySourcesPartialUpdateResponseSuccess)

export const getAcademySourcesPartialUpdateUrl = (id: string,) => {


  

  return `/api/v1/academy/sources/${id}/`
}

export const academySourcesPartialUpdate = async (id: string,
    patchedKnownSourceRequest: PatchedKnownSourceRequest, options?: RequestInit): Promise<academySourcesPartialUpdateResponse> => {
  
  return apiFetch<academySourcesPartialUpdateResponse>(getAcademySourcesPartialUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedKnownSourceRequest,)
  }
);}




export const getAcademySourcesPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academySourcesPartialUpdate>>, TError,{id: string;data: PatchedKnownSourceRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academySourcesPartialUpdate>>, TError,{id: string;data: PatchedKnownSourceRequest}, TContext> => {

const mutationKey = ['academySourcesPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academySourcesPartialUpdate>>, {id: string;data: PatchedKnownSourceRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  academySourcesPartialUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademySourcesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof academySourcesPartialUpdate>>>
    export type AcademySourcesPartialUpdateMutationBody = PatchedKnownSourceRequest
    export type AcademySourcesPartialUpdateMutationError = unknown

    export const useAcademySourcesPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academySourcesPartialUpdate>>, TError,{id: string;data: PatchedKnownSourceRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academySourcesPartialUpdate>>,
        TError,
        {id: string;data: PatchedKnownSourceRequest},
        TContext
      > => {

      const mutationOptions = getAcademySourcesPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type academySourcesDestroyResponse204 = {
  data: void
  status: 204
}
    
export type academySourcesDestroyResponseSuccess = (academySourcesDestroyResponse204) & {
  headers: Headers;
};
;

export type academySourcesDestroyResponse = (academySourcesDestroyResponseSuccess)

export const getAcademySourcesDestroyUrl = (id: string,) => {


  

  return `/api/v1/academy/sources/${id}/`
}

export const academySourcesDestroy = async (id: string, options?: RequestInit): Promise<academySourcesDestroyResponse> => {
  
  return apiFetch<academySourcesDestroyResponse>(getAcademySourcesDestroyUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}




export const getAcademySourcesDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academySourcesDestroy>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academySourcesDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['academySourcesDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academySourcesDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  academySourcesDestroy(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademySourcesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof academySourcesDestroy>>>
    
    export type AcademySourcesDestroyMutationError = unknown

    export const useAcademySourcesDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academySourcesDestroy>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academySourcesDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getAcademySourcesDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Students of the Academy managed by the agency (D-120).
 */
export type academyStudentsListResponse200 = {
  data: PaginatedStudentList
  status: 200
}
    
export type academyStudentsListResponseSuccess = (academyStudentsListResponse200) & {
  headers: Headers;
};
;

export type academyStudentsListResponse = (academyStudentsListResponseSuccess)

export const getAcademyStudentsListUrl = (params?: AcademyStudentsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/students/?${stringifiedParams}` : `/api/v1/academy/students/`
}

export const academyStudentsList = async (params?: AcademyStudentsListParams, options?: RequestInit): Promise<academyStudentsListResponse> => {
  
  return apiFetch<academyStudentsListResponse>(getAcademyStudentsListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyStudentsListQueryKey = (params?: AcademyStudentsListParams,) => {
    return [
    `/api/v1/academy/students/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAcademyStudentsListQueryOptions = <TData = Awaited<ReturnType<typeof academyStudentsList>>, TError = unknown>(params?: AcademyStudentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyStudentsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyStudentsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyStudentsList>>> = ({ signal }) => academyStudentsList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyStudentsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyStudentsListQueryResult = NonNullable<Awaited<ReturnType<typeof academyStudentsList>>>
export type AcademyStudentsListQueryError = unknown


export function useAcademyStudentsList<TData = Awaited<ReturnType<typeof academyStudentsList>>, TError = unknown>(
 params: undefined |  AcademyStudentsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyStudentsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyStudentsList>>,
          TError,
          Awaited<ReturnType<typeof academyStudentsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyStudentsList<TData = Awaited<ReturnType<typeof academyStudentsList>>, TError = unknown>(
 params?: AcademyStudentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyStudentsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyStudentsList>>,
          TError,
          Awaited<ReturnType<typeof academyStudentsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyStudentsList<TData = Awaited<ReturnType<typeof academyStudentsList>>, TError = unknown>(
 params?: AcademyStudentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyStudentsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyStudentsList<TData = Awaited<ReturnType<typeof academyStudentsList>>, TError = unknown>(
 params?: AcademyStudentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyStudentsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyStudentsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Students of the Academy managed by the agency (D-120).
 */
export type academyStudentsCreateResponse201 = {
  data: StudentDetail
  status: 201
}
    
export type academyStudentsCreateResponseSuccess = (academyStudentsCreateResponse201) & {
  headers: Headers;
};
;

export type academyStudentsCreateResponse = (academyStudentsCreateResponseSuccess)

export const getAcademyStudentsCreateUrl = () => {


  

  return `/api/v1/academy/students/`
}

export const academyStudentsCreate = async (studentCreateRequest: StudentCreateRequest, options?: RequestInit): Promise<academyStudentsCreateResponse> => {
  
  return apiFetch<academyStudentsCreateResponse>(getAcademyStudentsCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      studentCreateRequest,)
  }
);}




export const getAcademyStudentsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyStudentsCreate>>, TError,{data: StudentCreateRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyStudentsCreate>>, TError,{data: StudentCreateRequest}, TContext> => {

const mutationKey = ['academyStudentsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyStudentsCreate>>, {data: StudentCreateRequest}> = (props) => {
          const {data} = props ?? {};

          return  academyStudentsCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyStudentsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyStudentsCreate>>>
    export type AcademyStudentsCreateMutationBody = StudentCreateRequest
    export type AcademyStudentsCreateMutationError = unknown

    export const useAcademyStudentsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyStudentsCreate>>, TError,{data: StudentCreateRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyStudentsCreate>>,
        TError,
        {data: StudentCreateRequest},
        TContext
      > => {

      const mutationOptions = getAcademyStudentsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Students of the Academy managed by the agency (D-120).
 */
export type academyStudentsRetrieveResponse200 = {
  data: StudentDetail
  status: 200
}
    
export type academyStudentsRetrieveResponseSuccess = (academyStudentsRetrieveResponse200) & {
  headers: Headers;
};
;

export type academyStudentsRetrieveResponse = (academyStudentsRetrieveResponseSuccess)

export const getAcademyStudentsRetrieveUrl = (id: string,) => {


  

  return `/api/v1/academy/students/${id}/`
}

export const academyStudentsRetrieve = async (id: string, options?: RequestInit): Promise<academyStudentsRetrieveResponse> => {
  
  return apiFetch<academyStudentsRetrieveResponse>(getAcademyStudentsRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyStudentsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/academy/students/${id}/`
    ] as const;
    }

    
export const getAcademyStudentsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academyStudentsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyStudentsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyStudentsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyStudentsRetrieve>>> = ({ signal }) => academyStudentsRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyStudentsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyStudentsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academyStudentsRetrieve>>>
export type AcademyStudentsRetrieveQueryError = unknown


export function useAcademyStudentsRetrieve<TData = Awaited<ReturnType<typeof academyStudentsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyStudentsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyStudentsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyStudentsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyStudentsRetrieve<TData = Awaited<ReturnType<typeof academyStudentsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyStudentsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyStudentsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyStudentsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyStudentsRetrieve<TData = Awaited<ReturnType<typeof academyStudentsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyStudentsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyStudentsRetrieve<TData = Awaited<ReturnType<typeof academyStudentsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyStudentsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyStudentsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Students of the Academy managed by the agency (D-120).
 */
export type academyStudentsExamsCreateResponse200 = {
  data: StudentDetail
  status: 200
}
    
export type academyStudentsExamsCreateResponseSuccess = (academyStudentsExamsCreateResponse200) & {
  headers: Headers;
};
;

export type academyStudentsExamsCreateResponse = (academyStudentsExamsCreateResponseSuccess)

export const getAcademyStudentsExamsCreateUrl = (id: string,) => {


  

  return `/api/v1/academy/students/${id}/exams/`
}

export const academyStudentsExamsCreate = async (id: string,
    examsChangeRequest: ExamsChangeRequest, options?: RequestInit): Promise<academyStudentsExamsCreateResponse> => {
  
  return apiFetch<academyStudentsExamsCreateResponse>(getAcademyStudentsExamsCreateUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      examsChangeRequest,)
  }
);}




export const getAcademyStudentsExamsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyStudentsExamsCreate>>, TError,{id: string;data: ExamsChangeRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyStudentsExamsCreate>>, TError,{id: string;data: ExamsChangeRequest}, TContext> => {

const mutationKey = ['academyStudentsExamsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyStudentsExamsCreate>>, {id: string;data: ExamsChangeRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  academyStudentsExamsCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyStudentsExamsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyStudentsExamsCreate>>>
    export type AcademyStudentsExamsCreateMutationBody = ExamsChangeRequest
    export type AcademyStudentsExamsCreateMutationError = unknown

    export const useAcademyStudentsExamsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyStudentsExamsCreate>>, TError,{id: string;data: ExamsChangeRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyStudentsExamsCreate>>,
        TError,
        {id: string;data: ExamsChangeRequest},
        TContext
      > => {

      const mutationOptions = getAcademyStudentsExamsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Students of the Academy managed by the agency (D-120).
 */
export type academyStudentsExtendCreateResponse200 = {
  data: StudentDetail
  status: 200
}
    
export type academyStudentsExtendCreateResponseSuccess = (academyStudentsExtendCreateResponse200) & {
  headers: Headers;
};
;

export type academyStudentsExtendCreateResponse = (academyStudentsExtendCreateResponseSuccess)

export const getAcademyStudentsExtendCreateUrl = (id: string,) => {


  

  return `/api/v1/academy/students/${id}/extend/`
}

export const academyStudentsExtendCreate = async (id: string,
    extendStudentRequest: ExtendStudentRequest, options?: RequestInit): Promise<academyStudentsExtendCreateResponse> => {
  
  return apiFetch<academyStudentsExtendCreateResponse>(getAcademyStudentsExtendCreateUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      extendStudentRequest,)
  }
);}




export const getAcademyStudentsExtendCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyStudentsExtendCreate>>, TError,{id: string;data: ExtendStudentRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyStudentsExtendCreate>>, TError,{id: string;data: ExtendStudentRequest}, TContext> => {

const mutationKey = ['academyStudentsExtendCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyStudentsExtendCreate>>, {id: string;data: ExtendStudentRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  academyStudentsExtendCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyStudentsExtendCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyStudentsExtendCreate>>>
    export type AcademyStudentsExtendCreateMutationBody = ExtendStudentRequest
    export type AcademyStudentsExtendCreateMutationError = unknown

    export const useAcademyStudentsExtendCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyStudentsExtendCreate>>, TError,{id: string;data: ExtendStudentRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyStudentsExtendCreate>>,
        TError,
        {id: string;data: ExtendStudentRequest},
        TContext
      > => {

      const mutationOptions = getAcademyStudentsExtendCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Students of the Academy managed by the agency (D-120).
 */
export type academyStudentsHistoryListResponse200 = {
  data: History[]
  status: 200
}
    
export type academyStudentsHistoryListResponseSuccess = (academyStudentsHistoryListResponse200) & {
  headers: Headers;
};
;

export type academyStudentsHistoryListResponse = (academyStudentsHistoryListResponseSuccess)

export const getAcademyStudentsHistoryListUrl = (id: string,) => {


  

  return `/api/v1/academy/students/${id}/history/`
}

export const academyStudentsHistoryList = async (id: string, options?: RequestInit): Promise<academyStudentsHistoryListResponse> => {
  
  return apiFetch<academyStudentsHistoryListResponse>(getAcademyStudentsHistoryListUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyStudentsHistoryListQueryKey = (id?: string,) => {
    return [
    `/api/v1/academy/students/${id}/history/`
    ] as const;
    }

    
export const getAcademyStudentsHistoryListQueryOptions = <TData = Awaited<ReturnType<typeof academyStudentsHistoryList>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyStudentsHistoryList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyStudentsHistoryListQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyStudentsHistoryList>>> = ({ signal }) => academyStudentsHistoryList(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyStudentsHistoryList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyStudentsHistoryListQueryResult = NonNullable<Awaited<ReturnType<typeof academyStudentsHistoryList>>>
export type AcademyStudentsHistoryListQueryError = unknown


export function useAcademyStudentsHistoryList<TData = Awaited<ReturnType<typeof academyStudentsHistoryList>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyStudentsHistoryList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyStudentsHistoryList>>,
          TError,
          Awaited<ReturnType<typeof academyStudentsHistoryList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyStudentsHistoryList<TData = Awaited<ReturnType<typeof academyStudentsHistoryList>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyStudentsHistoryList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyStudentsHistoryList>>,
          TError,
          Awaited<ReturnType<typeof academyStudentsHistoryList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyStudentsHistoryList<TData = Awaited<ReturnType<typeof academyStudentsHistoryList>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyStudentsHistoryList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyStudentsHistoryList<TData = Awaited<ReturnType<typeof academyStudentsHistoryList>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyStudentsHistoryList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyStudentsHistoryListQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Students of the Academy managed by the agency (D-120).
 */
export type academyStudentsResendCreateResponse202 = {
  data: StudentDetail
  status: 202
}
    
export type academyStudentsResendCreateResponseSuccess = (academyStudentsResendCreateResponse202) & {
  headers: Headers;
};
;

export type academyStudentsResendCreateResponse = (academyStudentsResendCreateResponseSuccess)

export const getAcademyStudentsResendCreateUrl = (id: string,) => {


  

  return `/api/v1/academy/students/${id}/resend/`
}

export const academyStudentsResendCreate = async (id: string, options?: RequestInit): Promise<academyStudentsResendCreateResponse> => {
  
  return apiFetch<academyStudentsResendCreateResponse>(getAcademyStudentsResendCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getAcademyStudentsResendCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyStudentsResendCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyStudentsResendCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['academyStudentsResendCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyStudentsResendCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  academyStudentsResendCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyStudentsResendCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyStudentsResendCreate>>>
    
    export type AcademyStudentsResendCreateMutationError = unknown

    export const useAcademyStudentsResendCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyStudentsResendCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyStudentsResendCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getAcademyStudentsResendCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Students of the Academy managed by the agency (D-120).
 */
export type academyStudentsResumeCreateResponse200 = {
  data: StudentDetail
  status: 200
}
    
export type academyStudentsResumeCreateResponseSuccess = (academyStudentsResumeCreateResponse200) & {
  headers: Headers;
};
;

export type academyStudentsResumeCreateResponse = (academyStudentsResumeCreateResponseSuccess)

export const getAcademyStudentsResumeCreateUrl = (id: string,) => {


  

  return `/api/v1/academy/students/${id}/resume/`
}

export const academyStudentsResumeCreate = async (id: string, options?: RequestInit): Promise<academyStudentsResumeCreateResponse> => {
  
  return apiFetch<academyStudentsResumeCreateResponse>(getAcademyStudentsResumeCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getAcademyStudentsResumeCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyStudentsResumeCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyStudentsResumeCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['academyStudentsResumeCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyStudentsResumeCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  academyStudentsResumeCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyStudentsResumeCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyStudentsResumeCreate>>>
    
    export type AcademyStudentsResumeCreateMutationError = unknown

    export const useAcademyStudentsResumeCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyStudentsResumeCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyStudentsResumeCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getAcademyStudentsResumeCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Students of the Academy managed by the agency (D-120).
 */
export type academyStudentsRevokeCreateResponse200 = {
  data: StudentDetail
  status: 200
}
    
export type academyStudentsRevokeCreateResponseSuccess = (academyStudentsRevokeCreateResponse200) & {
  headers: Headers;
};
;

export type academyStudentsRevokeCreateResponse = (academyStudentsRevokeCreateResponseSuccess)

export const getAcademyStudentsRevokeCreateUrl = (id: string,) => {


  

  return `/api/v1/academy/students/${id}/revoke/`
}

export const academyStudentsRevokeCreate = async (id: string,
    noteRequest: NoteRequest, options?: RequestInit): Promise<academyStudentsRevokeCreateResponse> => {
  
  return apiFetch<academyStudentsRevokeCreateResponse>(getAcademyStudentsRevokeCreateUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      noteRequest,)
  }
);}




export const getAcademyStudentsRevokeCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyStudentsRevokeCreate>>, TError,{id: string;data: NoteRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyStudentsRevokeCreate>>, TError,{id: string;data: NoteRequest}, TContext> => {

const mutationKey = ['academyStudentsRevokeCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyStudentsRevokeCreate>>, {id: string;data: NoteRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  academyStudentsRevokeCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyStudentsRevokeCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyStudentsRevokeCreate>>>
    export type AcademyStudentsRevokeCreateMutationBody = NoteRequest
    export type AcademyStudentsRevokeCreateMutationError = unknown

    export const useAcademyStudentsRevokeCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyStudentsRevokeCreate>>, TError,{id: string;data: NoteRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyStudentsRevokeCreate>>,
        TError,
        {id: string;data: NoteRequest},
        TContext
      > => {

      const mutationOptions = getAcademyStudentsRevokeCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Students of the Academy managed by the agency (D-120).
 */
export type academyStudentsSuspendCreateResponse200 = {
  data: StudentDetail
  status: 200
}
    
export type academyStudentsSuspendCreateResponseSuccess = (academyStudentsSuspendCreateResponse200) & {
  headers: Headers;
};
;

export type academyStudentsSuspendCreateResponse = (academyStudentsSuspendCreateResponseSuccess)

export const getAcademyStudentsSuspendCreateUrl = (id: string,) => {


  

  return `/api/v1/academy/students/${id}/suspend/`
}

export const academyStudentsSuspendCreate = async (id: string,
    noteRequest: NoteRequest, options?: RequestInit): Promise<academyStudentsSuspendCreateResponse> => {
  
  return apiFetch<academyStudentsSuspendCreateResponse>(getAcademyStudentsSuspendCreateUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      noteRequest,)
  }
);}




export const getAcademyStudentsSuspendCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyStudentsSuspendCreate>>, TError,{id: string;data: NoteRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyStudentsSuspendCreate>>, TError,{id: string;data: NoteRequest}, TContext> => {

const mutationKey = ['academyStudentsSuspendCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyStudentsSuspendCreate>>, {id: string;data: NoteRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  academyStudentsSuspendCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyStudentsSuspendCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyStudentsSuspendCreate>>>
    export type AcademyStudentsSuspendCreateMutationBody = NoteRequest
    export type AcademyStudentsSuspendCreateMutationError = unknown

    export const useAcademyStudentsSuspendCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyStudentsSuspendCreate>>, TError,{id: string;data: NoteRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyStudentsSuspendCreate>>,
        TError,
        {id: string;data: NoteRequest},
        TContext
      > => {

      const mutationOptions = getAcademyStudentsSuspendCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Students of the Academy managed by the agency (D-120).
 */
export type academyStudentsImportCreateResponse200 = {
  data: StudentImportRow[]
  status: 200
}
    
export type academyStudentsImportCreateResponseSuccess = (academyStudentsImportCreateResponse200) & {
  headers: Headers;
};
;

export type academyStudentsImportCreateResponse = (academyStudentsImportCreateResponseSuccess)

export const getAcademyStudentsImportCreateUrl = () => {


  

  return `/api/v1/academy/students/import/`
}

export const academyStudentsImportCreate = async (studentImportRequest: StudentImportRequest, options?: RequestInit): Promise<academyStudentsImportCreateResponse> => {
    const formData = new FormData();
formData.append(`file`, studentImportRequest.file)

  return apiFetch<academyStudentsImportCreateResponse>(getAcademyStudentsImportCreateUrl(),
  {      
    ...options,
    method: 'POST'
    ,
    body: 
      formData,
  }
);}




export const getAcademyStudentsImportCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyStudentsImportCreate>>, TError,{data: StudentImportRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyStudentsImportCreate>>, TError,{data: StudentImportRequest}, TContext> => {

const mutationKey = ['academyStudentsImportCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyStudentsImportCreate>>, {data: StudentImportRequest}> = (props) => {
          const {data} = props ?? {};

          return  academyStudentsImportCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyStudentsImportCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyStudentsImportCreate>>>
    export type AcademyStudentsImportCreateMutationBody = StudentImportRequest
    export type AcademyStudentsImportCreateMutationError = unknown

    export const useAcademyStudentsImportCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyStudentsImportCreate>>, TError,{data: StudentImportRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyStudentsImportCreate>>,
        TError,
        {data: StudentImportRequest},
        TContext
      > => {

      const mutationOptions = getAcademyStudentsImportCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Students of the Academy managed by the agency (D-120).
 */
export type academyStudentsOptionsRetrieveResponse200 = {
  data: StudentOptions
  status: 200
}
    
export type academyStudentsOptionsRetrieveResponseSuccess = (academyStudentsOptionsRetrieveResponse200) & {
  headers: Headers;
};
;

export type academyStudentsOptionsRetrieveResponse = (academyStudentsOptionsRetrieveResponseSuccess)

export const getAcademyStudentsOptionsRetrieveUrl = () => {


  

  return `/api/v1/academy/students/options/`
}

export const academyStudentsOptionsRetrieve = async ( options?: RequestInit): Promise<academyStudentsOptionsRetrieveResponse> => {
  
  return apiFetch<academyStudentsOptionsRetrieveResponse>(getAcademyStudentsOptionsRetrieveUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyStudentsOptionsRetrieveQueryKey = () => {
    return [
    `/api/v1/academy/students/options/`
    ] as const;
    }

    
export const getAcademyStudentsOptionsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academyStudentsOptionsRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyStudentsOptionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyStudentsOptionsRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyStudentsOptionsRetrieve>>> = ({ signal }) => academyStudentsOptionsRetrieve({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyStudentsOptionsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyStudentsOptionsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academyStudentsOptionsRetrieve>>>
export type AcademyStudentsOptionsRetrieveQueryError = unknown


export function useAcademyStudentsOptionsRetrieve<TData = Awaited<ReturnType<typeof academyStudentsOptionsRetrieve>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyStudentsOptionsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyStudentsOptionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyStudentsOptionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyStudentsOptionsRetrieve<TData = Awaited<ReturnType<typeof academyStudentsOptionsRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyStudentsOptionsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyStudentsOptionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyStudentsOptionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyStudentsOptionsRetrieve<TData = Awaited<ReturnType<typeof academyStudentsOptionsRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyStudentsOptionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyStudentsOptionsRetrieve<TData = Awaited<ReturnType<typeof academyStudentsOptionsRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyStudentsOptionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyStudentsOptionsRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type academyTasksListResponse200 = {
  data: PaginatedTaskList
  status: 200
}
    
export type academyTasksListResponseSuccess = (academyTasksListResponse200) & {
  headers: Headers;
};
;

export type academyTasksListResponse = (academyTasksListResponseSuccess)

export const getAcademyTasksListUrl = (params?: AcademyTasksListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/tasks/?${stringifiedParams}` : `/api/v1/academy/tasks/`
}

export const academyTasksList = async (params?: AcademyTasksListParams, options?: RequestInit): Promise<academyTasksListResponse> => {
  
  return apiFetch<academyTasksListResponse>(getAcademyTasksListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyTasksListQueryKey = (params?: AcademyTasksListParams,) => {
    return [
    `/api/v1/academy/tasks/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAcademyTasksListQueryOptions = <TData = Awaited<ReturnType<typeof academyTasksList>>, TError = unknown>(params?: AcademyTasksListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyTasksList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyTasksListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyTasksList>>> = ({ signal }) => academyTasksList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyTasksList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyTasksListQueryResult = NonNullable<Awaited<ReturnType<typeof academyTasksList>>>
export type AcademyTasksListQueryError = unknown


export function useAcademyTasksList<TData = Awaited<ReturnType<typeof academyTasksList>>, TError = unknown>(
 params: undefined |  AcademyTasksListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyTasksList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyTasksList>>,
          TError,
          Awaited<ReturnType<typeof academyTasksList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyTasksList<TData = Awaited<ReturnType<typeof academyTasksList>>, TError = unknown>(
 params?: AcademyTasksListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyTasksList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyTasksList>>,
          TError,
          Awaited<ReturnType<typeof academyTasksList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyTasksList<TData = Awaited<ReturnType<typeof academyTasksList>>, TError = unknown>(
 params?: AcademyTasksListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyTasksList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyTasksList<TData = Awaited<ReturnType<typeof academyTasksList>>, TError = unknown>(
 params?: AcademyTasksListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyTasksList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyTasksListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type academyTasksCreateResponse201 = {
  data: Task
  status: 201
}
    
export type academyTasksCreateResponseSuccess = (academyTasksCreateResponse201) & {
  headers: Headers;
};
;

export type academyTasksCreateResponse = (academyTasksCreateResponseSuccess)

export const getAcademyTasksCreateUrl = () => {


  

  return `/api/v1/academy/tasks/`
}

export const academyTasksCreate = async (taskRequest: TaskRequest, options?: RequestInit): Promise<academyTasksCreateResponse> => {
  
  return apiFetch<academyTasksCreateResponse>(getAcademyTasksCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      taskRequest,)
  }
);}




export const getAcademyTasksCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyTasksCreate>>, TError,{data: TaskRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyTasksCreate>>, TError,{data: TaskRequest}, TContext> => {

const mutationKey = ['academyTasksCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyTasksCreate>>, {data: TaskRequest}> = (props) => {
          const {data} = props ?? {};

          return  academyTasksCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyTasksCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyTasksCreate>>>
    export type AcademyTasksCreateMutationBody = TaskRequest
    export type AcademyTasksCreateMutationError = unknown

    export const useAcademyTasksCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyTasksCreate>>, TError,{data: TaskRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyTasksCreate>>,
        TError,
        {data: TaskRequest},
        TContext
      > => {

      const mutationOptions = getAcademyTasksCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type academyTasksRetrieveResponse200 = {
  data: Task
  status: 200
}
    
export type academyTasksRetrieveResponseSuccess = (academyTasksRetrieveResponse200) & {
  headers: Headers;
};
;

export type academyTasksRetrieveResponse = (academyTasksRetrieveResponseSuccess)

export const getAcademyTasksRetrieveUrl = (id: string,) => {


  

  return `/api/v1/academy/tasks/${id}/`
}

export const academyTasksRetrieve = async (id: string, options?: RequestInit): Promise<academyTasksRetrieveResponse> => {
  
  return apiFetch<academyTasksRetrieveResponse>(getAcademyTasksRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyTasksRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/academy/tasks/${id}/`
    ] as const;
    }

    
export const getAcademyTasksRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academyTasksRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyTasksRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyTasksRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyTasksRetrieve>>> = ({ signal }) => academyTasksRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyTasksRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyTasksRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academyTasksRetrieve>>>
export type AcademyTasksRetrieveQueryError = unknown


export function useAcademyTasksRetrieve<TData = Awaited<ReturnType<typeof academyTasksRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyTasksRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyTasksRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyTasksRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyTasksRetrieve<TData = Awaited<ReturnType<typeof academyTasksRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyTasksRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyTasksRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyTasksRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyTasksRetrieve<TData = Awaited<ReturnType<typeof academyTasksRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyTasksRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyTasksRetrieve<TData = Awaited<ReturnType<typeof academyTasksRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyTasksRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyTasksRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type academyTasksPartialUpdateResponse200 = {
  data: Task
  status: 200
}
    
export type academyTasksPartialUpdateResponseSuccess = (academyTasksPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type academyTasksPartialUpdateResponse = (academyTasksPartialUpdateResponseSuccess)

export const getAcademyTasksPartialUpdateUrl = (id: string,) => {


  

  return `/api/v1/academy/tasks/${id}/`
}

export const academyTasksPartialUpdate = async (id: string,
    patchedTaskRequest: PatchedTaskRequest, options?: RequestInit): Promise<academyTasksPartialUpdateResponse> => {
  
  return apiFetch<academyTasksPartialUpdateResponse>(getAcademyTasksPartialUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedTaskRequest,)
  }
);}




export const getAcademyTasksPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyTasksPartialUpdate>>, TError,{id: string;data: PatchedTaskRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyTasksPartialUpdate>>, TError,{id: string;data: PatchedTaskRequest}, TContext> => {

const mutationKey = ['academyTasksPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyTasksPartialUpdate>>, {id: string;data: PatchedTaskRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  academyTasksPartialUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyTasksPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof academyTasksPartialUpdate>>>
    export type AcademyTasksPartialUpdateMutationBody = PatchedTaskRequest
    export type AcademyTasksPartialUpdateMutationError = unknown

    export const useAcademyTasksPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyTasksPartialUpdate>>, TError,{id: string;data: PatchedTaskRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyTasksPartialUpdate>>,
        TError,
        {id: string;data: PatchedTaskRequest},
        TContext
      > => {

      const mutationOptions = getAcademyTasksPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type academyTasksPublishCreateResponse200 = {
  data: Task
  status: 200
}
    
export type academyTasksPublishCreateResponseSuccess = (academyTasksPublishCreateResponse200) & {
  headers: Headers;
};
;

export type academyTasksPublishCreateResponse = (academyTasksPublishCreateResponseSuccess)

export const getAcademyTasksPublishCreateUrl = (id: string,) => {


  

  return `/api/v1/academy/tasks/${id}/publish/`
}

export const academyTasksPublishCreate = async (id: string, options?: RequestInit): Promise<academyTasksPublishCreateResponse> => {
  
  return apiFetch<academyTasksPublishCreateResponse>(getAcademyTasksPublishCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getAcademyTasksPublishCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyTasksPublishCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyTasksPublishCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['academyTasksPublishCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyTasksPublishCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  academyTasksPublishCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyTasksPublishCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyTasksPublishCreate>>>
    
    export type AcademyTasksPublishCreateMutationError = unknown

    export const useAcademyTasksPublishCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyTasksPublishCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyTasksPublishCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getAcademyTasksPublishCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type academyTasksReviewCreateResponse200 = {
  data: Task
  status: 200
}
    
export type academyTasksReviewCreateResponseSuccess = (academyTasksReviewCreateResponse200) & {
  headers: Headers;
};
;

export type academyTasksReviewCreateResponse = (academyTasksReviewCreateResponseSuccess)

export const getAcademyTasksReviewCreateUrl = (id: string,) => {


  

  return `/api/v1/academy/tasks/${id}/review/`
}

export const academyTasksReviewCreate = async (id: string, options?: RequestInit): Promise<academyTasksReviewCreateResponse> => {
  
  return apiFetch<academyTasksReviewCreateResponse>(getAcademyTasksReviewCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getAcademyTasksReviewCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyTasksReviewCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyTasksReviewCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['academyTasksReviewCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyTasksReviewCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  academyTasksReviewCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyTasksReviewCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyTasksReviewCreate>>>
    
    export type AcademyTasksReviewCreateMutationError = unknown

    export const useAcademyTasksReviewCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyTasksReviewCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyTasksReviewCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getAcademyTasksReviewCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Moderation of the reviews: nothing is published without a human decision; a review is
never rewritten (only personal data may be removed, then shown as such).
 */
export type academyTestimonialsListResponse200 = {
  data: PaginatedTestimonialAdminList
  status: 200
}
    
export type academyTestimonialsListResponseSuccess = (academyTestimonialsListResponse200) & {
  headers: Headers;
};
;

export type academyTestimonialsListResponse = (academyTestimonialsListResponseSuccess)

export const getAcademyTestimonialsListUrl = (params?: AcademyTestimonialsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/testimonials/?${stringifiedParams}` : `/api/v1/academy/testimonials/`
}

export const academyTestimonialsList = async (params?: AcademyTestimonialsListParams, options?: RequestInit): Promise<academyTestimonialsListResponse> => {
  
  return apiFetch<academyTestimonialsListResponse>(getAcademyTestimonialsListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyTestimonialsListQueryKey = (params?: AcademyTestimonialsListParams,) => {
    return [
    `/api/v1/academy/testimonials/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAcademyTestimonialsListQueryOptions = <TData = Awaited<ReturnType<typeof academyTestimonialsList>>, TError = unknown>(params?: AcademyTestimonialsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyTestimonialsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyTestimonialsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyTestimonialsList>>> = ({ signal }) => academyTestimonialsList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyTestimonialsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyTestimonialsListQueryResult = NonNullable<Awaited<ReturnType<typeof academyTestimonialsList>>>
export type AcademyTestimonialsListQueryError = unknown


export function useAcademyTestimonialsList<TData = Awaited<ReturnType<typeof academyTestimonialsList>>, TError = unknown>(
 params: undefined |  AcademyTestimonialsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyTestimonialsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyTestimonialsList>>,
          TError,
          Awaited<ReturnType<typeof academyTestimonialsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyTestimonialsList<TData = Awaited<ReturnType<typeof academyTestimonialsList>>, TError = unknown>(
 params?: AcademyTestimonialsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyTestimonialsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyTestimonialsList>>,
          TError,
          Awaited<ReturnType<typeof academyTestimonialsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyTestimonialsList<TData = Awaited<ReturnType<typeof academyTestimonialsList>>, TError = unknown>(
 params?: AcademyTestimonialsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyTestimonialsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyTestimonialsList<TData = Awaited<ReturnType<typeof academyTestimonialsList>>, TError = unknown>(
 params?: AcademyTestimonialsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyTestimonialsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyTestimonialsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Moderation of the reviews: nothing is published without a human decision; a review is
never rewritten (only personal data may be removed, then shown as such).
 */
export type academyTestimonialsRetrieveResponse200 = {
  data: TestimonialAdmin
  status: 200
}
    
export type academyTestimonialsRetrieveResponseSuccess = (academyTestimonialsRetrieveResponse200) & {
  headers: Headers;
};
;

export type academyTestimonialsRetrieveResponse = (academyTestimonialsRetrieveResponseSuccess)

export const getAcademyTestimonialsRetrieveUrl = (id: string,
    params?: AcademyTestimonialsRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/testimonials/${id}/?${stringifiedParams}` : `/api/v1/academy/testimonials/${id}/`
}

export const academyTestimonialsRetrieve = async (id: string,
    params?: AcademyTestimonialsRetrieveParams, options?: RequestInit): Promise<academyTestimonialsRetrieveResponse> => {
  
  return apiFetch<academyTestimonialsRetrieveResponse>(getAcademyTestimonialsRetrieveUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyTestimonialsRetrieveQueryKey = (id?: string,
    params?: AcademyTestimonialsRetrieveParams,) => {
    return [
    `/api/v1/academy/testimonials/${id}/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAcademyTestimonialsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academyTestimonialsRetrieve>>, TError = unknown>(id: string,
    params?: AcademyTestimonialsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyTestimonialsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyTestimonialsRetrieveQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyTestimonialsRetrieve>>> = ({ signal }) => academyTestimonialsRetrieve(id,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyTestimonialsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyTestimonialsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academyTestimonialsRetrieve>>>
export type AcademyTestimonialsRetrieveQueryError = unknown


export function useAcademyTestimonialsRetrieve<TData = Awaited<ReturnType<typeof academyTestimonialsRetrieve>>, TError = unknown>(
 id: string,
    params: undefined |  AcademyTestimonialsRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyTestimonialsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyTestimonialsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyTestimonialsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyTestimonialsRetrieve<TData = Awaited<ReturnType<typeof academyTestimonialsRetrieve>>, TError = unknown>(
 id: string,
    params?: AcademyTestimonialsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyTestimonialsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyTestimonialsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyTestimonialsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyTestimonialsRetrieve<TData = Awaited<ReturnType<typeof academyTestimonialsRetrieve>>, TError = unknown>(
 id: string,
    params?: AcademyTestimonialsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyTestimonialsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyTestimonialsRetrieve<TData = Awaited<ReturnType<typeof academyTestimonialsRetrieve>>, TError = unknown>(
 id: string,
    params?: AcademyTestimonialsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyTestimonialsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyTestimonialsRetrieveQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Moderation of the reviews: nothing is published without a human decision; a review is
never rewritten (only personal data may be removed, then shown as such).
 */
export type academyTestimonialsModerateCreateResponse200 = {
  data: TestimonialAdmin
  status: 200
}
    
export type academyTestimonialsModerateCreateResponseSuccess = (academyTestimonialsModerateCreateResponse200) & {
  headers: Headers;
};
;

export type academyTestimonialsModerateCreateResponse = (academyTestimonialsModerateCreateResponseSuccess)

export const getAcademyTestimonialsModerateCreateUrl = (id: string,
    params?: AcademyTestimonialsModerateCreateParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/testimonials/${id}/moderate/?${stringifiedParams}` : `/api/v1/academy/testimonials/${id}/moderate/`
}

export const academyTestimonialsModerateCreate = async (id: string,
    reviewModerateRequest: ReviewModerateRequest,
    params?: AcademyTestimonialsModerateCreateParams, options?: RequestInit): Promise<academyTestimonialsModerateCreateResponse> => {
  
  return apiFetch<academyTestimonialsModerateCreateResponse>(getAcademyTestimonialsModerateCreateUrl(id,params),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      reviewModerateRequest,)
  }
);}




export const getAcademyTestimonialsModerateCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyTestimonialsModerateCreate>>, TError,{id: string;data: ReviewModerateRequest;params?: AcademyTestimonialsModerateCreateParams}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyTestimonialsModerateCreate>>, TError,{id: string;data: ReviewModerateRequest;params?: AcademyTestimonialsModerateCreateParams}, TContext> => {

const mutationKey = ['academyTestimonialsModerateCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyTestimonialsModerateCreate>>, {id: string;data: ReviewModerateRequest;params?: AcademyTestimonialsModerateCreateParams}> = (props) => {
          const {id,data,params} = props ?? {};

          return  academyTestimonialsModerateCreate(id,data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyTestimonialsModerateCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyTestimonialsModerateCreate>>>
    export type AcademyTestimonialsModerateCreateMutationBody = ReviewModerateRequest
    export type AcademyTestimonialsModerateCreateMutationError = unknown

    export const useAcademyTestimonialsModerateCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyTestimonialsModerateCreate>>, TError,{id: string;data: ReviewModerateRequest;params?: AcademyTestimonialsModerateCreateParams}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyTestimonialsModerateCreate>>,
        TError,
        {id: string;data: ReviewModerateRequest;params?: AcademyTestimonialsModerateCreateParams},
        TContext
      > => {

      const mutationOptions = getAcademyTestimonialsModerateCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * « Tendances TCF Cameroun » from the learners' exam feedback (P3B-16).
 */
export type academyTrendsListResponse200 = {
  data: Trend[]
  status: 200
}
    
export type academyTrendsListResponseSuccess = (academyTrendsListResponse200) & {
  headers: Headers;
};
;

export type academyTrendsListResponse = (academyTrendsListResponseSuccess)

export const getAcademyTrendsListUrl = (params?: AcademyTrendsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/trends/?${stringifiedParams}` : `/api/v1/academy/trends/`
}

export const academyTrendsList = async (params?: AcademyTrendsListParams, options?: RequestInit): Promise<academyTrendsListResponse> => {
  
  return apiFetch<academyTrendsListResponse>(getAcademyTrendsListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyTrendsListQueryKey = (params?: AcademyTrendsListParams,) => {
    return [
    `/api/v1/academy/trends/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAcademyTrendsListQueryOptions = <TData = Awaited<ReturnType<typeof academyTrendsList>>, TError = unknown>(params?: AcademyTrendsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyTrendsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyTrendsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyTrendsList>>> = ({ signal }) => academyTrendsList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyTrendsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyTrendsListQueryResult = NonNullable<Awaited<ReturnType<typeof academyTrendsList>>>
export type AcademyTrendsListQueryError = unknown


export function useAcademyTrendsList<TData = Awaited<ReturnType<typeof academyTrendsList>>, TError = unknown>(
 params: undefined |  AcademyTrendsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyTrendsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyTrendsList>>,
          TError,
          Awaited<ReturnType<typeof academyTrendsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyTrendsList<TData = Awaited<ReturnType<typeof academyTrendsList>>, TError = unknown>(
 params?: AcademyTrendsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyTrendsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyTrendsList>>,
          TError,
          Awaited<ReturnType<typeof academyTrendsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyTrendsList<TData = Awaited<ReturnType<typeof academyTrendsList>>, TError = unknown>(
 params?: AcademyTrendsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyTrendsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyTrendsList<TData = Awaited<ReturnType<typeof academyTrendsList>>, TError = unknown>(
 params?: AcademyTrendsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyTrendsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyTrendsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * The bilingual tutor: its current stage (share of French), and one turn of conversation.
 */
export type academyTutorRetrieveResponse200 = {
  data: TutorState
  status: 200
}
    
export type academyTutorRetrieveResponseSuccess = (academyTutorRetrieveResponse200) & {
  headers: Headers;
};
;

export type academyTutorRetrieveResponse = (academyTutorRetrieveResponseSuccess)

export const getAcademyTutorRetrieveUrl = (params?: AcademyTutorRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/tutor/?${stringifiedParams}` : `/api/v1/academy/tutor/`
}

export const academyTutorRetrieve = async (params?: AcademyTutorRetrieveParams, options?: RequestInit): Promise<academyTutorRetrieveResponse> => {
  
  return apiFetch<academyTutorRetrieveResponse>(getAcademyTutorRetrieveUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyTutorRetrieveQueryKey = (params?: AcademyTutorRetrieveParams,) => {
    return [
    `/api/v1/academy/tutor/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAcademyTutorRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof academyTutorRetrieve>>, TError = unknown>(params?: AcademyTutorRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyTutorRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyTutorRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyTutorRetrieve>>> = ({ signal }) => academyTutorRetrieve(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyTutorRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyTutorRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof academyTutorRetrieve>>>
export type AcademyTutorRetrieveQueryError = unknown


export function useAcademyTutorRetrieve<TData = Awaited<ReturnType<typeof academyTutorRetrieve>>, TError = unknown>(
 params: undefined |  AcademyTutorRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyTutorRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyTutorRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyTutorRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyTutorRetrieve<TData = Awaited<ReturnType<typeof academyTutorRetrieve>>, TError = unknown>(
 params?: AcademyTutorRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyTutorRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyTutorRetrieve>>,
          TError,
          Awaited<ReturnType<typeof academyTutorRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyTutorRetrieve<TData = Awaited<ReturnType<typeof academyTutorRetrieve>>, TError = unknown>(
 params?: AcademyTutorRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyTutorRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyTutorRetrieve<TData = Awaited<ReturnType<typeof academyTutorRetrieve>>, TError = unknown>(
 params?: AcademyTutorRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyTutorRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyTutorRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * The bilingual tutor: its current stage (share of French), and one turn of conversation.
 */
export type academyTutorCreateResponse200 = {
  data: TutorReply
  status: 200
}
    
export type academyTutorCreateResponseSuccess = (academyTutorCreateResponse200) & {
  headers: Headers;
};
;

export type academyTutorCreateResponse = (academyTutorCreateResponseSuccess)

export const getAcademyTutorCreateUrl = () => {


  

  return `/api/v1/academy/tutor/`
}

export const academyTutorCreate = async (tutorMessageRequest: TutorMessageRequest, options?: RequestInit): Promise<academyTutorCreateResponse> => {
  
  return apiFetch<academyTutorCreateResponse>(getAcademyTutorCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      tutorMessageRequest,)
  }
);}




export const getAcademyTutorCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyTutorCreate>>, TError,{data: TutorMessageRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyTutorCreate>>, TError,{data: TutorMessageRequest}, TContext> => {

const mutationKey = ['academyTutorCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyTutorCreate>>, {data: TutorMessageRequest}> = (props) => {
          const {data} = props ?? {};

          return  academyTutorCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyTutorCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyTutorCreate>>>
    export type AcademyTutorCreateMutationBody = TutorMessageRequest
    export type AcademyTutorCreateMutationError = unknown

    export const useAcademyTutorCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyTutorCreate>>, TError,{data: TutorMessageRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyTutorCreate>>,
        TError,
        {data: TutorMessageRequest},
        TContext
      > => {

      const mutationOptions = getAcademyTutorCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * English false friends and calques found in a text (EE draft, EO transcript).
 */
export type academyTutorFalseFriendsCreateResponse200 = {
  data: FalseFriendsResult
  status: 200
}
    
export type academyTutorFalseFriendsCreateResponseSuccess = (academyTutorFalseFriendsCreateResponse200) & {
  headers: Headers;
};
;

export type academyTutorFalseFriendsCreateResponse = (academyTutorFalseFriendsCreateResponseSuccess)

export const getAcademyTutorFalseFriendsCreateUrl = () => {


  

  return `/api/v1/academy/tutor/false-friends/`
}

export const academyTutorFalseFriendsCreate = async (falseFriendsRequestRequest: FalseFriendsRequestRequest, options?: RequestInit): Promise<academyTutorFalseFriendsCreateResponse> => {
  
  return apiFetch<academyTutorFalseFriendsCreateResponse>(getAcademyTutorFalseFriendsCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      falseFriendsRequestRequest,)
  }
);}




export const getAcademyTutorFalseFriendsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyTutorFalseFriendsCreate>>, TError,{data: FalseFriendsRequestRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof academyTutorFalseFriendsCreate>>, TError,{data: FalseFriendsRequestRequest}, TContext> => {

const mutationKey = ['academyTutorFalseFriendsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof academyTutorFalseFriendsCreate>>, {data: FalseFriendsRequestRequest}> = (props) => {
          const {data} = props ?? {};

          return  academyTutorFalseFriendsCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcademyTutorFalseFriendsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof academyTutorFalseFriendsCreate>>>
    export type AcademyTutorFalseFriendsCreateMutationBody = FalseFriendsRequestRequest
    export type AcademyTutorFalseFriendsCreateMutationError = unknown

    export const useAcademyTutorFalseFriendsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof academyTutorFalseFriendsCreate>>, TError,{data: FalseFriendsRequestRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof academyTutorFalseFriendsCreate>>,
        TError,
        {data: FalseFriendsRequestRequest},
        TContext
      > => {

      const mutationOptions = getAcademyTutorFalseFriendsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Urgent session mock exams sent by an admin to the learner's exam centre (the analysis of
the sessions stays in the back office); started with POST academy/mocks {mock}.
 */
export type academyUrgentListResponse200 = {
  data: UrgentMock[]
  status: 200
}
    
export type academyUrgentListResponseSuccess = (academyUrgentListResponse200) & {
  headers: Headers;
};
;

export type academyUrgentListResponse = (academyUrgentListResponseSuccess)

export const getAcademyUrgentListUrl = (params?: AcademyUrgentListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/academy/urgent/?${stringifiedParams}` : `/api/v1/academy/urgent/`
}

export const academyUrgentList = async (params?: AcademyUrgentListParams, options?: RequestInit): Promise<academyUrgentListResponse> => {
  
  return apiFetch<academyUrgentListResponse>(getAcademyUrgentListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAcademyUrgentListQueryKey = (params?: AcademyUrgentListParams,) => {
    return [
    `/api/v1/academy/urgent/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAcademyUrgentListQueryOptions = <TData = Awaited<ReturnType<typeof academyUrgentList>>, TError = unknown>(params?: AcademyUrgentListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyUrgentList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAcademyUrgentListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof academyUrgentList>>> = ({ signal }) => academyUrgentList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof academyUrgentList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AcademyUrgentListQueryResult = NonNullable<Awaited<ReturnType<typeof academyUrgentList>>>
export type AcademyUrgentListQueryError = unknown


export function useAcademyUrgentList<TData = Awaited<ReturnType<typeof academyUrgentList>>, TError = unknown>(
 params: undefined |  AcademyUrgentListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyUrgentList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyUrgentList>>,
          TError,
          Awaited<ReturnType<typeof academyUrgentList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyUrgentList<TData = Awaited<ReturnType<typeof academyUrgentList>>, TError = unknown>(
 params?: AcademyUrgentListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyUrgentList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof academyUrgentList>>,
          TError,
          Awaited<ReturnType<typeof academyUrgentList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAcademyUrgentList<TData = Awaited<ReturnType<typeof academyUrgentList>>, TError = unknown>(
 params?: AcademyUrgentListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyUrgentList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAcademyUrgentList<TData = Awaited<ReturnType<typeof academyUrgentList>>, TError = unknown>(
 params?: AcademyUrgentListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof academyUrgentList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAcademyUrgentListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




